import { Component, OnInit, OnDestroy, DoCheck} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { Observable, of, Subject } from 'rxjs';
import { appConfig, baseUrl, google, intUrl, localUrl, online, pdf, pdf1 } from '../app.config';
import { takeUntil, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import {  CommonService } from '../_service/common.service';
import {  purchasingApiService } from '../_service/purchasing.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PagerService } from '../_service/pager-service';
import { SupplierService } from '../_service/supplier.service';
import { DocumentsService } from '../_service/documents.service';
import { SitesService } from '../_service/sites.service';
import { AddressService } from '../_service/address.service';
import { ContactsService } from '../_service/contacts.service';
import { CountryService } from '../_service/country.service';
import { K2Service } from '../_service/K2.service';
import { ArcaService } from '../_service/arca.service';
import { BrowserTitleService } from '../_service/browser-title.service';
import * as XLSX from 'xlsx';
import { BlankstatusService } from '../_service/blankstatus.service';

@Component({
    selector: 'app-site-details',
    templateUrl: './site-details.component.html',
    styleUrls: ['./site-details.component.css'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
        MatSelectModule, MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, MatSnackBarModule, NgxPaginationModule, NgSelectModule,
        NgbModule, NgxMatSelectSearchModule, SortPipe, LazyLoadImgDirective,
        HelpsectionComponent, SuppliertabComponent
    ]
})
export class SiteDetailsComponent implements OnInit, OnDestroy, DoCheck {
  private static readonly ICONMOON_LABEL_CODE_POINT = 0xe07f;
  private static readonly DEBOUNCE_MS_STANDARD = 500;
  private static readonly DEBOUNCE_MS_SLOW = 1000;
  private static readonly DEBOUNCE_MS_MEDIUM = 400;
  private static readonly DEBOUNCE_MS_FAST = 100;
  private static readonly DEBOUNCE_MS_QUICK = 300;
  private static readonly ADDRESS_INFO_CHUNK_LENGTH = 35;
  private static readonly ADDRESS_INFO_TOTAL_LENGTH = 70;
  private static readonly COORD_SCALE_MICRO = 1000000;
  private static readonly MINUTES_PER_DEGREE = 60;
  private static readonly SECONDS_PER_DEGREE = 3600;
  private static readonly COORD_FRACTION_SCALE = 100000;
  private static readonly DECIMAL_TENTH = 10;
  private static readonly ROUND_TRIM_SCALE = 1e3;
  private static readonly COORD_PRECISION_SCALE = 1e7;
  private static readonly IDENTIFIER_LOOP_DELAY_MS = 70;
  private static readonly SUPPLIER_PREFIX_LENGTH = 3;
  private static readonly RAFT_PREFIX_LENGTH = 6;
  private static readonly RAFT_SUFFIX_START = 6;
  private static readonly RAFT_SUFFIX_END = 8;
  private static readonly SHORT_NAME_LENGTH = 10;
  private static readonly CITY_SHORT_LENGTH = 5;
  private static readonly RETRY_DELAY_MS = 300;
  private static readonly UI_REFRESH_DELAY_MS = 400;
  private static readonly SHORT_DELAY_MS = 200;
  private static readonly CLOSE_MODAL_DELAY_MS = 2000;
  private static readonly POLLING_DELAY_MS = 1000;
  private static readonly STANDARD_PAGE_SIZE = 50;
  private static readonly LONG_OPERATION_DELAY_MS = 3000;
  private static readonly SAER_CODE_LENGTH = 8;
  private static readonly SAER_NAME_MAX_LENGTH = 10;
  private static readonly LATAM_CODE_MAX_LENGTH = 10;
  private static readonly RNAIPL_CODE_MIN_LENGTH = 2;
  private static readonly RNAIPL_CODE_MAX_LENGTH = 6;
  private static readonly DEFAULT_PAGE = 1;
  private static readonly NEXT_PAGE_STEP = 1;
  private static readonly SECOND_PAGE = 2;
private static readonly SEVEN = 7;
private static readonly TEN = 10;
private static readonly TWO = 2;
private static readonly EIGHT_THOUSAND_MS = 8000;
private static readonly NINE_HUNDRED_MS = 900;
private static readonly EIGHT = 8;
private static readonly SIX = 6;
private static readonly TWENTY = 20;
private static readonly FOUR = 4;
private static readonly THREE = 3;
private static readonly NINETY_NINE = 99;
private static readonly HTTP_STATUS_NOT_FOUND = 404;
  /**SEVEN
   * SIX)
   * Returns the total count of Tax Identifier values (all keys and all values)
   */

  ngUnsubscribe = new Subject();
  delayCpyResponse = new UntypedFormControl();
  delayCpyAlcorResponse = new UntypedFormControl();
  delayCpyResponseAllianceId = new UntypedFormControl();
  delaySiteSearchResCity = new UntypedFormControl();
  delaycityCreateResCountry =new UntypedFormControl();
  delaySiteSearchResCountry = new UntypedFormControl();
  delayResCountry = new UntypedFormControl();
  Config:any;
  siteId:any;
  companyId : any;
  loading = false;
  ActivityList=[];
  public CaptCountry : any = [];
  public CountryNameKeyId : any = [];
  public tempcountry = '';
  public bvdidloading = false;
  public bvdidstatusloading = false;
  public countryloading = false;
  public cityloading = false;
  public companynameloading = false;
  public alliancecompanyidloading = false;
  public siteName:any = '';
  public qualiferSiteAdditionalAddress:any='';
  public qualiferSiteAdditionalAddressInfo:any='';
  public additional:any='';
  public additionalInfo:any='';
  public siteCountry:any = '';
  public siteCity:any = '';
  public countValue:any='';
  public businessEntityCompanyLegalName:any = '';
  public businessEntityCompanyAllianceIdentifier:any = '';
  public sitebvidid:any = '';
  public sitebvididstatus:any = '';
  public qualiferAliasTypeModel:any = '';
  public qualiferAliasValueModel:any = '';
  public qualiferAliasAccessPRowidModel:any = '';
  public qualifierAliasStatusModelError = false;
  public qualiferAliasTypeModelError = false;
  public qualiferAliasValueModelError = false;

  public showTaxIdentifiers = false;
  public taxIdentifiersDebugLogged = false;
  sites: any;
  public newSiteData =[];
  public sitesData = [];
  public qualifierNo = '';
  public showCount = false;
  public rowIdQua = [];
  public persistentGpsAddressData: any = {}; // Persistent storage for GPS and address data (localStorage)
  private localStorageKey = 'siteGpsAddressData'; // Key for localStorage
  public qualifierAliasStatusModelvalUp = '';
  public qualifierOption = [];
  public qualiferAliasAccessPRowid = '';
  public currentStatus = '';
  public selectedQualifierVal = '';
  public qualiferSiteStreetModelUp ='';
  public qualiferSiteAdditionalAddressInfoModelUp = '';
  public qualiferSiteStreetModelErrorUp = false;
  public qualiferSiteTypeModelErrorUp = false;
  public postalCodeModel ='';
  public sortedSitesData:any =[];
  public editBvdIdValueModel = '';
  public editBvdIdModalError = false;
  public tempBvdId = '';
  public parentageData:any = [];
  public loadingQualifier = false;
  public parentageOriData = [];
  public parentageLoading =false;
  public mainEntranceExists = false;
  public roleVariableHide = false;
  public editSiteNameValueModel = '';
  public editSiteNameModalError = false;
  public qualiferSiteNameModelUp = '';
  public activityValue = '';
  public activityValueOption = [];
  public activityValueError = false;
  public activityValueBtn = false;
  public materialGroupRowId = ''
  public rowIdData:any
  public values: any;
  public statusData = '';
  public oldStatus = ''
  public statusOption = [];
  public statusError = false;
  public statusBtn = false;
  public statusrowIdData:any;
  public selectedIdentifier: any
  public selectedRow = false;
  public validData = false;

  public editRaftAliasModel = '';
  public editRaftAliasError = false;
  public hasMultipleRaftAlias = false;
  public raftRowIdVar = '';
  public raftAccessRowIdVar = '';
  public saveAsNewRaftCode = false;
  public displayParam = 'none';
  public loadingValidateAcp = false;
  public loadingValidateAcpSaer = false;
  public validateACPData = [];
  public maskValidateACPData = [];
  public mainValidateAcpData = [];
  public raftRadioVal = '';
  public raftNameisNull = false;
  public cpyShortName = '';
  public rowIdforNewAlias = '';
  public mainValidateAlcorData = [];
  public alcorRadioVal = '';
  public disableType = '';
  public accessPointRowIds = [];
  public companyfielderror = false;
  public editCompanyField = '';
  public changeCpyData:any = [];
  public noSiteAssn = true;
  public changeCpyBvdModel = '';
  public loadingBvdsearch = '';
  public cpyRowIdHolder = '';
  public bvdidchangecpyfielderror = false;
  public multipleSiteAssn = false;
  public singleAlcorIden = '';
  public newRaftIdentifierModel = '';
  public siteAssignmentRowId = '';
  public alcorVal = '';
  public paramsValidate = '';
  public already100Raft = false;
  public cpyAlcorToRaft = [];
  public arrBasedOnVal = [];
  public mainEntranceVals:any = [];
  public editGpsCoordinatesError1 = false;
  public editGpsCoordinatesError2 = false;
  public latitudeVal = '';
  public longitudeVal = '';
  public gpsEditRowID = '';
  public gpsAlreadyExist = false;
  public gpsValueModelLat = '';
  public gpsValueModelLon = '';
  public sitestatus = '';
  public siteActiveStatus = '';
  public siteStatusLoading = false;
  public siteActiveStatusLoading = false;
  public editSiteStatusError = false;
  public editSiteValStatusError = false;
  public editSiteStatusModel = '';
  public editSiteValStatusModel = '';
  public raftCpyGroupData = [];
  public raftCpyGroupData2 = [];
  public raftCpyGroupData3 = [];
  public raftCpyGroupData4 = [];
  public raftCpyGroupModel = '';
  public lookCpyLoading = false;
  public alcorValsArray = [];
  public showLoadedLookCpyData = false;
  public lookForCpyRowIdArr:any = [];
  public raftCpyGroupMainData = [];
  public allQualifierAccordion = [];
  public showBoxDown = true;
  public showBoxDowncomp = true;
  public assnPickingLoading = false;
  public associatedPickingData = [];
  public associatedPickingDataPoints = [];
  public identifierManufacturing = [];
  public disableNg2Cpy = false;
  public moreThanOneCpyFlag = false;
  public newCategoryAssignment = '6'; 
  public newCategoryName = 'SUPPLIER SITE' 
  public cpyNameForValidate = '';
  public noSiteExists = false;
  public validateAlcorValue = '';
  public accessPointIdenRowIds= [];
  public cpyNameForChangeCpy = '';
  public qualifierNameModelError = false;
  public qualifierNameEdit = '';
  public wayNumberModel = '';
  public streetModel = '';
  public additionalInfoModel = '';
  public updatePostalCodeModel = '';
  public territorialDivModel = '';
  public streetModelError = false;
  public postalCodeModelError = false;
  public addressEditRowId = '';
  public superAdminAllProfiles:any = false;
  public accessPointAddressData:any = [];
  public addressIdOnAccessId:any = [];
  public changeCpyAllianceId = '';
  public showChangeCpyLoading= false;
  public accessPointRowIdAddress = '';
  public territorialDivModelQualifierEdit = '';
  public wayNumberModelQualifierEdit = '';
  public siteIdentTypesData:any = [];
  public siteSourceSystems:any = [];
  public allAddressIdsGeo:any = [];
  public geoRowId:any = [];
  public allAddressIdsPostal:any = [];
  public allAddressIdsGeoloc:any = [];
  public allAddressGeoData:any = [];
  public allAddressPostalData:any = [];
  public allAddressGeoLocData:any = [];
  public geo1Loading = false;
  public geo2Loading = false;
  public geo3Loading = false;
  public inputNameForLabel = '';
  public inputForGeo1 = '';
  public inputForGeo2 = '';
  public inputForGeo3 = '';
  public geo1AddressError = false;
  public geo3AddressError = false;
  public geo2AddressError = false;
  public inputLabelError = false;
  public labelValueArrays:any = [];
  public raftCpyRowIdsOnVal:any = [];
  public toggleChangeCpyModal = false;
  public showParam = 'mainEntrance'
  public changeCpyRowIds:any = [];
  public disableSaveRaftBtn = false;
  saveDatas:any = "Save";
  siteIdLoading = true;
  siteIdentifier = '';
  public qualifierTypes = {
  'Manufacturing':'P05',
  'Invoicing':'P06',
  'Picking':'P07',
  'Customer':'P08',
  'Quality return':'P09',
  'Ordering':'P11',
  'Grouping':'P13',
  'Main Entrance':'P14',
  'B2B Partner':'B2bn',
  'Supply Chain EDI':'P19',
  'P100':'assets/sites/icons/P100.png',
  };
  public qualifierChangetoPending = ['P19','P07','P09','P08'];
  public qualifierChangeToArchived = ['P05','P11','P06','P19','P07','P09','P08','P18'];
  public qualifierTypesText = {
    'P05':'Manufacturing',
    'P06':'Invoicing',
    'P07':'Picking',
    'P08':'Customer',
    'P09':'Quality Return',
    'P11':'Ordering',
    'P13':'Grouping',
    'P14':'Main Entrance',
    'P18':'B2B Partner',
    'P19':'Supply Chain EDI'
  };
  public sortedQualifierTypes = {
    'P14' : 'Main Entrance',
    'P18' : 'B2B Partner',
    'P11' : 'Ordering',
    'P05' : 'Manufacturing',
    'P13' : 'Grouping',
    'P19' : 'Supply Chain EDI',
    'P07' : 'Picking',
    'P09' : 'Quality return',
    'P06' : 'Invoicing',
    'P08' : 'Customer'
  };
  public sortedQualifierArray = [
    'Main Entrance',
    'B2B Partner',
    'Ordering',
    'Manufacturing',
    'Grouping',
    'Supply Chain EDI',
    'Picking',
    'Quality return',
    'Invoicing',
     'Customer'
  ]
  public siteStatusColor = {'built' : '#5CBA63', '' : '#D8C4A0', 'destroyed' : '#CB4B32', 'greenfield': '#FFBD69', 'brownfield' : '#FFBD69',"prospect":"#4B9BF5", "inactive": "#FFBD69", "WAITING FOR APPROVAL": "#B7783C", "created":"#D8C4A0"};

  public colorStatus = { "waiting for approval": "#B7783C","archived": "#CB4B32", "active": "#5CBA63", "draft": "#5CBA63", "validated": "#5CBA63",'pending_validation':'#B7783C','pending' : '#B7783C', 'greenfield': '#FFBD69', 'brownfield': '#FFBD69', "destroyed": "#CB4B32", "built": "#5CBA63", "WAITING FOR APPROVAL": "#B7783C", "created":"#D8C4A0","identified": "#D8C4A0" ,"registered":"#66D8D0","approved":"#5CBA63", "prospect":"#4B9BF5", "inactive": "#FFBD69"}
  public colors = { "": "#D8C4A0", "approved": "#5CBA63", "identified": "#D8C4A0", "pending" : "#B7783C", "registered": "#66D8D0", "archived": "#CB4B32", "WAITING FOR APPROVAL": "#B7783C", "prospect":"#4B9BF5", "inactive": "#FFBD69","created":"#D8C4A0"}
  public colorsGroup = { "": "#D8C4A0", "active": "#5CBA63", "validated": "#5CBA63", "inactive": "#FFBD69","pending_validation" : "#B7783C","pending" : "#B7783C", "archived": "#CB4B32", "blocked": "#D8C4A0","WAITING FOR APPROVAL": "#B7783C","identified": "#D8C4A0", "draft":"yellow","created":"#D8C4A0" }

  public envHide : any = "";
  public showBuyerProfile:any;
  public Http_URL: string;
  public pdfLink = '';
  public contactButton: boolean;
  public filtername = '';
  public isEnvQua: boolean;
  public isEnvInt: boolean;
  public raftNameUpdatedForAlcor:any=[];
  public alcorRealEstateIdenData:any=[];
  public accessIdentValues:any=[];
  public validateACPDataAccessPoinId:any=[];
  public accessPointRowIdHolder = '';
  public allAlcorRaftVals:any =[];
  public businessEntityIdSite = '';
  public raftNameHolder='';
  public showNoCompanyShortName = false;
  public showNoSiteCity = false;
  public allSiteData:any = [];
  public wayNumberModelRegExError = false;
  public streetModelRegExError = false;
  public additionalRegExError = false;
  public additionalInfoRegExError = false;
  public updatePostalCodeModelRegExError = false;
  public territorialDivModelRegExError = false;
  public regExObjForAddressUpdate = {
    wayNumberModel : 'wayNumberModelRegExError',
    streetModel : 'streetModelRegExError',
    additional : 'additionalRegExError',
    additionalInfo : 'additionalInfoRegExError',
    updatePostalCodeModel : 'updatePostalCodeModelRegExError',
    territorialDivModel : 'territorialDivModelRegExError'
  }
  public addressUpdateModelObj = {
    streetModel : 'streetModelError'
  }
  public accessPointOnRaftAlias :any=[];
  public bvdIdRegExError = false;
  public bvdIdStatusText = '';
  public showForConsult = false;
  superUserShow: boolean;
  editAlcorField = '';
  changeCpyDataAlcor: any=[];
  changeCpyDataALcorCpy:any=[];
  currentAddressId: any='';
  currentGpsAddressId: any='';
  disableEditAddressBtn=false;
  qualifierNameModelRegExError = false;
  editSiteNameModalRegExError: boolean;
  editAllianceIdField = '';
  changeCpyDataAllianceId:any=[];
  allianceIdOnCpyName:any=[];
  disableUpdateCpyBtn = false;
  editCityModel = '';
  editCityModelError = false;
  editCityDropDown = [];
  editCityAllData:any= [];
  disableSaveBvdBtn = false;
  iconmoonLbl = String.fromCharCode(SiteDetailsComponent.ICONMOON_LABEL_CODE_POINT);
  cityCreateCountryModel = '';
  cityCreateCountryDropDown = [];
  cityCreateCityModel = '';
  cityCreateCityDisable = false;
  createCityPostalModel = '';
  disableCreateCityBtn = false;
  createCityCountryData:any = [];
  createCityGotCountryData = '';
  editCreateCityCountryModelError = false;
  editCreateCityCityModelError = false;
  cityAlreadyExistsError = false;
  mainEntranceData:any = [];
  showForSupplier: boolean;
  orbisBvdData: any=[];
  orbisBvdDataLoading: boolean;
  groupAssignToCpy = '';
  showArchivedBvdId  = false;
  showArchivedRaftcode  = false;
  disableAddQualifierToSite: boolean;
  disableEditSiteNameBtn: boolean;
  disableEditSiteStatusBtn: boolean;
  disableEditSiteValStatusBtn: boolean;
  disableEditQuaNameBtn: boolean;
  disableEditQuaSiteStatusBtn: boolean;
  disableEditRaftNameBtn: boolean;
  disableEditRaftCodeBtn: boolean;
  disableEditGpsCorBtn: boolean;
  disableValidateAcpBtn: boolean;
  public disableInPortfolioSwitch = false;
  inPortfolioLoading = true;
  bvdInPortfolioSet: any;
  showSearCode = false;
  showSaerFields = false;
  showRnaiplCode = false;
  showC2BFields = false;
  validationSuccess = false;
  loadingSteps = '<span><img src="assets/images/loading.gif" alt="loading..."></span>'
  successSteps = '<span class="text-success"> Success </span>';
  cityNewSteps = '<span class="text-success"> New City Created </span>';
  dangerSteps= '<span class="text-danger">';
  successSingleSteps= '<span class="text-success">';
  endSpanSteps = '</span>';
  acpMainCreation = '';
  acpAddressCreation = '';
  gpsCreation = '';
  finalAcpCreated = '';
  validationSuccessCity: boolean;
  cityCreation: any;
  validationSuccessUpdateCpy = false;
  UClegalEntity = '';
  UCcatergoryName = '';
  UCrealEstateIdens = '';
  UCdelAlcorPrevCpy = '';
  UCdelRaftAcc = '';
  UCchangeSiteName = '';
  UCnewSiteAssn = '';
  UCnewBvdId = '';
  UCnewBusinessE = '';
  UCarchiveLink = '';
  UCcheckDupLink = '';
  dateForTO:any;
  validationSuccessValidateacp = false;
  raftCodeAddin = '';
  raftNameAddin = '';
  raftMaxCode = '';
  acpStatusChange = '';
  saerCodeModel = '';
  saerNameModel = '';
  saer_CodeModel = '';
  saer_NameModel = '';
    showSearCodeSwitch: boolean;
  saerCodeModelError: boolean;
  nissanPlantCodeModel = '';
  nissanVendorCodeModel = '';
  nissanWarehouseModel = false;
  nissanPlantCodeModelError = false;
  nissanVendorCodeModelError = false;
  disableSaveNissanBtn = false;
  disableDeleteNissanBtn = false;
  addOrEdit = '';
  public nissanCodeRowId = '';
  CompanyIdentiTypes: any[] =[];
  TaxIdentifierKeys: any[]=[];
  TaxIdentifierType: any;
  compAliasType: any[]=[];
  TaxIdentifiLoading = false;
  CompanyIdentiLoading = false;
  companyAliasAll: any=[];
  BvDdata: any;
  noTaxIdentifierData: boolean;
  addTaxIdentifierLoading: boolean;
  companyIdenKeys: any = [];
  showTaxIdentifiersTab = false;
  description: any;
  editNotes= '';
  EditNoteValueError: boolean;
  EditNoteValueRegExError: boolean;
  siteNoteval= '';
  disableEditNotes: boolean;
  showSiteContactsBlock = false;
  NotesExistsval= '';
  pickingSiteQualifierData : any[] = [];
  pickingSitesData: any[] = [];
  pickingAccessIdenData: any[] = [];
  showAddPickingLoading: boolean;
  selectedACPid= '';
  public alcornameandvalue: any;
  mainEntranceNameToSync= '';
  disableNameSync = false;
  uniquefactcode: any;
  FactoriescodeLoading: boolean;
  uniquefactNameAndCode: any[];
  AcpID1: any;
  AcpID2 :any;
  forAcpRowId: any;
  Acp2rowId:any;
  manufacturingAcpStatus: any = '';
  roleIsManager: boolean;
  acp1Identifier: any;
  public allAttachmentData: any;
  public companyGroupSection: any[] = [];
  public saerRowIdVar = '';
  public saerAccessRowIdVar = '';
  public saerNameHolder='';
  public editsaerAliasModel='';
  disableEditsaerCodeBtn: boolean;
  disableEditsaerNameBtn: boolean;
  public hasMultiplesaerAlias = false;
  public saveAsNewsaerCode = false;
  public saveAsNewsaerName = false;
  public editsaerAliasError = false;
  public editsaerNameError = false;
  public changeStatusforRaftAlias = false;
  AddNewAddress = false;
  newData:any = [];
  public radioNotChecked = false;
  public addressRadioval : any = '';
  public wayNumberModelQualifierEditRegExError = false;
  public qualiferSiteStreetModelUpRegExError = false;
  public qualiferSiteAdditionalAddressRegExError = false;
  public qualiferSiteAdditionalAddressInfoRegExError = false;
  public postalCodeModelRegExError = false;
  public territorialDivModelQualifierEditRegExError = false;
  public regExObjForAddressAdd = {
    wayNumberModelQualifierEdit : 'wayNumberModelQualifierEditRegExError',
    qualiferSiteStreetModelUp : 'qualiferSiteStreetModelUpRegExError',
    qualiferSiteAdditionalAddress : 'qualiferSiteAdditionalAddressRegExError',
    qualiferSiteAdditionalAddressInfo : 'qualiferSiteAdditionalAddressInfoRegExError',
    postalCodeModel : 'postalCodeModelRegExError',
    territorialDivModelQualifierEdit : 'territorialDivModelQualifierEditRegExError',
    rnaiplCodeModel : 'rnaiplCodeModelError'
  }
 public GroupAssign: any =[];
 public showBoxDownGroup: boolean;
 public workFlowDetails: any[];
 public Uid: any;
 public allianceIdentifier: any;
 public colorForWorkflow = { "In progress": "#FFBD69","Need more info":"#66D8D0", "Approved": "#5CBA63", "Refused": "#CB4B32"}
 public workflowFolioFromK2Isa: any = '';
 public workflowValidationLoading = false;
 public wkfValNotesModel:any = '';
 public wkfRejNotesModel:any = '';
 public wkfInfoNotesModel:any = '';
 public rejectWorkflowNotesError = false;
  showBoxDowncompany: boolean;
  showBoxDownSite: boolean;
  showBoxDownworkflow: boolean;
  showBoxDownForAllSec = true;
  public FiltercheckStatusWorkFlow=["Inprogress_status","Needmoreinfo_status", "Approved_status","Refused_status"];
  public showFilterStatusWorkFlow=false;
  public statusOrderWorkFlow = ["In progress","Need more info", "Approved","Refused"];
  public colors2 = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "PENDING_VALIDATION", color: "#FFBD69" },
    { status: "Need more info", color: "#66D8D0" },
    { status: "DRAFT", color: "yellow" },
    { status: "Approved", color: "#5CBA63" },
    { status: "Archived", color: "#CB4B32" },
    { status: "Updating...", color: "white" },
    { status: "Blocked", color: "#CB4B32" },
    { status: "Refused", color: "#CB4B32" },
    { status: "Active", color: "#5CBA63" },
    { status: "Registered", color: "#66D8D0" },
    { status: "Prospect", color: "#4B9BF5" },
    { status: "Identified", color: "#D8C4A0" },
    { status: "", color: "white" }
  ];
 public filteredWorkFlow: any[];
 public statusFilteredWorkFlow: boolean;
 public  tempWorkflow: any =[];
 public siteRowIdFilterWorkFlow:any = [];
 public workflowStatus:any = [];
  workFlowVisibility: boolean;
  public Approved_status=false; public Refused_status=false; public Inprogress_status=false;
  public Needmoreinfo_status=false;
  loadingg: boolean;
  public customLoadingTemplate : any;
  requestForNotesHistory : any = [];
  public siteWorkflowStatus = '';
  public companyWorkflowStatus = '';
  public companyWorkflowStatusloading = false;
  public siteWorkflowStatusModel = '';
  public disableSiteWorkflowStatusBtn = false;
  public siteWorkflowStatusOptions = ['NotStarted', 'WaitingForSupplier', 'WaitingForRenault', 'Completed'];
  public workflowStatusColors: any = {
    'NotStarted': '#D8C4A0',
    'WaitingForSupplier': '#B7783C',
    'WaitingForRenault': '#B7783C',
    'Completed': '#5CBA63'
  };
  public latDegVal = '';
  public latMinVal = '';
  public latSecVal = '';
  public northSouthModel = '';
  public longDegVal = '';
  public longMinVal = '';
  public longSecVal = '';
  public eastWestModel = '';
  public tempcity = '';
  public bvdidNumber: any ='';
  public saerUnique=false;
  public saerLessthanEight=false;
  disabledeleteSaerCode: boolean;
  saerNotUniqueError=false;
  public accessPointRowIdForSelAnAdd = '';
  public addressEditRowIdForSelAnAdd = '';

  disableSelAnotherAddress: boolean;
  tempNewData:any = [];
  public addressRadioval2 : any = '';
  workflowReqIdFromK2Isa: any = '';
  specificCpyLink = '';
  public mailBodyContent = `<p>Hello,</p><p>You have been designed by an Alliance Renault-Nissan buyer to complete several information that will allow you to begin business with the Renault Group.For that please access the following page ${this.specificCpyLink} and update the missing data listed on the top of the page. For any help please contact <u>isa@renault.com</u></p><p>Regards,</p><p>Alliance Supplier Admin</p>`;
  NewIdnetifierValue= '';
  TaxTypeIdnetifierModel= '';
  IdnetifierValueError=false;
  IdnetifierTypeError=false;
  disableSaveBtnAlias=false;
  saveIdenClicked: boolean;
  taxIdentifierRowName: any =[];
  raftcode: any =[];
  rnaiplCodes: any = [];
  rowidraft: any;
  public  certiFicate: any[];
  CertificateTypeAll: any = ['ISO-9001-2015','ISO-14001-2015', 'ISO-45001', 'IATF-16949-2016'];
  CertificateTypeModel:string='';
  CertificateTypeError = false;
  CertificateNumberModel:string='';
  CertificateNumberError = false;
  CertificateStartDateModel='';
  CertificateStartDateError = false;
  CertificateEndDateModel='';
  saveCertificate: any = "Save";
  disableAddCertBtn=false;
  companyStatusCode= '';
  SiteRowID: any=[];
  public sitesInfo: any=[];
  public archivedBusIds: any=[];
  gpsModelError: boolean;
  orderingACPs:any=[];
  gpsModelError1: boolean;
  MaterialGroupLoading =false;
  dataForMaterialGroup: any=[];
  ACPdataForMaterialGroup: any=[];
  selectedSaerCode: any;
  selectedLabel: any;
  public alcorNameValsOnAlcorVal: any = [];
  public alcorValueWithApos: any = [];
  public alcorValueCpy: any = [];
  companyAlias: any;
  public aliasAccToRowId = [];
  CompanyIdentiTypes1: any[];
  compAliasType1: any;
  companyAliasAll1: any;
  groupAlias: any[];
  identifierValue= false;
  materialGroupNameModal = '';
  activityTypeList: { code: string; name: string; }[];
  materialGroupActivityModal = '';
  MailNameModel = '';
  differenceinDays = '';
  googleLink = '';
  sitecontact = true;
  disableContactRoleEdit: boolean;
  cellPhoneEdit = false;
  fixedPhoneEdit = false;
  openData = true;
  openRole = false;
  editSiteConFname = '';
  editSiteConLname = '';
  editSiteConCellphone = '';
  editSiteConPhone = "";
  grpAllianceIdForGR: any;
  groupbvdIDcpy: any;
  inPortfolioLoadingGrp = true;
  countValueGrp: any = '';
  bvdInPortfolioSetGrp: any;
  bvdloading = true;
  companybvdIDcpy: any;
  BPNLValue='';
  DUNSValue='';
  countValueCmp: any = 0;
  bvdInPortfolioSetCmp: any;
  inPortfolioLoadingCmp=true;
  validatingWorkflow=false;
  commonService: any;
  removeDatas: any = "Remove";
  remvoeContactModelval: any;
  statusDisplay: any;
  dateDisplay: any;
  siteDate: any;
  grpDate: any;
  orbisDate: any;
  orbisStatusCode:string;
  showc2bCode=false;
  c2bNameModel:any
  showc2bCodeSwitch: boolean
  isC2BNameModelValid = true;
  disableNext: boolean;
  c2bNameModelError= '';
  saerNamemodal= '';
  saerCodemodal= '';
  materialGroupNameError = false;
  materialGroupActivityError = false
  public site_modelEmail = true;
  public site_modelFname = false;
  public site_modelLname = false;
  public site_modelCellphone = false;
  public site_modelPhone = false;
  public site_modelRole = false;
  public disableEmail = false;
  public site_modelLabelName = false;
  public site_modelIpn = false;
  public site_ShowSave = false;
  public site_ShowNext = true;
  public siteModelName: any = "";
  public siteModelIpn: any = "";
  siteConEmailexistsError = false;
  public isReadOnly = false;

  SiteIdRole: any = [];

  SiteIdRoleDetails: any = [];
  CompanyContacts: any = [];


  SiteContactsLoading = true;
  SiteIdentiLoading = false;
  ContactsFlag = false;
  AllPersonIdArr: any = "";
  PersonDetails: any = [];
  personIpn: any = [];
  public SiteConRoleError: any;
  public SiteConRoleSelected: any;
  public SiteConFnameError: any;
  public SiteConLnameError: any;
  public SiteConIpn: any;
  public SiteConIpnError: any;
  public SiteConEmail: any;
  public SiteConEmailError: any;
  public SiteConCellphone: any;
  public SiteConCellphoneError: any;
  public SiteConCellphoneError2: any;
  public SiteConPhone: any;
  public SiteConPhoneError: any;
  public SiteConPhoneError2: any;
  Editrow_id_siteContactcs = "";
  PersonRoleSelectOp: any = [];
  SiteConField = ['SiteConFname', 'SiteConLname', 'SiteConRole', 'SiteConEmail'];
  SiteConLname = "";
  SiteConFname = "";
  public Editcontact_rowId = "";
  public personRowId = "";
  public updPersonId = "";
  SiteConRole = "";
  public SiteConEmailExists: any = '';
  SiteContacts: any = [];
  public siteConRoleexists = false;
  public siteRolechanged = false;
  changedRoleId: any;
  upd_usersRow_id = "";
  addquaSiteRowid: any ;
  saerCodeExists = false;
  saerNameExists = false;
  saerUniqueError = false;
  saerMinlength = false;
  saerNameMinlen = false;
  c2bExists: boolean;
  editNameModel='';
  editNameModelError = false;
  usualName = '';
  nameloading = false;
  siteShortName: any = '';
  pager: any = {};
  pageAllinfos : any = [];
  PageTotalLength: any='';
  editc2bAliasModel: any;
  c2bRowIdVar: any;
  c2bCodeExists: boolean;
  c2bAccessRowIdVar: any;
  key = 'name'; 
  reverse = false;
  showArchivedId: boolean;
  showArchivedSAER: any;
  saerCode = '';
  isArchived: boolean;
  loadSaerCpy: any;
  parentage: any;
  history: boolean;
  public latamRowIdVar = '';
  public latamAccessRowIdVar = '';
  public latamNameHolder='';
  disableEditLatamNameBtn: boolean;
  disableEditLatamCodeBtn: boolean;
  public hasMultipleLatamAlias = false;
  public editLatamAliasModel = '';
  public editLatamAliasError = false;
  public saveAsNewLatamCode = false;
  public changeStatusforLatamAlias = false;
  public editLatamNameError = false;
  public saveAsNewLatamName = false;
  public rnaiplRowIdVar = '';
  public rnaiplAccessRowIdVar = '';
  public hasMultipleRnaiplAlias = false;
  public editRnaiplAliasModel = '';
  public editRnaiplAliasError = false;
  public saveAsNewRnaiplCode = false;
  public changeStatusforRnaiplAlias = false;
  public rnaiplNameHolder = '';
  public saveAsNewRnaiplName = false;
  public editRnaiplNameError = false;
  public rnaiplNameRowIdVar = '';
  public rnaiplNameAliasHolder = '';
  disableEditRnaiplCodeBtn: boolean;
  disableEditRnaiplNameBtn: boolean;
  showArchivedLatamId: boolean;
  showArchivedLATAM: any;
  editLatamAliasErrorMessage = '';
  showLatamCodeSwitch: boolean;
  latamNameModel = '';
  latamNameModelError = '';
  latamCodeModel = '';
  showRnaiplCodeSwitch = false;
  rnaiplNameModel = '';
  rnaiplCodeModel = '';
  showLatamCode: boolean;
  latamCodeModelError: boolean;
  rnaiplCodeModelError = false;
  latamswitch: any;
  rnaiplswitch = false;
  saerswitch: boolean;
  autoload = false;
  autoload1 = false;
  autoload2 = false;
  autoload4 = false;
  autoload5 = false;
  parPager: any = {};
  histPager: any = {};
  showSaerValidate: boolean;
  showRaftValidate: boolean;
  showLatamValidate: boolean;
  showRnaiplValidate = false;
  displayValidate =false;
  rowVar: any;
  raftAliasVars: any;
  quaType: any;
  editRowIdForAlias: any;
  siteRaftName: any;
  saerCodeModelValidate: any;
  saerNameModelValidate: any;
  latamCodeModelValidate: any;
  latamNameModelValidate: any;
  rnaiplCodeModelValidate = '';
  rnaiplNameModelValidate = '';
  rnaiplCodeModelValidateError = false;
  saerswitchvalidate: boolean;
  raftvalidtaeswitch: boolean;
  latamswitchvalidate: boolean;
  rnaiplswitchvalidate = false;
  taxIdModel: any;
  taxIdRowId: any;
  mutiplecodes: boolean;
  raftLoading = false;
  saveButtonClicked: boolean;
  public companyShortName = '';
  SiteConEmailFormatError: boolean;
  endDateisPresent: boolean;
  showArchivedTax = false;
  endDateistrue: boolean;
  businessEntityValue: any;
  currentOrbisStatus: any;
  identifierTypes: any;
  allIdentifierType: any[];
  latestOrbisStatus: any;
  isLoading = false;
  TextForCompleteUpload = '';
  blankUpdateCompleted: boolean;
  TableData: Object[];
  approverEdit: boolean;
  sendMailToApprover: any;
  senReqNotesMOdel: any;
  arcasearchModel = '';
  senReqSamMOdel = '';
  senReqSamMOdelError: boolean;
  senReqBuyerAssiMOdel = '';
  buyerNameSelected = '';
  ArcIpn = '';
  ArcFirstName = '';
  ArcLastName = '';
  data: any[];
  resetArca: boolean;
  arcaSrchWait: boolean;
  arcaSrchnoresults: boolean;
  isaRoleFor_Uid: any[]=[];
  showUidDisable: boolean;
  editCountryModelError = false;
  editCountryModel = '';
  countryLoad1 = false;
  siteCountryModel = '';
  selectedCountry: any = '';
  siteCountryModelError = false;
  editCountryAllData:any= [];
  editCountryDropDown=[];
  CountryRowId: any;
  contName: any;
  latestCmpOrbisStatus: any;
  orbisRowId = '';
  associatedCount = 0;
  bpnCount: number = 0;
  BPNSValue= '';
  bpnSCount: number = 0;
  countryId: any;
  maplatitudeVal = '';
  maplongitudeVal = '';
  showCityForCountryEdit = false;
  editCountryCityDropDown = [];
  editCountryCityModel:any = '';
  editCountryCityAllData:any = [];
  editCountryCityModelError = false;
  delaySiteSearchResCountryCity = new UntypedFormControl();
  cityLoad1 = false;

  constructor(public apiService: CommonService,private pagerService: PagerService, private PurchasingApi: purchasingApiService,route: ActivatedRoute, private router : Router,private http: HttpClient,private supplierService:SupplierService,private sitesService:SitesService,private AddressService:AddressService,private contactsService:ContactsService,private countryService:CountryService,private k2Service:K2Service,private arcaService:ArcaService,private blankUpdate: BlankstatusService, private documentService: DocumentsService, private browserTitleService: BrowserTitleService) {
    this.Config = appConfig;
    this.siteId = route.snapshot.params['row_id'];
    this.companyId = route.snapshot.params['companyId'];
    this.delayCpyResponse.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_STANDARD), distinctUntilChanged()).subscribe(sat => {
      this.editCompanyField = sat
      this.changeCompanyFn();
    });
    this.delayCpyAlcorResponse.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_STANDARD), distinctUntilChanged()).subscribe(sat => {
      this.editAlcorField = sat
      this.changeCompanyAlcorFn();
    });
    this.delayCpyResponseAllianceId.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_STANDARD), distinctUntilChanged()).subscribe(sat => {
      this.editAllianceIdField = sat
      this.changeCompanyFnAllianceId();
    });
    this.delaySiteSearchResCity.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_SLOW), distinctUntilChanged()).subscribe(sat => {
      this.editCityModel = sat.toUpperCase()
      this.changeCityEditFn();
    });
    this.delaycityCreateResCountry.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_MEDIUM), distinctUntilChanged()).subscribe(sat => {
      this.cityCreateCountryModel = sat.toUpperCase()
      this.getCountryList(sat.toUpperCase());
    });
     this.delaySiteSearchResCountry.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_SLOW), distinctUntilChanged()).subscribe(sat => {
      this.editCountryModel = sat.toUpperCase()
      this.changeCountryEditFn();
    });

    this.delayResCountry.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_FAST),distinctUntilChanged(),takeUntil(this.ngUnsubscribe)).subscribe(value => {
      this.siteCountryModel = value;
      if (value && value.length >= 1) {
        this.getCountriesListForEdit(value);
      }
    });
    this.delaySiteSearchResCountryCity.valueChanges.pipe(debounceTime(SiteDetailsComponent.DEBOUNCE_MS_QUICK),distinctUntilChanged(),takeUntil(this.ngUnsubscribe)).subscribe(value => {
      this.editCountryCityModel = value;
      if (value && value.length >= SiteDetailsComponent.TWO) {
        this.changeCountryCityEditFn();
      } else {
        this.editCountryCityDropDown = [];
      }
    });
  }

  ngOnInit() {
    this.Http_URL = this.apiService.getDocument();
    // Load persistent GPS data from localStorage
    this.loadPersistentGpsData();
    this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?cityName=UNKNOWN`).subscribe(() => {})
    this.getCallingDataAgain();
    this.dateForTO = new Date();
    this.getGroupAssignments();
    this.ActivityList=[]
    this.ActivityList['01']='MANUFACTURER'
    this.ActivityList['02']='RESELLER'
    this.ActivityList['03']='DISTRIBUTOR'
    this.ActivityList['04']='SUB-CONTRACTOR'
    this.pdfLink=pdf
    this.googleLink=google
    this.getShortNameDetails();
    this.blankUpdate.TextForCompleteUpload$.subscribe((message) => {
      this.TextForCompleteUpload = message;
    });
    this.blankUpdate.uploadCompleted$.subscribe((status) => {
      this.blankUpdateCompleted = status;
    })
    this.blankUpdate.ExportFile$.subscribe((Array)=>{
      this.TableData = Array
    })
  }

  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    var RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  navigateToHome() {
    if(!this.showForSupplier){
    if (this.companyStatusCode && this.companyStatusCode.toLowerCase() === 'pending') {
      this.router.navigate(['/company-details', this.companyId]);
    } else {
      if (this.GroupAssign && this.GroupAssign.groupId) {
        this.router.navigate(['/supplier-group-details', this.GroupAssign.groupId]);
      }
    }}
    else{
      this.router.navigate(['/sites']);}
  }

  isSendToBuyerInProgress = false;

  async sendToBuyers() {
    if (this.isSendToBuyerInProgress) {
      return;
    }

    this.isSendToBuyerInProgress = true;
    console.info('Send to Buyer functionality for site:', this.siteId, 'company:', this.companyId);
    
    try {
      const hasDocuments = await this.validateCompanyDocuments(this.companyId, this.businessEntityCompanyAllianceIdentifier);
      if (!hasDocuments) {
        console.info('Document validation failed for company:', this.companyId);
        this.showDocumentValidationPopup();
        this.isSendToBuyerInProgress = false;
        return;
      }
       const hasQualifiers = await this.validateCompanyQualifiers(this.companyId);
      if (!hasQualifiers) {
        console.info('Qualifier validation failed for company:', this.companyId);
        this.showQualifierValidationPopup();
        this.isSendToBuyerInProgress = false;
        return;
      }
      console.info('All validations passed - sending to buyer');
      this.proceedWithSendToBuyer();
      
    } catch (error) {
      this.isSendToBuyerInProgress = false;
      console.info('Error during send to buyer:', error);
      alert('An error occurred during validation. Please try again.');
    }
  }

  async validateGroupDocuments(): Promise<boolean> {
    try {
      console.info('Validating documents for group companies');
      
      if (!this.companyGroupSection?.length) {
        console.info('No companies in group');
        return false;
      }

      for (const company of this.companyGroupSection) {
        if (company.hideRow === false && company.filterTrue === true) {
          const hasDocuments = await this.validateCompanyDocuments(company.companyId, company.companyAllianceIdentifier);
          if (hasDocuments) {
            return true; 
          }
        }
      }
      
      return false;
      
    } catch (error) {
      console.info('Error validating group documents:', error);
      return false;
    }
  }

  async validateCompanyDocuments(companyId: string, allianceIdentifier: string): Promise<boolean> {
    try {
      console.info('Validating documents for company:', companyId);
      if (!this.Http_URL) {
        console.info('Document service URL not available');
        return false;
      }
      
      const cpyDetails = `${companyId}-${allianceIdentifier || 'UNKNOWN'}`;
      const sharePointUrl = `${this.Http_URL}getDocfiles/${cpyDetails}`;
      
      console.info('Fetching documents from:', sharePointUrl);
      
      const response = await this.documentService.getServiceCall(sharePointUrl, '').toPromise();
      
      console.info('Document API response for company', companyId, ':', response);
      
      if (response?.rs?.body?.value) {
        const documents = response.rs.body.value;
        console.info('Found documents for company', companyId, ':', documents.length, documents);
        
        const hasNonArchivedDoc = documents.some(doc => {
          const status = doc.fields?.Status || doc.fields?.Document_x0020_Status;
          const isNotArchived = !status || (
            status.toUpperCase() !== 'ARCHIVED' && 
            status.toUpperCase() !== 'ARCHIVE'
          );
          console.info('Company', companyId, 'Document:', doc.name, 'Status:', status, 'IsNotArchived:', isNotArchived);
          return isNotArchived;
        });
        
        console.info('Company', companyId, 'has non-archived documents:', hasNonArchivedDoc);
        return hasNonArchivedDoc;
      }
      
      console.info('No documents found for company', companyId);
      return false;
      
    } catch (error) {
      console.info('Error validating documents for company:', companyId, error);
      return false;
    }
  }

  async validateGroupQualifiers(): Promise<boolean> {
    try {
      console.info('Validating qualifiers for group companies');
      
      if (!this.companyGroupSection?.length) {
        return false;
      }
      for (const company of this.companyGroupSection) {
        if (company.hideRow === false && company.filterTrue === true) {
          const hasQualifiers = await this.validateCompanyQualifiers(company.companyId);
          if (hasQualifiers) {
            return true;
          }
        }
      }
      
      return false;
      
    } catch (error) {
      console.info('Error validating group qualifiers:', error);
      return false;
    }
  }

  async validateCompanyQualifiers(_companyId: string): Promise<boolean> {
    if (!this.sitesData || this.sitesData.length === 0) {
      return false;
    }
    return this.sitesData.some(q => q.type && q.type !== 'Main Entrance' && q.type !== 'P14');
  }

  showDocumentValidationPopup() {
    document.getElementById('btnForDocumentValidation')?.click();
  }

  showQualifierValidationPopup() {
    document.getElementById('btnForQualifierValidation')?.click();
  }

  proceedWithSendToBuyer() {
    console.info('Proceeding with Send to Buyer for company:', this.companyId);
    const sendReq = {
      workflowStatus: "WaitingForRenault"
    };
    
    this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyId}`, sendReq).subscribe((data: any) => {
      console.info('Company status updated to Waiting for Approval', data);
      this.sendEmailToBuyer();
    }, (error) => {
      this.isSendToBuyerInProgress = false;
      console.info('Error updating company status for:', this.companyId, error);
      alert('Error updating company status. Please try again.');
    });
    
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=${this.companyId}`).subscribe((data1: any) => {
      if (data1['site-assignments'].length > 0) {
        data1['site-assignments'].forEach(element => {
          if (element.site.href) {
            const siteIdTemp = element.site.href.split('/');
            const siteId = siteIdTemp[siteIdTemp.length - 1];
            
            this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${siteId}`).subscribe((_siteData: any) => {
                const siteStatusChange = {
                  workflowStatus: "WaitingForRenault"
                };
                this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${siteId}`, siteStatusChange).subscribe(siteUpdateData => {
                  console.info('Site status updated to CREATED', siteUpdateData);
                });
            });
          }
        });
      }
    });
  }
 
  sendEmailToBuyer() {
    const companyAllianceId = this.businessEntityCompanyAllianceIdentifier || this.companyId;
    const companyName = this.businessEntityCompanyLegalName || 'Company';
    const directLink = `${window.location.origin}/company-details/${this.companyId}`;
    const sendMailTo = 'isa@renault.com';
    const subject = `Supplier has Filled in the Data for company ${companyAllianceId} - ${companyName}`;
    const body = `<p>Hello,</p><p>Please check the supplier data for company ${companyAllianceId} - ${companyName} and validate the workflow for the supplier.</p><p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href="${directLink}">ISA</a></p><p>Regards,</p><p>Supplier</p>`;
    this.sendMailFn(
      sendMailTo,
      subject,
      body,
      () => {
        window.location.reload();
      },
      () => {
        this.isSendToBuyerInProgress = false;
        alert('Error sending email to buyer. Please try again.');
      }
    );
  }

  showSendToBuyerButton(): boolean {
    return !this.showForSupplier && 
           this.companyWorkflowStatus && 
           this.companyWorkflowStatus.toLowerCase() === 'waitingforsupplier';
  }

  checkAllProfilesAndEnv(RoleByService){
    const c = RoleByService;

    if(c['userAccess']!=undefined && !c['userAccess'].includes('Deined')) {
      if(c['buyer'] == 'yes'){
        this.showBuyerProfile = false;
      }else{
        this.showBuyerProfile = true;
      }
      if(c['env'] =='qua' || c['env'] == 're7' || c['env'] == 'ope'){
        this.envHide = false;
      }else{
        this.envHide = true;
      }
      if(c['role'] == 'admin' || c['role'].includes('admin')){
        this.roleVariableHide = true;
      }else{
        this.roleVariableHide = false;
      }
      if(c['superAdminAllProfiles'] == 'yes'){
        this.superAdminAllProfiles = true;
      }else{
        this.superAdminAllProfiles = false;
      }
       if (c['env'] == 'qua') {
        this.isEnvQua = true;
      } else {
        this.isEnvQua = false;
      }
      if (c['env'] == 'int') {
        this.isEnvInt = true;
      } else {
        this.isEnvInt = false;
      }
      if(c['role'] == 'consult' || c['role'].includes('consult')){
        this.showForConsult = false;
      }else{
        this.showForConsult = true;
      }
      if(c['superAdmin'] == 'yes'){
        this.superUserShow = true;
      }else{
        this.superUserShow = false;
      }
      if(c['role'] == 'manager'){
        this.roleIsManager = true;
      }else{
        this.roleIsManager = false;
      }

      if(c['role'].includes('supplier')){
        this.showForSupplier = false;
        this.contactButton = true
      }else{
        this.showForSupplier = true;
        this.contactButton = false
        this.pdfLink = pdf1
      }
    }
  }


  resetEditNotes(val){
    if (val === 'notes'){
      this.siteNoteval = '';
    }else if (val =='modal'){
      this.disableEditNotes = false;
      this.siteNoteval = this.description;
    }
  }

  updateEditNotes() {
    this.disableEditNotes = true;
    this.saveDatas = 'Saving...'
    const datas = {description : this.siteNoteval.trim()};
    this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,datas ).subscribe(() => {
      window.document.getElementById("closeEditShortNote").click();
      this.saveDatas = "Save";
      this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data1 => {
        this.description = data1['description'];
      });
    },_error => {
      this.disableEditNotes = false;
      this.saveDatas = "Save";
    });
  }

  getCallingDataAgain(){
    this.loading = true;
    this.countryloading = true;
    this.cityloading = true;
    this.siteStatusLoading = true;
    this.siteActiveStatusLoading = true;
    this.newSiteData = [];
    this.sitesData = [];
    this.companynameloading = true;
    this.companyWorkflowStatusloading = true;
    this.alliancecompanyidloading = true;
    this.bvdidloading = true;
    this.bvdidstatusloading = true;
    this.siteIdLoading = true;
    if(this.siteId != 'undefined' && this.siteId != ''){
      this.noSiteExists = false;
      this.dispNameCountryCity(this.siteId);
    }else{
      this.noSiteExists = true;
      this.loading = false;
      this.countryloading = false;
      this.cityloading = false;
      this.siteStatusLoading = false;
      this.siteActiveStatusLoading = false;
      this.siteIdLoading = false;
    }
    if(this.companyId != 'undefined' && this.companyId != ''){
      this.dispCompanyAndId(this.companyId);
      this.sortData('none');
    }else{
      this.inPortfolioLoading = false;
      this.companynameloading = false;
      this.alliancecompanyidloading = false;
      this.bvdidstatusloading = false;
      this.bvdidloading = false;
      this.sitecontact = false
    }
  }

  dispNameCountryCity(a){
    this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${a}` ).subscribe( data => {
      this.allSiteData = data;
      this.siteName    = data['name'];
      this.browserTitleService.setSiteName(this.siteName);
      this.description = data['description'];
      this.siteCity    = data['cityName'];
      this.siteCountry = data['countryName'];
      this.countryId = data['countryCode'];
      this.sitestatus = data['physicalState'];
      this.siteActiveStatus = data['activeStatus'];
      this.siteDate = data['activeStatus']?data['activeStatus'].toLowerCase() === 'archived' ? data['endDate'] : data['effectiveDate']:''
      this.siteIdentifier = data['identifier'];
      this.siteShortName = data['usualName'];
      this.siteWorkflowStatus = data['workflowStatus'] || '';
      this.siteStatusLoading = false;
      this.siteActiveStatusLoading = false;
      this.countryloading = false;
      this.cityloading = false;
      this.nameloading = false;
      this.siteIdLoading = false;
      this.getRowIdForQua('a');
      this.getSiteIdenTypes();
      this.getSourceSytemId();
      this.getraftcode();
      this.getRnaiplCodes();
      this.getCompanyIdentifierTypes();
      this.getCompanyIdentifierTypes1();
      this.goToMap()

      this.getCertificates();
    },_error => {
      this.noSiteExists = true;
      this.countryloading = true;
      this.cityloading = true;
      this.nameloading = true;
      this.siteStatusLoading = true;
      this.siteActiveStatusLoading = true;
      this.siteIdLoading = false;
      this.loading = false;
    });

  }

  getraftcode(){
    this.raftcode=[];
      this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?identifierType=RAFT_ACCOUNT&realEstateAssetId=${this.siteId}` ).subscribe(data =>{
      console.info("data['access-point-identifiers']",data['real-estate-asset-identifiers'])
      data['real-estate-asset-identifiers'].forEach(element => {
        this.raftcode.push(element);
        if(element.endDate === ''){
          this.showArchivedRaftcode=false;
        }else{
          this.showArchivedRaftcode=true;
        }
      });
    })
  }

  getRnaiplCodes(page = SiteDetailsComponent.DEFAULT_PAGE) {
    if (!this.siteIdentifier) {
      console.info('getRnaiplCodes: siteIdentifier not yet set, will retry');
      setTimeout(() => this.getRnaiplCodes(page), SiteDetailsComponent.RETRY_DELAY_MS);
      return;
    }
    if (page === SiteDetailsComponent.DEFAULT_PAGE) {
      this.rnaiplCodes = [];
    }
    const url = `${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_RNAIPL_CODE&siteIdentifier=${this.siteIdentifier}&_page=${page}`;
    console.info('Fetching RNAIPL codes from:', url);
    this.sitesService.getAccessPointIdentifiers(url).subscribe(
      data => {
        console.info('RNAIPL API Response:', data);
        if (data && data['access-point-identifiers'] && data['access-point-identifiers'].length > 0) {
          data['access-point-identifiers'].forEach(element => {
            console.info('RNAIPL Element:', element);
            const value = element.identifierValue;
            if (value && this.rnaiplCodes.indexOf(value) === -1) {
              this.rnaiplCodes.push(value);
              console.info('Added RNAIPL value:', value);
            }
          });
        }
        console.info('Current rnaiplCodes array:', this.rnaiplCodes);
        if (data && data['maxPage'] && data['maxPage'] > page) {
          this.getRnaiplCodes(page + SiteDetailsComponent.NEXT_PAGE_STEP);
        }
      },
      error => {
        console.info('Error fetching RNAIPL codes:', error);
      }
    );
  }

  getCompanyIdentifierTypes1(page = SiteDetailsComponent.DEFAULT_PAGE, subscribeData = []) {
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys?_page=${page}`).subscribe((data: any) => {

      this.CompanyIdentiTypes1 = [];
      this.compAliasType1 = [];
      data['company-identifier-keys'].forEach(element => {
        subscribeData.push(element);
      });
      if (data['maxPage'] > SiteDetailsComponent.DEFAULT_PAGE && data['maxPage'] != page) {
        this.getCompanyIdentifierTypes1(page + SiteDetailsComponent.NEXT_PAGE_STEP, subscribeData);
      } else if (data['maxPage'] === page) {
        subscribeData.forEach(element => {
          if (element.type.toLowerCase() === "oth") {
            this.CompanyIdentiTypes1.push(element.name);
            this.compAliasType1.push(element);
            this.aliasAccToRowId[element.name.toLowerCase()] = element.row_id;
          }
        });
        console.info("this.CompanyIdentiTypes",this.CompanyIdentiTypes)
        this.CompanyIdnentifiers();
        this.TaxIdentifiLoading = false;
        this.CompanyIdentiLoading = false;
      }
    }, _error => {
      this.TaxIdentifiLoading = false;
      this.CompanyIdentiLoading = false;
    });
  }

  CompanyIdnentifiers(callby = "sss", page = SiteDetailsComponent.DEFAULT_PAGE, loopC = "cont") {
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.companyId}&_page=${page}`).subscribe((data: any) => {

      if (loopC === "cont" || loopC === "no" || loopC === 'reload') {
        this.companyAlias = [];
        this.companyAliasAll1 = [];
      }
      let i = SiteDetailsComponent.DEFAULT_PAGE;
      this.alcorValueCpy = [];
      console.info("data['company-identifiers']====>",data['company-identifiers']);
      data['company-identifiers'].forEach(element => {
          if (!this.companyAliasAll1[element.companyIdentifierKeyName]){
            this.companyAliasAll1[element.companyIdentifierKeyName] = [];
          }
          let temps = {};
          if (element.companyIdentifierKeyName.toLowerCase() === 'mdm' || element.companyIdentifierKeyName.toLowerCase() === 'gtop') {
            if(this.roleVariableHide === true){
            if(element.endDate !=""){
              temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': true, 'endDate': element.endDate ,'archived':true, 'iden':element.companyIdentifierKeyName}
            }else if(element.endDate ==""){
             temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': true, 'endDate': element.endDate ,'archived':false}
            }
          }else if(this.roleVariableHide === false){
            if(element.endDate ==""){
              temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': true, 'endDate': element.endDate ,'archived':false}
            }else{
              temps='';
            }
          }
          } else if (element.companyIdentifierKeyName.toLowerCase() === 'alcor') {
            if (this.alcorValueWithApos.indexOf(`'${element.value}'`) === -1) {
              this.alcorValueWithApos.push(`'${element.value}'`);
            }
            this.alcorValueCpy.push(element.value);
            if(this.roleVariableHide === true){
            if(element.endDate !=""){
              temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': false, 'endDate': element.endDate ,'archived':true}
            }else if(element.endDate ==""){
             temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': false, 'endDate': element.endDate ,'archived':false}
            }
          }else if(this.roleVariableHide === false){
            if(element.endDate ==""){
              temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': false, 'endDate': element.endDate ,'archived':false}
            }else{
              temps='';
            }
          }
          }
           else {
            if(this.roleVariableHide === true){
            if(element.endDate !=""){
              temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': true, 'endDate': element.endDate ,'archived':true}
            }else{
             temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': true, 'endDate': element.endDate ,'archived':false}
            }
          }else if(this.roleVariableHide === false){
            if(element.endDate ==""){
              temps = { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': true, 'endDate': element.endDate ,'archived':false}
            }else{
              temps='';
            }
          }
        }
        setTimeout(() => {
          if(temps !=''){
          this.companyAliasAll1[element.companyIdentifierKeyName].push(temps);
          }
          i++;
        }, SiteDetailsComponent.CLOSE_MODAL_DELAY_MS);

      });
      var j = SiteDetailsComponent.DEFAULT_PAGE;
      if (data['maxPage'] > SiteDetailsComponent.DEFAULT_PAGE && loopC != "stop") {
        for (j = SiteDetailsComponent.SECOND_PAGE; j <= data['maxPage']; j++) {
          this.CompanyIdnentifiers('', j, 'stop');
        }
      }
      console.info('company identifiers>>', this.companyAliasAll1);
      if (j <= SiteDetailsComponent.DEFAULT_PAGE) {
        if (callby === "two") {
          this.companyAliasAll =[];
          this.CompanyIdnentifiers('', SiteDetailsComponent.DEFAULT_PAGE, 'no');
        }
      }
      if(loopC === 'reload'){
        this.getAlcorNameVals();
      }
      if (loopC === "cont") {
        this.siteRoles();
        this.getAlcorNameVals();
      }
    });
  }
  siteRoles(page = SiteDetailsComponent.DEFAULT_PAGE, loopCRole = "yes") {
    this.contactsService.getSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles?site=CtcSiteService:${this.siteId}&personRoleStatus=VALIDATED&_page=${page}`).subscribe((data: any) => {
      if (loopCRole === "yes") {
        this.SiteIdRole = [];
        this.SiteContacts = [];
        this.AllPersonIdArr = [];
      }
      if (data['supplierSiteRoles'].length > 0) {
        this.showSiteContactsBlock = true
        data['supplierSiteRoles'].forEach(element => {
          var compID = ''
          if (element.personSupplierCompany) {
            if (typeof element.personSupplierCompany === 'string') {
                compID = element.personSupplierCompany.split(":");
              }else{
                compID = element.personSupplierCompany.href.split("/");
              }
            if (this.companyId === compID[1] && element.personRoleStatus.toLowerCase() === "validated") {
              const captain_exist = this.SiteIdRole.indexOf(compID[1]);
              if (captain_exist === -1) {
                this.SiteIdRole.push(compID[1])
                this.SiteIdRoleDetails[compID[1]] = []
              }
              this.SiteIdRoleDetails[compID[1]].push(element);

              const personRowidexist = this.AllPersonIdArr.indexOf(element.personRowId)
              if (personRowidexist === -1 && element.personRowId != '') {
                this.AllPersonIdArr.push(element.personRowId);
              }
            }
          }
        });
        var jx = SiteDetailsComponent.DEFAULT_PAGE;
        if (data['maxPage'] > SiteDetailsComponent.DEFAULT_PAGE && loopCRole != "stop") {
          for (jx = SiteDetailsComponent.SECOND_PAGE; jx <= data['maxPage']; jx++) {
            this.siteRoles(jx, 'stop');
          }
        }
        this.SiteContactsLoading = false;
        if (this.SiteIdRoleDetails[this.companyId] != undefined) {
          this.SiteContacts = this.SiteIdRoleDetails[this.companyId];
          if (this.AllPersonIdArr.length > 0) {
            this.PersonAddresses();
          } else {
            this.ContactsFlag = true;
          }
        } else {
          this.ContactsFlag = true;
        }
      } else {
        this.SiteIdentiLoading = false;
        this.ContactsFlag = true;
      }
    }, _error => {
      this.CompanyIdentiLoading = false;
      this.ContactsFlag = true;
    });
  }

  PersonAddresses(page = SiteDetailsComponent.DEFAULT_PAGE, subscribeData = []) {
    this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=in(${this.AllPersonIdArr})&_page=${page}`).subscribe((data: any) => {

      if (data['personAddresses'].length > 0) {
        data['personAddresses'].forEach(element => {
          subscribeData.push(element);
        });
        if (data['maxPage'] == undefined) {
          subscribeData.forEach(element => {
            if (this.AllPersonIdArr.includes(element.personRowId) == 1) {
              if (element.addressType.toLowerCase() == "email") {
                this.PersonDetails[`${element.personRowId}_email`] = element.summary;
                this.PersonDetails[`${element.personRowId}_addIDEmail`] = element.addressId;
              }
              if (element.addressType.toLowerCase() == "telephone") {
                var addsplit = element.summary.split("*");
                if (addsplit.length > 1) {
                  if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
                    this.PersonDetails[`${element.personRowId}_p`] = addsplit[0];
                    this.PersonDetails[`${element.personRowId}_addIDp`] = element.addressId;
                  }
                  if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
                    this.PersonDetails[`${element.personRowId}_f`] = addsplit[0];
                    this.PersonDetails[`${element.personRowId}_addIDf`] = element.addressId;
                  }
                }
              }
            }
          });

        }
        else {
          if (data['maxPage'] > SiteDetailsComponent.DEFAULT_PAGE && data['maxPage'] != page) {
            this.PersonAddresses(page + SiteDetailsComponent.NEXT_PAGE_STEP, subscribeData);
          } else if (data['maxPage'] == page) {
            subscribeData.forEach(element => {
              if (this.AllPersonIdArr.includes(element.personRowId) == 1) {
                if (element.addressType.toLowerCase() == "email") {
                  this.PersonDetails[`${element.personRowId}_email`] = element.summary;
                  this.PersonDetails[`${element.personRowId}_addIDEmail`] = element.addressId;
                }
                if (element.addressType.toLowerCase() == "telephone") {
                  var addsplit = element.summary.split("*");
                  if (addsplit.length > 1) {
                    if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
                      this.PersonDetails[`${element.personRowId}_p`] = addsplit[0];
                      this.PersonDetails[`${element.personRowId}_addIDp`] = element.addressId;
                    }
                    if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
                      this.PersonDetails[`${element.personRowId}_f`] = addsplit[0];
                      this.PersonDetails[`${element.personRowId}_addIDf`] = element.addressId;
                    }
                  }
                }
              }
            });
            console.info('person addresses', this.PersonDetails);
            this.getPersonsIpns(this.AllPersonIdArr);
          }
        }
      }

    });
    this.ContactsFlag = true;
  }
  getPersonsIpns(AllPersonIdArr) {
    if (AllPersonIdArr.length > 0) {
      this.contactsService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=in(${AllPersonIdArr})`).subscribe(data => {
        if (data['users'].length > 0) {
          data['users'].forEach(e => {
            if(e.endDate){
              this.endDateistrue =true
            }else{
              this.endDateistrue =false;
            }
            this.personIpn[e.personRowId] = e;
          });
          console.info('ipn data', this.personIpn);
        }
      });
    }
  }
  getAlcorNameVals(page = SiteDetailsComponent.DEFAULT_PAGE,loop = 'start', subscribeData = []) {
    if(loop === 'start'){
      this.alcorNameValsOnAlcorVal = "";
      this.alcorNameValsOnAlcorVal = [];
    }
    if(this.alcorValueWithApos.length > 0 && this.alcorValueWithApos != ''){
      this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${this.alcorValueWithApos})&_page=${page}`).subscribe(data0 => {

        if (data0['real-estate-asset-identifiers'].length > 0) {
          data0['real-estate-asset-identifiers'].forEach(element => {
            if (this.alcorNameValsOnAlcorVal[element.businessIdentifierValue] === undefined) {
              this.alcorNameValsOnAlcorVal[element.businessIdentifierValue] = [];
            }
            this.alcorNameValsOnAlcorVal[element.businessIdentifierValue].push(element);
          });
          if (data0['maxPage'] > SiteDetailsComponent.DEFAULT_PAGE && data0['maxPage'] != page) {
            this.getAlcorNameVals(page + SiteDetailsComponent.NEXT_PAGE_STEP,'continue' ,subscribeData);
          }
        }

      });
    }
  }
  loadraftcode(val){
    this.rowidraft =val;
  }

  UnarchiveRaftcode(){
    if(this.raftcode != ''){
      const setEndDate = {endDate : ''}
      this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${this.rowidraft}`,setEndDate).subscribe(() => {
        document.getElementById('closeraftmodal').click();
        this.getraftcode();
      });
    }
  }

  DeleteRaftcode(){
    if(this.raftcode != ''){
      this.sitesService.deleteRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${this.rowidraft}`).subscribe(() => {
        this.dispBvdId(this.businessEntityIdSite,'first');
        document.getElementById('closeraftmodal').click();
        this.getraftcode();
      });
    }
  }
  dispCompanyAndId(b){
    if(b != undefined && b != ''){
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${b}`).subscribe( data => {
        this.businessEntityCompanyLegalName = data['legalName'];
        this.businessEntityCompanyAllianceIdentifier = data['allianceIdentifier'];
        this.companyStatusCode=data['companyStatusCode'];
        this.companyWorkflowStatus = data['workflowStatus'] || '';
        this.dateDisplay = data['companyStatusCode'].toLowerCase() === 'archived' ? data['endDate'] : data['startDate']
        this.companynameloading = false;
        this.alliancecompanyidloading = false;
        this.getCmpBvd();
      },_error => {

        this.companyWorkflowStatusloading = false;
        this.companynameloading = false;
        this.alliancecompanyidloading = false;
      });
    this.dispParentageStatus();
    }else{
      this.companyWorkflowStatusloading = false;
      this.companynameloading = false;
      this.alliancecompanyidloading = false;
      this.bvdidstatusloading = false;
      this.bvdidloading = false;
    }
  }

  dispParentageStatus(_page=1){
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}&_page=1&status=VALIDATED`).subscribe( data => {
      var c = '';
      let count =0;
      var bvdf = '';
      this.siteStatusLoading = false;
      if(data['pageCount'] === 1){
        this.multipleSiteAssn = false;
        if(data['site-assignments'][0]['status'] === 'VALIDATED'){
        data['site-assignments'].forEach( element => {
          this.noSiteAssn = false;
          if(count === 0){
            c = element.validityStartDate;
          }
          count++;
          if( c!= '' && count> 0){
            if(c < element.validityStartDate){
                c = element.validityStartDate
              }
          }
          if( c === element.validityStartDate){
            if(element.status === 'VALIDATED'){

            }
            if(element.businessEntityCompanyId === this.companyId){
              this.sitebvididstatus = element.status;
            }else{
              this.sitebvididstatus = 'ARCHIVED';
            }
            this.bvdidstatusloading = false;
            this.businessEntityIdSite = element.businessEntityId;

            this.siteAssignmentRowId = element.rowId;
            bvdf = element.businessEntityId
          }else{
            this.bvdidstatusloading = false;
          }
        });
        this.dispBvdId(bvdf);
        }
        else{
          this.noSiteAssn = true;
          this.multipleSiteAssn = false;
        }
      }
      else if(data['pageCount'] > 1){
        this.bvdidstatusloading = false;
        this.bvdidloading = false;
        this.noSiteAssn = false;
        this.multipleSiteAssn = true;
      }
      else{
        this.bvdidstatusloading = false;
        this.bvdidloading = false;
        this.multipleSiteAssn = false;
        this.noSiteAssn = true;
      }
        },_error =>{
          this.bvdidloading = false;
          this.bvdidstatusloading = false;
        }
    );
  }

  dispBvdId(d,val = 'first',page = 1, subscribeData = []){
    if(val === 'first' && d != ''){
      let archiveBvdId = '';
      let archiveBvdIdval = '';
      let notArchived:boolean;
      if(page ==1){
        notArchived = false;
        this.companyAliasAll = [];
        this.archivedBusIds=[];
      }
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${d}&_page=${page}`).subscribe(data => {
        this.businessEntityValue = data['business-entity-identifiers'];
        if(data['business-entity-identifiers'].length > 0){
          data['business-entity-identifiers'].forEach((e,index) => {
            if(e.businessEntityIdentifierTypeName === 'BVD ID'){
              if(e.endDate === ''){
                this.showTaxIdentifiersTab = true;
                this.showArchivedBvdId = false;
                this.tempBvdId  = e.row_id;
                notArchived = true;
                this.sitebvidid  = e.value;
              }else{
                archiveBvdId = e.row_id;
                archiveBvdIdval = e.value;
                this.showTaxIdentifiersTab =false;
              }
            }else if(index+1 === data['business-entity-identifiers'].length && this.showTaxIdentifiersTab != true){
              this.showTaxIdentifiersTab = false;
            }
            console.info('Processing identifier:', e.businessEntityIdentifierTypeName, 'Value:', e.value, 'EndDate:', e.endDate);
            let temps = {};
            if(e.endDate === ""){
              if (!this.companyAliasAll[e.businessEntityIdentifierTypeName]){
                this.companyAliasAll[e.businessEntityIdentifierTypeName] = [];
              }
              temps = { 'val': e.value, 'key': e.row_id,'endDate': 'notarchived' }
            }else{
              if (!this.companyAliasAll[e.businessEntityIdentifierTypeName]){
                this.companyAliasAll[e.businessEntityIdentifierTypeName] = [];
              }
              temps = { 'val': e.value, 'key': e.row_id,'endDate': 'archived' }
            }
            this.companyAliasAll[e.businessEntityIdentifierTypeName].push(temps);
            console.info('Added to companyAliasAll:', e.businessEntityIdentifierTypeName, temps);
            
            if (e.businessEntityIdentifierTypeName === 'ORBIS-STATUS' && e.endDate === '') {
            if (!this.latestOrbisStatus || new Date(e.startDate) > new Date(this.latestOrbisStatus.startDate)) {
                    const statusValue = e.value;
                    this.orbisRowId = e.row_id
                    let pillColor = '#B7783C'; 
 
                    if (statusValue === 'Active') {
                      pillColor = '#5CBA63'; 
                    } else if (statusValue.startsWith('Active')) {
                      pillColor = '#FFBD69'; 
                    } else if (
                      statusValue.startsWith('Inactive') ||
                      statusValue.startsWith('Administratively suspended')
                    ) {
                      pillColor = '#FFBD69'; 
                    } else if (statusValue.startsWith('Status unknown')){
                     pillColor = '#FFBD69'; 
                    }else if (
                      statusValue.startsWith('In liquidation') ||
                      statusValue.startsWith('Dissolved') ||
                      statusValue.startsWith('Bankruptcy')
                    ) {
                      pillColor = '#CB4B32'; 
                    }
 
                    this.latestOrbisStatus = {
                      value: statusValue,
                      startDate: e.startDate,
                      color: pillColor
                    };
          }
        } if ((e.businessEntityIdentifierTypeName === 'BPN-S' || e.businessEntityIdentifierTypeName === 'BPN-L') && e.endDate === '') {
            this.bpnSCount+=1;
            this.BPNSValue = e.value;
          }

          });
          if(notArchived === false){
            this.showArchivedBvdId = true;
            this.tempBvdId = archiveBvdId;
            this.sitebvidid = archiveBvdIdval;
          }
          if(data['maxPage'] > 1 && data['maxPage'] != page){
            this.dispBvdId(d,val,page+1,subscribeData);
          }else if(data['maxPage'] === page){
            console.info('Ã¢Å“â€œ All pages aggregated. Total identifiers by type:', 
              Object.keys(this.companyAliasAll).map(key => 
                `${key}: ${this.companyAliasAll[key].length}`
              ).join(', '));
            this.getInPortfolioDetails();
            this.bvdidloading = false;
          }
        } else{
          this.showTaxIdentifiersTab = false;
          this.bvdidloading = false;
        }
      },_error => {
        this.showTaxIdentifiersTab = false;
        this.bvdidloading = false;
      });
    }else{
      this.bvdidloading = false;
    }
    if(val === 'reload'){
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`).subscribe(data1 => {
        if(data1['endDate'] === ''){
          this.sitebvidid  = data1['value'];
        }
        this.addTaxIdentifiers();
        this.bvdidloading = false;
      },_error => {
        this.bvdidloading = false;
      });
    }
    console.info('companyAliasAll',this.companyAliasAll)
  }

  getCompanyIdentifierTypes(page = 1, subscribeData = []) {
    let entityId: any
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}&status=VALIDATED`).subscribe( businessId => {
      businessId['site-assignments'].forEach( element => {
        entityId = element.businessEntityId
      })
      this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?type=TAXATION&_page=${page}`).subscribe(data => {
        if (page === 1) {
          this.CompanyIdentiTypes = [];
          this.TaxIdentifierKeys = [];
          this.TaxIdentifierType = [];
          this.compAliasType = [];
        }
        data['business-entity-identifier-types'].forEach(element => {
          subscribeData.push(element)
        })
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getCompanyIdentifierTypes(page + 1, subscribeData);
        } else if (data['maxPage'] === page) {

        subscribeData.forEach(element => {
          if (element['name'] !== 'BVD ID') {
            this.TaxIdentifierKeys.push(element['name'])
            this.TaxIdentifierType.push(element);
            this.taxIdentifierRowName[element['name']] = element['row_id'];
          }
        })
        console.info("TaxIdentifierType" ,this.TaxIdentifierType)
        console.info("TaxIdentifierKeys" ,this.TaxIdentifierKeys)
        this.TaxIdentifiLoading = false;
        this.CompanyIdentiLoading = false;
        }
      }, _error => {
      this.TaxIdentifiLoading = false;
      this.CompanyIdentiLoading = false;
      })
    });
  }

  getRowIdForQua(a='a'){
    if( a === 'reload'){
      this.newSiteData = [];
      this.sitesData = [];
      this.sortedSitesData = [];
    }
    this.dispQualifiers(a);
  }

  dispQualifiers(a,page =1,subscribeData = [], loop='start',mainEntranceRow=''){

    this.disableValidateAcpBtn = false;
    if(a === 'reload' && loop === 'start'){
      this.newSiteData = [];
      this.sitesData = [];
      this.loading = true;
      this.sortedSitesData = [];
      this.mainEntranceExists = false;
      this.mainEntranceVals = [];
      this.showBoxDown = false;
      this.addressIdOnAccessId = [];
      this.accessIdentValues=[];
    }
    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${this.siteId})&_display=true&_page=${page}`).subscribe( data => {
      let count = 1;
      if(data['access-points'].length > 0){
        data['access-points'].forEach(element => {
          if(element.irnAuthor!='IRN-70907'){
            subscribeData.push(element);
          }
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.dispQualifiers('',page+1,subscribeData,'continue',mainEntranceRow);
        }else if(data['maxPage'] === page){

          subscribeData.forEach( (element : any) => {
            if(this.accessIdentValues.indexOf(`'${element.identifier}'`)){
              this.accessIdentValues.push(`'${element.identifier}'`);
            }
            this.rowIdQua.push(element.rowId);
            
            var sort ={};
            if(this.labelValueArrays.indexOf(element.label) === -1){
              this.labelValueArrays.push(element.label);
            }
            if(element.type){
              sort['type'] = element.type;
              if(element.type === 'Main Entrance'){
                this.mainEntranceExists = true;
                mainEntranceRow = element.rowId;
                if(this.mainEntranceVals[0]==undefined){
                  this.mainEntranceVals[0] = [];
                }
                this.mainEntranceVals[0]['label'] = element.label;
                this.mainEntranceData = element;
              }
              sort['status'] = element.activeStatus;
              sort['identifier'] = element.identifier;
              sort['rowId'] = element.rowId;
              sort['label'] = element.label;
              sort['effectiveDate'] = element.effectiveDate;
              sort['activity']=element.activity;
              sort['acpEndDate']=element.endDate;
              this.newSiteData[element.rowId] = (sort);
              if(this.sortedSitesData[element.type] === undefined){
                this.sortedSitesData[element.type] = [];
              }
              this.sortedSitesData[element.type].push(sort);
              this.sortedSitesData['count'] = count;
              this.newSiteData['count'] = count;
              count ++;
            }
          });
          setTimeout( function(){
          this.dispGpsAndStreet(mainEntranceRow);
          }.bind(this),SiteDetailsComponent.UI_REFRESH_DELAY_MS);
        }
      }else{
        this.loading = false;
      }
    });
  }

  dispGpsAndStreet(x, page = 1, subscribeData = [],_loop='start',accessIDs=[]){
    // Try to get all addresses including archived ones by not filtering on endDate
    this.sitesService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=in(${this.rowIdQua})&_page=${page}&endDate=gte(1900-01-01)`).subscribe(data =>{
      if(data['access-points-addresses'].length > 0){
        data['access-points-addresses'].forEach( (element : any) => {
          this.contName=element.addressId;
          let mainEntranceAddressId = '';
          if(element.addressType === 'GEOGRAPHICAL'){
            if(this.allAddressIdsGeo.indexOf(element.addressId) === -1){
              this.allAddressIdsGeo.push(element.addressId);
            }
          }
          if(element.addressType === 'POSTAL'){
            if(this.allAddressIdsPostal.indexOf(element.addressId) === -1){
              this.allAddressIdsPostal.push(element.addressId);
            }
          }
          if(element.addressType === 'GEOLOC'){
            if(this.allAddressIdsGeoloc.indexOf(element.addressId) === -1){
              this.allAddressIdsGeoloc.push(element.addressId);
            }
          }
          if(this.newSiteData[element.accessPointId]){
            let sum ='';
            let tum = '';
            let signlat;
            let latAbs;
            let lonAbs;
            let signlon;
            if(element.addressType === 'GEOGRAPHICAL'){
              if(accessIDs.indexOf(element.addressId) === -1){
                accessIDs.push(element.addressId);
              }
              if(this.addressIdOnAccessId[element.addressId] === undefined){
                this.addressIdOnAccessId[element.addressId] = [];
              }
              this.addressIdOnAccessId[element.addressId].push(element.accessPointId);
              sum = element.addressSummary;
              this.newSiteData[element.accessPointId]['street'] = sum;
              if(this.mainEntranceExists === true && element.accessPointId === x){
                mainEntranceAddressId = element.addressId;
              }
              this.newSiteData[element.accessPointId]['addressEditRowId'] = element.addressId;
              
              // Persist street address data to localStorage
              if(!this.persistentGpsAddressData[element.accessPointId]) {
                this.persistentGpsAddressData[element.accessPointId] = {};
              }
              this.persistentGpsAddressData[element.accessPointId]['street'] = sum;
              this.persistentGpsAddressData[element.accessPointId]['addressEditRowId'] = element.addressId;
              this.savePersistentGpsData();
              
              if(this.mainEntranceVals[element.accessPointId] === undefined){
                this.mainEntranceVals[element.accessPointId] = [];
              }
              if(this.mainEntranceVals[element.accessPointId].indexOf(element.accessPointId)==-1){
                this.mainEntranceVals[element.accessPointId]['addressEditRowId'] = element.addressId;
              }
            }
            if(element.addressType === 'POSTAL'){
              const splitAll = element.addressSummary.split(',');
              const noOfLine = splitAll.length;
              if(this.newSiteData[element.accessPointId]['postalSummary'] === undefined){
                this.newSiteData[element.accessPointId]['postalSummary'] = [];
              }

              for(let i =0; i< noOfLine; i++){
                this.newSiteData[element.accessPointId]['postalSummary'][`line${i}`] = splitAll[i];
              }
              
              // Persist postal address data to localStorage
              if(!this.persistentGpsAddressData[element.accessPointId]) {
                this.persistentGpsAddressData[element.accessPointId] = {};
              }
              this.persistentGpsAddressData[element.accessPointId]['postalSummary'] = this.newSiteData[element.accessPointId]['postalSummary'];
              this.savePersistentGpsData();

            }
            if(element.addressType === 'GEOLOC'){
              let c = element.addressSummary.split(';');
              if(c.length < 1){
                c = element.addressSummary.split(',');
              } else{

              }

              if(this.mainEntranceVals[element.accessPointId] === undefined){
                this.mainEntranceVals[element.accessPointId] = [];
              }
              if(this.mainEntranceVals[element.accessPointId].indexOf(element.accessPointId)==-1){
                this.mainEntranceVals[element.accessPointId]['addressEditRowIdForGPS'] = element.addressId;
                this.mainEntranceVals[element.accessPointId]['gpsDataLat'] = c[0];
                this.mainEntranceVals[element.accessPointId]['gpsDataLon'] = c[1];
              }

              this.newSiteData[element.accessPointId]['gpslatdec'] = c[0];
              this.newSiteData[element.accessPointId]['gpslondec'] = c[1];
              this.newSiteData[element.accessPointId]['gpsEditRowId'] = element.addressId;
              
              // Persist GPS data so it survives when qualifier is archived
              if(!this.persistentGpsAddressData[element.accessPointId]) {
                this.persistentGpsAddressData[element.accessPointId] = {};
              }
              this.persistentGpsAddressData[element.accessPointId]['gpslatdec'] = c[0];
              this.persistentGpsAddressData[element.accessPointId]['gpslondec'] = c[1];
              this.persistentGpsAddressData[element.accessPointId]['gpsEditRowId'] = element.addressId;
              console.log('💾 Persisted GPS for accessPointId:', element.accessPointId, {lat: c[0], lon: c[1]});
              // Save to localStorage
              this.savePersistentGpsData();
              
              const compareNumber = function(a,b) 
              {
                if (a < b)       return '-';
                else if(a === b) return '=';
                else if(a > b)   return '+';
                else             return 'z';
              }
              latAbs = Math.abs( Math.round(c[0] * SiteDetailsComponent.COORD_SCALE_MICRO));
              lonAbs = Math.abs( Math.round(c[1] * SiteDetailsComponent.COORD_SCALE_MICRO));
              if(compareNumber(c[0], 0) === '-')  { signlat = -1.; } else { signlat = 1.; }
              if(compareNumber(c[1], 0) === '-' )  { signlon = -1.; } else { signlon = 1.; }
              let tem=( Math.floor(((((latAbs / SiteDetailsComponent.COORD_SCALE_MICRO)-Math.floor(latAbs / SiteDetailsComponent.COORD_SCALE_MICRO))*SiteDetailsComponent.MINUTES_PER_DEGREE)-Math.floor(((latAbs / SiteDetailsComponent.COORD_SCALE_MICRO)-Math.floor(latAbs / SiteDetailsComponent.COORD_SCALE_MICRO))*SiteDetailsComponent.MINUTES_PER_DEGREE))*SiteDetailsComponent.COORD_FRACTION_SCALE)*SiteDetailsComponent.MINUTES_PER_DEGREE / SiteDetailsComponent.COORD_FRACTION_SCALE)
              let tem1=(Math.floor(((((lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO)-Math.floor(lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO))*SiteDetailsComponent.MINUTES_PER_DEGREE)-Math.floor(((lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO)-Math.floor(lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO))*SiteDetailsComponent.MINUTES_PER_DEGREE))*SiteDetailsComponent.COORD_FRACTION_SCALE)*SiteDetailsComponent.MINUTES_PER_DEGREE / SiteDetailsComponent.COORD_FRACTION_SCALE )
              sum = `${Math.floor(latAbs / SiteDetailsComponent.COORD_SCALE_MICRO) * signlat}Ã‚Â° ${Math.floor(((latAbs / SiteDetailsComponent.COORD_SCALE_MICRO) - Math.floor(latAbs / SiteDetailsComponent.COORD_SCALE_MICRO)) * SiteDetailsComponent.MINUTES_PER_DEGREE)}' ${Math.round(tem * SiteDetailsComponent.DECIMAL_TENTH) / SiteDetailsComponent.DECIMAL_TENTH}"`
              tum = `${Math.floor(lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO) * signlon}Ã‚Â° ${Math.floor(((lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO) - Math.floor(lonAbs / SiteDetailsComponent.COORD_SCALE_MICRO)) * SiteDetailsComponent.MINUTES_PER_DEGREE)}' ${Math.round(tem1 * SiteDetailsComponent.DECIMAL_TENTH) / SiteDetailsComponent.DECIMAL_TENTH}"`
              this.newSiteData[element.accessPointId]['gpslat'] = sum ;
              this.newSiteData[element.accessPointId]['gpslon'] = tum ;
              
              // Also persist formatted GPS coordinates
              this.persistentGpsAddressData[element.accessPointId]['gpslat'] = sum;
              this.persistentGpsAddressData[element.accessPointId]['gpslon'] = tum;
            }
          }
        });
        console.info("mainEntranceVals",this.mainEntranceVals)
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.dispGpsAndStreet(x,page+1,subscribeData,'continue',accessIDs);
        }else if(data['maxPage'] === page){
          this.getGeographicalAdds(accessIDs);
          setTimeout(function(){
              this.dispRaftAlias();
          }.bind(this),SiteDetailsComponent.UI_REFRESH_DELAY_MS);
        }
      }else{
        this.loading = false
      }
    },_error=>{
    });
  }

  getGeographicalAdds(accessIDs,page = 1, subscribeData = []){
    if(accessIDs.length > 0){
      this.AddressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${accessIDs})&_page=${page}`).subscribe(data1 => {
        if(data1['geographical-addresses'].length > 0){
          data1['geographical-addresses'].forEach(element => {
            this.geoRowId.push(element.rowId);
            this.mainEntranceVals.forEach(vals => {
              if(vals['addressEditRowId']==element.rowId){
                if(element['additionalInformation'] === ''){
                  vals['additionalInformation1'] = '';
                  vals['additionalInformation2'] = '';
                }else if(element['additionalInformation'] != ''){
                  const temp = element['additionalInformation'].match(new RegExp(`.{1,${SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH}}`, 'g'));
                  vals['additionalInformation1'] = temp[0];
                  vals['additionalInformation2'] = temp[1];
                }
                vals['streetName'] = element['streetName'];
                vals['postalCode'] = element['postalCode'];
                vals['wayNumber'] = element['wayNumber'];
                vals['territorialDivision'] = element['territorialDivision'];
              }
            });
            console.info("addressIdOnAccessId",this.addressIdOnAccessId)
            if(this.addressIdOnAccessId[element.rowId]?this.addressIdOnAccessId[element.rowId].length >1:false){
              for(let i=0;i<this.addressIdOnAccessId[element.rowId].length;i++){
                this.accessPointAddressData[this.addressIdOnAccessId[element.rowId][i]] = element;
                if(this.accessPointAddressData[this.addressIdOnAccessId[element.rowId][i]]['addressinfo'] === undefined){
                  this.accessPointAddressData[this.addressIdOnAccessId[element.rowId][i]]['addressinfo'] =[];
                  this.accessPointAddressData[this.addressIdOnAccessId[element.rowId][i]]['addressinformation'] =[];
                  }
                 this.accessPointAddressData[this.addressIdOnAccessId[element.rowId][i]]['addressinfo'] = (element.additionalInformation.slice(0, SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH));
                 this.accessPointAddressData[this.addressIdOnAccessId[element.rowId][i]]['addressinformation'] = (element.additionalInformation.slice(SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH, SiteDetailsComponent.ADDRESS_INFO_TOTAL_LENGTH));
                 
                 // Persist detailed address for this accessPointId (multiple case)
                 const accessPointId = this.addressIdOnAccessId[element.rowId][i];
                 if(!this.persistentGpsAddressData[accessPointId]) {
                   this.persistentGpsAddressData[accessPointId] = {};
                 }
                 this.persistentGpsAddressData[accessPointId]['detailedAddress'] = {
                   wayNumber: element.wayNumber,
                   streetName: element.streetName,
                   postalCode: element.postalCode,
                   territorialDivision: element.territorialDivision,
                   addressinfo: this.accessPointAddressData[accessPointId]['addressinfo'],
                   addressinformation: this.accessPointAddressData[accessPointId]['addressinformation']
                 };
                 console.log('🏢 Saved detailed address to localStorage for accessPointId (multiple):', accessPointId);
              }
              this.savePersistentGpsData();
            }else{
              this.accessPointAddressData[this.addressIdOnAccessId[element.rowId]] = element;
              if(this.accessPointAddressData[this.addressIdOnAccessId[element.rowId]]['addressinfo'] === undefined){
                this.accessPointAddressData[this.addressIdOnAccessId[element.rowId]]['addressinfo'] =[];
                this.accessPointAddressData[this.addressIdOnAccessId[element.rowId]]['addressinformation'] =[];
                }
                 this.accessPointAddressData[this.addressIdOnAccessId[element.rowId]]['addressinfo'] = (element.additionalInformation.slice(0, SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH));
                 this.accessPointAddressData[this.addressIdOnAccessId[element.rowId]]['addressinformation'] = (element.additionalInformation.slice(SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH, SiteDetailsComponent.ADDRESS_INFO_TOTAL_LENGTH));
                 
                 // Persist detailed address data to localStorage for each accessPointId
                 const accessPointIds = Array.isArray(this.addressIdOnAccessId[element.rowId]) 
                   ? this.addressIdOnAccessId[element.rowId] 
                   : [this.addressIdOnAccessId[element.rowId]];
                 
                 accessPointIds.forEach(accessPointId => {
                   if(!this.persistentGpsAddressData[accessPointId]) {
                     this.persistentGpsAddressData[accessPointId] = {};
                   }
                   this.persistentGpsAddressData[accessPointId]['detailedAddress'] = {
                     wayNumber: element.wayNumber,
                     streetName: element.streetName,
                     postalCode: element.postalCode,
                     territorialDivision: element.territorialDivision,
                     addressinfo: this.accessPointAddressData[accessPointId]['addressinfo'],
                     addressinformation: this.accessPointAddressData[accessPointId]['addressinformation']
                   };
                   console.log('🏢 Saved detailed address to localStorage for accessPointId (single):', accessPointId);
                 });
                 this.savePersistentGpsData();
                }
            });
          if(data1['maxPage'] > 1 && data1['maxPage'] != page){
            this.getGeographicalAdds(accessIDs,page+1,subscribeData);
          }else if(data1['maxPage'] === page){
            console.info('new address>>',this.accessPointAddressData);

            const temp = [];
            this.newData = [];
            this.mainEntranceVals.forEach(element => {
              if(!element['label']){
                temp.push(element);
              }
            });
            console.info("temp data without label",temp)
            const unique = temp.filter(
              (obj, index) =>
              temp.findIndex((item) => item.addressEditRowId === obj.addressEditRowId && item.addressEditRowIdForGPS === obj.addressEditRowIdForGPS) === index
            );
            console.info("unique address data",unique)
            unique.forEach(element => {
              this.newData.push(element);
            });
            console.info('new main Data>>',this.newData);
          }
        }
      });
    }
  }

  dispRaftAlias(page =1,loop='start',subscribeData=[]){
    if(loop === 'start'){
      this.accessPointIdenRowIds = [];
    }
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointRowId=in(${this.rowIdQua})&_page=${page}`).subscribe(data =>{
      if(data['access-point-identifiers'].length > 0){
        data['access-point-identifiers'].forEach(element1 => {
          if(element1.identifierTypeName === 'HOMOLOGATION NBOP' && element1.sourceSystemName === 'SAER' && element1.accessPointType=='P11'){
            this.orderingACPs[element1.accessPointRowId]=element1;
       }
          if(this.newSiteData[element1.accessPointRowId]){
            if(this.newSiteData[element1.accessPointRowId]['code'] === undefined){
              this.newSiteData[element1.accessPointRowId]['code']= []
            }
          }
          if(element1.identifierTypeName === 'RAFT_CODE'){
            if(this.accessPointOnRaftAlias[element1.accessPointIdentifier] === undefined){
              this.accessPointOnRaftAlias[element1.accessPointIdentifier] = [];
            }
            this.accessPointOnRaftAlias[element1.accessPointIdentifier] = element1;
          }
          if(this.accessPointIdenRowIds[element1.accessPointIdentifier] === undefined){
            this.accessPointIdenRowIds[element1.accessPointIdentifier] = [];
          }
          this.accessPointIdenRowIds[element1.accessPointIdentifier].push(element1.rowId);
          if(this.newSiteData[element1.accessPointRowId]){
            if(element1.identifierTypeName === 'RAFT_CODE'){
              if(this.newSiteData[element1.accessPointRowId]['raft_alias'] === undefined){
                this.newSiteData[element1.accessPointRowId]['raft_alias']= []
              }
              this.newSiteData[element1.accessPointRowId]['raft_alias'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['editRowIdRaftAlias'] = element1.rowId;
              this.newSiteData[element1.accessPointRowId]['endDate'] = element1.endDate;
            }
            if(element1.identifierTypeName === 'SAER_CODE' && element1.accessPointType === 'P11'){
              if(this.newSiteData[element1.accessPointRowId]['saer_code'] === undefined){
                this.newSiteData[element1.accessPointRowId]['saer_code']= []
              }
              this.newSiteData[element1.accessPointRowId]['saer_code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['edit_saer_code'] = element1.rowId;
              this.newSiteData[element1.accessPointRowId]['endDate'] = element1.endDate;
            }
            if(element1.identifierTypeName === 'AP_LATAM_CODE' && element1.accessPointType === 'P11' && element1.sourceSystemName === 'LATAM'){
              if(this.newSiteData[element1.accessPointRowId]['latam_code'] === undefined){
                this.newSiteData[element1.accessPointRowId]['latam_code']= []
              }
              this.newSiteData[element1.accessPointRowId]['latam_code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['edit_latam_code'] = element1.rowId;
              this.newSiteData[element1.accessPointRowId]['endDate'] = element1.endDate;
            }
            if(element1.identifierTypeName === 'AP_RNAIPL_CODE' && element1.accessPointType === 'P11'){
              if(this.newSiteData[element1.accessPointRowId]['rnaipl_code'] === undefined){
                this.newSiteData[element1.accessPointRowId]['rnaipl_code']= []
              }
              this.newSiteData[element1.accessPointRowId]['rnaipl_code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['edit_rnaipl_code'] = element1.rowId;
              this.newSiteData[element1.accessPointRowId]['endDate'] = element1.endDate;
            }
            if(this.newSiteData[element1.accessPointRowId]['code'].length>1){
              const codeTypes = ['raft_alias', 'saer_code', 'latam_code', 'rnaipl_code', 'c2b_code'];
              let presentTypes = 0;
              codeTypes.forEach(type => {
                if (Array.isArray(this.newSiteData[element1.accessPointRowId][type]) && this.newSiteData[element1.accessPointRowId][type].length > 0) {
                  presentTypes++;
                }
              });
              if (presentTypes > 1) {
                this.newSiteData[element1.accessPointRowId]['multiplecode'] = true;
                this.mutiplecodes = true;
              } else {
                this.newSiteData[element1.accessPointRowId]['multiplecode'] = false;
              }
            }
          
            
            if(element1.identifierTypeName === 'SOCIAL_RAISON'){
              if(this.newSiteData[element1.accessPointRowId]['raft_name'] === undefined){
                this.newSiteData[element1.accessPointRowId]['raft_name']= []
              }
              this.newSiteData[element1.accessPointRowId]['raft_name'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['editRowIdRaftName']= element1.rowId;
            }

            if(element1.identifierTypeName === 'SOCIAL_RAISON'){
              if(this.newSiteData[element1.accessPointRowId]['latam_name'] === undefined){
                this.newSiteData[element1.accessPointRowId]['latam_name']= []
              }
              this.newSiteData[element1.accessPointRowId]['latam_name'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['editRowIdLatamName']= element1.rowId;
            }

            if(element1.identifierTypeName === 'SOCIAL_RAISON'){
              if(this.newSiteData[element1.accessPointRowId]['rnaipl_name'] === undefined){
                this.newSiteData[element1.accessPointRowId]['rnaipl_name']= []
              }
              this.newSiteData[element1.accessPointRowId]['rnaipl_name'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['editRowIdRnaiplName']= element1.rowId;
            }

            if(element1.identifierTypeName === 'AP_C2B_CODE'){
              if(this.newSiteData[element1.accessPointRowId]['c2b_code'] === undefined){
                this.newSiteData[element1.accessPointRowId]['c2b_code']= []
              }
              this.newSiteData[element1.accessPointRowId]['c2b_code'].push(element1.identifierValue);
              this.newSiteData[element1.accessPointRowId]['edit_c2b_code']= element1.rowId;
            }
            if(element1.identifierTypeName === 'ASUSI_CODE'){
              if(this.newSiteData[element1.accessPointRowId]['raft_value'] === undefined){
                this.newSiteData[element1.accessPointRowId]['raft_value']= [];
                this.newSiteData[element1.accessPointRowId]['editNissan_raft_value'] = [];
              }
              this.newSiteData[element1.accessPointRowId]['raft_value'].push(element1.identifierValue.split("#"));
              this.newSiteData[element1.accessPointRowId]['editNissan_raft_value'].push(element1.rowId);
            }
          }
        });
        if(data['maxPage'] > page && data['maxPage'] != page){
          this.dispRaftAlias(page+1,'continue',subscribeData);
        }else if(data['maxPage'] === page){
          if(loop != 'stop'){
          setTimeout( function(){
              this.sortData('exist')
            }.bind(this), SiteDetailsComponent.SHORT_DELAY_MS);
          }
          console.info('raft on access',this.accessPointOnRaftAlias);
        }
      }else{
        if(loop != 'stop'){
        setTimeout( function(){
            this.sortData('exist')
          }.bind(this), SiteDetailsComponent.SHORT_DELAY_MS);
        }
      }
    });
  }

  sortData(val){
    if(val === 'exist'){
      console.log('🔍 sortData called. persistentGpsAddressData keys:', Object.keys(this.persistentGpsAddressData));
      // Don't clear newSiteData - we need it to preserve GPS/address data for archived qualifiers
      this.sitesData = [];
      this.allQualifierAccordion = [];
      this.sortedQualifierArray.forEach( (element : any) =>{
        console.info("this.sortedSitesData[element]",this.sortedSitesData[element])
        if(this.sortedSitesData[element]){
          for(let i =0;i<this.sortedSitesData['count'];i++){
            if(this.sortedSitesData[element][i] != undefined){
              // Preserve GPS and address data
              const rowId = this.sortedSitesData[element][i].rowId;
              const identifier = this.sortedSitesData[element][i].identifier;
              const status = this.sortedSitesData[element][i].status;
              console.log(`🔍 Processing qualifier: rowId=${rowId}, identifier=${identifier}, status=${status}`);
              console.log(`   newSiteData[${rowId}]:`, this.newSiteData[rowId]);
              
              // Copy data from newSiteData if available
              if(this.newSiteData[rowId]){
                // Copy address data if available
                if(this.newSiteData[rowId]['street']) this.sortedSitesData[element][i]['street'] = this.newSiteData[rowId]['street'];
                if(this.newSiteData[rowId]['addressEditRowId']) this.sortedSitesData[element][i]['addressEditRowId'] = this.newSiteData[rowId]['addressEditRowId'];
                if(this.newSiteData[rowId]['postalSummary']) this.sortedSitesData[element][i]['postalSummary'] = this.newSiteData[rowId]['postalSummary'];
                
                // Copy GPS from newSiteData if it has valid GPS coordinates
                if(this.newSiteData[rowId]['gpslatdec'] && this.newSiteData[rowId]['gpslondec']){
                  console.log('✅ Copying GPS from newSiteData for rowId:', rowId, {
                    gpslatdec: this.newSiteData[rowId]['gpslatdec'],
                    gpslondec: this.newSiteData[rowId]['gpslondec']
                  });
                  this.sortedSitesData[element][i]['gpslatdec'] = this.newSiteData[rowId]['gpslatdec'];
                  this.sortedSitesData[element][i]['gpslondec'] = this.newSiteData[rowId]['gpslondec'];
                  if(this.newSiteData[rowId]['gpslat']) this.sortedSitesData[element][i]['gpslat'] = this.newSiteData[rowId]['gpslat'];
                  if(this.newSiteData[rowId]['gpslon']) this.sortedSitesData[element][i]['gpslon'] = this.newSiteData[rowId]['gpslon'];
                  if(this.newSiteData[rowId]['gpsEditRowId']) this.sortedSitesData[element][i]['gpsEditRowId'] = this.newSiteData[rowId]['gpsEditRowId'];
                }
              }
              
              // Restore missing data from localStorage (for archived qualifiers)
              if(this.persistentGpsAddressData[rowId]){
                console.log('📦 Available data in localStorage for rowId:', rowId, this.persistentGpsAddressData[rowId]);
                console.log('   accessPointAddressData[rowId] before restoration:', this.accessPointAddressData[rowId]);
                
                // Restore detailed address data if available
                if(!this.accessPointAddressData[rowId] && this.persistentGpsAddressData[rowId]['detailedAddress']){
                  console.log('🏢 Restoring detailed address from persistent storage for rowId:', rowId);
                  this.accessPointAddressData[rowId] = this.persistentGpsAddressData[rowId]['detailedAddress'];
                  console.log('   accessPointAddressData[rowId] after restoration:', this.accessPointAddressData[rowId]);
                }
                
                // Restore GPS if missing
                if(!this.sortedSitesData[element][i]['gpslatdec']){
                  console.log('🔄 Restoring GPS from persistent storage for rowId:', rowId);
                  if(this.persistentGpsAddressData[rowId]['gpslatdec']) this.sortedSitesData[element][i]['gpslatdec'] = this.persistentGpsAddressData[rowId]['gpslatdec'];
                  if(this.persistentGpsAddressData[rowId]['gpslondec']) this.sortedSitesData[element][i]['gpslondec'] = this.persistentGpsAddressData[rowId]['gpslondec'];
                  if(this.persistentGpsAddressData[rowId]['gpslat']) this.sortedSitesData[element][i]['gpslat'] = this.persistentGpsAddressData[rowId]['gpslat'];
                  if(this.persistentGpsAddressData[rowId]['gpslon']) this.sortedSitesData[element][i]['gpslon'] = this.persistentGpsAddressData[rowId]['gpslon'];
                  if(this.persistentGpsAddressData[rowId]['gpsEditRowId']) this.sortedSitesData[element][i]['gpsEditRowId'] = this.persistentGpsAddressData[rowId]['gpsEditRowId'];
                }
                // Restore address data if missing
                if(!this.sortedSitesData[element][i]['street']){
                  console.log('🔄 Restoring address from persistent storage for rowId:', rowId);
                  if(this.persistentGpsAddressData[rowId]['street']) {
                    this.sortedSitesData[element][i]['street'] = this.persistentGpsAddressData[rowId]['street'];
                    console.log('✅ Restored street:', this.persistentGpsAddressData[rowId]['street']);
                  } else {
                    console.log('❌ No street data in localStorage for rowId:', rowId);
                  }
                  if(this.persistentGpsAddressData[rowId]['addressEditRowId']) this.sortedSitesData[element][i]['addressEditRowId'] = this.persistentGpsAddressData[rowId]['addressEditRowId'];
                }
                // Restore postal summary if missing
                if(!this.sortedSitesData[element][i]['postalSummary']){
                  if(this.persistentGpsAddressData[rowId]['postalSummary']) {
                    this.sortedSitesData[element][i]['postalSummary'] = this.persistentGpsAddressData[rowId]['postalSummary'];
                    console.log('✅ Restored postalSummary');
                  }
                }
              }
              
              this.sitesData.push(this.sortedSitesData[element][i]);
            }
          }
        };
      });
      this.qualifierNo = this.sitesData.length.toString();
      for(let i =0; i < parseInt(this.qualifierNo) ; i++){
        this.allQualifierAccordion.push(`#collapsible${i}`);
      }
      this.showCount = true;
      this.loading =false;
      
      // Log final GPS status for each qualifier
      console.log('📍 Final GPS Status:');
      this.sitesData.forEach((site, idx) => {
        console.log(`  ${idx}. ${site.type} (${site.status}): GPS=${site.gpslatdec ? site.gpslatdec + ', ' + site.gpslondec : 'MISSING'}`);
      });
      
       if (this.sitesData && Array.isArray(this.sitesData)) {
              this.sitesData.forEach(site => {
                if (site.type === 'Manufacturing') {
                  this.showAssociatedPicking(site.type,site.identifier,site.rowId,site.status,true);

                }
              });
            }
      console.info('%c Qualifier Data>>>>', "color : aqua;font-weight:bold",this.sitesData);

    }
    else{

    }
  }

loadMaterialGrpHomologation(site, loop='start', page = 1){
this.ACPdataForMaterialGroup=[];
this.dataForMaterialGroup=[];

  if(loop=='start'){
    this.selectedSaerCode=site.saer_code
    this.selectedLabel=site.label
    this.selectedIdentifier=site.identifier
    this.selectedRow = site.rowId

  }
  this.MaterialGroupLoading=true;

this.PurchasingApi.getQualifiersById(this.selectedIdentifier,'HOMOLOGATION NBOP',page).subscribe(data=>{
 data['access-point-identifiers'].forEach(x=>{
  const id= x.identifierValue.split('#')[0];
  this.ACPdataForMaterialGroup[id]=x;
  this.ACPdataForMaterialGroup[id]['saerCode']=this.selectedSaerCode;
  this.ACPdataForMaterialGroup[id]['activity']=x.identifierValue.split('#')[1];
  this.ACPdataForMaterialGroup[id]['id']=x.identifierValue.split('#')[0];
  this.ACPdataForMaterialGroup[id]['status']=(x.endDate != null && x.endDate != "")? 'ARCHIVED' : (x.effectiveDate <= this.apiService.getTodayDate()? 'ACTIVE':'PENDING')
});
 let identifiers:any= data['access-point-identifiers'].map(x=>x.identifierValue.split('#')).map(x=>x[0].toString())
 identifiers= identifiers.map(x => `'${x}'`).toString()

 this.PurchasingApi.getMaterialGroupHomologation(identifiers,page,SiteDetailsComponent.STANDARD_PAGE_SIZE).subscribe(mGroups=>{
  if (mGroups[ "commodity-perimeters" ]) {
    this.dataForMaterialGroup.push.apply(this.dataForMaterialGroup, mGroups[ "commodity-perimeters" ]);
    this.MaterialGroupLoading = false;

    this.pageAllinfos['totalItems'] = data['count'];
    this.pageAllinfos['currentPage'] = page;
    this.pageAllinfos['pageSize'] = data['pageCount'];
    this.pageAllinfos['totalPages'] = data['maxPage'];
   
    this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'],SiteDetailsComponent.TWENTY);

    console.info('pager',this.pager)
    this.PageTotalLength = this.pageAllinfos['totalItems'];
   
  }
}, () => {
  this.MaterialGroupLoading = false;
})
}, () => {
  this.MaterialGroupLoading = false;
})
}

  saveCurQualifier(curStatus,rowId,label,raftCode,saerCode,saerRaftId){
    this.qualifierAliasStatusModelvalUp = '';
    this.qualiferAliasAccessPRowid = rowId;
    this.qualifierNameModelError = false;
    this.qualifierNameEdit = label;
    this.qualifierOption = [];
    this.currentStatus = curStatus;
    this.editRaftAliasModel = raftCode;
    this.qualifierNameModelRegExError = false;
    this.disableEditQuaNameBtn = false;
    this.disableEditQuaSiteStatusBtn = false;
    this.editsaerAliasModel = saerCode;
    this.saerRowIdVar = saerRaftId;
    if(curStatus != ''){
      if(curStatus === 'active'){
        this.qualifierOption.push('PENDING','ARCHIVED');
      }
      if(curStatus === 'pending'){
        this.qualifierOption.push('ARCHIVED');
      }
      if(curStatus === 'archived'){
        this.qualifierOption.push('PENDING');
      }
      if(curStatus === 'greenfield' || curStatus === 'created'){
        this.qualifierOption = [];
      }
    }
  }

  updateQualifierStatus(){
    if(this.currentStatus != 'archived'){
      if(this.qualifierAliasStatusModelvalUp != '' && this.qualifierAliasStatusModelvalUp != undefined) {
        this.disableEditQuaSiteStatusBtn = true;
        this.saveDatas = "Save...";
        this.qualifierAliasStatusModelError=false;
        let datas = {};
        if(this.qualifierAliasStatusModelvalUp.toUpperCase() === 'ARCHIVED'){
          datas = { "activeStatus" : this.qualifierAliasStatusModelvalUp , "endDate" : this.apiService.getTodayDate()};
          this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${this.editRaftAliasModel}&identifierTypeName=RAFT_CODE`).subscribe(data1 => {
            if(data1['access-point-identifiers'].length > 0){
              const accessPointsArr = [];
              const accessPointsOri = [];
              let accessPointIdens:any=[];
              data1['access-point-identifiers'].forEach(element => {
                if(accessPointsArr.indexOf(`'${element.accessPointIdentifier}'`) === -1){
                  accessPointsArr.push(`'${element.accessPointIdentifier}'`);
                }
                if(accessPointsOri.indexOf(element.accessPointIdentifier) === -1){
                  accessPointsOri.push(element.accessPointIdentifier);
                }
                accessPointIdens[element.accessPointIdentifier] = element;
              });
              if(accessPointsArr.length > 0){
                const archiveIds = [];
                let activeExist = false;
                this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?identifier=in(${accessPointsArr})`).subscribe(data2 => {
                  if(data2['access-points'].length > 0){
                    data2['access-points'].forEach(ele => {
                      if(ele.activeStatus === 'ARCHIVED'){
                        archiveIds.push(ele.identifier);
                      }else{
                        activeExist = true;
                      }
                    });
                  }
                  if(activeExist === false){
                    const updateEnd = {endDate : this.apiService.getTodayDate()}
                    accessPointsOri.forEach(element1 => {
                      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${accessPointIdens[element1].rowId}`,updateEnd).subscribe(() => {

                      });
                    })
                  }
                });
              }
            }
          });
          this.archiveSaer('reload')
        }else if(this.qualifierAliasStatusModelvalUp === 'ACTIVE' || this.qualifierAliasStatusModelvalUp === 'PENDING'){
          datas = { "activeStatus" : this.qualifierAliasStatusModelvalUp , "endDate" : ""};
          // this.sitesService.getAccessPointIdentifiers(this.Config.ApiSitesUrl + 'access-point-identifiers?accessPointRowId=' + this.qualiferAliasAccessPRowid + '&identifierTypeName=RAFT_CODE').subscribe(data1 => {
          //   data1['access-point-identifiers'].forEach(rowid => {
          //     this.sitesService.updateAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers/'+ rowid.rowId,datas).subscribe(dataA => {})
          //   })
          // })
          this.unarchiveSaer('reload')
        }else{
          datas = { "activeStatus" : this.qualifierAliasStatusModelvalUp};
        }
        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.qualiferAliasAccessPRowid}`, datas).subscribe(() => {
          window.document.getElementById("closeQASBtn").click();
          this.saveDatas = "Save";
          this.dispQualifiers('reload');
        },error => {
          this.saveDatas = "Save";
          console.info('error in Updating, try again',error)
        });
      }else {
        this.qualifierAliasStatusModelError=true;
      }
    }
    else {
      if(this.qualifierAliasStatusModelvalUp != '' && this.qualifierAliasStatusModelvalUp != undefined && this.currentStatus === 'archived') {
        this.saveDatas = "Save...";
        this.disableEditQuaSiteStatusBtn = true;
        this.qualifierAliasStatusModelError=false;
        const datas = { "activeStatus" : "ACTIVE"};
        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.qualiferAliasAccessPRowid}`, datas).subscribe(() => {
          this.currentStatus = '';
          this.qualifierOption = [];
          this.qualifierOption.push('PENDING');
          setTimeout( function(){
            this.updateQualifierStatus();
          }.bind(this),SiteDetailsComponent.SHORT_DELAY_MS)
          this.qualifierAliasStatusModelvalUp = 'PENDING';
        });
      }
    }
  }

  getAccessPointByIdens(accessPointsArr,accessPointsOri,accessPointIdens,page=1,_loop='start',archiveIds=[],activeExist=false){
    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?identifier=in(${accessPointsArr})`).subscribe(data2 => {
      if(data2['access-points'].length > 0){
        data2['access-points'].forEach(ele => {
          if(ele.activeStatus === 'ARCHIVED'){
            archiveIds.push(ele.identifier);
          }else{
            activeExist = true;
          }
        });
        if(data2['maxPage'] > 1 && data2['maxPage'] != page){
          this.getAccessPointByIdens(accessPointsArr,accessPointsOri,accessPointIdens,page+1,'continue',archiveIds,activeExist);
        }
      }
      if(activeExist === false && data2['maxPage'] === page){
        const updateEnd = {endDate : this.apiService.getTodayDate()}
        accessPointsOri.forEach(element1 => {
          this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${accessPointIdens[element1].rowId}`,updateEnd).subscribe(() => {

          });
        })
      }
    });
  }

  setDropdownValues(){
    this.showC2BFields = false;
    this.latamswitch = false;
    this.saerswitch = false;
    this.rnaiplswitch = false;
    if(this.mainEntranceExists === true){
      if(this.noSiteAssn === false){
        document.getElementById('btnForDispAddQualifier').click();
        this.qualiferSiteNameModelUp = this.mainEntranceVals[0]['label'];
        this.qualiferSiteStreetModelUp = '';
        this.qualiferSiteAdditionalAddressInfoModelUp = '';
        this.AddNewAddress = false;
        const tempNewAddBtn = document.getElementById('AddNewAddressRadio') as HTMLInputElement;
        tempNewAddBtn.checked = false;
        if(this.newData.length==1){
          if(this.newData[0].addressEditRowIdForGPS!=undefined){
          const tempOldBtns = document.getElementById('addressRadiovalBtn[0]') as HTMLInputElement;
          tempOldBtns.checked = true;
          this.addressRadioval = this.newData[0].addressEditRowIdForGPS;
          }else if(this.newData[0].addressEditRowId!=undefined){
            const tempOldBtns = document.getElementById('addressRadiovalBtn[0]') as HTMLInputElement;
            tempOldBtns.checked = true;
            this.addressRadioval = this.newData[0].addressEditRowId;
          }
        }else{
          for(let index=0;index<this.newData.length;index++){
            const tempOldBtns = document.getElementById(`addressRadiovalBtn[${index}]`) as HTMLInputElement;
            tempOldBtns.checked = false;
          }
          this.addressRadioval = '';
        }
        this.qualiferSiteAdditionalAddress = '';
        this.qualiferSiteAdditionalAddressInfo = '';
        this.postalCodeModel = '';
        this.gpsValueModelLat = '';
        this.gpsValueModelLon = '';
        this.territorialDivModelQualifierEdit = '';
        this.wayNumberModelQualifierEdit = '';
        this.wayNumberModelQualifierEditRegExError = false;
        this.qualiferSiteStreetModelUpRegExError = false;
        this.qualiferSiteAdditionalAddressRegExError = false;
        this.qualiferSiteAdditionalAddressInfoRegExError = false;
        this.postalCodeModelRegExError = false;
        this.territorialDivModelQualifierEditRegExError = false;
      }else{
        document.getElementById('btnForWarningAddQualifier').click();
      }
    }else{
      this.getAllGeoAddresses();
      document.getElementById('btnForNoMainEntranceACP').click();
      this.qualiferSiteAdditionalAddressInfoModelUp = '';
      this.qualiferSiteStreetModelUp = '';
      this.postalCodeModel = '';
      this.qualiferSiteNameModelUp = '';
    }
    this.disableAddQualifierToSite = false;
    this.qualiferSiteTypeModelErrorUp = false;
    this.qualiferSiteStreetModelErrorUp = false;
    this.selectedQualifierVal = '';
    this.saveDatas = 'Save';
    this.showSearCode = false;
    this.showLatamCode = false;
    this.showRnaiplCode = false;
    this.showRaftValidate =false;
    this.showLatamValidate =false;
    this.showSaerValidate =false;
    this.validationSuccess = false;
    this.saerCodeModel = '';
    this.latamCodeModel = '';
    this.rnaiplCodeModel = '';
    this.saerNameModel = '';
    this.c2bNameModel = '';
    this.latamNameModel = '';
    this.rnaiplNameModel = '';
    this.saerCodeModelError = false;
    this.latamCodeModelError = false;
    this.rnaiplCodeModelError = false;
    this.showSearCodeSwitch = false;
    this.showLatamCodeSwitch = false
    this.showRnaiplCodeSwitch = false;
    this.radioNotChecked = false;
    this.saerNotUniqueError=false;
  }

  upresetAddQualifierSiteFields(as){
    this[as] = '';
    const exo = this.regExObjForAddressAdd[as];
    if(exo != undefined){
      this[exo] = false;
    }
  }
  

  /**START add address regex check */
  checkForRegExAddressAdd(_event,expression,model){
    const regEx =  new RegExp('^[A-Z0-9 \(\)\-\.]*$');
    const newRegex = new RegExp(`.{1,${SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH}}`, 'g');
    if(/^\s/.test(expression)){
      this[model] = expression.trimStart();
      return false;
    }
    this[model] = expression.replace(/(\r\n|\n|\r)/gm," ");
    const modelsVal = this.regExObjForAddressAdd[model];
    if(expression.length > 0){

      if(!expression.match(/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/gm)){

        this[modelsVal] = true;
      }else{
        const temp = expression.match(newRegex);
        if(temp.length > 1){
          for(let i =0;i< temp.length-1;i++){
            temp[i] = `${temp[i]}\n`
          }
          this[model] = temp.join("");
        }
        this[modelsVal] = false;
      }
    }else{
      this[modelsVal] = false;
    }
  }

  qualifierTypeChange(){
    this.showC2BFields = false;
    console.info('selectedQualifierVal',this.selectedQualifierVal)

    var c = this.selectedQualifierVal;

    if(c=='P11'){
      this.showSearCodeSwitch = true;
      this.showLatamCodeSwitch = true;
      this.showRnaiplCodeSwitch = true;
      this.saerCodeModel = '';
      this.saerNameModel = '';
      this.rnaiplCodeModel = '';
      this.rnaiplNameModel = '';
      this.c2bNameModel = '';
      this.saerCodeModelError = false;
      this.latamCodeModelError = false;
      this.rnaiplCodeModelError = false;
      this.saerNotUniqueError=false;
      this.saerswitch = false;
      this.latamswitch = false;
      this.rnaiplswitch = false;
    }else{
      this.showSearCodeSwitch = false;
      this.showLatamCodeSwitch = false;
      this.showRnaiplCodeSwitch = false;
      this.showSearCode = false;
      this.showLatamCode = false;
      this.showRnaiplCode = false;
      this.saerswitch = false;
      this.latamswitch = false;
      this.rnaiplswitch = false;
    }
  }

  AddQualifierDetails() { 
    this.saerNotUniqueError =false;

    var c=this.selectedQualifierVal;
    if(c === 'B2b'){
      c = 'P18'
    }
    if (this.showForSupplier === false && c === 'P13') {
      this.qualiferSiteTypeModelErrorUp = true;
      return;
    }
    let temporaryAddress=[];
    if(this.AddNewAddress==false && this.addressRadioval!='' && this.addressRadioval!=undefined){
      console.info("radio checked",this.addressRadioval)
      this.radioNotChecked = false;
      this.newData.forEach(element => {
        console.info("element",element)
        if(element.addressEditRowIdForGPS==this.addressRadioval || element.addressEditRowId==this.addressRadioval){
          temporaryAddress=element;
        }
      });

      this.qualiferSiteStreetModelUp = temporaryAddress['streetName'];
      if(temporaryAddress['additionalInformation1']){
        this.qualiferSiteAdditionalAddress = temporaryAddress['additionalInformation1'];
      }else{
        this.qualiferSiteAdditionalAddress = '';
      }
      if(temporaryAddress['additionalInformation2']){
        this.qualiferSiteAdditionalAddressInfo = temporaryAddress['additionalInformation2'];
      }else{
        this.qualiferSiteAdditionalAddressInfo = '';
      }
      this.postalCodeModel = temporaryAddress['postalCode'];
      this.gpsValueModelLat = temporaryAddress['gpsDataLat'];
      this.gpsValueModelLon = temporaryAddress['gpsDataLon'];
      this.territorialDivModelQualifierEdit = temporaryAddress['territorialDivision'];
      this.wayNumberModelQualifierEdit = temporaryAddress['wayNumber'];
      this.currentAddressId = temporaryAddress['addressEditRowId'];
      this.currentGpsAddressId = temporaryAddress['addressEditRowIdForGPS'];
      this.wayNumberModelQualifierEditRegExError = false;
      this.qualiferSiteStreetModelUpRegExError = false;
      this.qualiferSiteAdditionalAddressRegExError = false;
      this.qualiferSiteAdditionalAddressInfoRegExError = false;
      this.postalCodeModelRegExError = false;
      this.territorialDivModelQualifierEditRegExError = false;
    }else{
      this.currentAddressId='';
      this.currentGpsAddressId='';
    }
    const temp = this.qualiferSiteAdditionalAddress;
    if(temp.length <= SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH){   
      for (let i =temp.length; i < SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH; i++){
        this.qualiferSiteAdditionalAddress =  `${this.qualiferSiteAdditionalAddress} `;
      }
    }
    let str1 =  this.qualiferSiteAdditionalAddress;
    let str2 = this.qualiferSiteAdditionalAddressInfo;
    this.qualiferSiteAdditionalAddressInfoModelUp= `${str1}${str2}`;
    let saerCheckDone = false;
    let latamCheckDone = false;
    let rnaiplCheckDone = false;
    const saerCode = this.saerCodeModel.trim();
    const latamCode = this.latamCodeModel.trim();
    const rnaiplCode = this.rnaiplCodeModel.trim();
    const regExNum = new RegExp('^[0-9]+$');
    const regExAlphaNum = new RegExp('^[A-Za-z0-9]+$');
    const saerCodeSyntax = regExNum.test(saerCode);
    const latamCodeSyntax = regExNum.test(latamCode);
    const rnaiplCodeSyntax = regExAlphaNum.test(rnaiplCode);
    this.saerNotUniqueError =false;
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&identifierValue=${this.saerCodeModel}` ).subscribe( data => {
    if(this.saerCodeModel!=''){
      if(data['access-point-identifiers'].length>0){
        this.saerNotUniqueError =true
      }else{
        this.saerNotUniqueError =false;
      }
    }

    if(saerCode != '' && saerCode.length === SiteDetailsComponent.SAER_CODE_LENGTH && saerCodeSyntax === true && this.showSearCodeSwitch === true && this.showSearCode === true &&this.saerNotUniqueError === false){
      saerCheckDone = true;
    }else if(this.showSearCodeSwitch === false || this.showSearCode === false){
      saerCheckDone = true;
    }

    if(latamCode != '' && latamCode.length <= SiteDetailsComponent.LATAM_CODE_MAX_LENGTH && latamCodeSyntax === true && this.showLatamCodeSwitch === true && this.showLatamCode === true){
      latamCheckDone = true;
    }else if(this.showLatamCodeSwitch === false || this.showLatamCode === false){
      latamCheckDone = true;
    }
    if(rnaiplCode != '' &&
      rnaiplCode.length >= SiteDetailsComponent.RNAIPL_CODE_MIN_LENGTH &&
      rnaiplCode.length <= SiteDetailsComponent.RNAIPL_CODE_MAX_LENGTH &&
      rnaiplCodeSyntax === true &&
      this.showRnaiplCodeSwitch === true &&
      this.showRnaiplCode === true){
      rnaiplCheckDone = true;
    }else if(this.showRnaiplCodeSwitch === false || this.showRnaiplCode === false){
      rnaiplCheckDone = true;
    }
    if(c != '' &&
    c != undefined &&
    this.qualiferSiteStreetModelUp != '' &&
    this.qualiferSiteStreetModelUp != undefined &&
    saerCheckDone === true &&
    latamCheckDone === true &&
    rnaiplCheckDone === true &&
    this.saerNotUniqueError === false &&
    this.wayNumberModelQualifierEditRegExError==false &&
    this.qualiferSiteStreetModelUpRegExError === false &&
    this.qualiferSiteAdditionalAddressRegExError === false &&
    this.qualiferSiteAdditionalAddressInfoRegExError === false &&
    this.postalCodeModelRegExError === false &&
    this.territorialDivModelQualifierEditRegExError === false){
      this.validationSuccess = true;
      this.acpMainCreation = this.loadingSteps;
      this.acpAddressCreation = this.loadingSteps;
      this.gpsCreation = this.loadingSteps;
      this.finalAcpCreated = this.loadingSteps;
      document.getElementById('showAddQuaSteps').click();
      const date = new Date();
      this.saveDatas = "Save...";
      this.disableAddQualifierToSite = true;
      var status = 'PENDING';
      if(c === 'P14' || (this.showSearCodeSwitch === true && this.showSearCode === true)){
        status = 'ACTIVE'
      }
      this.qualiferSiteTypeModelErrorUp = false;
      this.qualiferSiteStreetModelErrorUp = false;
      this.radioNotChecked = false;
      if(c === 'P11' && (this.showSearCodeSwitch === true && this.saerCodeModel != '' && this.saerNameModel != '')){
        status = 'ACTIVE';
      } else if(c === 'P11' && (this.showLatamCodeSwitch === true && this.latamCodeModel != '' && this.latamNameModel != '')){
        status = 'ACTIVE';
      } else if(c === 'P11' && (this.showRnaiplCodeSwitch === true && this.rnaiplCodeModel != '' && this.rnaiplNameModel != '')){
        status = 'ACTIVE';
      }
      else{
        status = 'PENDING';
      }
      const siteDatas =
      {
        activeStatus      : status,
        realEstateAssetId : this.siteId,
        label             : this.qualiferSiteNameModelUp,
        type              : c,
        effectiveDate     : this.apiService.getTodayDate(),
        irnAuthor         : 'IRN-71016',
        siaAuthor         : 'IAF',
        activity          : 'A10'
      };
      this.sitesService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, siteDatas).subscribe((dataSite:any) => {
        var access_point_row_id = dataSite['rowId'];
        this.acpMainCreation = this.successSteps;
        const geoADatas =
        {
          additionalInformation:this.qualiferSiteAdditionalAddressInfoModelUp,
          streetName:this.qualiferSiteStreetModelUp,
          cityName:this.siteCity,
          cityId : this.allSiteData['cityId'],
          countryName:this.siteCountry,
          postalCode:this.postalCodeModel,
          wayNumber:this.wayNumberModelQualifierEdit,
          territorialDivision:this.territorialDivModelQualifierEdit
        };
        if(this.currentAddressId != ''){
          const accessPointDatas = {accessPointId:access_point_row_id, addressId: this.currentAddressId};
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
            this.acpAddressCreation = this.successSteps;
            this.loading=true;
            window.document.getElementById("closeQSBtn").click();
            this.finalAcpCreated = this.successSteps;
            this.getRowIdForQua('reload');
          },error => {
            this.finalAcpCreated = this.successSteps;
            this.getRowIdForQua('reload');
            window.document.getElementById("closeQSBtn").click();
            this.acpAddressCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
          });
        }else{
          this.AddressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA:any) => {
            var geo_adress_row_id = dataGeoA['rowId'];
            this.acpAddressCreation = this.successSteps;
            const accessPointDatas = {accessPointId:access_point_row_id, addressId: geo_adress_row_id};
            this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
              this.loading=true;
              this.finalAcpCreated = this.successSteps;
              window.document.getElementById("closeQSBtn").click();
              this.getRowIdForQua('reload');
            },error => {
              this.getRowIdForQua('reload');
              window.document.getElementById("closeQSBtn").click();
              this.finalAcpCreated = this.successSteps;
              this.acpAddressCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
            });
          },error => {
            this.getRowIdForQua('reload');
            window.document.getElementById("closeQSBtn").click();
            this.finalAcpCreated = this.successSteps;
            this.acpAddressCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
          });
        }

        if(this.gpsValueModelLat != '' && this.gpsValueModelLat != undefined && this.gpsValueModelLon != '' && this.gpsValueModelLon != undefined){
          if(this.currentGpsAddressId != ''){
            const accessPointDatas = {accessPointId:access_point_row_id, addressId:this.currentGpsAddressId};
            this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
              this.gpsCreation = this.successSteps;
                setTimeout(function (){
                  document.getElementById('closeShowAddQualifierSteps').click();
                }.bind(this),SiteDetailsComponent.CLOSE_MODAL_DELAY_MS)
            },error => {
              this.gpsCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
            });
          }else{
            const gpsDatas = { 'accessPointId' : access_point_row_id, 'latitude' : this.gpsValueModelLat,'longitude' : this.gpsValueModelLon.toString()}
            this.AddressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA:any) => {
            var geo_adress_row_id2 = dataGeoA['rowId'];
              const accessPointDatas = {accessPointId:access_point_row_id, addressId:geo_adress_row_id2};
              this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
                this.gpsCreation = this.successSteps;
                setTimeout(function (){
                  document.getElementById('closeShowAddQualifierSteps').click();
                }.bind(this),SiteDetailsComponent.CLOSE_MODAL_DELAY_MS)
              },error => {
                this.gpsCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
              });
            },error => {
              this.gpsCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
            });
          }
        }else{
          this.gpsCreation = `${this.dangerSteps}No GPS value Exist${this.endSpanSteps}`;
          setTimeout(function (){
            document.getElementById('closeShowAddQualifierSteps').click();
          }.bind(this),SiteDetailsComponent.CLOSE_MODAL_DELAY_MS)
        }
        this.saveDatas = "Save";
        this.showCount = false;

        if(this.showSearCodeSwitch === true && this.showSearCode === true){
          const siteDatasSaerCode =
          {
            identifierId:this.siteIdentTypesData['SAER_CODE'],
            sourceSystemId:this.siteSourceSystems['SAER'],
            accessPointRowId: access_point_row_id,
            identifierValue:this.saerCodeModel,
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasSaerCode).subscribe(() => { });
        }
        if(this.saerNameModel.trim() != ''){
          const siteDatasSaerName =
          {
            identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
            sourceSystemId:this.siteSourceSystems['SAER'],
            accessPointRowId: access_point_row_id,
            identifierValue:this.saerNameModel,
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasSaerName).subscribe(() => { });
        }
        if(this.showLatamCodeSwitch === true && this.showLatamCode === true){
          const siteDataLatamCode =
          {
            identifierId:this.siteIdentTypesData['AP_LATAM_CODE'],
            sourceSystemId:this.siteSourceSystems['LATAM'],
            accessPointRowId: access_point_row_id,
            identifierValue:this.latamCodeModel,
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDataLatamCode).subscribe(() => { });
        }
        if(this.latamNameModel.trim() != ''){
          const siteDataslatamName =
          {
            identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
            sourceSystemId:this.siteSourceSystems['LATAM'],
            accessPointRowId: access_point_row_id,
            identifierValue:this.latamNameModel,
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDataslatamName).subscribe(() => { });
        }
        if(this.showRnaiplCodeSwitch === true && this.showRnaiplCode === true){
          const siteDataRnaiplCode =
          {
            identifierId:this.siteIdentTypesData['AP_RNAIPL_CODE'],
            sourceSystemId:this.siteSourceSystems['RNAIPL'],
            accessPointRowId: access_point_row_id,
            identifierValue:this.rnaiplCodeModel.toUpperCase(),
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDataRnaiplCode).subscribe(() => { });
        }
        if(this.rnaiplNameModel.trim() != ''){
          const siteDatasRnaiplName =
          {
            identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
            sourceSystemId:this.siteSourceSystems['RNAIPL'],
            accessPointRowId: access_point_row_id,
            identifierValue:this.rnaiplNameModel,
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasRnaiplName).subscribe(() => { });
        }
          if(this.c2bNameModel.trim() != ''){
            const siteDatasC2bName =
            {
              identifierId:this.siteIdentTypesData['AP_C2B_CODE'],
              sourceSystemId:this.siteSourceSystems['C2B'],
              accessPointRowId: access_point_row_id,
              identifierValue:this.c2bNameModel,
              effectiveDate:this.apiService.getTodayDate(),
            };
            this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasC2bName).subscribe(() => { });
        };error =>{
        this.acpMainCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
        this.acpAddressCreation = `${this.dangerSteps}Error ${this.endSpanSteps}`;
        this.gpsCreation = `${this.dangerSteps}Error ${this.endSpanSteps}`;
        this.finalAcpCreated = `${this.dangerSteps}Error ${this.endSpanSteps}`;
      }   
    });
  }
    else {
      this.saerNotUniqueError === true;
      if(this.AddNewAddress==false && (this.addressRadioval=='' || this.addressRadioval==undefined)){
        this.radioNotChecked = true;
      }else {
        this.radioNotChecked = false;
      }
      if(c === '' || c === undefined) {
        this.qualiferSiteTypeModelErrorUp = true;
      }else {
        this.qualiferSiteTypeModelErrorUp = false;
      }
      if(this.qualiferSiteStreetModelUp === '' && this.AddNewAddress==true) {
        this.qualiferSiteStreetModelErrorUp = true;
      }else {
        this.qualiferSiteStreetModelErrorUp = false;
      }
      if(saerCode.length != SiteDetailsComponent.SAER_CODE_LENGTH || saerCodeSyntax === false){
        this.saerCodeModelError = true;
      }else{
        this.saerCodeModelError = false;
      }
      if((latamCode.length <= SiteDetailsComponent.TWO && latamCode.length > SiteDetailsComponent.LATAM_CODE_MAX_LENGTH) || latamCodeSyntax === false){
        this.latamCodeModelError = true;
      }else{
        this.latamCodeModelError = false;
      }
      if((rnaiplCode.length < SiteDetailsComponent.RNAIPL_CODE_MIN_LENGTH || rnaiplCode.length > SiteDetailsComponent.RNAIPL_CODE_MAX_LENGTH || rnaiplCodeSyntax === false) && this.showRnaiplCode === true){
        this.rnaiplCodeModelError = true;
      }else{
        this.rnaiplCodeModelError = false;
      }
    }
  });
}

  AddSaerCode(rowId){
this.addquaSiteRowid=rowId;
this.saer_NameModel="";
this.saer_CodeModel="";
this.saerMinlength=false;
this.saerNameExists=false;
this.saerCodeExists=false;
this.saerUniqueError =false;
  }

  AddSaerCodetoQua(){
    this.saerMinlength=false;
    this.saerNameExists=false;
    this.saerCodeExists=false;
    this.saerUniqueError =false;
    this.saerNameMinlen=false;
    if(this.saer_NameModel.trim() === "" || this.saer_NameModel === undefined) {
this.saerNameExists=true;
return
}else{
  if(this.saer_NameModel.length > SiteDetailsComponent.SAER_NAME_MAX_LENGTH ){
this.saerNameMinlen=true;
  }
}
if(this.saer_CodeModel.trim() === "" || this.saer_CodeModel === undefined) {
  this.saerCodeExists=true;
  
  }else{
    const saerCode = this.saer_CodeModel.trim();
    const regExNum = new RegExp('^[0-9]+$');
    const saerCodeSyntax = regExNum.test(saerCode);
    if(saerCode.length > SiteDetailsComponent.SAER_CODE_LENGTH || saerCodeSyntax === false){
      this.saerMinlength=true;
      return;
    }
  }
     this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&identifierValue=${this.saer_CodeModel}` ).subscribe( data => {
      if(this.saer_CodeModel!=''){
        if(data['access-point-identifiers'].length>0){
          this.saerUniqueError =true
          return
        }else{
          this.saerUniqueError =false;
          const siteDatasSaerCode =
          {
            identifierId:this.siteIdentTypesData['SAER_CODE'],
            sourceSystemId:this.siteSourceSystems['SAER'],
            accessPointRowId: this.addquaSiteRowid,
            identifierValue:this.saer_CodeModel,
            effectiveDate:this.apiService.getTodayDate(),
          };
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasSaerCode).subscribe(() => {
            const siteDatasSaerName =
            {
              identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
              sourceSystemId:this.siteSourceSystems['SAER'],
              accessPointRowId: this.addquaSiteRowid,
              identifierValue:this.saer_NameModel,
              effectiveDate:this.apiService.getTodayDate(),
            };
            this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasSaerName).subscribe(() => { });
                 
            const datas = { "activeStatus" : "ACTIVE"};
            this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.addquaSiteRowid}`, datas).subscribe(() => {
              window.document.getElementById("closeAddSaer").click() ;
              this.dispQualifiers('reload');
            })

          });
        }
      }
      })
  }
  checkvalidatec2b(event,type=''){
    let valueLength:number
    const c2bName=event.toUpperCase()
    if(type=='edit'){
      this.editc2bAliasModel=event.toUpperCase();
      valueLength=this.editc2bAliasModel.length
    }else{
    this.c2bNameModel= event.toUpperCase();
    this.c2bExists=false;
    this.c2bNameModelError='';
    valueLength=this.c2bNameModel.length
    }
    if(valueLength>=SiteDetailsComponent.FOUR && valueLength<=SiteDetailsComponent.TEN){
      const regex = /^[A-Z]{3}[0-9]{1,7}$/;
      if(regex.test(c2bName)){
        if(c2bName.slice(0, SiteDetailsComponent.SUPPLIER_PREFIX_LENGTH)=='SUP'){
          this.c2bNameModelError=''
          this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${c2bName}&identifierTypeName=AP_C2B_CODE`).subscribe(data => {
            if(data['access-point-identifiers'].length>0){
              this.disableAddQualifierToSite = true;
              this.c2bExists=true;
              this.c2bNameModelError='C2B Code already exists';
            }else{
              this.disableAddQualifierToSite = false;
              this.c2bExists=false;
            }
          })
        }else{
          this.c2bNameModelError='First 3 letter should be SUP';
          this.disableAddQualifierToSite = true;
        }
      }else{
        this.c2bNameModelError='Must start with SUP followed by 7 digits';
        this.disableAddQualifierToSite = true;
      }
    }else{
      this.disableAddQualifierToSite=true;
      this.c2bNameModelError='';
    }
  }

  changeArrow(a){
    const vor = document.getElementsByClassName('change_img');
    const tem = document.getElementById(`img${a}`);
    tem.classList.remove('down_arrow','master');
    const morty = tem.getAttribute('data-target');
    const shorty = document.getElementById(morty.substr(1));
    if(shorty.classList.contains('show')){
      tem.classList.add('down_arrow');
    }else{
      tem.classList.remove('down_arrow');
    }
  }

  changeArrowAlt(_inc){
    const allDiv = document.getElementsByClassName('recurring');
    for(let i=0; i<allDiv.length; i++){
      if(allDiv[i].classList.contains('show')){
        console.info('openDiv',allDiv[i].getAttribute('id'));
      }else{
        console.info('closed',allDiv[i].getAttribute('id'));
      }
    }
  }

  setQualifierAccessId(modelValue){
    if(modelValue != '' && modelValue != undefined){
    this.qualiferAliasAccessPRowidModel = modelValue;
    }
    this.qualiferAliasValueModel = '';
    this.qualiferAliasTypeModel ='';
  }


  AddQualifierAliasDetails() {
    if(this.qualiferAliasTypeModel != '' && this.qualiferAliasTypeModel != undefined && this.qualiferAliasValueModel != '' && this.qualiferAliasValueModel != undefined)  {
      this.saveDatas = "Save...";
      this.qualiferAliasTypeModelError = false;
      this.qualiferAliasValueModelError = false;
      const siteDatas =
      {
        identifierId:this.siteIdentTypesData['RAFT_CODE'],
        sourceSystemId:"2",
        accessPointRowId: this.qualiferAliasAccessPRowidModel,
        identifierValue:this.qualiferAliasValueModel,
        effectiveDate:this.apiService.getTodayDate(),
      };
      this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatas).subscribe(() => {
        window.document.getElementById("closeQABtn").click() ;
        this.saveDatas = "Save";
        this.dispQualifiers('reload');
      },_error => {
        this.saveDatas = "Save";
      });

    }else {
      if(this.qualiferAliasTypeModel === '') {
        this.qualiferAliasTypeModelError = true;
      }else {
        this.qualiferAliasTypeModelError = false;
      }
      if(this.qualiferAliasValueModel === '') {
        this.qualiferAliasValueModelError = true;
      }else {
        this.qualiferAliasValueModelError = false;
      }
    }
  }




  revQualifierSort(){
    this.loading = true;
    this.sitesData.reverse()
    this.loading = false;
  }



  resetBvdId(val){
    if (val === 'bvdid'){
      this.editBvdIdValueModel = '';
      this.editBvdIdModalError = true;
    }else if (val =='modal'){
      this.disableSaveBvdBtn = false;
      this.editBvdIdValueModel = this.sitebvidid;
      this.editBvdIdModalError = false;
    }else if(val === 'city'){
      this.editCityModel ='';
      this.editCityModelError = true;
      this.delaySiteSearchResCity.setValue('')
    }
    else if (val === 'name'){
      this.editNameModel = '';
      this.editNameModelError = true;
    }
  }

  checkForBvdId(expression,model,errorModel){
    this[model] = expression.replace(/\s/g, "");;
    if(expression.length > 0){
      this[errorModel] = false;
    }else{
      this[errorModel] = true;
    }
  }

  saveBvdId(){
    if(this.editBvdIdValueModel != '' && this.editBvdIdValueModel != undefined){
      this.saveDatas = "Saving...";
      this.disableSaveBvdBtn = true;
      if(this.tempBvdId != ''){
        const const5 = {
          value : this.editBvdIdValueModel
        }
        const setEndDate = {
          endDate : this.apiService.getTodayDate()
        }
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.editBvdIdValueModel}`).subscribe(data1 => {
          if(data1['business-entity-identifiers'].length === 0){
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,const5).subscribe(data => {
              if(data != null){
                this.bvdidloading = true;
                this.saveDatas = "Save"
                this.disableSaveBvdBtn = false;
                this.dispBvdId(this.tempBvdId,'reload');
              }
              document.getElementById('closebvdmodal').click();
            });
          }else if(data1['business-entity-identifiers'].length > 0 && data1['business-entity-identifiers'][0]['endDate'] != ''){
            const bvdRowId = data1['business-entity-identifiers'][0]['row_id'];
            const replaceBvd = {
              businessEntityId : this.businessEntityIdSite,
              endDate          : ''
            }
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${bvdRowId}`,replaceBvd).subscribe(dataA => {
              this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,setEndDate).subscribe(() => {
                this.bvdidloading = true;
                this.saveDatas = "Save"
                this.disableSaveBvdBtn = false;
                this.tempBvdId = dataA['row_id'];
                this.dispBvdId(this.tempBvdId,'reload');
                document.getElementById('closebvdmodal').click();
              });
            });
          }else{
            document.getElementById('btnForBvdIdStatus').click();
            this.bvdIdStatusText = 'BvD ID already attached to a Site';
            this.saveDatas = "Save"
            this.disableSaveBvdBtn = false;
          }
        });
      }else{
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.editBvdIdValueModel}`).subscribe(data1 => {
          if(data1['business-entity-identifiers'].length === 0){
            const const2 = {
              "businessEntityIdentifierTypeId"    :"1",
              "businessEntityIdentifierTypeName"  :"BVD ID",
              "startDate"                         : this.apiService.getTodayDate(),
              "businessEntityId"                  : this.businessEntityIdSite,
              "value"                             : this.editBvdIdValueModel
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(data2 => {
              this.bvdidloading = true;
              this.saveDatas = "Save"
              this.disableSaveBvdBtn = false;
              this.tempBvdId = data2['row_id'];
              this.dispBvdId(this.tempBvdId,'reload');
              document.getElementById('closebvdmodal').click();
            });
          }else if(data1['business-entity-identifiers'].length > 0 && data1['business-entity-identifiers'][0]['endDate'] != ''){
            const BvdRowId = data1['business-entity-identifiers'][0]['row_id'];
            const const3 = {
              businessEntityId : this.businessEntityIdSite,
              endDate          : ''
            }
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${BvdRowId}`,const3).subscribe(data12 => {
              this.tempBvdId = data12['row_id'];
              this.bvdidloading = true;
              this.saveDatas = "Save"
              this.disableSaveBvdBtn = false;
              this.dispBvdId(this.tempBvdId,'reload');
              document.getElementById('closebvdmodal').click();
            });
          }else{
            document.getElementById('btnForBvdIdStatus').click();
            this.bvdIdStatusText = 'BvD ID already attached to another Site';
            this.saveDatas = "Save"
            this.disableSaveBvdBtn = false;
          }
        });
      }
    }
    else{
      this.disableSaveBvdBtn = false;
      this.editBvdIdModalError = true;
    }
  }

  openCnfArchiveModal(type){
    if(this.tempBvdId != ''){
      if(type=='archive'){
        document.getElementById('btnForCnfArchive').click();
      } else if(type=='unarchive'){
        document.getElementById('btnForCnfUnArchive').click();
      } else if(type=='delete'){
        document.getElementById('btnForDeleteBvd').click();
      }
    }
  }

  archiveBvDID(){
    if(this.tempBvdId != ''){
      const setEndDate = {endDate : this.apiService.getTodayDate()}
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,setEndDate).subscribe(() => {
        this.tempBvdId = '';
        this.dispBvdId(this.businessEntityIdSite,'first');
        document.getElementById('closeCnfArchiveBvdId').click();
        document.getElementById('closebvdmodal').click();
      });
    }else{

    }
  }

  UnarchiveBvDID(){
    if(this.tempBvdId != ''){
      const setEndDate = {endDate : ''}
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,setEndDate).subscribe(() => {
        this.tempBvdId = '';
        this.dispBvdId(this.businessEntityIdSite,'first');
        document.getElementById('closeCnfUnArchiveBvdId').click();
        document.getElementById('closebvdmodal').click();
      });
    }else{

    }
  }
  
   openCnfArchiveTaxModal(type){
    if(this.taxIdRowId != ''){
      if(type=='archive'){
        document.getElementById('btnForCnfTaxArchive').click();
      } else if(type=='unarchive'){
        document.getElementById('btnForCnfTaxUnArchive').click();
      }
    }
  }

  archiveTax(){
    if(this.taxIdRowId != ''){
      const setEndDate = {endDate : this.apiService.getTodayDate()}
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.taxIdRowId}`,setEndDate).subscribe(() => {
        this.taxIdRowId = '';
        this.dispBvdId(this.businessEntityIdSite,'first');
        document.getElementById('closeCnfArchiveTax').click();
        document.getElementById('closetaxmodal').click();
        this.showArchivedTax=true;
      });
    }else{

    }
  }

  UnarchiveTax(){
    console.info('UnarchiveTax called');
    if(this.taxIdRowId != ''){
      const setEndDate = {endDate : ''}
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.taxIdRowId}`,setEndDate).subscribe(() => {
        this.taxIdRowId = '';
        this.dispBvdId(this.businessEntityIdSite,'first');
        document.getElementById('closeCnfUnArchiveTax').click();
        document.getElementById('closetaxmodal').click();
        this.showArchivedTax=false;
      });
    }else{

    }
  }
  openCnfSaerArchiveModal(type){
    if(this.editsaerAliasModel != ''){
      if(type=='archive'){
        document.getElementById('btnForCnfSaerArchive').click();
      } else if(type=='unarchive'){
        document.getElementById('btnForCnfSaerUnArchive').click();
      }
    }
  }

  archiveSaer(a='') {
    const archiveId = this.editsaerAliasModel;
    if (archiveId != '' && archiveId != undefined) {
      const setEndDate = {endDate : this.apiService.getTodayDate()}
      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.saerRowIdVar}`,setEndDate).subscribe(() => {
        this.showArchivedSAER=true;
        if(a!='reload'){
        this.dispQualifiers('reload');
        }
        document.getElementById('closeCnfArchiveSAER').click();
        document.getElementById('closeeditsaerAlias').click();
      });
    }else {

    }
  } 

  unarchiveSaer(a='') {
    const UnarchiveId = this.editsaerAliasModel;
    if (UnarchiveId != '' && UnarchiveId != undefined) { 
      const setEndDate = { endDate: '' }
      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.saerRowIdVar}`,setEndDate).subscribe(() => {
        this.showArchivedSAER=false;
        if(a!='reload'){
          this.dispQualifiers('reload');
          }
        document.getElementById('closeCnfUnArchiveSAER').click();
        document.getElementById('closeeditsaerAlias').click();
      });
    }else {

    }
  } 




  checkRequiredFields(event: any,val) {
    if(val=='type'){    this.CertificateTypeModel = event.target.value;
    if (this.CertificateTypeModel.trim() != "" && this.CertificateTypeModel != undefined) {
      this.CertificateTypeError = false;
    }
  }
  if(val=='number'){
    this.CertificateNumberModel = event.target.value;
    if (this.CertificateNumberModel.trim() != "" && this.CertificateNumberModel != undefined) {
      this.CertificateNumberError = false;
    }
  }
  if(val=='startDate'){
    if (this.CertificateStartDateModel.trim() != "" && this.CertificateStartDateModel != undefined && this.CertificateStartDateModel != null) {
      this.CertificateStartDateError = false;
    }
  }
  }

  resetCertNo(){
    this.CertificateNumberModel = "";
    this.CertificateNumberError = true;
  }
  setAddCertModalVals(){
    this.CertificateTypeModel='';
     this.CertificateNumberModel='';
     this.CertificateStartDateModel='';
     this.CertificateEndDateModel='';
     this.CertificateNumberError=false;
     this.CertificateStartDateError=false;
     this.CertificateTypeError=false;
  }
  resetMaterilGroup(){
    this.materialGroupNameModal='';
    this.materialGroupNameError=false;
    this.validData=false;
    this.identifierValue=false;
  }
  setMaterilGroupModalVals() {
    this.activityTypeList = [{ code: '01', name: 'MANUFACTURER' },
    { code: '02', name: 'RESELLER' },
    { code: '03', name: 'DISTRIBUTOR' },
    { code: '04', name: 'SUB-CONTRACTOR' }]

    this.materialGroupNameModal = '';
    this.materialGroupActivityModal = '';
    this.materialGroupNameError = false;
    this.materialGroupActivityError = false;
    this.identifierValue=false;
    this.validData=false;
    this.identifierValue=false;
  }
  addMaterialGroup() {
    if (this.materialGroupNameModal.trim() != "" && this.materialGroupActivityModal.trim() != "") {
      const data = {
        endDate: "",
        sourceSystemId:'4',
        identifierValue: `${this.materialGroupNameModal}#${this.materialGroupActivityModal}`,
        identifierId: "38",
        accessPointRowId: this.selectedRow,
        effectiveDate: this.apiService.getTodayDate(),
      }
      this.dataForMaterialGroup.filter(x=>{
        if(x.code==this.materialGroupNameModal){
          this.identifierValue=true
        }
      })
      if(!this.identifierValue){
      this.PurchasingApi.getMaterialGroupHomologation(`'${this.materialGroupNameModal}'`,1,SiteDetailsComponent.STANDARD_PAGE_SIZE).subscribe(mGroups=>{
      if(mGroups['commodity-perimeters'].length>0){
        this.validData = false
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,data).subscribe(() =>{
          window.document.getElementById("openAddMaterialGroupModal").click();
          this.sitesData.forEach(abc => {
          if(abc.identifier === this.selectedIdentifier){
            this.loadMaterialGrpHomologation(abc,'start',1)
          }})
        })
      } else {
        this.validData=true
      }
      })}
    } else {
      if (this.materialGroupNameModal === '') {
        this.materialGroupNameError = true;
      } if (this.materialGroupActivityModal === '') {
        this.materialGroupActivityError = true;
      }
    }
  }
  checkRequiredFieldsForMG(event: any, val) {
    if (val === 'MG') {
      this.identifierValue=false
      this.validData=false
      this.materialGroupNameModal = event.target.value;
      if (this.materialGroupNameModal.trim() != "" && this.materialGroupNameModal != undefined) {
        this.materialGroupNameError = false;
      }
    }
    if (val === 'activity') {
      this.materialGroupActivityModal = event.target.value;
      if (this.materialGroupActivityModal.trim() != "" && this.materialGroupActivityModal != undefined) {
        this.materialGroupActivityError = false;
      }
    }
  }
 addCertificate(){
  if(this.CertificateTypeModel!='' && this.CertificateNumberModel!=''&& this.CertificateStartDateModel!='' && this.CertificateStartDateModel!=null){
  const data = {
    'number' : this.CertificateNumberModel,
    'siteIdentifier' : this.siteIdentifier,
    'type' : this.CertificateTypeModel,
    'startValidationDate' : this.CertificateStartDateModel,
    'realEstateAssetId' : this.siteId,
    'expirationDate' : this.CertificateEndDateModel==null ?'': this.CertificateEndDateModel.toString()
  }
  this.disableAddCertBtn=true;
  this.sitesService.createSitescertification(`${this.Config.ApiSitesUrl}sites-certifications`,data).subscribe(() => {
    this.getCertificates();
    document.getElementById('addcertificateCloseBtn').click();
    this.disableAddCertBtn=false;
  },_err=>{
    this.disableAddCertBtn=false;
  });
} else{
if(this.CertificateNumberModel==''){
  this.CertificateNumberError=true;
}  if(this.CertificateTypeModel==''){
  this.CertificateTypeError=true;
}  if(this.CertificateStartDateModel==''){
  this.CertificateStartDateError=true;
}
}
 }
  DeleteBvDID(){
    if(this.tempBvdId != ''){
      this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`).subscribe(_data => {
        if(this.orbisRowId!=undefined&&this.orbisRowId!=''){
        this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.orbisRowId}`).subscribe(() => {
          this.dispBvdId(this.businessEntityIdSite,'first');})
        }else{
          this.dispBvdId(this.businessEntityIdSite,'first');
        }
          this.latestOrbisStatus=''
        this.bvdidloading=true;
        this.sitebvidid='';
        this.tempBvdId = '';
        document.getElementById('closeCnfDeleteBvdId').click();
        document.getElementById('closebvdmodal').click();
    })
    }else{

    }
  }



  dispParentageStatusModal(page = 1, subscribeData = [],loop='start'){
    this.parentage;
    if(loop === 'start'){
      this.parentageLoading = true;
      this.parentageData = [];
      this.parentageOriData = [];
    }
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}&_page=${page}`).subscribe( data =>{
      if(data['site-assignments'].length > 0){
        data['site-assignments'].forEach(element =>{
          const val = {}
          val['legalName'] = element.businessEntityCompanyLegalName;
          if(element.status === 'VALIDATED'){

          }
          val['status'] = element.status;
          val['startDate'] = element.validityStartDate;
          val['endDate'] = element.validityEndDate;
          val['rowId'] = element.rowId;
          this.parentageData.push(val)
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.dispParentageStatusModal(page+1,subscribeData,'continue');
        }else if(data['maxPage'] === page){
          this.loadingQualifier = true;
          this.parentageLoading = false;
        }
      } else{
        this.loadingQualifier = false;
        this.parentageLoading = false;
      }
        this.parPager = this.pagerService.getPager(this.parentageData.length,page,SiteDetailsComponent.TEN);
        this.parentageOriData = this.parentageData.slice(this.parPager.startIndex,this.parPager.endIndex + 1)
        this.parentage=this.parentageData.length>SiteDetailsComponent.TEN ? false : true
    });
  }

  parentageTable(page){
    this.parPager = this.pagerService.getPager(this.parentageData.length,page,SiteDetailsComponent.TEN);
    this.parentageOriData = this.parentageData.slice(this.parPager.startIndex,this.parPager.endIndex + 1)
  }



  setNameValue(){
    this.editSiteNameValueModel = this.siteName;
    this.editSiteNameModalError = false;
    this.editSiteNameModalRegExError = false;
    this.disableEditSiteNameBtn = false;
  }
  saveNewSiteName(){
    if(this.editSiteNameValueModel != undefined && this.editSiteNameValueModel != '' && this.editSiteNameModalRegExError === false){
      this.disableEditSiteNameBtn = true;
      const const1 = {
        name : this.editSiteNameValueModel
      }
      this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}` , const1).subscribe( data => {
        if(data){
          document.getElementById('closeeditnamemodal').click()
          this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}`).subscribe( data2 =>{
            this.siteName = data2['name']
          })
        }
      })
    } else {
      if(this.editSiteNameModalRegExError === true){
        this.editSiteNameModalError = false;
      }else{
        this.editSiteNameModalError = true;
      }
    }
  }
  resetSiteName(we){
    if(we === 'name'){
      this.editSiteNameValueModel = '';
      this.editSiteNameModalRegExError = false;
    }
  }


  /** Remove Role for this Site start here */
  removeCompanyContactExists(rowId: any) {
    this.removeDatas = 'Remove';
    this.remvoeContactModelval = rowId;
  }

  ArchiveCompanyContactDetails(rowid) {
    const datas = { endDate: this.commonService.getTodayDate(), personRoleStatus: "ARCHIVED" };
    this.commonService.updateSub(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${rowid}`, datas).subscribe(() => {
    });
  }

  removeCompanyContactDetails() {
    if (this.remvoeContactModelval != '' && this.remvoeContactModelval != undefined) {
      this.removeDatas = "Remove...";
      const datas = { endDate: this.commonService.getTodayDate(), personRoleStatus: "ARCHIVED" }; 
      this.commonService.delete(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${this.remvoeContactModelval}`).subscribe(() => {

        this.CompanyContacts = [];
        this.siteRoles();
        window.document.getElementById("closeCCBtn").click();
        this.removeDatas = "Remove";
      });
    }
  }

  /** Remove Role for this Site end here */

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }


  editC2bCode(values,rowIdC2b,accessRowId,_name){
    this.editc2bAliasModel=values!=undefined?values[0].toUpperCase():'';
    this.c2bNameModelError=''
    this.c2bRowIdVar=rowIdC2b
    this.c2bAccessRowIdVar = accessRowId;
    this.editc2bAliasModel==''?this.c2bCodeExists=false:this.c2bCodeExists=true
  }

  resetC2bAliasVal(){
    this.editc2bAliasModel = '';
    this.disableAddQualifierToSite=true;
    this.c2bNameModelError = 'Please enter the C2B Value';
  }

  saveC2bAliasVal(){
    if(this.c2bNameModelError==''){
      if(this.c2bCodeExists){
        let const2 = {
          "identifierValue" : this.editc2bAliasModel
        }
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.c2bRowIdVar}`, const2 ).subscribe(() => {
          document.getElementById('closeC2bBtn').click();
            this.dispQualifiers('reload');
        },_error => {
          this.disableEditsaerCodeBtn = false;
        });
      }else{
        let const5 ={
          "identifierId":this.siteIdentTypesData['AP_C2B_CODE'],
          "sourceSystemId":this.siteSourceSystems['C2B'],
          "accessPointRowId" : this.c2bAccessRowIdVar,
          "identifierValue" : this.editc2bAliasModel,
          "effectiveDate" : this.apiService.getTodayDate()
      }
      this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
        document.getElementById('closeC2bBtn').click();
            this.dispQualifiers('reload');
      })
      }
    }
  }




  editRaftAliasSet(values,rowIdRaft,accessRowId,name){
    console.info("name",name)
    console.info("values",values)
    this.raftRowIdVar = rowIdRaft;
    this.raftAccessRowIdVar = accessRowId;
    this.saveDatas = 'Save';
    this.raftNameHolder = name;
    this.disableEditRaftCodeBtn = false;
    this.disableEditRaftNameBtn = false;
    if(values != undefined && values != ''){
      if(values.length > 1){
        this.hasMultipleRaftAlias = true;
      }
      else{
        this.saveAsNewRaftCode = false;       
        this.hasMultipleRaftAlias = false;    
        this.editRaftAliasModel = values;
      }
    }
    else{
      this.editRaftAliasModel = '';
      this.hasMultipleRaftAlias = false;
      this.saveAsNewRaftCode = true;
    }
    this.editRaftAliasError = false;
  }

  checkRaftAliasVal(){
    if(this.editRaftAliasModel != ''){
      this.editRaftAliasError = false;
    }
    else{
      this.editRaftAliasError = true;
    }
  }

  resetRaftAliasVal(){
    this.editRaftAliasModel = '';
    this.editRaftAliasError = true;
  }

  saveRaftAliasVal(){
    this.changeStatusforRaftAlias =true;
    if(this.editRaftAliasModel != undefined && this.editRaftAliasModel != ''){
      this.disableEditRaftCodeBtn = true;
      let const2 = {
        "identifierValue" : this.editRaftAliasModel
      }
      if(this.saveAsNewRaftCode === false){
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.raftRowIdVar}`, const2 ).subscribe(() => {
          this.changeStatusToPending();
        },_error => {
          this.disableEditRaftCodeBtn = false;
        });
      }
      else{
        let const5 ={
            "identifierId":this.siteIdentTypesData['RAFT_CODE'],
            "sourceSystemId":"2",
            "accessPointRowId" : this.raftAccessRowIdVar,
            "identifierValue" : this.editRaftAliasModel,
            "effectiveDate" : this.apiService.getTodayDate()
        }
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
          this.changeStatusToPending()
        })
      }
    }
  }

  changeStatusToPending(){
    const datas = { "activeStatus" : "ACTIVE",  "endDate" : ""};
    const datas1 = { "activeStatus" : "PENDING"};
    if(this.changeStatusforRaftAlias === true){
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.raftAccessRowIdVar}`, datas).subscribe(() => {
        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.raftAccessRowIdVar}`, datas1).subscribe(() =>{
          document.getElementById('closeeditRaftAlias').click();
          this.dispQualifiers('reload');
        });
      });
    }else if (this.changeStatusforLatamAlias === true) {
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.latamAccessRowIdVar}`, datas).subscribe(() => {
        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.latamAccessRowIdVar}`, datas1).subscribe(() =>{
          document.getElementById('closeeditLatamAlias').click();
          this.dispQualifiers('reload');
        });
      });
    } else if (this.changeStatusforRnaiplAlias === true) {
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rnaiplAccessRowIdVar}`, datas).subscribe(() => {
        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rnaiplAccessRowIdVar}`, datas1).subscribe(() =>{
          document.getElementById('closeeditRnaiplAlias').click();
          this.dispQualifiers('reload');
        });
      });
    } else{
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.saerAccessRowIdVar}`, datas).subscribe(() => {
        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.saerAccessRowIdVar}`, datas1).subscribe(() =>{
          document.getElementById('closeeditsaerAlias').click();
          this.dispQualifiers('reload');
        });
      });
    }
  }

  validateSite(rowVar,raftAliasVars,quaType,editRowIdForAlias,siteRaftName){
    this.mainValidateAcpData = [];
    this.validateACPData = [];
    this.accessPointRowIds = [];
    this.maskValidateACPData = [];
    this.displayParam = 'loading';
    this.rowIdforNewAlias = rowVar;
    this.alcorRadioVal = '';
    this.mainValidateAlcorData = [];
    this.alcorRealEstateIdenData = [];
    this.raftRadioVal = '';
    this.loadingValidateAcp = true;
    this.loadingValidateAcpSaer = true;
    this.paramsValidate = '';
    this.raftNameUpdatedForAlcor = [];
    this.allAlcorRaftVals = [];
    this.validateACPDataAccessPoinId=[];
    this.accessPointRowIdHolder = '';
    this.disableSaveRaftBtn = false;
    this.disableValidateAcpBtn = true;
    this.validationSuccessValidateacp = false;

    let cpyIdensVals = [];
    if(siteRaftName === '' || siteRaftName === undefined){
      this.raftNameisNull = true;
    }else{
      this.raftNameisNull = false;
    }
    const type = quaType;
    let raftaliasArrSliced = [];
    this.disableType = quaType;
    if(this.companyId != '' && this.companyId != 'undefined'){
      console.info('in')
      this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyId}&companyNameTypeName=SHORT NAME`).subscribe( ( data : any) => {
        if(data['company-names'].length > 0){
          this.cpyShortName = data['company-names'][0].value;
        }else{
          this.cpyShortName = this.businessEntityCompanyLegalName;
        }
      });
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}&status=VALIDATED`).subscribe(datas =>{
        if(datas['site-assignments'].length > 0){
          const cpyId = datas['site-assignments'][0]['businessEntityCompanyId'];
          this.cpyNameForValidate = datas['site-assignments'][0]['businessEntityCompanyLegalName'];
          if(raftAliasVars != undefined){ 
            if(raftAliasVars.length > 0){
              raftAliasVars.forEach(ele => {
                const c = ele.slice(0,ele.length-SiteDetailsComponent.TWO);
                raftaliasArrSliced.push(c);
              });
              this.getCompanyIdentifiers1(1,raftaliasArrSliced,editRowIdForAlias);              
            }
          }
          else{ 
            this.getCompanyIdentifiers2(1,cpyIdensVals,quaType);
          }
        }
        else{
          console.info('no cpy exist')
          this.loadingValidateAcp = false;
          this.loadingValidateAcpSaer = false;
          this.disableValidateAcpBtn = false;
          this.displayParam = 'nocpy'
        }
      });
    }else{
      this.loadingValidateAcp = false;
      this.loadingValidateAcpSaer = false;
      this.disableValidateAcpBtn = false;
      this.displayParam = 'nocpy'
    }
    const raftdata=[]
    const id = []
    let count = 0
    if(this.sitesData){
    this.sitesData.forEach(data => {
      if(data.rowId === this.qualiferAliasAccessPRowid){
        raftdata.push(data['raft_alias'])
      }
    })
  }
  if(raftdata[0]){
  raftdata[0].forEach(raft => {
    this.sitesData.forEach(dataid => {
        if(dataid.raft_alias){
          if(dataid.raft_alias.includes(raft) && dataid.rowId!=this.qualiferAliasAccessPRowid){
            id.push(dataid.rowId)
          }
          if(dataid.raft_alias.includes(raft) && dataid.status.toLowerCase()=='archived'){
            count +=1
          }
        }
      })
      if(id.length==count){
        const date={"endDate" : ""}
        const rowId = []
        id.forEach(ids=> {
          this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${ids}`, date).subscribe((_data:any) => {
           if (this.siteWorkflowStatus === 'WaitingForRenault') {
          const payload = { workflowStatus: 'Completed' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
          this.siteWorkflowStatus = 'Completed';
        });
        } 
          })
          this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${raft}*&identifierTypeName=RAFT_CODE`).subscribe(data1 => {
            rowId.push( data1['access-point-identifiers'])
            console.info(rowId)
            rowId[0].forEach(id=>{
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${id.rowId}`,date).subscribe(() => {
        })
      })
        })
      })
        }
    })
  }
}

  getCompanyIdentifiers1(page,raftaliasArrSliced,editRowIdForAlias,subscribeData = []){
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.companyId}&companyIdentifierKeyName=ALCOR&_page=${page}`).subscribe(data => {
      if(data['company-identifiers'].length > 0){
        data['company-identifiers'].forEach(e => {
          subscribeData.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getCompanyIdentifiers1(page+1,raftaliasArrSliced,editRowIdForAlias,subscribeData);
        }else if(data['maxPage'] === page){
          let v = 0;
          let isAllowedLoop = 'yes';
          subscribeData.forEach( ele => {
            if(isAllowedLoop === 'yes'){
              if(raftaliasArrSliced.indexOf(ele.value) != -1  && ele.endDate === ''){
                this.saveRaftNameandStatus(editRowIdForAlias,v);
                isAllowedLoop = 'no'
              }else{
                this.alcorVal = raftaliasArrSliced.toString();
                this.displayParam = 'alcornotset';
              }
            }
          });
        }
      }else{
        this.displayParam = 'alcornotset';
      }
    });
    this.getCmpBvd()
  }

  getCompanyIdentifiers2(page,cpyIdensVals,quaType,subscribeData1 = []){
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.companyId}&companyIdentifierKeyName=ALCOR&_page=${page}`).subscribe(data => {
      if(data['company-identifiers'].length > 0){
        data['company-identifiers'].forEach(e => {
          subscribeData1.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getCompanyIdentifiers2(page+1,cpyIdensVals,quaType,subscribeData1);
        }else if(data['maxPage'] === page){
          if(subscribeData1.length > 0){
              subscribeData1.forEach( ele => {
                if(cpyIdensVals.indexOf(`'${ele.value}'`) === -1){
                  cpyIdensVals.push(`'${ele.value}'`)
                }
              });
              if(subscribeData1[0]['companyIdentifierKeyName'] === 'ALCOR'){
                const val = subscribeData1[0]['value'];
                this.validateAlcorValue = val;

                if(subscribeData1.length === 1 && subscribeData1[0]['endDate'] === ''){ 
                  this.getNewAccessPointIdentifiers(this.accessIdentValues,'accessPointIdentifier=in(',1,val,quaType);
                }
                else if(subscribeData1.length > 1){ 
                  this.getRealEstateAssetIdens(1,cpyIdensVals,subscribeData1);
                }
                else if(subscribeData1.length === 0){ 
                  this.displayParam = 'noalcor';
                  document.getElementById('btnnoalcor').click();
                }
                else{ 
                  this.displayParam = 'noalcor';
                  document.getElementById('btnnoalcor').click();
                }
              }
          }
          this.getCmpBvd()
        }
      }else{

        this.displayParam = 'noalcor'
        document.getElementById('closeValidateAcplabelModel').click();
        document.getElementById('btnnoalcor').click();
        this.loadingValidateAcp = false;
        this.loadingValidateAcpSaer = false;

      }
    });
  }

  getRealEstateAssetIdens(page,cpyIdensVals,data1Cpyidens){
    if(cpyIdensVals.length > 0){
      this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${cpyIdensVals})&_page=${page}`).subscribe(data28 => {
        if(data28['real-estate-asset-identifiers'].length > 0){
          data28['real-estate-asset-identifiers'].forEach(element => {
            if(this.alcorRealEstateIdenData[element.businessIdentifierValue] === undefined){
              this.alcorRealEstateIdenData[element.businessIdentifierValue] = [];
            }
            this.alcorRealEstateIdenData[element.businessIdentifierValue] = element;
          });
          if(data28['maxPage'] > 1 && data28['maxPage'] != page){
            this.getRealEstateAssetIdens(page+1,cpyIdensVals,data1Cpyidens);
          }else if(data28['maxPage'] === page){
            let temIndex = 0;
            data1Cpyidens.forEach( ele => {
              if(ele.endDate === ''){
                let tem = [];
                tem['row_id'] = ele.row_id;
                tem['aliass'] = ele.value;
                this.mainValidateAlcorData[temIndex] = tem;
                temIndex++;
              }
            });
            if(this.mainValidateAlcorData.length > 1){
              this.displayParam = 'multiplealcor';
              document.getElementById('closeValidateAcplabelModel').click();
              if(this.displayParam =='multiplealcor'){
                document.getElementById("btnFormultiplealcor").click()
              }
              
              
              console.info("display param",this.displayParam)
            }
            else if(this.mainValidateAlcorData.length === 1){ 

              this.alcorRadioVal = this.mainValidateAlcorData[0]['aliass'];
              this.openAlcorVal();
            }
            else{
              this.displayParam = 'noalcor';
              document.getElementById('btnnoalcor').click();
            }
            console.info(this.mainValidateAlcorData);
            console.info('new ',this.alcorRealEstateIdenData);
          }
        }
      });
    }
  }

  setStatus(value,rowid){
  this.statusData = "";
  this.oldStatus = value;
  this.statusOption = [];
  this.statusError = false;
  this.statusBtn = false;
  this.materialGroupRowId = rowid
  if(value=='PENDING'){
    this.statusOption.push('ACTIVE','ARCHIVED')
  } else if(value=='ACTIVE'){
    this.statusOption.push('PENDING','ARCHIVED')
  } else {
    this.statusOption.push('ACTIVE','PENDING')
  }
  this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers/${rowid}`).subscribe(data12 => {
    this.statusrowIdData = data12
   })
  }

  updateStatus(){
    if(this.statusData!='' && this.statusData!=undefined){
      let datas: any
      this.statusBtn = true;
      const date = '2222-01-01'
      if(this.oldStatus=='PENDING'){
        if(this.statusData === 'ACTIVE'){
          datas={effectiveDate:this.apiService.getTodayDate()}
        }
        if(this.statusData === 'ARCHIVED'){
          datas={endDate:this.apiService.getTodayDate()}
        }
      } else if(this.oldStatus=='ACTIVE'){
        if(this.statusData === 'PENDING'){
          datas={effectiveDate:date}
        }
        if(this.statusData === 'ARCHIVED'){
          datas={endDate:this.apiService.getTodayDate()}
        }
      } else if(this.oldStatus=='ARCHIVED'){
        if(this.statusData === 'ACTIVE'){
          datas={effectiveDate:this.apiService.getTodayDate(),endDate:""}
        }
        if(this.statusData === 'PENDING'){
          datas={effectiveDate:date,endDate:""}
        }
      }
      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.materialGroupRowId}`,datas).subscribe(() => {
      })

    window.document.getElementById("statusEditPopup").click();
    this.sitesData.forEach(abc => {
      if(abc.identifier === this.selectedIdentifier){
        this.loadMaterialGrpHomologation(abc,'',this.pager.currentPage)
      }
    })
  }
  else{
    this.statusError=true;
  }
  }
  setActivityValue(value,rowid){
    this.activityValue = "";
    this.activityValueOption =[];
    this.activityValueError = false;
    this.activityValueBtn = false
    this.materialGroupRowId = rowid
    const activityTypeListData = [{ code: '01', name: 'MANUFACTURER' },
    { code: '02', name: 'RESELLER' },
    { code: '03', name: 'DISTRIBUTOR' },
    { code: '04', name: 'SUB-CONTRACTOR' }]
    if(value=='01'){
      this.activityValueOption.push(activityTypeListData[1],activityTypeListData[2],activityTypeListData[3]);
    } else if(value=='02'){
      this.activityValueOption.push(activityTypeListData[0],activityTypeListData[2],activityTypeListData[3]);
    } else if(value=='03'){
      this.activityValueOption.push(activityTypeListData[0],activityTypeListData[1],activityTypeListData[3]);
    } else if(value=='04'){
      this.activityValueOption.push(activityTypeListData[0],activityTypeListData[1],activityTypeListData[2]);
    }
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers/${rowid}`).subscribe(data12 => {
      this.rowIdData = data12
     })
  }
  updateActivityValue(){
    if(this.activityValue != '' && this.activityValue != undefined){
      this.activityValueBtn = true
      const activityval = this.rowIdData.identifierValue.split('#')[0]
      const data = `${activityval}#${this.activityValue}`
      const datas = {identifierValue : data}
      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.materialGroupRowId}`,datas).subscribe(() => {
        window.document.getElementById("closeActivitymodal").click();
      })
      window.document.getElementById("closeActivitymodal").click();
      this.sitesData.forEach(abc => {
        if(abc.identifier === this.selectedIdentifier){
          this.loadMaterialGrpHomologation(abc,'',this.pager.currentPage)
        }
      })
    }
    else {
      this.activityValueError = true
    }
  }
  getNewAccessPointIdentifiers(rowIds,param,page,val,quaType,subscribeData = []){
    if(rowIds.length > 0){
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?${param}${rowIds})&_page=${page}`).subscribe(data => {

        if(data['access-point-identifiers'].length > 0){
          data['access-point-identifiers'].forEach(e => {
            subscribeData.push(e);
          });
          if(data['maxPage'] > 1 && data['maxPage'] != page){
            this.getNewAccessPointIdentifiers(rowIds,param,page+1,val,quaType,subscribeData);
          }else if(data['maxPage'] === page){

            console.info('done');
            this.getNewIdensTypes(val,'identifierTypeName=RAFT_CODE&identifierValue=*',1,subscribeData,quaType);
          }
        }else{
          this.getNewIdensTypes(val,'identifierTypeName=RAFT_CODE&identifierValue=*',1,subscribeData,quaType);

        }
      });
    }
  }

  getNewIdensTypes(vals,param,page,subscribeData,quaType,subscribeData1=[]){
    if(vals != ''){
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?${param}${vals}*&_page=${page}`).subscribe(data => {

        if(data['access-point-identifiers'].length > 0){
          data['access-point-identifiers'].forEach(e => {
            subscribeData1.push(e);
          });
          if(data['maxPage'] > 1 && data['maxPage'] != page){
            this.getNewIdensTypes(vals,param,page+1,subscribeData,quaType,subscribeData1);
          }else if(data['maxPage'] === page){
            console.info('done');
            if(subscribeData1.length > 0){
              subscribeData1.forEach(eleCon => {
                if(eleCon.endDate === ''){
                  if(this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] === undefined){
                    this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] = [];
                  }
                  const split = eleCon.identifierValue.slice(SiteDetailsComponent.RAFT_SUFFIX_START, SiteDetailsComponent.RAFT_SUFFIX_END);
                  if(this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)].length > 0){
                    if(this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] > split){

                    }else{
                      this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] = split;
                    }
                  }else{
                    this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] = split;
                  }
                }
              });

            }
            this.sortGotAccessData(subscribeData,quaType);
          }
        }else{
          this.sortGotAccessData(subscribeData,quaType);

        }
      });
    }
  }

  sortGotAccessData(subscribeData,quaType){
    console.info('sorting data');
    if(subscribeData.length != 0){
      const type = quaType;
      let gotEndDateDate = true;
      subscribeData.forEach( ele =>{
        if(ele.identifierTypeName === 'RAFT_CODE'){
          gotEndDateDate = false;
          this.validateACPDataAccessPoinId[ele.accessPointRowId]=(ele);
          if(ele.endDate != ''){
          const temp = {};
          temp['alias'] = ele.identifierValue;
          temp['qualifierDesignation'] = ele.sourceSystemName;
          temp['effectiveDate'] = ele.effectiveDate;
          temp['endDate'] = ele.endDate;
          temp['rowId'] = ele.accessPointRowId;
          temp['qualifier'] = [];
          if(temp['qualifier'].indexOf(ele.accessPointType) === -1){
            temp['qualifier'].push(ele.accessPointType);
          }
          if(this.validateACPData[ele.identifierValue]){
            if(this.validateACPData[ele.identifierValue]['qualifier'].indexOf(ele.accessPointType) === -1){
              this.validateACPData[ele.identifierValue]['qualifier'].push(ele.accessPointType);
            }
          }
          else{
            this.validateACPData[ele.identifierValue] = temp;
            this.maskValidateACPData.push(ele.identifierValue);
            this.accessPointRowIds.push(ele.accessPointRowId);
          }
          if(ele.accessPointType === type){
            this.validateACPData[ele.identifierValue]['disableRadio'] = true;
          }
          else{
            this.validateACPData[ele.identifierValue]['disableRadio'] = false;
          }
        } else {
          const temp1 = {};
          temp1['alias'] = ele.identifierValue;
          temp1['qualifierDesignation'] = ele.sourceSystemName;
          temp1['effectiveDate'] = ele.effectiveDate;
          temp1['endDate'] = ele.endDate;
          temp1['rowId'] = ele.accessPointRowId;
          temp1['qualifier'] = [];
          if(temp1['qualifier'].indexOf(ele.accessPointType) === -1){
            temp1['qualifier'].push(ele.accessPointType);
          }
          if(this.validateACPData[ele.identifierValue]){
            if(this.validateACPData[ele.identifierValue]['qualifier'].indexOf(ele.accessPointType) === -1){
              this.validateACPData[ele.identifierValue]['qualifier'].push(ele.accessPointType);
            }
          }
          else{
            this.validateACPData[ele.identifierValue] = temp1;
            this.maskValidateACPData.push(ele.identifierValue);
            this.accessPointRowIds.push(ele.accessPointRowId);
          }
          if(ele.accessPointType === type){
            this.validateACPData[ele.identifierValue]['disableRadio'] = true;
          }
          else{
            this.validateACPData[ele.identifierValue]['disableRadio'] = false;
          }
        }
      }
        if(ele.identifierTypeName === 'SOCIAL_RAISON'){

          this.raftNameUpdatedForAlcor[ele.accessPointRowId] = ele;
        }
      });
      if(gotEndDateDate === true){
        const vair = {'alias':'New Raft alias','disableRadio':false,'qualifier': []}
        this.mainValidateAcpData.push(vair)
        this.singleAlcorIden = this.validateAlcorValue;
        this.raftRadioVal = 'New Raft alias'
        this.paramsValidate = 'no';
        this.saveUpdateRaft();
      }
      console.info('social data>>',this.raftNameUpdatedForAlcor);
      this.maskValidateACPData.sort();
      this.maskValidateACPData.forEach( element => {
        this.mainValidateAcpData.push(this.validateACPData[element]);
      });
      const vair = {'alias':'New Raft alias','disableRadio':false,'qualifier': []}
      this.mainValidateAcpData.push(vair)
      this.displayParam = 'singlealcor';
      console.info('main data',this.mainValidateAcpData)
      document.getElementById('closeValidateAcplabelModel').click();
      if (this.displayParam == 'singlealcor'){
        document.getElementById('btnForsinglealcor').click();
        console.info('single Alcor')
      }
      
    }
    else if(subscribeData.length === 0){
      const vair = {'alias':'New Raft alias','disableRadio':false,'qualifier': []}
      this.mainValidateAcpData.push(vair)
      this.singleAlcorIden = this.validateAlcorValue;
      this.raftRadioVal = 'New Raft alias'
      this.paramsValidate = 'no';
      this.saveUpdateRaft();
    }
    console.info('alcor vals all>>',this.allAlcorRaftVals);
    console.info('alor',this.singleAlcorIden);
  }

  saveAccessPointRowId(val,aliass){
    this.accessPointRowIdHolder = val;
    if(aliass != '' && aliass != undefined){
      this.raftRadioVal = aliass;
    }
    console.info(this.raftRadioVal);
    console.info(aliass);
  }

  saveUpdateRaft(){
    let len;
    var tempu;
    let firstStr;
    let raftCodeData ={};
    let socialRaisonData={};
    console.info('main validate acp data>>',this.mainValidateAcpData);
    console.info('radio val>>',this.raftRadioVal);
    if(this.mainValidateAcpData.length > 0 && this.raftRadioVal != ''){

      this.validationSuccessValidateacp = true;

      this.raftCodeAddin = this.loadingSteps;
      this.raftNameAddin = this.loadingSteps;
      this.acpStatusChange = this.loadingSteps;
      this.disableSaveRaftBtn = true;
      if(this.raftRadioVal === 'New Raft alias'){
        this.accessPointRowIdHolder = '';
        if(this.mainValidateAcpData.length === 1){
          len = this.mainValidateAcpData.slice(-SiteDetailsComponent.TWO)[0]['alias'].length;
          this.paramsValidate = '00';
          tempu = '00'
          firstStr = this.singleAlcorIden;
          if(this.allAlcorRaftVals[firstStr]){
            tempu  = parseInt(this.allAlcorRaftVals[firstStr]);
            console.info("check for 100!")
            if(tempu < SiteDetailsComponent.NINETY_NINE){
              tempu  = tempu + 1
              this.already100Raft = false;

            }
            else{

              this.displayParam = '100raftalias';
              this.already100Raft = true;
            }
          }else{
            this.already100Raft = false;
          }
          console.info('default',this.singleAlcorIden);
          console.info(tempu,this.allAlcorRaftVals[firstStr]);
          console.info(len,this.paramsValidate,firstStr);
        }else{
          len = this.mainValidateAcpData.slice(-SiteDetailsComponent.TWO)[0]['alias'].length;
          this.paramsValidate = this.mainValidateAcpData.slice(-SiteDetailsComponent.TWO)[0]['alias'].slice(-SiteDetailsComponent.TWO);
          firstStr = this.mainValidateAcpData.slice(-SiteDetailsComponent.TWO)[0]['alias'].substring(0,len - SiteDetailsComponent.TWO);
          console.info(len,this.paramsValidate,firstStr)
          console.info(tempu,this.allAlcorRaftVals[firstStr]);
          tempu = parseInt(this.paramsValidate)
          if(this.allAlcorRaftVals[firstStr]){
            tempu  = parseInt(this.allAlcorRaftVals[firstStr]);
          }
          if(tempu < SiteDetailsComponent.NINETY_NINE){
            tempu  = tempu + 1
            this.already100Raft = false;

          }
          else{

            this.displayParam = '100raftalias';
            this.already100Raft = true;
          }
        }
        var c = tempu.toString().padStart(SiteDetailsComponent.TWO,'0');
        this.newRaftIdentifierModel = firstStr.toString() + c;
      }else{
        if(this.accessPointRowIdHolder != ''){
          console.info('not null acp holder');
          raftCodeData =
          {
            'effectiveDate' : this.validateACPDataAccessPoinId[this.accessPointRowIdHolder].effectiveDate,
            'endDate' : this.validateACPDataAccessPoinId[this.accessPointRowIdHolder].endDate
          }
          socialRaisonData =
          {
            'effectiveDate' : this.raftNameUpdatedForAlcor[this.accessPointRowIdHolder].effectiveDate,
            'endDate' : this.raftNameUpdatedForAlcor[this.accessPointRowIdHolder].endDate,
            'raftCodeName' : this.raftNameUpdatedForAlcor[this.accessPointRowIdHolder].identifierValue
          }
        }

        console.info(this.raftRadioVal)
        console.info('copying this data>>',raftCodeData,socialRaisonData);
        this.newRaftIdentifierModel = this.raftRadioVal;
        this.already100Raft = false;
      }
      console.info(this.newRaftIdentifierModel)
      if(this.newRaftIdentifierModel != undefined && this.already100Raft === false && this.newRaftIdentifierModel != ''){
        if(document.getElementById('btnForShowValidateAcp')){
          document.getElementById('btnForShowValidateAcp').click();
        }
        let const3;
        let const2;
        let sht;
        sht = `${this.cpyShortName.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH).padEnd(SiteDetailsComponent.SHORT_NAME_LENGTH,' ')} ${this.siteCity.slice(0, SiteDetailsComponent.CITY_SHORT_LENGTH)}`;
        console.info(this.alcorRadioVal);
        console.info(this.alcorRealEstateIdenData);
        if(this.alcorRealEstateIdenData[this.alcorRadioVal]){
          if(this.alcorRealEstateIdenData[this.alcorRadioVal].businessIdentifierName != ''){
            sht = `${this.alcorRealEstateIdenData[this.alcorRadioVal].businessIdentifierName.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH).padEnd(SiteDetailsComponent.SHORT_NAME_LENGTH,' ')} ${this.siteCity.slice(0, SiteDetailsComponent.CITY_SHORT_LENGTH)}`;
          }
        }
        if(this.accessPointRowIdHolder === ''){
          console.info('sht>>',sht);
          const3 = {
            "identifierTypeName" : "SOCIAL_RAISON",
            "sourceSystemId" : '2',
            "identifierValue" : sht,
            "identifierId":this.siteIdentTypesData['SOCIAL_RAISON'],
            "accessPointRowId" : this.rowIdforNewAlias
          }
          const2 = {
              "identifierId":this.siteIdentTypesData['RAFT_CODE'],
              "sourceSystemId":"2",
              "accessPointRowId" : this.rowIdforNewAlias,
              "identifierValue" : this.newRaftIdentifierModel,
              "effectiveDate" : this.apiService.getTodayDate()
          }
        }else{
          const3 = {
            "identifierTypeName" : "SOCIAL_RAISON",
            "sourceSystemId" : '2',
            "identifierValue" : socialRaisonData['raftCodeName'],
            "identifierId":this.siteIdentTypesData['SOCIAL_RAISON'],
            "accessPointRowId" : this.rowIdforNewAlias,
            "effectiveDate" : socialRaisonData['effectiveDate'],
            "endDate" : socialRaisonData['endDate']
          }
          const2 = {
              "identifierId":this.siteIdentTypesData['RAFT_CODE'],
              "sourceSystemId":"2",
              "accessPointRowId" : this.rowIdforNewAlias,
              "identifierValue" : this.newRaftIdentifierModel,
              "effectiveDate" : raftCodeData['effectiveDate'],
              "endDate" : raftCodeData['endDate']
          }
        }
        const datas = { "activeStatus" : "ACTIVE"};
        let tempRowId = '';
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, const2 ).subscribe( data => {
          this.raftCodeAddin = this.successSteps;
          tempRowId = data['rowId'];
          if(this.raftNameisNull === true){
            this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, const3).subscribe(() => {
              this.raftNameAddin = this.successSteps;
              document.getElementById('closeshowValidateAcpSteps').click();
               if(document.getElementById('btnFormultiplealcor')){
                document.getElementById('closeFormultipleAlcor').click();
               }
               if(document.getElementById('showValidateAcp')){
                 document.getElementById('showValidateAcp').click();
                }
               if(document.getElementById('btnForsinglealcor')){
                document.getElementById('closeForsingleAlcor').click();
              }setTimeout(function(){
            document.getElementById('closeshowValidateAcpSteps').click();
            }.bind(this),SiteDetailsComponent.CLOSE_MODAL_DELAY_MS)
               this.dispQualifiers('reload');
            },error => {
              this.raftNameAddin = `${this.dangerSteps}Error ${error.status}${this.dateForTO} ${this.endSpanSteps}`;
            });
          }else{
            this.raftNameAddin = `${this.dangerSteps}Raft Name already exists ${this.endSpanSteps}`;
            this.dispQualifiers('reload');
          }
          
        },error => {
          this.raftCodeAddin = `${this.dangerSteps}Error ${error.status}${this.dateForTO} ${this.endSpanSteps}`;
          this.raftNameAddin = `${this.dangerSteps}Error ${this.endSpanSteps}`;
        });

        this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowIdforNewAlias}`, datas).subscribe((_data:any) => {
            if (this.siteWorkflowStatus === 'WaitingForRenault') {
          const payload = { workflowStatus: 'Completed' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
          this.siteWorkflowStatus = 'Completed';
        });
        }
        // Update Site status to Active if not already Active
        if (this.siteActiveStatus && this.siteActiveStatus.toUpperCase() !== 'ACTIVE') {
          const sitePayload = { activeStatus: 'ACTIVE' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
            this.siteActiveStatus = 'ACTIVE';
          });
        } 
          this.acpStatusChange = this.successSteps;

          if(document.getElementById('btnFormultiplealcor')){
                document.getElementById('closeFormultipleAlcor').click();
               }
               if(document.getElementById('btnForsinglealcor')){
                console.info('closing single alcor')
                document.getElementById('closeForsingleAlcor').click();
               }                  
        },error => {
          this.acpStatusChange = `${this.dangerSteps}Error ${error.status} ${this.dateForTO}${this.endSpanSteps}`;
        });
        document.getElementById('closeValidateAcplabelModel').click();
      }else{
        this.displayParam = '100raftalias';
      }
    }
  }

updateSaveBusinessIdens(_callSep){

  const sht = this.cpyShortName.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH).trim();
  this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${this.validateAlcorValue}&_page=1`).
  subscribe(data101 => {
    if(data101['pageCount'] === 0){
      const constRaft = {
        'sourceSystemId' : '2',
        'businessIdentifierId' : this.siteIdentTypesData['RAFT_ACCOUNT'],
        'effectiveDate' : this.apiService.getTodayDate(),
        'businessIdentifierName' : sht,
        'realEstateAssetId' : this.siteId,
        'businessIdentifierValue' : this.validateAlcorValue
      }
      this.sitesService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`,constRaft).subscribe(() => {

      });
    }else if(data101['pageCount'] === 1){
      if(data101['real-estate-asset-identifiers'][0]['endDate'] != ''){
        const noEndDate = {'endDate' : ''};
        this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${data101['real-estate-asset-identifiers'][0]['rowId']}`,noEndDate).subscribe(() => {

        });
      }
      const updateShortName = {'businessIdentifierName' : sht}
      this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${data101['real-estate-asset-identifiers'][0]['rowId']}`,updateShortName).subscribe(() => {

      });
    }
  });
}

  getACPIdensUpdatePagination1(page,subscribeData = []){
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointIdentifier=in(${this.accessIdentValues})&_page=${page}`).subscribe(data => {
      if(data['access-point-identifiers'].length > 0){
        data['access-point-identifiers'].forEach(e => {
          subscribeData.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getACPIdensUpdatePagination1(page+1,subscribeData);
        }else if(data['maxPage'] === page){
          this.getACPIdensUpdatePagination2(1,subscribeData);
        }
      }else{
        this.getACPIdensUpdatePagination2(1,subscribeData);
      }
    });
  }

  getACPIdensUpdatePagination2(page,subscribeData,subscribeData1= []){
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=RAFT_CODE&identifierValue=*${this.alcorRadioVal}*&_page=${page}`).subscribe(data => {
      if(data['access-point-identifiers'].length > 0){
        data['access-point-identifiers'].forEach(e => {
          subscribeData1.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getACPIdensUpdatePagination2(page+1,subscribeData,subscribeData1);
        }else if(data['maxPage'] === page){
          this.sortGetACPIdensData(subscribeData,subscribeData1);
        }
      }else{
        this.sortGetACPIdensData(subscribeData,subscribeData1);
      }
    });
  }

  sortGetACPIdensData(subscribeData,subscribeData1){
    if(subscribeData1.length > 0){
      subscribeData1.forEach(eleCon => {
        if(this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] === undefined){
          this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] = [];
        }
        const split = eleCon.identifierValue.slice(SiteDetailsComponent.RAFT_SUFFIX_START, SiteDetailsComponent.RAFT_SUFFIX_END);
        if(this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)].length > 0){
          if(this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] > split){

          }else{
            this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] = split;
          }
        }else{
          this.allAlcorRaftVals[eleCon.identifierValue.slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH)] = split;
        }
      });

    }
    console.info(this.allAlcorRaftVals);
    if(subscribeData.length > 0){
      subscribeData.forEach( ele =>{
        if(ele.identifierValue.slice(0,ele.identifierValue.length-SiteDetailsComponent.TWO) === this.alcorRadioVal && ele.identifierTypeName === 'RAFT_CODE'){
          this.validateACPDataAccessPoinId[ele.accessPointRowId]=(ele);
          let vai = [];
          vai['alias'] = ele.identifierValue;
          vai['rowId'] = ele.accessPointRowId;
          vai['effectiveDate'] = ele.effectiveDate;
          vai['endDate'] = ele.endDate;
          vai['qualifierDesignation'] = ele.sourceSystemName;
          if(vai['qualifier'] === undefined){
            vai['qualifier'] = [];
          }
          vai['qualifier'].push(ele.accessPointType)
          if(this.validateACPData[ele.identifierValue]){
            this.validateACPData[ele.identifierValue]['qualifier'].push(ele.accessPointType)
          }
          else{
          this.validateACPData[ele.identifierValue] = vai;
          this.maskValidateACPData.push(ele.identifierValue)
          this.accessPointRowIds.push(ele.accessPointRowId)
          }
          if(this.validateACPData[ele.identifierValue]['qualifier'].indexOf(this.disableType) != -1){
            this.validateACPData[ele.identifierValue]['disableRadio'] = true;
          }
          else{
            this.validateACPData[ele.identifierValue]['disableRadio'] = false;
          }
        }
        if(ele.identifierTypeName === 'SOCIAL_RAISON'){
          this.raftNameUpdatedForAlcor[ele.accessPointRowId] = ele;
        }
      });
    }
    this.loadingValidateAcp = false;
    this.loadingValidateAcpSaer=false
    this.maskValidateACPData.sort();
    const vair = {'alias':'New Raft alias','disableRadio':false,'qualifier': []};

    this.maskValidateACPData.forEach( element => {
      this.mainValidateAcpData.push(this.validateACPData[element]);
    });
    this.mainValidateAcpData.push(vair);
    console.info("main",this.mainValidateAcpData)
    if(this.mainValidateAcpData.length === 1){
      this.raftRadioVal = 'New Raft alias';
      this.saveUpdateRaft();
    }else{
      this.displayParam = 'singlealcor';
      document.getElementById("btnFormultiplealcor").click();
      document.getElementById('btnForsinglealcor').click();
      console.info('single Alcor')
    }
    console.info(this.mainValidateAcpData);
    console.info('BOL',this.validateACPDataAccessPoinId);
  }

  openAlcorVal(){
    this.displayParam = 'loading';
    this.loadingValidateAcp = true;
    this.getACPIdensUpdatePagination1(1);
    this.singleAlcorIden = this.alcorRadioVal;
  }

  saveRaftNameandStatus(_editRowIdForAlias,limit){
    if( this.raftNameisNull === true && limit === 0){
      const short = `${this.cpyShortName.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH).trim()} ${this.siteCity.slice(0, SiteDetailsComponent.CITY_SHORT_LENGTH)}`
      const const3 = {
          "identifierTypeName" : "SOCIAL_RAISON",
          "sourceSystemId" : '2',
          "identifierValue" : short,
          "identifierId":this.siteIdentTypesData['SOCIAL_RAISON'],
          "accessPointRowId" : this.rowIdforNewAlias
        }
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, const3).subscribe(() => {
          });
    }
    if(limit === 0){
      const datas = { "activeStatus" : "ACTIVE", "endDate" : ""};
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowIdforNewAlias}`, datas).subscribe((_data:any) => {
        if (this.siteWorkflowStatus === 'WaitingForRenault') {
          const payload = { workflowStatus: 'Completed' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
          this.siteWorkflowStatus = 'Completed';
        });
        }
        // Update Site status to Active if not already Active
        if (this.siteActiveStatus && this.siteActiveStatus.toUpperCase() !== 'ACTIVE') {
          const sitePayload = { activeStatus: 'ACTIVE' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
            this.siteActiveStatus = 'ACTIVE';
          });
        }
        document.getElementById('closeValidateAcp').click();
        this.dispQualifiers('reload');
      });
    }
    limit++;
  }
  selectInputField(alias){
    if(alias != '' && alias != undefined){
    this.alcorRadioVal = alias
    }
  }
  selectInputFieldRaftselect(aliass,disableradio){
    if(aliass != '' && aliass != undefined && disableradio === false){
      this.raftRadioVal = aliass;
    }
  }
  changeCompanyFn(page =1,pageSize=SiteDetailsComponent.TWENTY){ 
    const c  = this.editCompanyField.split('--');
    this.autoload=true
    console.info(this.editCompanyField);
    if(c[0] != '' && c[0] != undefined){
      this.companyfielderror = false;
      this.saveDatas = "Save";
      this.editAlcorField = '';
      this.cpyRowIdHolder = '';
      this.changeCpyAllianceId = '';
      this.cpyNameForChangeCpy = '';
      if(c[0].length > SiteDetailsComponent.TWO){
        this.showChangeCpyLoading = true;
        this.cpyRowIdHolder = '';
        this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?legalName=*${encodeURIComponent(c[0])}*&_page=${page}&_pagesize=${pageSize}`).subscribe(data => {
          this.autoload=false
          if(data['pageCount'] > 0){
            this.changeCpyData = "";
            this.changeCpyData = [];
            data['companies'].forEach(ele => {
              if(ele.companyStatusCode.toLowerCase() != 'archived'){
                this.changeCpyData.push(ele.legalName);
                this.changeCpyRowIds[ele.allianceIdentifier] = ele.rowId;
                this.allianceIdOnCpyName[ele.legalName] = ele.allianceIdentifier;
              }
            });
            this.cpyRowIdHolder = this.changeCpyRowIds[c[1]];
            this.changeCpyAllianceId = c[1];
            this.cpyNameForChangeCpy = c[0];
          }
          this.showChangeCpyLoading = false;
        });
      }
    }else {
      console.info('4602')
      this.companyfielderror = true;
    }
  }

  changeCompanyAlcorFn(page=1,pagesize=SiteDetailsComponent.TWENTY){ 
    this.autoload2=true
    const alcor = this.editAlcorField.trim();
    if(alcor != undefined && alcor != '' && alcor.length > SiteDetailsComponent.THREE){
      this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierTypeId=1&value=*${alcor}*&_page=${page}&_pagesize=${pagesize}`).subscribe(data => {
        if(data['pageCount'] > 0){
          data['company-identifiers'].forEach(elements => {
            if(this.changeCpyDataAlcor.indexOf(elements.value) === -1){
              this.changeCpyDataAlcor.push(elements.value);
            }
            this.changeCpyDataALcorCpy[elements.value] = elements.companyAllianceIdentifier;
            this.autoload2=false
          });
          if(alcor.length === SiteDetailsComponent.SIX){
            this.getCompanyListOfAlcor();
          }
        }
      });
    }
  }

  changeCompanyFnAllianceId(page=1,pagesize=SiteDetailsComponent.TWENTY){
    this.autoload1=true
    const allianceId = this.editAllianceIdField ? this.editAllianceIdField.trim() : this.editAllianceIdField
    if(allianceId != '' && allianceId != undefined && allianceId.length > SiteDetailsComponent.FOUR){
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${allianceId}*&_page=${page}&_pagesize=${pagesize}`).subscribe(data => {
        if(data['pageCount'] > 0){
          data['companies'].forEach(elements => {
            if(this.changeCpyDataAllianceId.indexOf(elements.allianceIdentifier) === -1){
              this.changeCpyDataAllianceId.push(elements.allianceIdentifier);
            }
            this.allianceIdOnCpyName[elements.allianceIdentifier] = elements.legalName;
            this.changeCpyRowIds[elements.allianceIdentifier] = elements.rowId;
          });
          this.autoload1=false
        }
      });
    }
  }

  onIdentivalueSelect(selected){
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ){
      this.editAlcorField = selected;
      this.showChangeCpyLoading = true;
      this.getCompanyListOfAlcor();
    }
  }

  onIdentivalueSelectUpdateCpy(selected){
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ){
      this.editAllianceIdField = this.allianceIdOnCpyName[selected];
      this.delayCpyResponseAllianceId.setValue(this.allianceIdOnCpyName[selected])
      this.companyfielderror = false
    }
  }

  onIdentivalueSelectUpdateAlliance(selected){
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ){
      this.editCompanyField = this.allianceIdOnCpyName[selected];
      this.delayCpyResponse.setValue(this.allianceIdOnCpyName[selected])
      this.cpyNameForChangeCpy = this.editCompanyField;
      this.companyfielderror = false;
    }
  }

  getCompanyListOfAlcor(){
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=${this.changeCpyDataALcorCpy[this.editAlcorField.trim()]}`).subscribe(data => {
      if(data['companies'].length > 0){
        this.cpyRowIdHolder = data['companies'][0]['rowId'];
        this.changeCpyAllianceId = data['companies'][0]['allianceIdentifier'];
        this.cpyNameForChangeCpy = data['companies'][0]['legalName'];
        this.changeCpyRowIds[data['companies'][0]['allianceIdentifier']] = data['companies'][0]['rowId'];
        this.editCompanyField = this.cpyNameForChangeCpy;
        this.delayCpyResponse.setValue(this.cpyNameForChangeCpy)
        this.editAllianceIdField = this.changeCpyAllianceId;
        this.delayCpyResponseAllianceId.setValue(this.changeCpyAllianceId)
        this.companyfielderror = false;
      }
      this.showChangeCpyLoading = false;
    });
  }

  resetcpyfield(tab){
    if(tab === 'cpy'){
      this.editCompanyField = '';
      this.delayCpyResponse.setValue('')
      this.companyfielderror = true;
    }else if(tab === 'allianceId'){
      this.editAllianceIdField = '';
      this.delayCpyResponseAllianceId.setValue('')
    }else{
      this.editAlcorField = '';
      this.delayCpyAlcorResponse.setValue('')
    }
  }
  resetInputField(para = ''){
    this.showParam = '';
    this.bvdidchangecpyfielderror = false;
    this.editAllianceIdField = '';
    this.allianceIdOnCpyName = [];
    this.changeCpyRowIds = [];
    this.disableUpdateCpyBtn = false;
    this.changeCpyBvdModel = '';
    this.delayCpyAlcorResponse.setValue('');
    this.delayCpyResponseAllianceId.setValue('');
    this.delayCpyResponse.setValue('');
    setTimeout(()=>{
      this.companyfielderror = false
    },SiteDetailsComponent.POLLING_DELAY_MS)
    this.companyfielderror = false

    if(this.mainEntranceExists === true){

      if(para === 'fromLook'){
        const split = this.raftCpyGroupModel.split('@@');
        if(split[0] != ''){
          this.disableNg2Cpy = true;
        }else{
          this.disableNg2Cpy = false;
        }
        this.showChangeCpyLoading = false;
        this.editCompanyField = split[2];
        this.changeCpyAllianceId = split[1];
        this.editAllianceIdField = split[1];
        this.cpyRowIdHolder = split[0];
        this.cpyNameForChangeCpy = split[2];
        if(this.cpyRowIdHolder === this.companyId){
          document.getElementById('btnForLinkToSameSite').click();
        }else{
          document.getElementById('btnForChangeCompany').click();
          this.autoload = false
          this.changeCompanyFnSave('fromlookforcpy');
        }
      }else{
        /**CHECK link with company for site */
        if(this.noSiteAssn === false){ 
          document.getElementById('btnForChangeCompany').click(); 
          this.disableNg2Cpy = false;
          this.editCompanyField = '';
          this.editAlcorField = '';
          this.companyfielderror = false;
          this.cpyRowIdHolder = '';
          this.changeCpyRowIds = [];
        }else{ 
          this.showParam = 'existAlcor';
          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${this.siteId}`).subscribe(data => {
            if(data['real-estate-asset-identifiers'].length > 0){
              let isExistIden = false;
              data['real-estate-asset-identifiers'].forEach(ele => {
                if(ele.endDate === ''){
                  isExistIden = true;
                }
              });
              if(isExistIden){
                document.getElementById('btnForNoMainEntranceQualifier').click();
              }else{
                document.getElementById('btnForChangeCompany').click();
              }
            }else{
              document.getElementById('btnForChangeCompany').click();
            }
          });
          this.showChangeCpyLoading = false;
          this.autoload = false
          this.disableNg2Cpy = false;
          this.editCompanyField = '';
          this.editAlcorField = '';
          this.companyfielderror = false;
          this.bvdidchangecpyfielderror = false;
          this.cpyRowIdHolder = '';
        }
      }
    }else{
      this.showParam = 'mainEntrance';
      document.getElementById('btnForNoMainEntranceQualifier').click();
    }

  }

  resetChangeCpyBvdId(){
    this.changeCpyBvdModel = '';
    this.loadingBvdsearch = '';
    this.bvdidchangecpyfielderror = true;
    this.bvdIdRegExError = false;
  }

  checkCpyLinkToSite(page,from,subscribeData = []){
    this.cpyRowIdHolder = this.changeCpyRowIds[this.editAllianceIdField];
    if(this.cpyRowIdHolder != '' && this.cpyRowIdHolder != undefined && this.editCompanyField != '' && this.editCompanyField != undefined){
      this.disableUpdateCpyBtn = true;
      this.validationSuccessUpdateCpy = true;
      if(this.siteAssignmentRowId != '' && from === ''){
        from = 'exist';
      }else{
        from = 'doesnotexist';
      }
      this.UClegalEntity = this.loadingSteps;
      this.UCcatergoryName = this.loadingSteps;
      this.UCrealEstateIdens = this.loadingSteps;
      this.UCdelAlcorPrevCpy = this.loadingSteps;
      this.UCdelRaftAcc = this.loadingSteps;
      this.UCchangeSiteName = this.loadingSteps;
      this.UCnewSiteAssn = this.loadingSteps;
      this.UCnewBvdId = this.loadingSteps;
      this.UCnewBusinessE = this.loadingSteps;
      this.UCarchiveLink = this.loadingSteps;
      this.UCcheckDupLink = this.loadingSteps;
      document.getElementById('btnForUpdateCpySteps').click();
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}&_page=${page}`).subscribe(data0 => {
        if(data0['site-assignments'].length > 0){
          data0['site-assignments'].forEach(e => {
            subscribeData.push(e);
          });
          if(data0['maxPage'] > 1 && data0['maxPage'] != page){
            this.checkCpyLinkToSite(page+1,from,subscribeData);
          }else if(data0['maxPage'] === page){
            let doNotGoFurther = false;
            subscribeData.forEach((e,index) => {
              console.info(index,subscribeData.length);
              if(e.businessEntityCompanyId === this.cpyRowIdHolder && doNotGoFurther === false){
                doNotGoFurther = true;
                if(e.status.toLowerCase() === 'validated'){ 
                  this.UCcheckDupLink = `${this.dangerSteps}Same Site Update Active${this.endSpanSteps}`;
                  document.getElementById('btnForWarnSameSite').click();
                  this.disableUpdateCpyBtn = false;
                }else if(e.status.toLowerCase() === 'archived'){ 
                  console.info('unarchive link');
                  if(this.changeCpyBvdModel != ''){
                    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.changeCpyBvdModel}`).subscribe(data => {
                      if(data['business-entity-identifiers'].length > 0){
                        if(data['business-entity-identifiers'][0]['endDate'] != ''){
                          const updateBvd = { endDate : '' , businessEntityId : e.businessEntityId}
                          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${data['business-entity-identifiers'][0]['row_id']}` , updateBvd).subscribe(() => {
                            this.UCcheckDupLink = `${this.successSingleSteps}Same Site Update Archived${this.endSpanSteps}`;
                          },error => {
                            this.UCcheckDupLink = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
                          });
                          this.unarchiveSiteCpylink(e.rowId);
                          this.changeParamsforNewCpy(from);


                        }else{
                          if(data['business-entity-identifiers'][0]['value'] === this.sitebvidid){
                            const updateBvd1 = {businessEntityId : e.businessEntityId}
                            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${data['business-entity-identifiers'][0]['row_id']}` , updateBvd1).subscribe(() => {
                              this.UCcheckDupLink = `${this.successSingleSteps}Same Site Update Archived${this.endSpanSteps}`;
                            },error => {
                              this.UCcheckDupLink = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
                            });
                            if(from=='fromlookforcpy'){
                              this.unarchiveSiteCpylink(e.rowId,'no');
                              this.changeParamsforNewCpy(from);
                            }else{

                              this.unarchiveSiteCpylink(e.rowId,'no');
                              this.changeParamsforNewCpy(from);
                            }
                          }else{
                            document.getElementById('btnForBvdIdStatus').click();
                            this.bvdIdStatusText = 'BvD ID already attached to another Site';
                            this.disableUpdateCpyBtn = false;
                          }
                        }
                      }else{
                        if(from=='fromlookforcpy'){
                          this.unarchiveSiteCpylink(e.rowId);
                          this.changeParamsforNewCpy(from);
                        }else{
                          if(this.tempBvdId != ''){
                            this.unarchiveSiteCpylink(e.rowId);
                            const archiveBvd = { endDate : this.apiService.getTodayDate()}
                            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`).subscribe(data3 => {
                              if(data3 != null){
                                if(data3['endDate'] === ''){
                                  this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,archiveBvd).subscribe(() => {
                                    this.changeParamsforNewCpy(from);
                                  });
                                }else{
                                  this.changeParamsforNewCpy(from);
                                }
                              }
                            });
                          }else{
                            this.unarchiveSiteCpylink(e.rowId);
                            this.changeParamsforNewCpy(from);
                          }
                        }
                      }
                    });
                  }else if(this.changeCpyBvdModel === ''){
                    this.unarchiveSiteCpylink(e.rowId);
                    this.changeParamsforNewCpy(from);
                  }
                }
              }else if(index + 1 === subscribeData.length && doNotGoFurther === false && e.businessEntityCompanyId != this.cpyRowIdHolder){
                console.info('called caution');
                this.UCcheckDupLink = this.successSteps;
                this.checkForBvdStatus(from);
              }
            });
          }
        }else{
          this.UCcheckDupLink = this.successSteps;
          this.UCarchiveLink = `${this.successSingleSteps}No previous link${this.endSpanSteps}`;
          this.checkForBvdStatus(from);
        }
      });
    }else{
      this.validationSuccessUpdateCpy = false;
      if(this.editCompanyField === '' || this.cpyRowIdHolder === ''){
        this.companyfielderror = true;
      }
    }
  }

  unarchiveSiteCpylink(id,archive='yes'){
    const unarchiveLink = { validityEndDate : '' , status : 'VALIDATED' }
    this.supplierService.updateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${id}` , unarchiveLink).subscribe(_data => {
      const archiveBvd = { endDate : this.apiService.getTodayDate()}
      const archiveLink =
      {
        validityEndDate : this.apiService.getTodayDate(),
        status          : 'ARCHIVED'
      }
      if(this.siteAssignmentRowId != '' && this.siteAssignmentRowId != undefined){
        this.supplierService.updateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${this.siteAssignmentRowId}`,archiveLink).subscribe(() => {
          this.UCarchiveLink = this.successSteps;
          if(this.tempBvdId != '' && archive === 'yes'){
                  this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,archiveBvd).subscribe(() => {
                  });
          }
        });
      }
    });
  }

  checkForBvdStatus(from=''){
    this.cpyRowIdHolder = this.changeCpyRowIds[this.editAllianceIdField];
    if(this.cpyRowIdHolder != '' && this.cpyRowIdHolder != undefined && this.editCompanyField != '' && this.editCompanyField != undefined && this.changeCpyBvdModel != ''){
      this.disableUpdateCpyBtn = true;

      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.changeCpyBvdModel}`).subscribe(data => {
        if(data['business-entity-identifiers'].length > 0){
          if(data['business-entity-identifiers'][0]['endDate'] != ''){
            this.changeCompanyFnSave(from);
          }else{
            if(data['business-entity-identifiers'][0]['value'] === this.sitebvidid){
              if(from=='fromlookforcpy'){
                this.changeCompanySiteAssnNoExist(from);
              }else{

                this.updateSameBvdOnSameSite(from);
              }
            }else{
              document.getElementById('btnForBvdIdStatus').click();
              this.bvdIdStatusText = 'BvD ID already attached to another Site';
            }
          }
        }else{
          if(from=='fromlookforcpy'){
            this.changeCompanySiteAssnNoExist(from);
          }else{
            if(this.tempBvdId != ''){
              const archiveBvd = { endDate : this.apiService.getTodayDate()}
              this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`).subscribe(data3 => {
                if(data3 != null){
                  if(data3['endDate'] === ''){
                    this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,archiveBvd).subscribe(() => {
                      this.changeCompanyFnSave(from);
                    });
                  }else{
                    this.changeCompanyFnSave(from);
                  }
                }
              });
            }else{
              this.changeCompanyFnSave(from);
            }
          }
        }
      });
    }else if(this.changeCpyBvdModel === '' && this.editCompanyField != '' && this.cpyRowIdHolder != ''){ 
      this.UCnewBvdId = this.successSteps;
      if(this.siteAssignmentRowId != ''){
        const archiveBvd = { endDate : this.apiService.getTodayDate()}
        const archiveLink =
          {
            validityEndDate : this.apiService.getTodayDate(),
            status          : 'ARCHIVED'
          }
        this.supplierService.updateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${this.siteAssignmentRowId}`,archiveLink).subscribe(() => {
          this.UCarchiveLink = this.successSteps;
          if(this.tempBvdId != ''){
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`).subscribe(data3 => {
                if(data3['endDate'] === ''){
                  this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,archiveBvd).subscribe(() => {
                  });
                }
            });
          }
          let tempBusinessRowId;
          const const1 = {
            'companyId' : this.cpyRowIdHolder,
            'isHQ'      : 'N'
          }
          this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`,const1).subscribe(data => {
            this.UCnewBusinessE = this.successSteps;
            tempBusinessRowId = data['row_id'];
            const const3 = {
              "validityStartDate": this.apiService.getTodayDate(),
              "status" : "VALIDATED",
              "businessEntityId" : tempBusinessRowId
            }
            this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}`,const3).subscribe(() => {
              this.UCnewSiteAssn = this.successSteps;
              let para = 'exist';
              if(this.noSiteAssn === true){
                para = 'doesnotexist';
              }
              this.changeParamsforNewCpy(para);
            },error => {
              this.UCnewSiteAssn = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
            });
          },error => {
            this.UCnewBusinessE = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
            this.UCnewSiteAssn = `${this.dangerSteps}Error${this.endSpanSteps}`;
          });
        },error => {
          this.UCarchiveLink = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
          this.UCnewBusinessE = `${this.dangerSteps}Error${this.endSpanSteps}`;
          this.UCnewSiteAssn = `${this.dangerSteps}Error${this.endSpanSteps}`;
        });
      }else{
        this.UCarchiveLink = `${this.successSingleSteps}No previous link${this.endSpanSteps}`;
        const const1 = {
          'companyId' : this.cpyRowIdHolder,
          'isHQ'      : 'N'
        }
        this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`,const1).subscribe(data => {
          this.UCnewBusinessE = this.successSteps;
          const tempBusinessRowId = data['row_id'];
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status" : "VALIDATED",
            "businessEntityId" : tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}`,const3).subscribe(() => {
            this.UCnewSiteAssn = this.successSteps;
            let para = 'exist'
            if(this.noSiteAssn === true){
              para = 'doesnotexist'
            }
            this.changeParamsforNewCpy(para);
          },error => {
            this.UCnewSiteAssn = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
          });
        },error => {
          this.UCnewBusinessE = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
          this.UCnewSiteAssn = `${this.dangerSteps}Error${this.endSpanSteps}`;
        });
      }
    }else{
      if(this.editCompanyField === '' || this.cpyRowIdHolder === ''){
        this.companyfielderror = true;
      }
    }
  }

  updateSameBvdOnSameSite(_from){
    const archiveLink =
    {
      validityEndDate : this.apiService.getTodayDate(),
      status          : 'ARCHIVED'
    }
    this.supplierService.updateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${this.siteAssignmentRowId}`,archiveLink).subscribe(() => {
      const const1 =
        {
          'companyId' : this.cpyRowIdHolder,
          'isHQ'      : 'N'
        }
        this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`,const1).subscribe(data => {
          const tempBusinessRowId = data['row_id'];
          const newBusinessEntity =
          {
            businessEntityId : tempBusinessRowId
          }
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`,newBusinessEntity).subscribe(() => {

          });
          const const3 =
          {
            "validityStartDate": this.apiService.getTodayDate(),
            "status" : "VALIDATED",
            "businessEntityId" : tempBusinessRowId
           }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}`,const3).subscribe(() => {
              let para = 'exist'
              if(this.noSiteAssn === true){
                para = 'doesnotexist'
              }
              this.changeParamsforNewCpy(para);
          });
        });
    });
  }

  changeCompanyFnSave(from=''){
    if(this.cpyRowIdHolder != '' && this.cpyRowIdHolder != undefined && this.editCompanyField != '' && this.editCompanyField != undefined && this.changeCpyBvdModel != ''){
      this.companyfielderror = false;
      if(from != 'fromlookforcpy'){
        this.cpyRowIdHolder = this.changeCpyRowIds[this.editAllianceIdField];
        this.proxyFnForChangeCpy();
      }else{
        this.changeCompanySiteAssnNoExist(from);
      }
      console.info(this.changeCpyBvdModel);
    }else {
      if(from=='fromlookforcpy'){
        this.changeCompanySiteAssnNoExist(from);
      }
      if(this.editCompanyField === '' || this.cpyRowIdHolder === ''){
        this.companyfielderror = true;
      }
    }
  }

  proxyFnForChangeCpy(){
    if(this.noSiteAssn === true){ 
      this.changeCompanySiteAssnNoExist();
      this.saveDatas = 'Saving...';
    }else { 
      this.changeCompanySiteAssnExist('exist');
      this.saveDatas = 'Saving...';
    }
  }

  changeCompanySiteAssnExist(from){
    console.info('beforesaving',this.cpyRowIdHolder);
    if(this.editCompanyField != '' && this.cpyRowIdHolder != '' && this.cpyRowIdHolder != undefined){
      this.validationSuccessUpdateCpy = true;
      const archiveLink =
      {
        validityEndDate : this.apiService.getTodayDate(),
        status          : 'ARCHIVED'
      }
      this.supplierService.updateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${this.siteAssignmentRowId}`,archiveLink).subscribe(() => {
        this.UCarchiveLink = this.successSteps;
        this.changeCompanySiteAssnNoExist(from);
      },error => {
        this.UCarchiveLink = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
      });
    }else{
      this.validationSuccessUpdateCpy = false;
      if(this.editCompanyField === ''){
        this.companyfielderror = true;
      } else {
        this.companyfielderror = false;
      }
    }
  }

  changeCompanySiteAssnNoExist(from=''){
    let tempBusinessRowId;
    const const1 = {
      'companyId' : this.cpyRowIdHolder,
      'isHQ'      : 'N'
    }
    this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`,const1).subscribe(data => {
      this.UCnewBusinessE = this.successSteps;
      console.info('changeCompanySiteAssnNoExist',from);
      tempBusinessRowId = data['row_id'];
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
        if(data1['pageCount'] > 0){

        }
        else{
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD%20ID&value=${this.changeCpyBvdModel}&_page=1`).subscribe(data => {
            if(data['pageCount'] === 0){
              const const2 = {
                "businessEntityIdentifierTypeId"    :"1",
                "businessEntityIdentifierTypeName"  :"BVD ID",
                "startDate"                         : this.apiService.getTodayDate(),
                "businessEntityId"                 : tempBusinessRowId,
                "value"                             : this.changeCpyBvdModel
              }
              this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(() => {
                this.UCnewBvdId = this.successSteps;
              },error => {
                this.UCnewBvdId = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
              });
            }else{
              this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${data['business-entity-identifiers'][0]['row_id']}`).subscribe(() => {
                const const2 = {
                  "businessEntityIdentifierTypeId"    :"1",
                  "businessEntityIdentifierTypeName"  :"BVD ID",
                  "startDate"                         : this.apiService.getTodayDate(),
                  "businessEntityId"                 : tempBusinessRowId,
                  "value"                             : this.changeCpyBvdModel
                }
                this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(() => {

                });
              });
            }
          });

        }
        const const3 = {
          "validityStartDate": this.apiService.getTodayDate(),
          "status" : "VALIDATED",
          "businessEntityId" : tempBusinessRowId
        }
        this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${this.siteId}`,const3).subscribe(() => {
          this.UCnewSiteAssn = this.successSteps;
          if(from === ''){
            this.changeParamsforNewCpy('doesnotexist');
          }else if(from != ''){
            this.changeParamsforNewCpy(from);
          }else{
            this.saveDatas = 'Saving...'
            this.reloadCurrentPage();

          }
        },error => {
          this.UCnewSiteAssn = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
        });
      });
    },error => {
      this.UCnewBusinessE = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
    });
  }

  changeParamsforNewCpy(con){ 
    this.cpyAlcorToRaft = [];
    let shortName;
    if(this.cpyRowIdHolder != '' && this.cpyRowIdHolder != undefined){
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${this.cpyRowIdHolder}`).subscribe(data1 => {
        const siteName = `${data1['legalName']} ${this.siteCity}`;
        const const1 = { "name" : siteName}
        this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, const1).subscribe(() => {
          this.UCchangeSiteName = this.successSteps;
        },error => {
          this.UCchangeSiteName = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
        });
        this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.cpyRowIdHolder}`).subscribe(data2 => {
          if(data2['company-names'].length > 0){
             shortName = data2['company-names'][0].value;
          }else {
            shortName = data1['legalName'].slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH);
          }
          this.getRealEstateAssignsUC(con,1,shortName);
        });
        this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${this.siteId}&identifierType=SHORT_NAME`).subscribe(data3 => {
          if(data3['real-estate-asset-identifiers'].length > 0){ 
            const tempShtNameRowId = data3['real-estate-asset-identifiers'][0]['rowId'];

            const const1 = {'endDate' : this.apiService.getTodayDate()}
            this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${tempShtNameRowId}`,const1).subscribe(() => {

            });
          }
        });
      });
      this.changeRealEstateAssignments(con); 
    }
  }

  getRealEstateAssignsUC(con,page = 1,shortName, subscribeData = []){
    this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${this.siteId}&identifierType=RAFT_ACCOUNT&_page=${page}`).subscribe(data => {
      if(data['real-estate-asset-identifiers'].length > 0){
        data['real-estate-asset-identifiers'].forEach(e => {
          subscribeData.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getRealEstateAssignsUC(con,page+1,subscribeData);
        }else if(data['maxPage'] === page){
          let counte = 0;
          if(subscribeData.length > 0){
            subscribeData.forEach((ele,index) => {
              this.cpyAlcorToRaft.push(ele.businessIdentifierValue);
              this.arrBasedOnVal[ele.businessIdentifierValue] = ele.rowId;
              if(con === 'exist'){
                this.sitesService.deleteRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${ele.rowId}`).subscribe(() => {
                  if(index+1 === subscribeData.length){
                    this.UCdelRaftAcc = this.successSteps;
                  }
                },error => {
                  ++counte;
                  this.UCdelRaftAcc = `${this.dangerSteps}Error Deleting -${counte}Status ${error.status} ${this.dateForTO}${this.endSpanSteps}`;
                });
              }else{
                this.UCdelRaftAcc = this.successSteps;
              }
            });
          }else{
            this.UCdelRaftAcc = this.successSteps;
          }
          this.getCpyIdensUC(con,1,shortName,subscribeData);
        }
      }else{
        this.getCpyIdensUC(con,1,shortName,subscribeData);
        this.UCdelRaftAcc = this.successSteps;
      }
    });
  }

  getCpyIdensUC(con,page = 1,shortName,subscribeData,subscribeData1 = []){
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.cpyRowIdHolder}&companyIdentifierKeyName=ALCOR&_page=${page}`).subscribe(data => {
      if(data['company-identifiers'].length > 0){
        data['company-identifiers'].forEach(e => {
          subscribeData1.push(e);
        });
      }else{
        this.UCrealEstateIdens = this.successSteps;
        this.UCdelAlcorPrevCpy = this.successSteps;
      }
      if(data['maxPage'] > 1 && data['maxPage'] != page){
        this.getCpyIdensUC(con,page+1,shortName,subscribeData,subscribeData1);
      }else if(data['maxPage'] === page){
        let alcorValsOfCpy=[];
        let searchAlcorVal=[];
        let idensData:any=[];
        subscribeData1.forEach(elem => {
          searchAlcorVal.push(`'${elem.value}'`);
          alcorValsOfCpy.push(elem.value);
          idensData[elem.value]=elem;
        });
        if(searchAlcorVal.length > 0){
          this.getRealEstateIdens2UC(con,searchAlcorVal,alcorValsOfCpy,idensData,shortName,subscribeData);
        }else{
          let counte = 0;
          subscribeData.forEach((elementA,index) => {
            if(con === 'exist' && (alcorValsOfCpy.indexOf(elementA.businessIdentifierValue) === -1)){
              this.sitesService.deleteRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${elementA.rowId}`).subscribe(() => {
                if(index+1 === subscribeData.length){
                  this.UCdelAlcorPrevCpy = this.successSteps;
                }
              },error => {
                ++counte;
                this.UCdelRaftAcc = `${this.dangerSteps}Error Deleting${counte}${error.status}${this.dateForTO}${this.endSpanSteps}`;
              });
            }else if(con != 'exist'){
              this.UCdelAlcorPrevCpy = this.successSteps;
            }
          });
        }
        if(con === 'exist'){
          this.changeAccessPointsToPending();
        }
      }
    });
  }

  getRealEstateIdens2UC(con,searchAlcorVal,alcorValsOfCpy,idensData,shortName,mainRealData,page=1,subscribeData=[]){
    this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${searchAlcorVal})&identifierType=RAFT_ACCOUNT&_page=${page}`).subscribe(data => {
      if(data['real-estate-asset-identifiers'].length > 0){
        data['real-estate-asset-identifiers'].forEach(e => {
          subscribeData.push(e);
        });
      }
      if(data['maxPage'] > 1 && data['maxPage'] != page){
        this.getRealEstateIdens2UC(con,searchAlcorVal,alcorValsOfCpy,idensData,shortName,mainRealData,page+1,subscribeData);
      }else if(data['maxPage'] === page){
        let allSitesAlcorVals = [];
        if(subscribeData.length > 0){
          let realEstateAviodDuplicate =[];
          console.info('creating raft accounts>>');
          subscribeData.forEach(elementAlcor => {

              allSitesAlcorVals.push(elementAlcor.businessIdentifierValue);

            const indexTemp = alcorValsOfCpy.indexOf(elementAlcor.businessIdentifierValue)
            alcorValsOfCpy.splice(indexTemp,1);
            if(idensData[elementAlcor.businessIdentifierValue] && (alcorValsOfCpy.indexOf(elementAlcor.businessIdentifierValue) === -1) && elementAlcor.endDate === '' && realEstateAviodDuplicate.indexOf(elementAlcor.businessIdentifierValue) === -1){ 
              const  constN =
                {
                  "businessIdentifierId" : this.siteIdentTypesData['RAFT_ACCOUNT'],
                  "sourceSystemId" : "2",
                  "businessIdentifierValue" : elementAlcor.businessIdentifierValue,
                  "effectiveDate" : elementAlcor.effectiveDate,
                  "businessIdentifierName" : elementAlcor.businessIdentifierName,
                  "realEstateAssetId" : this.siteId
                }
              realEstateAviodDuplicate.push(elementAlcor.businessIdentifierValue);
              this.sitesService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`,constN).subscribe(() => {
                console.info('created 1st');
              });
            }else if(idensData[elementAlcor.businessIdentifierValue] && idensData[elementAlcor.businessIdentifierValue].endDate === '' && realEstateAviodDuplicate.indexOf(elementAlcor.businessIdentifierValue) === -1){
              const  constN =
                {
                  "businessIdentifierId" : this.siteIdentTypesData['RAFT_ACCOUNT'],
                  "sourceSystemId" : "2",
                  "businessIdentifierValue" : idensData[elementAlcor.businessIdentifierValue].value,
                  "effectiveDate" : this.apiService.getTodayDate(),
                  "businessIdentifierName" : shortName,
                  "realEstateAssetId" : this.siteId
                }
              realEstateAviodDuplicate.push(elementAlcor.businessIdentifierValue);
              this.sitesService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`,constN).subscribe(() => {
                console.info('created 2nd');
              });
            }
          });
        }else{

        }
        const newEndDate = { "endDate" : this.apiService.getTodayDate()}
        let conte = 0;
        mainRealData.forEach(elementA => {
          if(con === 'exist' && (alcorValsOfCpy.indexOf(elementA.businessIdentifierValue) === -1) && allSitesAlcorVals.indexOf(elementA.businessIdentifierValue) === -1){
            this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${elementA.rowId}`,newEndDate).subscribe(() => {
            },_error => {
              conte++;
            });
          }else if(con === 'exist' && (alcorValsOfCpy.indexOf(elementA.businessIdentifierValue) === -1)){
            this.sitesService.deleteRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${elementA.rowId}`).subscribe(() => {
            });
          }
        });
        console.info('alcorValsCPY',alcorValsOfCpy);
        alcorValsOfCpy.forEach(elementNew => {
          if(idensData[elementNew].endDate === ''){
            const constal =
            {
              "businessIdentifierId" : this.siteIdentTypesData['RAFT_ACCOUNT'],
              "sourceSystemId" : "2",
              "businessIdentifierValue" : idensData[elementNew].value,
              "effectiveDate" : this.apiService.getTodayDate(),
              "businessIdentifierName" : shortName,
              "realEstateAssetId" : this.siteId
            }
            this.sitesService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`,constal).subscribe(() => {
              console.info('created 3rd');
            });
          }
        });
        this.UCrealEstateIdens = this.successSteps;
        this.UCdelAlcorPrevCpy = this.successSteps;
        if(conte != 0){
          this.UCrealEstateIdens = `${this.successSteps}${this.dangerSteps}Error for-${conte}${this.endSpanSteps}`;
        }
      }
    });
  }

  changeRealEstateAssignments(cons){
    this.getRealEstateAssignsUC3(cons);
    this.getRealEstateAssignsUC4(cons);
  }

  getRealEstateAssignsUC4(cons,page=1,subscribeData=[]){
    this.sitesService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?corporateName=${this.cpyNameForChangeCpy}&realEstateAssetId=${this.siteId}&_page=${page}`).subscribe(data =>{
      if(data['real-estate-asset-assignments'].length > 0){
        data['real-estate-asset-assignments'].forEach(e => {
          subscribeData.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getRealEstateAssignsUC4(cons,page+1,subscribeData);
        }else if(data['maxPage'] === page){
          const newLegalEntity = {"corporateName" : this.cpyNameForChangeCpy , "active" : '1'}
          let runLegal = true;
          if(subscribeData.length > 0){
            const endDateSet = {endDate : this.apiService.getTodayDate() };
            const noEndD = {endDate : ''}
            for(let i=0;i<subscribeData.length;i++){
              if(subscribeData[i]['legalEntityIdentifier'] != '' && subscribeData[i]['endDate'] === '' && subscribeData[i]['legalEntityCorporateName'] != this.cpyNameForChangeCpy){
                this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${subscribeData[i]['rowId']}`,endDateSet).subscribe(() => {

                });
              }
              if(subscribeData[i]['legalEntityCorporateName'] === this.cpyNameForChangeCpy){
                console.info('same corp name no new legal entity required')
                runLegal = false;
                if(subscribeData[i]['endDate'] != ''){
                  this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${subscribeData[i]['rowId']}`,noEndD).subscribe(() => {
                  });
                }
              }
            }
          }else{
            this.UClegalEntity = this.successSteps;
          }
          if(runLegal === true){
            console.info('creating new legal entity');
            this.sitesService.createLegalEntity(`${this.Config.ApiSitesUrl}legal-entities`,newLegalEntity).subscribe(data013 => {
              const newLegalPost = {'realEstateAssetId' : this.siteId, 'legalEntityId' : data013['rowId']}
              this.sitesService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`,newLegalPost).subscribe(() => {
                this.UClegalEntity = this.successSteps;
              },error => {
                this.UClegalEntity = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
              });
            },error => {
              this.UClegalEntity = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
            });
          }else{
            this.UClegalEntity = this.successSteps;
          }
          if(cons === 'doesnotexist'){
            setTimeout(function() {
              this.reloadCurrentPage();
            }.bind(this),subscribeData.length*SiteDetailsComponent.NINE_HUNDRED_MS);
          }
        }
      }
    });
  }

  getRealEstateAssignsUC3(cons,page=1,subscribeData=[]){
    this.sitesService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=${this.siteId}&_page=${page}`).subscribe(data => {
      if(data['real-estate-asset-assignments'].length > 0){
        data['real-estate-asset-assignments'].forEach(e => {
          subscribeData.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getRealEstateAssignsUC3(cons,page+1,subscribeData);
        }else if(data['maxPage'] === page){
          let exist:any = false;
          let rowId = '';
          const const1 = {categoryId:this.newCategoryAssignment , categoryName: this.newCategoryName};
          const constEndDate= {"endDate" : this.apiService.getTodayDate()};
          subscribeData.forEach((element,_index) => {
            if((element.categoryCode != '' || element.categoryName != '') && exist === false && element.legalEntityIdentifier === ''){
              rowId = element.rowId;
              exist = true;
            }
            if(element.legalEntityIdentifier != '' && element.endDate != ''  && cons === 'exist'){
              this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${element.rowId}`,constEndDate).subscribe(() => {

              });
            }
          });
          if(exist === false){
            this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${rowId}`,const1).subscribe(() =>{
              this.UCcatergoryName = this.successSteps;
            },error => {
              this.UCcatergoryName = `${this.dangerSteps}Error${error.status}${this.dateForTO}${this.endSpanSteps}`;
            });
          }else{
            this.UCcatergoryName = this.successSteps;
          }
        }
      }
    });
  }

 changeMainEntranceLabel(shrtName){
  this.sitesData.forEach(element => {
    if(element.type === 'Main Entrance' && shrtName != ''){
      const UpdateLabel = {label : this.cpyNameForChangeCpy}
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`,UpdateLabel).subscribe(() => {

      });
    }
  });
 }

 changeAccessPointsToPending(){
  if(this.sitesData.length > 0){
    const constPending = {"activeStatus": "PENDING"}
    const constActive = {"activeStatus" : "ACTIVE"}
    const constArchive = {"activeStatus" : "ARCHIVED","endDate" : this.apiService.getTodayDate()}
    const constEndDate= {"endDate" : this.apiService.getTodayDate()}
    const OrderManuInvoi = ['P05', 'P06','P11'];
    this.sitesData.forEach(element => {
      if(this.qualifierChangeToArchived.indexOf(element.type) != -1){
        if(element.status != 'ARCHIVED'){
          this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`,constArchive).subscribe(() => {

          });
        }
        if(this.accessPointOnRaftAlias[element.identifier]){
          this.getAccessPointIdensUC(element);
          }
      }
    });
    document.getElementById('closeChangeCompany').click();
    this.saveDatas = 'Save';
  }
  setTimeout(function(){
    this.reloadCurrentPage();
  }.bind(this),this.sitesData.length*SiteDetailsComponent.NINE_HUNDRED_MS);
 }

 getAccessPointIdensUC(element,page=1,subscribeData= []){
  this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${this.accessPointOnRaftAlias[element.identifier].identifierValue}&identifierTypeName=RAFT_CODE&_page=${page}`).subscribe(data => {
    if(data['access-point-identifiers'].length > 0){
      data['access-point-identifiers'].forEach(e => {
        subscribeData.push(e);
      });
      if(data['maxPage'] > 1 && data['maxPage'] != page){
        this.getAccessPointIdensUC(element,page+1,subscribeData);
      }else if(data['maxPage'] === page){
        const accessPointsArr = [];
        const accessPointsOri = [];
        let accessPointIdens:any=[];
        subscribeData.forEach(element2 => {
          if(accessPointsArr.indexOf(`'${element2.accessPointIdentifier}'`) === -1){
            accessPointsArr.push(`'${element2.accessPointIdentifier}'`);
          }
          if(accessPointsOri.indexOf(element2.accessPointIdentifier) === -1){
            accessPointsOri.push(element2.accessPointIdentifier);
          }
          accessPointIdens[element2.accessPointIdentifier] = element2;
        });
        if(accessPointsArr.length > 0){
          this.getAccessPointsToArcUC(accessPointsArr,accessPointsOri,accessPointIdens);
        }
      }
    }
  });
 }

  getAccessPointsToArcUC(accessPointsArr,accessPointsOri,accessPointIdens,page=1,subscribeData=[]){
    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?identifier=in(${accessPointsArr})&_page=${page}`).subscribe(data => {
      if(data['access-points'].length > 0){
        data['access-points'].forEach(e => {
          subscribeData.push(e);
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getAccessPointsToArcUC(accessPointsArr,accessPointsOri,accessPointIdens,page+1,subscribeData);
        }else if(data['maxPage'] === page){
          const archiveIds = [];
          let activeExist = false;
          subscribeData.forEach(ele => {
            if(ele.activeStatus === 'ARCHIVED'){
              archiveIds.push(ele.identifier);
            }else{
              activeExist = true;
            }
          });
          if(activeExist === false){
            const updateEnd = {endDate : this.apiService.getTodayDate()}
            accessPointsOri.forEach(element1 => {
              this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${accessPointIdens[element1].rowId}`,updateEnd).subscribe(() => {

              });
            })
          }
        }
      }
    });
  }

  reloadCurrentPage(){
    document.getElementById('closeChangeCompany').click();
    document.getElementById('closeshowUpdateCpySteps').click();
    this.saveDatas = 'Save';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(`site-details/${this.siteId}/${this.cpyRowIdHolder}`);
  }

  goToMap(){
    this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${this.countryId}&name=${this.siteCity}`).subscribe((data: any) => {
      this.maplatitudeVal = data['cities'][0]['latitude'].replace(",", ".");;
      this.maplongitudeVal = data['cities'][0]['longitude'].replace(",", ".");;
    })
  }

  saveNewGps(){
  const lat = this.latitudeVal.toString();
  const lon = this.longitudeVal.toString();
   if(lat != '' && lon != '' && lat != undefined && lon != undefined){
    this.disableEditGpsCorBtn = true;
    this.editGpsCoordinatesError1 = false;
    this.editGpsCoordinatesError2 = false;
    if(this.gpsAlreadyExist === true && this.gpsEditRowID != ''){
      const const2 = {'latitude' : lat, 'longitude' : lon}
      this.AddressService.updateGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses/${this.gpsEditRowID}`, const2).subscribe(() => {
        document.getElementById('closeEditGps').click();
        this.dispQualifiers('reload');
      });
    }else if(this.gpsAlreadyExist === false && this.gpsEditRowID != ''){
      const constGeo = {'latitude' : lat,'longitude': lon,'accessPointId': this.gpsEditRowID}
      this.AddressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`,constGeo).subscribe(data1 => {
        const constAdd = {'accessPointId' : this.gpsEditRowID, 'addressId': data1['rowId']}
        this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`,constAdd).subscribe(() => {
          document.getElementById('closeEditGps').click();
          this.dispQualifiers('reload');
        });
      });
    }
   } else {
    if(lat === '' && lon === ''){
      this.editGpsCoordinatesError1 = true;
      this.editGpsCoordinatesError2 = true;
    } else if(lat === '' && lon != ''){
      this.editGpsCoordinatesError1 = true;
      this.editGpsCoordinatesError2 = false;
    } else if(lat != '' && lon === ''){
      this.editGpsCoordinatesError1 = false;
      this.editGpsCoordinatesError2 = true;
    }
   }
  }

 resetGpsVals(co){
   if(co === 'lat'){
     this.latitudeVal = '';
   } else {
     this.longitudeVal = '';
   }
 }

  loadGpsCoordinates(x,y,z,rowId,dmsLat,dmsLon){
    console.info(rowId);
    this.editGpsCoordinatesError1 = false;
    this.editGpsCoordinatesError2 = false;
    this.disableEditGpsCorBtn = false;
    if(x != '' && x!= undefined && y != '' && y!= undefined){
      this.latitudeVal = x;
      this.longitudeVal = y;
      this.gpsAlreadyExist = true;
    } else{
      this.latitudeVal = '';
      this.longitudeVal = '';
      this.gpsAlreadyExist = false;
    }
    if(dmsLat != '' && dmsLat!= undefined && dmsLon != '' && dmsLon!= undefined){
      const temp1 = dmsLat.split(" ");
      if(temp1[0].includes("-")){
        this.northSouthModel='South';
        this.latDegVal = temp1[0].replace('-','').replace('Ã‚Â°','');
      }else{
        this.northSouthModel='North';
        this.latDegVal = temp1[0].replace('Ã‚Â°','');
      }
      this.latMinVal = temp1[1].replace("'","");
      this.latSecVal = temp1[2].replace('"','');
      const temp2 = dmsLon.split(" ");
      if(temp2[0].includes("-")){
        this.eastWestModel='West';
        this.longDegVal = temp2[0].replace('-','').replace('Ã‚Â°','');
      }else{
        this.eastWestModel='East';
        this.longDegVal = temp2[0].replace('Ã‚Â°','');
      }
      this.longMinVal = temp2[1].replace("'","");
      this.longSecVal = temp2[2].replace('"','');
    } else{
      this.northSouthModel='North';
      this.eastWestModel='East';
      this.latDegVal = '';
      this.latMinVal = '';
      this.latSecVal = '';
      this.longDegVal = '';
      this.longMinVal = '';
      this.longSecVal = '';
    }
    if(z != '' && z != undefined){
      this.gpsEditRowID = z;
    }else{
      this.gpsEditRowID = rowId;
    }
  }

  resetSiteStatus(){
    this.editSiteStatusError = false;
    this.editSiteStatusModel = this.sitestatus;
    this.disableEditSiteStatusBtn = false;
    this.editSiteValStatusError = false;
    this.editSiteValStatusModel = this.siteActiveStatus;
    this.disableEditSiteValStatusBtn = false;
  }

  updateSiteStatus(){
    if(this.editSiteStatusModel != '' && this.editSiteStatusModel != undefined){
      this.disableEditSiteStatusBtn = true;
      let const1;
      if(this.editSiteStatusModel === 'Destroyed'){
        if(this.businessEntityIdSite != ''){
          this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${this.businessEntityIdSite}`).subscribe(data123 => {
            if(data123['isHQ'] === 'Y'){
              document.getElementById('btnForIsHQArchive').click();
            }else{
              const1 =
              {
                'physicalState' : this.editSiteStatusModel,
                'endDate' : this.apiService.getTodayDate()
              }
              this.siteStatusLoading = true;
              this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
                document.getElementById('closeSiteStatusmodal').click();
                this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
                  this.siteName    = data['name'];
                  this.siteCity    = data['cityName'];
                  this.siteCountry = data['countryName'];
                  this.sitestatus = data['physicalState'];
                  this.siteStatusLoading = false;
                  document.getElementById('closeSiteStatusmodal').click();
                });
              });
            }
          });
        }else{
          const1 =
          {
            'physicalState' : this.editSiteStatusModel,
            'endDate' : this.apiService.getTodayDate()
          }
          this.siteStatusLoading = true;
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
            document.getElementById('closeSiteStatusmodal').click();
            this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
              this.siteName    = data['name'];
              this.siteCity    = data['cityName'];
              this.siteCountry = data['countryName'];
              this.sitestatus = data['physicalState'];
              this.siteStatusLoading = false;
              document.getElementById('closeSiteStatusmodal').click();
            });
          });
        }

      }else{
        const1 = { 'physicalState' : this.editSiteStatusModel, 'endDate' : '' }
        this.siteStatusLoading = true;
        this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
          document.getElementById('closeSiteStatusmodal').click();
          this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
            this.siteName    = data['name'];
            this.siteCity    = data['cityName'];
            this.siteCountry = data['countryName'];
            this.sitestatus = data['physicalState'];
            this.siteStatusLoading = false;
          });
        });
      }
    }else{
      this.editSiteStatusError = true;
    }
  }

  blankStatusUpdate(){
    document.getElementById("btnForblankupdate").click();
    document.getElementById("closeblankStatusUpdate").click();
    const siteStatus = this.siteActiveStatus?.toLowerCase();
    this.blankUpdate.siteBlankStatusUpdate(this.siteId);
    // this.blankUpdateCompleted = this.blankUpdate.completed
  }
  downloadUploadLogFile() {
      const element = document.getElementById('excelTableLog');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Update To PENDING');
      XLSX.writeFile(wb, 'UpdatedDetails.xlsx');
    }
  updateSiteValStatus(){
    if(this.editSiteValStatusModel != '' && this.editSiteValStatusModel != undefined){
      let allArchived:any = true;
      this.disableEditSiteValStatusBtn = true;
      let const1;
      let const2;
      let mainEntranceRowId;
      if(this.editSiteValStatusModel.toUpperCase() === 'ARCHIVED'){
        this.sitesData.forEach(element => {
          if(element.type != 'Main Entrance' && element.status.toUpperCase() === 'ARCHIVED'){

          }else if(element.type != 'Main Entrance'){
            allArchived = false;
          }
          if(element.type === 'Main Entrance'){
            mainEntranceRowId = element.rowId;
          }
        });
        if(allArchived === false){
          document.getElementById('btnForNoArchivedQua').click();
          this.disableEditSiteValStatusBtn = false;
        }
      }
      if(allArchived === true){
        if(this.editSiteValStatusModel.toUpperCase() === 'ARCHIVED'){
          if(this.businessEntityIdSite != ''){
            this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${this.businessEntityIdSite}`).subscribe(() => {
              
              
              
                const1 =
                {
                  'activeStatus' : this.editSiteValStatusModel,
                  'endDate' : this.apiService.getTodayDate()
                }
                this.siteActiveStatusLoading = true;
                this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
                  document.getElementById('closeSiteValStatusmodal').click();
                  this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
                    this.siteName    = data['name'];
                    this.siteCity    = data['cityName'];
                    this.siteCountry = data['countryName'];
                    this.sitestatus = data['physicalState'];
                    this.siteActiveStatus = data['activeStatus'];
                    this.siteActiveStatusLoading = false;
                    document.getElementById('closeSiteValStatusmodal').click();
                  });
                });
              
            });
          }else{
            const1 =
            {
              'activeStatus' : this.editSiteValStatusModel,
              'endDate' : this.apiService.getTodayDate()
            }
            this.siteActiveStatusLoading = true;
            this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
              document.getElementById('closeSiteValStatusmodal').click();
              this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
                this.siteName    = data['name'];
                this.siteCity    = data['cityName'];
                this.siteCountry = data['countryName'];
                this.sitestatus = data['physicalState'];
                this.siteActiveStatus = data['activeStatus'];
                this.siteActiveStatusLoading = false;
                document.getElementById('closeSiteValStatusmodal').click();
              });
            });
          }

        }else if(this.siteActiveStatus=='CREATED' && this.editSiteValStatusModel=='ACTIVE'){
          const1 = { 'activeStatus' : 'PENDING', 'endDate' : '' }
          const2 = { 'activeStatus' : this.editSiteValStatusModel, 'endDate' : '' }
          this.siteActiveStatusLoading = true;
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(_data0 => {
            this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const2).subscribe(() => {
              document.getElementById('closeSiteValStatusmodal').click();
              this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
                this.siteName    = data['name'];
                this.siteCity    = data['cityName'];
                this.siteCountry = data['countryName'];
                this.sitestatus = data['physicalState'];
                this.siteActiveStatus = data['activeStatus'];
                this.siteActiveStatusLoading = false;
              });
            });
          });
        }else{
          const1 = { 'activeStatus' : this.editSiteValStatusModel, 'endDate' : '' }
          this.siteActiveStatusLoading = true;
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
            document.getElementById('closeSiteValStatusmodal').click();
            this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
              this.siteName    = data['name'];
              this.siteCity    = data['cityName'];
              this.siteCountry = data['countryName'];
              this.sitestatus = data['physicalState'];
              this.siteActiveStatus = data['activeStatus'];
              this.siteActiveStatusLoading = false;
            });
          });
        }
      }
    }else{
      this.editSiteValStatusError = true;
    }
  }

  loadLookForCpy(){

    if(this.mainEntranceExists === true){
      this.raftCpyGroupData = [];
      this.raftCpyGroupData2 = [];
      this.raftCpyGroupData3 = [];
      this.raftCpyGroupData4 = [];
      this.raftCpyGroupMainData = [];
      this.lookForCpyRowIdArr = [];
      this.lookCpyLoading = true;
      this.raftCpyGroupModel = '';
      this.moreThanOneCpyFlag = false;
      this.toggleChangeCpyModal = false;
      document.getElementById('btnForOpenLookForCpy').click();
      this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${this.siteId}&identifierType=RAFT_ACCOUNT`).subscribe(data0 => {
        if(data0['real-estate-asset-identifiers'].length > 0){
        data0['real-estate-asset-identifiers'].forEach((ele,_index) => {
            if(ele.endDate === ''){
              this.raftCpyGroupData.push(ele);
              this.lookForCpyRowIdArr.push(`'${ele.businessIdentifierValue}'`);
            }
        });
        }else{
          this.lookCpyLoading = false;
          this.showLoadedLookCpyData = false;
        }
        setTimeout(function (){
          this.callCpyAndGrp();
        }.bind(this),SiteDetailsComponent.IDENTIFIER_LOOP_DELAY_MS * data0['real-estate-asset-identifiers'].length)
      });
    }else{

      this.showParam = 'mainEntrance';
      document.getElementById('btnForNoMainEntranceQualifier').click();
    }
  }

  callCpyAndGrp(){
    if(this.lookForCpyRowIdArr.length > 0){
      let tempArr = [];
        this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=in(${this.lookForCpyRowIdArr})`).subscribe(data1 => {
          if(data1['company-identifiers'].length > 0){
            data1['company-identifiers'].forEach(element => {
              if(tempArr.indexOf(`'${element.companyAllianceIdentifier}'`) === -1){
                tempArr.push(`'${element.companyAllianceIdentifier}'`);
              }
              if(this.raftCpyGroupData2[element.value] === undefined){
                this.raftCpyGroupData2[element.value] = [];
              }
              this.raftCpyRowIdsOnVal[element.value] = element.linkedCompanyId;
              this.raftCpyGroupData2[element.value].push(element);
            });
            this.getCpyAndGrpData(tempArr);
          }else{
            this.showLoadedLookCpyData = true;
            this.lookCpyLoading = false;
          }
        });

    }else{
        this.lookCpyLoading = false;
        this.showLoadedLookCpyData = false;
    }
  }

  getCpyAndGrpData(arr){
    if(arr != ''){
      const cpyIds = [];
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=in(${arr})`).subscribe(data2 => {
        if(data2['companies'].length>0){
          data2['companies'].forEach(element => {
            this.raftCpyGroupData3[element.rowId] = element;
            if(cpyIds.indexOf(element.rowId) === -1){
              cpyIds.push(element.rowId);
            }
          });
          this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?companyId=in(${cpyIds})&apoStatus=ACTIVE&status=VALIDATED`).subscribe(data3 =>{
            if(data3['group-assignments'].length > 0){
              data3['group-assignments'].forEach(element1 => {
                this.raftCpyGroupData4[element1.companyId] = element1;
              });
              this.showLoadedLookCpyData = true;
              this.lookCpyLoading = false;
            }else{
              this.showLoadedLookCpyData = true;
              this.lookCpyLoading = false;
            }
          });
        }else{
          this.showLoadedLookCpyData = true;
          this.lookCpyLoading = false;
        }
      });
    }
  }

  openAllAccordion(){
    const a = document.getElementById('openAllBox');
    if(a.classList.contains('opened')){
      this.showBoxDown = false;
      a.classList.remove('opened');
      const v = document.getElementsByClassName('recurring');
        for(let j =0; j< v.length; j++){
          if(v[j].classList.contains('show')){
            v[j].classList.remove('show');
          }
        }
      const vor = document.getElementsByClassName('change_img');
        for(let k = 0; k < vor.length; k++){
          vor[k].classList.add('down_arrow','master');
        }
    }else{
      this.showBoxDown = true;
      a.classList.add('opened');
      var c :HTMLCollection = document.getElementsByClassName('collapse');
        for(let i =0; i< c.length; i++){
          c[i].classList.add('show');
        }
      const vor = document.getElementsByClassName('change_img');
        for(let k = 0; k < vor.length; k++){
          vor[k].classList.remove('down_arrow','master');
        }
    }
  }

  c2bDisplay(sitedata){
    if(sitedata.type === 'Ordering'){
      if(sitedata.c2b_code!='' && sitedata.c2b_code!=undefined){
        return true
      }else{
        if(sitedata.saer_code != '' && sitedata.saer_code != undefined){
          return true
        }else{
          return false
        }
      }
    }
  }
openPicking(){
    document.getElementById('btnForIdAssociatedPick').click();
  }
  showAssociatedPicking(qualifier : string,identifier : string,rowId : string,sitestatus :string,factReLoad=false){
    this.manufacturingAcpStatus=sitestatus;
    this.acp1Identifier =identifier;
    if(qualifier.toLowerCase() === 'manufacturing'){
      this.associatedPickingData = [];
      this.identifierManufacturing = [];
      this.selectedACPid = rowId;
      let temprows = [];
      let avoidDuplicateforAcp1 = [];
      let avoidDuplicateforAcp2 = [];
      let rowiid = [];
      this.allAttachmentData =[];
      this.alcornameandvalue =[];
      let effectiveDate =[];

      this.sitesService.getAccessPointAttachments(`${this.Config.ApiSitesUrl}access-point-attachments?acp1Identifier=${identifier}`).subscribe(data0 => {
        if(data0['access-point-attachments'] != null && data0['access-point-attachments'].length > 0){
          if(factReLoad ==false){
            document.getElementById('btnForIdAssociatedPick').click();
          }
          this.assnPickingLoading = true;
          for(let i =0; i< data0['access-point-attachments'].length ; i++){
            if(temprows.indexOf(data0['access-point-attachments'][i]['acp1Id']) === -1){
              temprows.push(data0['access-point-attachments'][i]['acp1Id']);
            }
            if(temprows.indexOf(data0['access-point-attachments'][i]['acp2Id']) === -1){
              temprows.push(data0['access-point-attachments'][i]['acp2Id']);
            }
            if(avoidDuplicateforAcp2.indexOf(data0['access-point-attachments'][i]['acp2Identifier']) === -1){
              this.associatedPickingData.push(data0['access-point-attachments'][i]);
               avoidDuplicateforAcp2.push(data0['access-point-attachments'][i]['acp2Identifier']);
            }

            if(avoidDuplicateforAcp1.indexOf(data0['access-point-attachments'][i]['acp1Identifier']) === -1){
              this.identifierManufacturing.push(data0['access-point-attachments'][i]);
              avoidDuplicateforAcp1.push(data0['access-point-attachments'][i]['acp1Identifier']);
            }
            if(effectiveDate[data0['access-point-attachments'][i]['rowId']] === undefined){
              effectiveDate[data0['access-point-attachments'][i]['rowId']]= []
            }
            effectiveDate[data0['access-point-attachments'][i]['rowId']].push(data0['access-point-attachments'][i]['effectiveDate']);
          }
          this.associatedCount = this.associatedPickingData.length

          this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?rowId=in(${temprows})`).subscribe(data1 => {
            if(data1['access-points'].length > 0){
              for(let j = 0; j< data1['access-points'].length; j++){
                this.associatedPickingDataPoints[data1['access-points'][j]['rowId']] = data1['access-points'][j];
                rowiid.push(`'${data1['access-points'][j]['siteIdentifier']}'`);
              }
              this.getsiteAcpData(rowiid);
              this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?identifier=in(${rowiid})`).subscribe(data3 => {
                if(data3['sites'].length > 0){
                  data3['sites'].forEach(element2 => {
                    for(let j = 0; j< data1['access-points'].length; j++){
                      if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']].siteIdentifier==element2.identifier){
                        if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]){
                          if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['country'] === undefined){
                            this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['country']= []
                          }
                          this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['country'].push(element2.countryName);
                          if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['city'] === undefined){
                            this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['city']= []
                          }
                          this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['city'].push(element2.cityName);
                        }
                      }
                    }
                  });
                }
              });
              this.sitesService.getAccessPointAttachmentAttributes(`${this.Config.ApiSitesUrl}access-point-attachment-attributes?type=FACTORY_CODE&acp1Id=${avoidDuplicateforAcp1}`).subscribe((data: any) => {
                if(data['access-point-attachment-attributes'].length > 0){
                  data['access-point-attachment-attributes'].forEach(element1 => {
                    element1.businessvalue=element1.value.slice(2);
                    this.allAttachmentData.push(element1);
                    if(effectiveDate.indexOf(element1.attId) != 1){
                     element1.EffectiveDate =effectiveDate[element1.attId]
                    }
                  });
                }
                this.allAttachmentData.forEach(element2 => {
                  this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${element2.businessvalue}`). subscribe(data101 => {
                    if(this.alcornameandvalue[element2.acp2Id] ==undefined){
                      this.alcornameandvalue[element2.acp2Id] =[];
                    }
                    this.alcornameandvalue[element2.acp2Id].push({'value':element2.businessvalue,'label':data101['real-estate-asset-identifiers'][0].businessIdentifierName ,'alcorEffectiveDate':element2.EffectiveDate});
                  });
                });
              });
            }
            this.assnPickingLoading = false;
          });
        }else{

          if(factReLoad ==false){
            document.getElementById('btnForIdAssociatedPick').click();
          }
          this.identifierManufacturing.push({'acp1Identifier':identifier ,'acp1Id' :this.selectedACPid})
          this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?rowId=in(${this.selectedACPid})`).subscribe(data1 => {
            if(data1['access-points'].length > 0){
              for(let j = 0; j< data1['access-points'].length; j++){
                this.associatedPickingDataPoints[data1['access-points'][j]['rowId']] = data1['access-points'][j];
                rowiid.push(`'${data1['access-points'][j]['siteIdentifier']}'`);
              }
              this.getsiteAcpData(rowiid);
              this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?identifier=in(${rowiid})`).subscribe(data3 => {
                if(data3['sites'].length > 0){
                  data3['sites'].forEach(element2 => {
                    for(let j = 0; j< data1['access-points'].length; j++){
                      if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']].siteIdentifier==element2.identifier){
                        if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]){
                          if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['country'] === undefined){
                            this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['country']= []
                          }
                          this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['country'].push(element2.countryName);
                          if(this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['city'] === undefined){
                            this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['city']= []
                          }
                          this.associatedPickingDataPoints[data1['access-points'][j]['rowId']]['city'].push(element2.cityName);
                        }
                      }
                    }
                  });
                }
              });
            }
          });
        }
      },_error => {
        this.assnPickingLoading = false;
      });
    }
  }

  getsiteAcpData(siteIds,subscribeData=[],page=1){
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?siteIdentifier=in(${siteIds})&_page=${page}`).subscribe(data2 => {
      if(data2['access-point-identifiers'].length > 0){
        data2['access-point-identifiers'].forEach(element1 => {
          if(this.associatedPickingDataPoints[element1.accessPointRowId]){
            if(element1.identifierTypeName === 'RAFT_CODE' && element1.endDate === ''){
              if(this.associatedPickingDataPoints[element1.accessPointRowId]['raft_alias'] === undefined){
                this.associatedPickingDataPoints[element1.accessPointRowId]['raft_alias']= []
              }
              this.associatedPickingDataPoints[element1.accessPointRowId]['raft_alias'].push(element1.identifierValue);
            }
            if(element1.identifierTypeName === 'SOCIAL_RAISON' && element1.endDate === ''){
              if(this.associatedPickingDataPoints[element1.accessPointRowId]['raft_name'] === undefined){
                this.associatedPickingDataPoints[element1.accessPointRowId]['raft_name']= []
              }
              this.associatedPickingDataPoints[element1.accessPointRowId]['raft_name'].push(element1.identifierValue);
            }
          }
        });
        if(data2['maxPage'] > 1 && data2['maxPage'] != page){
          this.getsiteAcpData(siteIds,subscribeData,page+1);
        }else if(data2['maxPage'] === page){
          return this.associatedPickingDataPoints;
        }
      }
    });
  }

  updateQualifierName(){
    if(this.qualifierNameEdit != '' && this.qualifierNameEdit != undefined && this.qualifierNameModelRegExError === false){
      this.disableEditQuaNameBtn = true;
      this.saveDatas = 'Saving...'
      const datas = {label : this.qualifierNameEdit};
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.qualiferAliasAccessPRowid}`, datas).subscribe(() => {
        window.document.getElementById("closeQualifierNameEditBtn").click();
        this.saveDatas = "Save";
        this.dispQualifiers('reload');
      },error => {
        this.disableEditQuaNameBtn = false;
        this.saveDatas = "Save";
        console.info('error in Updating, try again',error)
      });
    }else{
      if(this.qualifierNameModelRegExError === true){
        this.qualifierNameModelError = false;
      }else{
        this.qualifierNameModelError = true;
      }
    }
  }

  resetQualifierEdit(){
    this.qualifierNameEdit = '';
    this.qualifierNameModelError = true;
    this.qualifierNameModelRegExError = false;
  }

/**START Edit address for qualifier */
  resetAddressField(as){
   this[as] = '';
  const exo = this.regExObjForAddressUpdate[as];
   this[exo] = false;
  }

  loadAddressModalDetails(x,y,z,addressEdit,accessPointRowId,addressObjData,dmsLat,dmsLon){
    this.editGpsCoordinatesError1 = false;
    this.editGpsCoordinatesError2 = false;
    this.disableEditGpsCorBtn = false;
    if(x != '' && x!= undefined && y != '' && y!= undefined){
      this.latitudeVal = x;
      this.longitudeVal = y;
      this.gpsAlreadyExist = true;
    } else{
      this.latitudeVal = '';
      this.longitudeVal = '';
      this.gpsAlreadyExist = false;
    }
    if(dmsLat != '' && dmsLat!= undefined && dmsLon != '' && dmsLon!= undefined){
      const temp1 = dmsLat.split(" ");
      if(temp1[0].includes("-")){
        this.northSouthModel='South';
        this.latDegVal = temp1[0].replace('-','').replace('Ã‚Â°','');
      }else{
        this.northSouthModel='North';
        this.latDegVal = temp1[0].replace('Ã‚Â°','');
      }
      this.latMinVal = temp1[1].replace("'","");
      this.latSecVal = temp1[2].replace('"','');
      const temp2 = dmsLon.split(" ");
      if(temp2[0].includes("-")){
        this.eastWestModel='West';
        this.longDegVal = temp2[0].replace('-','').replace('Ã‚Â°','');
      }else{
        this.eastWestModel='East';
        this.longDegVal = temp2[0].replace('Ã‚Â°','');
      }
      this.longMinVal = temp2[1].replace("'","");
      this.longSecVal = temp2[2].replace('"','');
    } else{
      this.northSouthModel='North';
      this.eastWestModel='East';
      this.latDegVal = '';
      this.latMinVal = '';
      this.latSecVal = '';
      this.longDegVal = '';
      this.longMinVal = '';
      this.longSecVal = '';
    }
    if(z != '' && z != undefined){
      this.gpsEditRowID = z;
    }else{
      this.gpsEditRowID = accessPointRowId;
    }
    this.saveDatas = 'Save';
    this.addressEditRowId = addressEdit;
    this.accessPointRowIdAddress = accessPointRowId;
    this.postalCodeModelError = false;
    this.streetModelError = false;
    if(addressObjData && addressObjData['additionalInformation'] === ''){
      this.additional = '';
      this.additionalInfo = '';
    }else if(addressObjData['additionalInformation'] != ''){
      const temp = addressObjData['additionalInformation'].match(new RegExp(`.{1,${SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH}}`, 'g'));
      this.additional = temp[0];
      this.additionalInfo = temp[1];
    }
    if(this.additional ==undefined || this.additional ==null){
      this.additional ="";
    }
    if(this.additionalInfo ==undefined || this.additionalInfo ==null){
      this.additionalInfo ="";
    }
    this.wayNumberModel = addressObjData['wayNumber'];
    this.streetModel = addressObjData['streetName'];
    this.updatePostalCodeModel = addressObjData['postalCode'];
    this.territorialDivModel = addressObjData['territorialDivision'];
    this.disableEditAddressBtn = false;
    this.wayNumberModelRegExError = false;
    this.streetModelRegExError = false;
    this.additionalRegExError = false;
    this.additionalInfoRegExError = false;
    this.updatePostalCodeModelRegExError = false;
    this.territorialDivModelRegExError = false;
  }

  updateAddressDetails(){
    const lat =this.latitudeVal.toString();;
    const lon =this.longitudeVal.toString();;
    const temp = this.additional;
    if(temp.length <= SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH){   
      for (let i =temp.length; i < SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH; i++){
        this.additional =  `${this.additional} `;
      }
    }
    if(this.additional ==undefined || this.additional ==null){
      this.additional ="";
    }
    if(this.additionalInfo ==undefined || this.additionalInfo ==null){
      this.additionalInfo ="";
    }
    let str1 =  this.additional;
    let str2 = this.additionalInfo;
    this.additionalInfoModel= `${str1}${str2}`;
    if(this.streetModel.trim().length > 0 &&
      this.wayNumberModelRegExError === false &&
      this.streetModelRegExError === false &&
      this.additionalRegExError === false &&
      this.additionalInfoRegExError === false &&
      this.updatePostalCodeModelRegExError === false &&
      this.territorialDivModelRegExError === false
      ){
      this.disableEditAddressBtn = true;
      this.saveDatas = 'Saving...'
      if(this.addressEditRowId != '' && this.addressEditRowId != undefined){
        const addressU = {
          additionalInformation:this.additionalInfoModel,
          wayNumber : this.wayNumberModel,
          streetName : this.streetModel,
          postalCode : this.updatePostalCodeModel,
          territorialDivision : this.territorialDivModel
        }
        this.AddressService.updateGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses/${this.addressEditRowId}`, addressU).subscribe(() => {
          if(this.gpsAlreadyExist === true && this.gpsEditRowID != ''){
            const const2 = {'latitude' : lat, 'longitude' : lon}
            this.AddressService.updateGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses/${this.gpsEditRowID}`, const2).subscribe(() => {
            });
          }else if(this.gpsAlreadyExist === false && this.gpsEditRowID != ''){
            const constGeo = {'latitude' : lat,'longitude': lon,'accessPointId': this.gpsEditRowID}
            this.AddressService.updateGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`,constGeo).subscribe(data1 => {
              const constAdd = {'accessPointId' : this.gpsEditRowID, 'addressId': data1['rowId']}
              this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`,constAdd).subscribe(() => {
              });
            });
          }
          this.dispQualifiers('reload');
          document.getElementById('closeEditAddressBtn').click();
          this.saveDatas = 'Save';
        });
      }else{

        const geoADatas = {
          additionalInformation:this.additionalInfoModel,
          wayNumber : this.wayNumberModel,
          streetName : this.streetModel,
          postalCode : this.updatePostalCodeModel,
          territorialDivision : this.territorialDivModel
        }
        this.AddressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA:any) => {
          var geo_adress_row_id = dataGeoA['rowId'];
          const accessPointDatas = {accessPointId: this.accessPointRowIdAddress, addressId:geo_adress_row_id};
          if(this.accessPointRowIdAddress != ''){
            this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
               if(this.gpsEditRowID != ''){
                const constGeo = {'latitude' : lat,'longitude': lon,'accessPointId': this.gpsEditRowID}
                this.AddressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`,constGeo).subscribe(data1 => {
                  const constAdd = {'accessPointId' : this.gpsEditRowID, 'addressId': data1['rowId']}
                  this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`,constAdd).subscribe(() => {
                  });
                });
              }
              this.dispQualifiers('reload');
              document.getElementById('closeEditAddressBtn').click();
              this.saveDatas = 'Save';
            });
          }else{
            if(this.gpsEditRowID != ''){
              const constGeo = {'latitude' : lat,'longitude': lon,'accessPointId': this.gpsEditRowID}
              this.AddressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`,constGeo).subscribe(data1 => {
                const constAdd = {'accessPointId' : this.gpsEditRowID, 'addressId': data1['rowId']}
                this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`,constAdd).subscribe(() => {
                });
              });
            }
            this.dispQualifiers('reload');
            document.getElementById('closeEditAddressBtn').click();
            this.saveDatas = 'Save';
          }
        });
      }
    }else{
      if(this.streetModel.length === 0){
        this.streetModelError = true;
      }else{this.streetModelError = false};
    }
  }
/**END edit address for qualifier */

/**GEt site iden types */

  getSiteIdenTypes(page = 1, subscribeData = []){
    this.sitesService.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?_page=${page}`).subscribe(data => {
      if(data['identifier-types'].length > 0){
        data['identifier-types'].forEach( ele => {
          this.siteIdentTypesData[ele.name] = ele.rowId;
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSiteIdenTypes(page+1,subscribeData);
        }
        else{
          console.info('siteIdentTypesData',this.siteIdentTypesData);
        }
      }
    });
  }

  getSourceSytemId(page = 1, subscribeData = []){
    this.sitesService.getSourceSystems(`${this.Config.ApiSitesUrl}source-systems?_page=${page}`).subscribe(data => {
      if(data['source-systems'].length > 0){
        data['source-systems'].forEach( ele => {
          this.siteSourceSystems[ele.name] = ele.rowId;
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSourceSytemId(page+1,subscribeData);
        }else{
          console.info('siteSourceSystems',this.siteSourceSystems);

        }
      }
    });
  }

  /**START add main entrance qualifier */
  getAllGeoAddresses(){
    if(this.allAddressIdsGeo.length > 0){
      this.geo1Loading = true;
      this.allAddressGeoData = "";this.allAddressGeoData = [];
      this.allAddressPostalData = "";this.allAddressPostalData = [];
      this.allAddressGeoLocData = "";this.allAddressGeoLocData = [];
      this.inputForGeo1 = '';this.geo1AddressError = false;
      this.inputForGeo2 = '';this.geo2AddressError = false;
      this.inputForGeo3 = '';this.geo3AddressError = false;
      this.inputNameForLabel = '';this.inputLabelError = false;
    }
    this.getGeographicalAddresses();
    if(this.allAddressIdsPostal.length > 0){
      this.getPostalAddresses();
    }
    if(this.allAddressIdsGeoloc.length > 0){
      this.getGeolocAddresses();
    }
    if(this.labelValueArrays.length === 1){
      this.inputNameForLabel = this.labelValueArrays[0];
    }
  }

  getGeographicalAddresses(page=1){
    this.AddressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${this.allAddressIdsGeo})&_page=${page}`).subscribe(data1 => {

      data1['geographical-addresses'].forEach(e => {
        this.allAddressGeoData.push(e);
      });
      if(data1['geographical-addresses'].length ==1 && data1['maxPage'] === 1){
        this.inputForGeo1 = data1['geographical-addresses'][0]['rowId'];
      }
      if(data1['maxPage'] > 1 && data1['maxPage'] != page){
        this.getGeographicalAddresses(page+1);
      }
      if(data1['maxPage'] === page){
        this.geo1Loading = false;
      }
    });
  }

  getPostalAddresses(page=1){
    this.geo2Loading = true;
    this.AddressService.getPostalAddresses(`${this.Config.ApiAddressUrl}postal-addresses?rowId=in(${this.allAddressIdsPostal})&_page=${page}`).subscribe(data2 => {

      data2['postal-addresses'].forEach(e => {
        this.allAddressPostalData.push(e);
      });
      if(data2['maxPage'] > 1 && data2['maxPage'] != page){
        this.getPostalAddresses(page+1);
      }
      if(data2['maxPage'] === page){
        this.geo2Loading = false;
      }
    });
  }

  getGeolocAddresses(page=1){
    this.geo3Loading = true;
    this.AddressService.getGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses?rowId=in(${this.allAddressIdsGeoloc})&_page=${page}`).subscribe(data3 => {

      data3['geolocation-coordinates-addresses'].forEach(e => {
        this.allAddressGeoLocData.push(e);
      });
      if(data3['maxPage'] > 1 && data3['maxPage'] != page){
        this.getGeolocAddresses(page+1);
      }
      if(data3['geolocation-coordinates-addresses'].length ==1  && data3['maxPage'] === 1){
        this.inputForGeo3 = data3['geolocation-coordinates-addresses'][0]['rowId'];
      }
      if(data3['maxPage'] === page){
        this.geo3Loading = false;
      }
    });
  }

  createMainEntraceAcp(){
    if(this.allAddressGeoData.length > 0 && this.inputForGeo1 === ''){
      this.geo1AddressError = true;
    }else{this.geo1AddressError = false;}



    if(this.allAddressGeoLocData.length > 0 && this.inputForGeo3 === ''){
      this.geo3AddressError = true;
    }else{this.geo3AddressError = false}
    if(this.inputNameForLabel === ''){
      this.inputLabelError = true;
    }else{this.inputLabelError = false}
    if(this.geo1AddressError === false && this.geo3AddressError === false && this.inputLabelError === false){
      const siteDatas = {activeStatus:'ACTIVE',
                         realEstateAssetId:this.siteId,
                         type: 'P14',
                         label:this.inputNameForLabel,
                         effectiveDate:this.apiService.getTodayDate(),
                         "irnAuthor":"IRN-71016",
                         "siaAuthor":"IAF",
                         "activity" : 'A10'
      }
      this.sitesService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, siteDatas).subscribe(data => {
        var access_point_row_id = data['rowId'];
        if(this.inputForGeo1 != ''){
          const accessPointDatas1 = {accessPointId:access_point_row_id, addressId:this.inputForGeo1};
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas1).subscribe(() => {
          });
        }
        if(this.inputForGeo2 != ''){
          const accessPointDatas2 = {accessPointId:access_point_row_id, addressId:this.inputForGeo2};
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe(() => {
          });
        }
        if(this.inputForGeo3 != ''){
          const accessPointDatas3 = {accessPointId:access_point_row_id, addressId:this.inputForGeo3};
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas3).subscribe(() => {
          });
        }
        document.getElementById('closeMainEntranceSelectModal').click();
        this.loading=true;
        this.getRowIdForQua('reload');
      });
    }
  }
  /**END add main entrance qualifier */

  /**START edit raft name Admin */
  updateRaftName(name,aliasValue){
    console.info(name,aliasValue);
    let tempAccessIdenVals = [];
    let newAlcorNameVal = '';
    const slicedAlcor  = aliasValue.toString().slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH);
    if(aliasValue != undefined){
      this.disableEditRaftNameBtn = true;
      this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyId}`).subscribe( ( data1 : any) => {
        if(data1['company-names'].length > 0 && this.siteCity != ''){
          this.cpyShortName = data1['company-names'][0].value.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH);
          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${slicedAlcor}&_page=1`).subscribe(data => {
            if(data['pageCount']> 0){
              newAlcorNameVal = data['real-estate-asset-identifiers'][0]['businessIdentifierName'];
            }
            this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${aliasValue}&identifierTypeName=RAFT_CODE`).subscribe(data => {
              data['access-point-identifiers'].forEach(element => {
                if(tempAccessIdenVals.indexOf(`'${element.accessPointIdentifier}'`) === -1){
                  tempAccessIdenVals.push(`'${element.accessPointIdentifier}'`);
                }
              });
              if(tempAccessIdenVals.length > 0){
                this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointIdentifier=in(${tempAccessIdenVals})&identifierTypeName=SOCIAL_RAISON`).subscribe(data12 => {
                  if(data12['access-point-identifiers'].length > 0){
                    let tempHolderVal = '';
                    if(newAlcorNameVal === ''){
                      tempHolderVal = this.cpyShortName;
                    }else{
                      tempHolderVal = newAlcorNameVal;
                    }
                    const constShort = { identifierValue : `${tempHolderVal.padEnd(SiteDetailsComponent.SHORT_NAME_LENGTH,' ')}${this.siteCity.slice(0, SiteDetailsComponent.CITY_SHORT_LENGTH)}`}
                    data12['access-point-identifiers'].forEach((element1,index) => {
                      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${element1.rowId}`,constShort).subscribe(() => {
                        if(index+1 === data['access-point-identifiers'].length){
                          document.getElementById('closeEditRaftName').click();
                          this.dispQualifiers('reload');
                        }
                      });
                    })
                  }else{
                    document.getElementById('closeEditRaftName').click();
                  }
                });
              }
            });
          });
        }else{
          if(this.siteCity === ''){
            this.showNoSiteCity = true;
          }else{
            this.showNoSiteCity = false;
          }
          if(data1['company-names'].length === 0){
            this.showNoCompanyShortName = true;
          }else{
            this.showNoCompanyShortName = false;
          }
          document.getElementById('btnForNoShortNameOrCity').click();
        }
      });
    }
  }
  /**END edit raft name Admin */

  /**START edit address regex check */
  checkForRegExAddressUpdate(_event,expression,model){
    const regEx =  new RegExp('^[A-Z0-9 \(\)\-\.]*$');
    const newRegex = new RegExp(`.{1,${SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH}}`, 'g');
    if(/^\s/.test(expression)){
      this[model] = expression.trimStart();
      return false;
    }
    this[model] = expression.replace(/(\r\n|\n|\r)/gm," ");
    const modelsVal = this.regExObjForAddressUpdate[model];
    const modelsOri = this.addressUpdateModelObj[model];
    if(expression.length > 0){
      this[modelsOri] = false;

      if(!expression.match(/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/gm)){

        this[modelsVal] = true;
      }else{
        const temp = expression.match(newRegex);
        if(temp.length > 1){
          for(let i =0;i< temp.length-1;i++){
            temp[i] = `${temp[i]}\n`
          }
          this[model] = temp.join("");
        }
        this[modelsVal] = false;
      }
    }else{
      this[modelsVal] = false;
    }
  }
  /**END edit address regex check */

  /**START bvd id regex change */
  checkBvdIdChange(expression,model){
    const regEx =  new RegExp('^[A-Z0-9\-]*$');
    if(/^\s/.test(expression)){
      this[model] = expression.trimStart();
      return false;
    }
    if(expression.length > 0){
      this.bvdidchangecpyfielderror = false;
      if(!regEx.test(expression)){
        this.bvdIdRegExError = true;
      }else{
        this.bvdIdRegExError = false;
      }
    }else{
      this.bvdIdRegExError = false;
      this.bvdidchangecpyfielderror = true;
    }
  }

  /**END bvd id regex change */

  /**START check qualifier name reg ex */
  checkQualifierNameRegEx(expression,model,modelerror,regexmodel){
    if(/^\s/.test(expression)){
      this[model] = expression.trimStart();
      return false;
    }
    this[model] = expression.replace(/(\r\n|\n|\r)/gm," ");
    if(expression.length > 0){
      this[modelerror] = false;

      if(!expression.match(/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/gm)){

        this[regexmodel] = true;
      }else{
        this[regexmodel] = false;
      }
    }else{
      this[regexmodel] = false;
      this[modelerror] = true;
    }
  }
  /**END check qualifier name reg ex */

  /**START edit city function */
  resetEditCity(){
    this.editCityModelError = false;
    this.editCityModel = '';
    this.delaySiteSearchResCity.setValue('')
  }

  resetEditName(val){
    this.editNameModelError = false;
    this.editNameModel = val.replace(/\s+/g, ' ');;
  }

  checkForShortName(){
    if(this.editNameModel.trim().length > 0){
      this.editNameModelError = false;
    }else{
      this.editNameModelError = true;
    }
  }

  saveNewName(){
    if(this.editNameModel != undefined && this.editNameModel != ''){
      const const1 = {
        usualName : this.editNameModel
      }
      this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(data => {
        if(data){
          document.getElementById('closeEditShortModal').click()
          this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data2 => {
            this.siteShortName = data2['usualName']
          })
        }
        else{
          this.editNameModelError = true;
        }
      });
    }
  }

  changeCityEditFn(){
    this.tempcity ='';
    this.editCityAllData = "";
    this.editCityAllData = [];
    this.editCityDropDown=[];
    this.autoload4=true;
    if(this.editCityModel.length != 0){
      this.editCityModelError = false;
    }
    if(this.editCityModel.trim().length >= 2){
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${this.countryId}&name=${this.editCityModel}`).subscribe((data1: any) => {
        this.tempcity ='';
        if(data1['cities'].length >0){
        data1['cities'].forEach(element => {
        this.tempcity = element;
        const cityObject = {
                name: element.name || '',
                latitude: element.latitude || '',
                longitude: element.longitude || '',
                adminZoneCode: element.adminZoneCode || '',
                adminZoneName: element.adminZoneName || '',
                adminZoneCode2: element.adminZoneCode2 || '',
                adminZoneName2: element.adminZoneName2 || ''
              };
        this.editCityDropDown.push(cityObject);
        });
      }
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${this.countryId}&name=*${this.editCityModel}*`).subscribe((data: any) => {

        if(data['cities'].length >0){
          data['cities'].forEach(element => {
            if(this.editCityModel.trim().toLowerCase() !=element.name.toLowerCase()){

              const cityObject = {
                name: element.name || '',
                latitude: element.latitude || '',
                longitude: element.longitude || '',
                adminZoneCode: element.adminZoneCode || '',
                adminZoneName: element.adminZoneName || '',
                adminZoneCode2: element.adminZoneCode2 || '',
                adminZoneName2: element.adminZoneName2 || ''
              };
              
              const alreadyExists = this.editCityDropDown.some(item => item.name.toLowerCase() === cityObject.name.toLowerCase());
              if (!alreadyExists) {
                this.editCityDropDown.push(cityObject);
              }
            }
            this.editCityAllData[element.name] = element;
            this.autoload4=false
          });

          console.info("this.editCityDropDown",this.editCityDropDown)
        }
      });
    });
    }else {
      this.editCityDropDown = [];
    }
  }

  editOnCityeSelect(selected){
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ){
      this.editCityModel = selected;
      this.editCityModelError = false;
    }
  }

  saveNewCity(){
    let city:any;
    if (typeof this.editCityModel === 'string') {
      city = this.editCityModel.toUpperCase();
    } else{
      city = this.editCityModel['name']
    }
    if(city != '' && this.editCityAllData[city]){
      let updateCity ={};
      const oldCity = this.siteCity;
      if(this.businessEntityCompanyLegalName != ''){
        updateCity  = { cityId : this.editCityAllData[city].rowId, name : `${this.businessEntityCompanyLegalName} ${city}`};
      }else{
        const newName = this.siteName.replace(this.siteCity,city);
        updateCity  = { cityId : this.editCityAllData[city].rowId, name : newName};
      }
      this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,updateCity).subscribe(_data1 => {
        document.getElementById('closeEditCityModal').click();
        this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data => {
          this.allSiteData    = data;
          this.siteName       = data['name'];
          this.siteCity       = data['cityName'];
          this.siteCountry    = data['countryName'];
          this.sitestatus     = data['physicalState'];
          this.siteIdentifier = data['identifier'];
          this.goToMap()
        });
        const updateCityName = {line7 : city}
        this.allAddressIdsPostal.forEach(ele => {
          this.AddressService.updatePostalAddresses(`${this.Config.ApiAddressUrl}postal-addresses/${ele}`,updateCityName).subscribe(() => {

          });
        });
        this.allAddressIdsGeo.forEach(ele1 => {
          this.AddressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses/${ele1}`).subscribe(data1 => {
            const updateCityId =
              {
                cityId : this.editCityAllData[city].rowId,
                cityPostalCode : this.editCityAllData[city].postalCode,
                postalCode : this.editCityAllData[city].postalCode,
                cityName : city,
                locality : data1['locality'].replace(oldCity,city)
              }
            this.AddressService.updateGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses/${ele1}`,updateCityId).subscribe(() => {

            });
          });
        });
        let raftAliass = [];
        let raftAliassSliced = [];
        if(this.companyId != ''){
          this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyId}`).subscribe( ( data1 : any) => {
            if(data1['company-names'].length > 0){
              this.cpyShortName = data1['company-names'][0].value.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH);
            }
          });
        }
        this.sitesData.forEach(element => {
          if(element.raft_alias && element.raft_alias != ''){
            if(raftAliass.indexOf(`'${element.raft_alias}'`) === -1){
              raftAliass.push(`'${element.raft_alias}'`);
            }
            const realRaft = element.raft_alias[0].slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH);
            if(raftAliassSliced.indexOf(`'${realRaft}'`) === -1){
              raftAliassSliced.push(`'${realRaft}'`);
            }
          }
        });

        let allRealIdens:any = [];
        let accessPointRowOnIden:any = [];
        if(raftAliassSliced.length > 0){
          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${raftAliassSliced})`).subscribe(data => {
            if(data['real-estate-asset-identifiers'].length > 0){
              data['real-estate-asset-identifiers'].forEach(element1 => {
                allRealIdens[element1.businessIdentifierValue] = element1.businessIdentifierName;
              });
            }
            let tempAccessIdenVals = [];
            this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=in(${raftAliass})&identifierTypeName=RAFT_CODE`).subscribe(data => {
              data['access-point-identifiers'].forEach(element => {
                accessPointRowOnIden[element.accessPointRowId] = element.identifierValue;
                if(tempAccessIdenVals.indexOf(`'${element.accessPointIdentifier}'`) === -1){
                  tempAccessIdenVals.push(`'${element.accessPointIdentifier}'`);
                }
              });

              if(tempAccessIdenVals.length > 0){
                this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointIdentifier=in(${tempAccessIdenVals})&identifierTypeName=SOCIAL_RAISON`).subscribe(data12 => {
                  if(data12['access-point-identifiers'].length > 0){






                    data12['access-point-identifiers'].forEach((element1,_index) => {
                      let tempVal = accessPointRowOnIden[element1.accessPointRowId].slice(0, SiteDetailsComponent.RAFT_PREFIX_LENGTH);
                      let tempHolderVal = allRealIdens[tempVal];
                      if(tempHolderVal != ''){

                      }else{
                        tempHolderVal = this.cpyShortName;
                      }

                      const constShort = { identifierValue : `${tempHolderVal.padEnd(SiteDetailsComponent.SHORT_NAME_LENGTH,' ')}${city.slice(0, SiteDetailsComponent.CITY_SHORT_LENGTH)}` }
                      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${element1.rowId}`,constShort).subscribe(() => {



                      });
                    });
                  }
                });
              }
            });
          });
        }
        setTimeout(function () {
          this.dispQualifiers('reload');
        }.bind(this),SiteDetailsComponent.UI_REFRESH_DELAY_MS)
      });
    }else{
      this.editCityModelError = true;
    }
  }
  /**END edit city function */

  /**START create city function */
  setCreateCityModalVals(){
    this.cityCreateCountryModel = '';
    this.cityCreateCityModel = '';
    this.cityCreateCountryDropDown = [];
    this.cityCreateCityDisable = true;
    this.createCityPostalModel = '';
    this.latitudeVal='';
    this.longitudeVal='';
    this.latDegVal = '';
    this.latMinVal = '';
    this.latSecVal = '';
    this.longDegVal = '';
    this.longMinVal = '';
    this.longSecVal = '';
    this.saveDatas = 'Save';
    this.disableCreateCityBtn = false;
    this.editCreateCityCountryModelError = false;
    this.gpsModelError =false;
    this.editCreateCityCityModelError = false;
    this.cityAlreadyExistsError = false;
    this.validationSuccessCity = false;
    this.delaycityCreateResCountry.setValue('')
  }

  private getAllCountryPages(searchQuery: string, page = 1, maxPage = 1, countries: any[] = []): Observable<any[]> {
    return this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?${searchQuery}&_page=${page}&_pagesize=${SiteDetailsComponent.STANDARD_PAGE_SIZE}`).pipe(
      switchMap((data: any) => {
        const mergedCountries = countries.concat(data['countries'] || []);
        const responseMaxPage = Number(data['maxPage'] ?? maxPage);

        if (page < responseMaxPage) {
          return this.getAllCountryPages(searchQuery, page + 1, responseMaxPage, mergedCountries);
        }

        return of(mergedCountries);
      })
    );
  }

  getCountryList(event){
    if(/^[A-Z]{1,3} - .+/i.test(event)){
      return;
    }
    if(event.length>=SiteDetailsComponent.TWO){
      this.editCreateCityCountryModelError = false;
      this.autoload5 = true
      const searchQuery = event.length===SiteDetailsComponent.TWO ? `countryCode=${this.cityCreateCountryModel}` : `countryName=*${this.cityCreateCountryModel}*`;
      this.getAllCountryPages(searchQuery).subscribe((countries: any[]) => {
        if(countries.length > 0){
          this.cityCreateCountryDropDown=[];
          this.createCityCountryData = "";
          this.createCityCountryData = [];
          countries.forEach(element => {
            const displayValue = `${element.countryCode} - ${element.countryName}`;
            const captain_exist = this.cityCreateCountryDropDown.indexOf(displayValue);
            if(captain_exist === -1) {
              this.cityCreateCountryDropDown.push(displayValue);
              this.createCityCountryData[displayValue.toUpperCase()] = element;
            }
            this.autoload5 = false
          });
        } else {
          this.cityCreateCountryDropDown = [];
          this.autoload5=false
        }
      });
    } else {
      this.cityCreateCountryDropDown = [];
      this.autoload5 = false;
    }
  }

  resetSelectedFields(model){
    this[model] = '';
    if(model === 'cityCreateCityModel'){
      this.createCityPostalModel = '';
    }
    if(model === 'gpslat'){
      this.latitudeVal = '';
    }
    if(model === 'gpslon'){
      this.longitudeVal = '';
    }
    if(model=='cityCreateCountryModel'){
      this.delaycityCreateResCountry.setValue('')
    }
  }


  cityCreateonCountryeSelect(selected) {
    if(selected) {
      this.cityCreateCountryModel = selected;
      this.createCityGotCountryData = "";
      this.cityCreateCityDisable = false;
    } else {
      this.createCityGotCountryData = "failed";
      this.cityCreateCityModel = "";
      this.cityCreateCityDisable = true;
    }
  }

  createNewCity(){
    if(
      this.cityCreateCountryModel != '' &&
      this.cityCreateCityModel != '' &&
      this.latitudeVal != '' &&
      this.longitudeVal != '' &&
      this.createCityGotCountryData != 'failed'
      )
    {
      this.validationSuccessCity = true;
      this.editCreateCityCityModelError = false;
      this.disableCreateCityBtn = true;
      this.cityAlreadyExistsError = false;
      this.cityCreation  = this.loadingSteps;
      const date  = new Date();
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${this.cityCreateCountryModel.split(' - ')[0]}&name=${this.cityCreateCityModel}`).subscribe((data: any) => {
        if(data['cities'].length > 0){
          this.cityAlreadyExistsError = true;
          this.disableCreateCityBtn = false;
        }else{
          document.getElementById('btnForCreateCitySteps').click();
          let countryData = this.createCityCountryData[this.cityCreateCountryModel];
          const cityDatas = {
            countryCode: countryData['countryCode'],
            name: this.cityCreateCityModel.toUpperCase(),
            active: "1",
            countryName: countryData['countryName'],
            countryId: countryData['rowId'],
            latitude:this.latitudeVal,
            longitude:this.longitudeVal.toString()
          };
          this.countryService.createCities(`${this.Config.ApiCountryUrl}cities`, cityDatas).subscribe(() => {
            this.cityCreation = this.successSteps;

            document.getElementById('closeCreateCityModal').click();
            setTimeout(function (){
              document.getElementById('closeShowCreateCitySteps').click();
            }.bind(this),SiteDetailsComponent.CLOSE_MODAL_DELAY_MS)
            this.disableCreateCityBtn = false;
          },error => {
            this.disableCreateCityBtn = false;
            this.cityCreation = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
          });
        }
      });
    }else{
      if(this.cityCreateCountryModel === '' || this.createCityGotCountryData === 'failed'){
        this.editCreateCityCountryModelError = true;
      }else{
        this.editCreateCityCountryModelError = false;
      }
      if(this.cityCreateCityModel === ''){
        this.editCreateCityCityModelError = true;
      }else{
        this.editCreateCityCityModelError = false;
      }
      console.info("lat",this.latitudeVal)
      console.info("long",this.longitudeVal)
      if(this.latitudeVal === ''){
        this.gpsModelError = true;
      }else{
        this.gpsModelError = false;
      }
      if(this.longitudeVal ==''){
        this.gpsModelError = true;
      }else{
        this.gpsModelError = false;
      }
    }
  }
  /**END create city function */

  /**START ADD or EDIT NISSAN CODE FUNCTION */
  addOrEditNissanCode(){
    if(
      this.nissanPlantCodeModel != '' &&
      this.nissanVendorCodeModel != ''
      )
    {
      let codeDatas;
      this.nissanPlantCodeModelError = false;
      this.nissanVendorCodeModelError = false;
      this.disableSaveNissanBtn = true;
      if(this.addOrEdit === 'Add'){
        if(this.nissanWarehouseModel){
          codeDatas = {
            identifierId:this.siteIdentTypesData['ASUSI_CODE'],
            sourceSystemId:"2",
            identifierValue:`${this.nissanPlantCodeModel}#${this.nissanVendorCodeModel}#Y` ,
            accessPointRowId : this.qualiferAliasAccessPRowid,
            effectiveDate:this.apiService.getTodayDate(),
          };
        }
        else{
          codeDatas = {
            identifierId:this.siteIdentTypesData['ASUSI_CODE'],
            sourceSystemId:"2",
            identifierValue:`${this.nissanPlantCodeModel}#${this.nissanVendorCodeModel}#N` ,
            accessPointRowId : this.qualiferAliasAccessPRowid,
            effectiveDate:this.apiService.getTodayDate(),
          };
        }
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, codeDatas).subscribe(() => {
          document.getElementById('closeAddEditNissanCodeModal').click();
          this.saveDatas = "Save";
          this.dispQualifiers('reload');
          },_error => {
            this.saveDatas = "Save";
            this.disableSaveNissanBtn = false;
        });
      } else{
        if(this.nissanWarehouseModel){
          codeDatas = {
            identifierValue:`${this.nissanPlantCodeModel}#${this.nissanVendorCodeModel}#Y`
          };
        }
        else{
          codeDatas = {
            identifierValue:`${this.nissanPlantCodeModel}#${this.nissanVendorCodeModel}#N`
          };
        }
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.nissanCodeRowId}`, codeDatas).subscribe(() => {
          document.getElementById('closeAddEditNissanCodeModal').click();
          this.saveDatas = "Save";
          this.dispQualifiers('reload');
          },_error => {
            this.saveDatas = "Save";
            this.disableSaveNissanBtn = false;
        });
      }
    }
    else{
      if(this.nissanVendorCodeModel === ''){
      this.nissanVendorCodeModelError = true;
      }
      else{
        this.nissanVendorCodeModelError = false;
      }
      if(this.nissanPlantCodeModel === ''){
      this.nissanPlantCodeModelError = true;
      }
      else{
        this.nissanPlantCodeModelError = false;
      }
    }
  }

  resetAddNissan(){
    this.addOrEdit = 'Add';
    this.nissanPlantCodeModel = '';
    this.nissanVendorCodeModel = '';
    this.nissanWarehouseModel = false;
    this.disableSaveNissanBtn = false;
    this.nissanPlantCodeModelError = false;
    this.nissanVendorCodeModelError = false;
  }

  setEditNissanCode(row,value){
    this.nissanCodeRowId = row;
    this.addOrEdit = 'Edit';
    this.nissanPlantCodeModel = value[0];
    this.nissanVendorCodeModel = value[1];
    if(value[2] === 'N'){
      this.nissanWarehouseModel = false;
    } else{
      this.nissanWarehouseModel = true;
    }
    this.disableSaveNissanBtn = false;
    this.disableDeleteNissanBtn = false;
    this.nissanPlantCodeModelError = false;
    this.nissanVendorCodeModelError = false;
  }
  /**END ADD or EDIT NISSAN CODE FUNCTION */

  /**START DELETE NISSAN CODE FUNCTION */
  deleteNissanCode(){
    if(
      this.nissanPlantCodeModel != '' &&
      this.nissanVendorCodeModel != ''
      ){
        this.disableDeleteNissanBtn = false;
        this.sitesService.deleteAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.nissanCodeRowId}`).subscribe(() => {
          document.getElementById('closeAddEditNissanCodeModal').click();
          this.dispQualifiers('reload');
        });
      } else{
        this.disableDeleteNissanBtn = true;
      }
  }
  /**END DELETE NISSAN CODE FUNCTION */

  /**START check Bvd function */
  getCheckBvd(){

    if(this.sitebvidid != ''){
      this.groupAssignToCpy = '';
      this.orbisBvdDataLoading = true;
      const datas = {}
      this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${this.companyId}`).subscribe(data1 => {
        if(data1['group-assignments'].length > 0){
          this.groupAssignToCpy = data1['group-assignments'][0]['groupName'];
        }
      });
      this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface?bvd-id=${this.sitebvidid}`,datas).subscribe((data:any) => {
        this.orbisBvdData = [];
        if(data != null){
          const tempData = JSON.parse(data.result);
          this.orbisBvdData = tempData['Data'][0];

        }
        this.orbisBvdDataLoading = false;
      },_error => {
        this.orbisBvdDataLoading = false;
      });
    }
  }

  saveMainEntranceEdit(label,rowId){
    this.qualiferAliasAccessPRowid = rowId;
    this.qualifierNameModelError = false;
    this.qualifierNameEdit = label;
    this.disableEditQuaNameBtn = false;
  }
  /**END check Bvd function */

  /**START In Portfolio fn */
  toggleInPortfolioSwitch(event){
    const data = { "bvd-id": this.sitebvidid }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`,data).subscribe((data:any) => {
        var bVdDatas = JSON.parse(data.result);
        console.info("bVdDatas",bVdDatas);
      if(bVdDatas['Data'].length>0){
        const temp = bVdDatas['Data'][0];
        console.info("temp",bVdDatas['Data'].length)
        this.bvdidNumber =temp.BVD_ID_NUMBER;
        if(this.bvdidNumber ==this.sitebvidid){
          const toggleEL = event.srcElement.checked;
          let urlOperation = 'add'
          if(this.bvdInPortfolioSet === 'on'){
            urlOperation = 'remove';
          }
          this.inPortfolioLoading = true;
          const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.apiService.PortfolioRecordSet}`;
          const datas =
          { 'WHERE' :
            [
              {
                "BvDID" : [this.sitebvidid]
              }
            ]
          }
          this.apiService.putCustomURLOrbis(bvdOrbisUrl,datas).subscribe(() => {
            this.getInPortfolioDetails();
          },_error => {
            this.getInPortfolioDetails();
            this.inPortfolioLoading = false;
          });
        }else{
          document.getElementById('btnForWarningBvdportfolio').click();
        }
      }else{
        document.getElementById("btnForbvdnotpresentinOrbis").click();
      }
  });
  }

  UpdateaddBvDID(){
    console.info("this.bvdidNumber",this.bvdidNumber);

    this.editBvdIdValueModel=this.bvdidNumber;
    console.info("editBvdIdValueModel",this.editBvdIdValueModel)
    let urlOperation = 'add'
    if(this.bvdInPortfolioSet === 'on'){
      urlOperation = 'remove';
    }
    this.inPortfolioLoading = true;

    const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.apiService.PortfolioRecordSet}`;
    const datas =
    { 'WHERE' :
      [
        {
          "BvDID" : [this.bvdidNumber]
        }
      ]
    }
    this.apiService.putCustomURLOrbis(bvdOrbisUrl,datas).subscribe(() => {
      this.getInPortfolioDetails();
    },_error => {
      this.getInPortfolioDetails();
      this.inPortfolioLoading = false;
    });
    document.getElementById('closeupdateaddbvdid').click();
    this.saveBvdId();
  }

  getInPortfolioDetails(){
    if(this.sitebvidid != ''){
      this.inPortfolioLoading = true;
      const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.apiService.PortfolioRecordSet}`;
      this.apiService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
        this.inPortfolioLoading = false;
        this.countValue = bvdData['Summary'] ? bvdData['Summary']['Count'] : 0;
        const switches = document.getElementById('sliderCheckBox');
        let bvdIndex = -1;
        if(bvdData['BvDIDs']){
          if(bvdData['BvDIDs'].length>0){
            bvdIndex = bvdData['BvDIDs'].indexOf(this.sitebvidid);
          }
      }
        if(bvdIndex != -1){
          if(switches){
            switches.setAttribute('checked','yes');
            this.bvdInPortfolioSet = 'on';
            this.isLoading = false;
          }
        }else{
          if(switches){
            switches.removeAttribute('checked');
            this.bvdInPortfolioSet = 'off';
            this.isLoading = false;
          }
        }
      },_error => {
        this.inPortfolioLoading = false;
        this.isLoading = false;
      });
    }else{
      this.inPortfolioLoading = false;
      this.isLoading = false;
    }
  }
  /**END In Portfolio fn */

  /**Show hide saer code */
  toggleSaerCodeDisp(type:string){
    if (type === 'SAER') {
      this.showSearCode = !this.showSearCode;
      this.saerCodeModel = '';
      this.saerNameModel = '';
      if(this.latamswitch==true){
        this.latamswitch=false;
        this.showLatamCode = false;
        this.latamNameModel='';
        this.latamNameModelError='';
        this.latamCodeModel='';
      }
      if(this.rnaiplswitch==true){
        this.rnaiplswitch=false;
        this.showRnaiplCode = false;
        this.rnaiplNameModel='';
        this.rnaiplCodeModel='';
        this.rnaiplCodeModelError=false;
      }
    }
    if (type === 'C2B') {
      this.showC2BFields = !this.showC2BFields; 
      this.c2bNameModel=''
      this.c2bNameModelError=''
      this.disableAddQualifierToSite=this.showC2BFields ? true:false
    }
    if (type === 'LATAM') {
      if(this.saerswitch==true){
        this.saerswitch=false;
        this.showSearCode = false;
        this.saerCodeModel = '';
        this.saerNameModel = '';
      }
      if(this.rnaiplswitch==true){
        this.rnaiplswitch=false;
        this.showRnaiplCode = false;
        this.rnaiplNameModel='';
        this.rnaiplCodeModel='';
        this.rnaiplCodeModelError=false;
      }
      this.showLatamCode = !this.showLatamCode;
      this.latamNameModel=''
      this.latamNameModelError=''
      this.latamCodeModel=''
    }
    if (type === 'RNAIPL') {
      if(this.saerswitch==true){
        this.saerswitch=false;
        this.showSearCode = false;
        this.saerCodeModel = '';
        this.saerNameModel = '';
      }
      if(this.latamswitch==true){
        this.latamswitch=false;
        this.showLatamCode = false;
        this.latamNameModel='';
        this.latamNameModelError='';
        this.latamCodeModel='';
      }
      this.showRnaiplCode = !this.showRnaiplCode;
      this.rnaiplNameModel='';
      this.rnaiplCodeModel='';
      this.rnaiplCodeModelError=false;
    }
  }
  /**Show hide saer code */

  /**START show tax identifiers */
  addTaxIdentifiers(){
    this.isLoading = true;
    if(this.sitebvidid != ''){
      this.BvDdata = [];
      this.noTaxIdentifierData = false;
      this.addTaxIdentifierLoading = true;
      const bvdConst = { 'bvd-id' : this.sitebvidid}

      this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`,bvdConst).subscribe((data:any) => {

        var bVdDatas = JSON.parse(data.result);
        if(bVdDatas['Data'][0] != undefined && bVdDatas['Data'][0] != null){
          this.BvDdata = bVdDatas['Data'][0];
          this.currentOrbisStatus=bVdDatas['Data'][0]['STATUS'][0];
        }
        console.info('this.bvdData',this.BvDdata);
        console.info('bVdDatas',bVdDatas);
        let variable = [];
        if(this.BvDdata != undefined && bVdDatas['Data'].length > 0){

          if(bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] != null){
            console.info("bVdDatas['Data'][0]['NATIONAL_ID_LABEL']",bVdDatas['Data'][0]['NATIONAL_ID_LABEL'])
            if(typeof bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] != "string"){
              variable = bVdDatas['Data'][0]['NATIONAL_ID_LABEL'].filter(d1=>{return d1!=null});
              bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] = variable;
            }
            if(bVdDatas['Data'][0]['NATIONAL_ID_LABEL'].length>0 && bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] != null){
              console.info('yes');
              this.noTaxIdentifierData = false;
              let nationalIdLabel = [];
              let nationalId = [];
              nationalIdLabel = bVdDatas['Data'][0]['NATIONAL_ID_LABEL'];
              nationalId = bVdDatas['Data'][0]['NATIONAL_ID'];
              this.identifierType(nationalIdLabel,nationalId);
            }else{
              this.identifierType()
              this.addTaxIdentifierLoading = false;
              this.noTaxIdentifierData = true;
            }
          }else{
            this.identifierType()
            this.addTaxIdentifierLoading = false;
            this.noTaxIdentifierData = true;
          }
        }else{
          this.deleteAllBusinesIdens();
          this.addTaxIdentifierLoading = false;
          this.noTaxIdentifierData = true;
        }
        console.info("BvDdata",this.BvDdata);
      },_error => {
        this.addTaxIdentifierLoading = false;
        document.getElementById('closeaddTaxIdentifier').click();
          this.isLoading = false;
      });
    }
  }

  deleteAllBusinesIdens(){
    const setEndDate = {endDate : this.apiService.getTodayDate()}
    this.TaxIdentifierKeys.forEach(e => {
      if(this.companyAliasAll[e]){
        this.companyAliasAll[e].forEach(ele => {
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${ele.key}?endDate=${this.apiService.getTodayDate()}`  ,setEndDate).subscribe(data => {
            console.info('archived',data)
         });
        }); 
      }
    });
    setTimeout( function(){
      this.dispBvdId(this.businessEntityIdSite);
    }.bind(this),SiteDetailsComponent.CLOSE_MODAL_DELAY_MS);
  }
  identifierType(nationalIdLabel=[],nationalId=[],idenType=[],allKeyNames=[],page=1): any{
    this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?_page=${page}`).subscribe((data:any) => {
      if(data['business-entity-identifier-types'].length>0){
        data['business-entity-identifier-types'].forEach(element => {
          idenType.push(element);
          allKeyNames.push(element['name'].toLowerCase())
        });
      }if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.identifierType(nationalIdLabel,nationalId,idenType,allKeyNames,page+1);
        }else if(data['maxPage'] === page){
          idenType.forEach(element => {
            if(element['name']!=undefined){
            this.companyIdenKeys[element['name'].toLowerCase()] = element['row_id'];
            }
          });
          this.addOrbisStatus()

          this.manageNewBeIdentifiers(nationalIdLabel,nationalId,allKeyNames);

        }
    })
  }

  manageNewBeIdentifiers(nationalIdLabel,nationalId,allKeyNames,allNAKeyNames=[],_subscribeData=[],_page=1){
          nationalIdLabel.forEach(e => {
            if(allKeyNames.indexOf(e.toLowerCase()) === -1){
              allNAKeyNames.push(e);
            }
          });
          if(allNAKeyNames.length > 0){
            this.createNewIdentifiers(allNAKeyNames,nationalIdLabel,nationalId,allKeyNames);
          }else{
            this.deletePreviousIdentifiers2(nationalIdLabel,nationalId);
          }
  }
  addOrbisStatus() {
    const orbisStatus = this.businessEntityValue.filter(d1 => { return d1['businessEntityIdentifierTypeName'] === 'ORBIS-STATUS' })
    if (orbisStatus.length === 1) {
      orbisStatus.forEach(entity => {
        if (entity.value === this.currentOrbisStatus) {
          const update = {
            "startDate": this.apiService.getTodayDate(),
            "endDate": ''
          }
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${entity['row_id']}`, update).subscribe(() => {
            this.getCmpBvd()
          })
        } else {
          const update = {
            "endDate": this.apiService.getTodayDate(),
          }
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${entity['row_id']}`, update).subscribe(() => {
            })
          this.newOrbisStatus();
        }
      })
    } else if (orbisStatus.length > 1) {
      const neworbisStatus = orbisStatus.filter(d1 => { return d1['value'] === this.currentOrbisStatus })
      if (neworbisStatus.length === 0) {
        this.newOrbisStatus();
      }
      else if (neworbisStatus.length === 1) {
        neworbisStatus.forEach(entity => {
          const update = {
            "startDate": this.apiService.getTodayDate(),
            "endDate":''
          }
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${entity['row_id']}`, update).subscribe(() => {
            this.getCmpBvd()
          })
        })
      }
      const exsistOrbisStatus = orbisStatus.filter(d1 => { return d1['value'] !== this.currentOrbisStatus })
      if (exsistOrbisStatus.length > 0) {
        exsistOrbisStatus.forEach(entity => {
          const update = {
            "endDate": this.apiService.getTodayDate(),
          }
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${entity['row_id']}`, update).subscribe(() => {
            this.getCmpBvd()
          })
        })
      }
    } else {
      this.newOrbisStatus();
    }
  }
  newOrbisStatus() {
    const const2 = {
      "businessEntityIdentifierTypeId": this.companyIdenKeys['orbis-status'],
      "businessEntityIdentifierTypeName": 'ORBIS-STATUS',
      "startDate": this.apiService.getTodayDate(),
      "businessEntityId": this.businessEntityIdSite,
      "value": this.currentOrbisStatus
    }
    this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(() => {
      this.getCmpBvd()
    })
  }

  createNewIdentifiers(allNAKeyNames,nationalIdLabel,nationalId,allKeyNames){
    console.info('allNAKeyNames',allNAKeyNames);
    allNAKeyNames.forEach((e,index) => {
      const createIden = { 'name' : e , 'type' : 'TAXATION'}
      this.supplierService.createBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types`,createIden).subscribe(() => {
        if(index+1 === allNAKeyNames.length){
          this.manageNewBeIdentifiers(nationalIdLabel,nationalId,allKeyNames);
        }
      });
    });
  }

  deletePreviousIdentifiers2(nationalIdLabel,nationalId,subscribeData=[],delBvdIds=[],page=1){
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${this.businessEntityIdSite})&businessEntityIdentifierType=TAXATION&_page=${page}` ).subscribe(data => {
      if(data['business-entity-identifiers'].length > 0){
        data['business-entity-identifiers'].forEach(e => {
          if(e.businessEntityIdentifierTypeName != 'BVD ID'){
            delBvdIds.push(e);
          }
        });
      }
      if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.deletePreviousIdentifiers2(nationalIdLabel,nationalId,subscribeData,delBvdIds,page+1);
      }else if(data['maxPage'] === page){
        const setEndDate = {endDate : this.apiService.getTodayDate()}

        if(delBvdIds.length > 0){
          delBvdIds.forEach((e,index) => {
            if(e.endDate==""){
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${e.row_id}?endDate=${this.apiService.getTodayDate()}` ,setEndDate).subscribe(() => {
              if(index+1 === delBvdIds.length){
                this.postNewBeIdentifiers(nationalIdLabel,nationalId,delBvdIds);
              }
            });
          }else{
            if(index+1 === delBvdIds.length){
              this.postNewBeIdentifiers(nationalIdLabel,nationalId,delBvdIds);
            }
          }
          });
        }else{
          this.postNewBeIdentifiers(nationalIdLabel,nationalId,delBvdIds);
        }
      }
    });
  }

  postNewBeIdentifiers(nationalIdLabel, nationalId, archivedBIs) {
    let setDate = { "endDate": '', "startDate": this.apiService.getTodayDate() }
    for (let i = 0; i < nationalIdLabel.length; i++) {
      if (nationalId[i] != null) {
        setDate['value'] = "";
        const const2 = {
          "businessEntityIdentifierTypeId": this.companyIdenKeys[nationalIdLabel[i].toLowerCase()],
          "businessEntityIdentifierTypeName": nationalIdLabel[i],
          "startDate": this.apiService.getTodayDate(),
          "businessEntityId": this.businessEntityIdSite,
          "value": nationalId[i]
        }
        setDate['value'] = nationalId[i];
        const isExists = archivedBIs.filter(x => x.businessEntityIdentifierTypeId == const2.businessEntityIdentifierTypeId && x.value.replace(/[\. ,:-]+/g, "") == const2.value.replace(/[\. ,:-]+/g, ""))
        console.info('isExists', isExists)
        if (isExists.length == 0) {
          this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(() => {
            if (i + 1 === nationalIdLabel.length) {
              this.ReloadBvdIds();
            }
          }, _error => {
            if (i + 1 === nationalIdLabel.length) {
              this.ReloadBvdIds();
            }
          });
        } else {
          this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${isExists[0].row_id}?startDate=${this.apiService.getTodayDate()}&endDate=""`, setDate).subscribe(() => {
            if (i + 1 === nationalIdLabel.length) {
              this.ReloadBvdIds();
            }
          }, _err => {
            if (i + 1 === nationalIdLabel.length) {
              this.ReloadBvdIds();
            }
          })
        }
      }
    }
  }
  ReloadBvdIds(){
    this.companyAliasAll= [];

    this.dispBvdId(this.businessEntityIdSite);
    document.getElementById('closeaddTaxIdentifier').click();
  }
  /**END show tax identifiers */

  /**START add associated picking */
  async addAssociatedPicking(){

    this.showAddPickingLoading = true;
    this.pickingSitesData = [];
    this.pickingSiteQualifierData = [];
    this.pickingAccessIdenData = [];
    const siteAssignmentData = await this.getSiteAssignmentData();
    console.info("siteAssignmentData",siteAssignmentData)
    this.getSitesData(siteAssignmentData);

  }

  async getSiteAssignmentData() : Promise<any>{
    return new Promise(resolve => {
      let cmpID=[];
      let siteIds=[];
      this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=${this.GroupAssign.groupId} &validityEndDate=is null`).subscribe(data => {
        if(data['group-assignments'].length > 0){
        data['group-assignments'].forEach(element => {
          if(element.validityEndDate =='')
            cmpID.push(element.companyId)
          });
        }else{
          cmpID =this.companyId
        }
          this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=in(${cmpID}) &validityEndDate=is null` ).subscribe(data => {
            data['site-assignments'].forEach(element => {
              if(element.validityEndDate =='' ){
                if (element.site.href) {
                  siteIds.push(element.site.href.split("/")[1]);
                  resolve(siteIds);
                  console.info("site_row_ID",siteIds[1])
                }else{
                  resolve(null);
                }
              }
            });
          })
      });
    })
  }

  getSiteQualifiers(siteIds,subscribeData=[],page =1){

    if(siteIds != null && siteIds.length > 0){
      this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${siteIds})&type=in('P07')&_page=${page} &endDate=is null`).subscribe( data => {
        if(data['access-points'].length > 0){
          subscribeData = data['access-points'].map(id => id);
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getSiteQualifiers(siteIds,subscribeData,page + 1);
          } else if (data['maxPage'] === page) {
            const accessIds = subscribeData.map(id => id.rowId);
            console.info("accessids",accessIds)
            this.pickingSiteQualifierData = subscribeData;
            let tempacps = [];
            for(let j=0;j<this.associatedPickingData.length;j++){
              tempacps.push(this.associatedPickingData[j].acp2Identifier);
            }
            for(let i=0;i<this.pickingSiteQualifierData.length;i++){
              if(tempacps.includes(this.pickingSiteQualifierData[i].identifier)){
                this.pickingSiteQualifierData[i].disableCheckBox = true;
              }else{
                this.pickingSiteQualifierData[i].disableCheckBox = false;
              }
            }
            const falseFirst = this.pickingSiteQualifierData.sort((a, b) => Number(a.disableCheckBox) - Number(b.disableCheckBox));
            console.info("sorted qualifier list",this.pickingSiteQualifierData)
            this.getAccessIdentifiers(accessIds);
          }
        }else{
          this.showAddPickingLoading = false;
        }
      });
    }else{
      this.showAddPickingLoading = false;
    }
  }

   getSitesData(siteIds,subscribeData=[],page=1){
  this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${siteIds})&_page=${page} &endDate=is null`).subscribe(data => {
      if(data['sites'].length > 0){
        subscribeData = data['sites'].map(id => id);
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSitesData(siteIds,subscribeData,page + 1);
        } else if (data['maxPage'] === page) {
          subscribeData.forEach(e => {
            this.pickingSitesData[e.rowId] = e
          })
          this.getSiteQualifiers(siteIds);
        }
      }else{
        this.showAddPickingLoading = false;
      }
    });
  }

  getAccessIdentifiers(accessIds,subscribeData=[],page =1){
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointRowId=in(${accessIds})&_page=${page} &endDate=is null`).subscribe(data => {
      if(data['access-point-identifiers'].length > 0){
        data['access-point-identifiers'].forEach(ele => {
            subscribeData.push(ele);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getAccessIdentifiers(accessIds,subscribeData,page + 1);
        } else if (data['maxPage'] === page) {
          subscribeData.forEach(e => {
            if(e.identifierTypeName === 'RAFT_CODE'){
              this.pickingAccessIdenData[`${[e.accessPointRowId]}raft`] =e;
            }else if(e.identifierTypeName === 'SOCIAL_RAISON'){
              this.pickingAccessIdenData[`${[e.accessPointRowId]}social`] =e;
            }
          });
          for(let i=0;i<this.pickingSiteQualifierData.length;i++){
            if(this.pickingAccessIdenData[`${[this.pickingSiteQualifierData[i].rowId]}raft`]){
              this.pickingSiteQualifierData[i].associatedRaftForSort = this.pickingAccessIdenData[`${[this.pickingSiteQualifierData[i].rowId]}raft`]['identifierValue'];
            }
          }
          this.pickingSiteQualifierData.sort((a, b) => (a.associatedRaftForSort < b.associatedRaftForSort ? -1 : 1))
          const falseFirst = this.pickingSiteQualifierData.sort((a, b) => Number(a.disableCheckBox) - Number(b.disableCheckBox));
          console.info("RaftCode sorted qualifier list",this.pickingSiteQualifierData)
          this.showAddPickingLoading = false;
        }
      }else{
        this.showAddPickingLoading = false;
      }
    });
  }

  selectQualifierPicking(id){
    this.pickingSiteQualifierData.forEach(e => {
      if(e.rowId === id){
        if(e['isChecked']){
          e['isChecked'] = !e['isChecked'];
        }else{
          e['isChecked'] = true;
        }
      }
    });
  }

  addPickingQualifier(){
    const temp = this.pickingSiteQualifierData.filter(val => val.isChecked === true);
    if(temp.length > 0){
      this.showAddPickingLoading = true;
      temp.forEach((e,i) => {
        const acpVals = {
          "type": "RAFT_EXCEPTION",
          "acp1Id": this.selectedACPid,
          "acp2Id": e.rowId,
          "effectiveDate": "2222-01-01"
        };
        this.sitesService.createAccessPointAttachment(`${this.Config.ApiSitesUrl}access-point-attachments`,acpVals).subscribe(() =>{
          if(i+1 === temp.length){
            this.showAddPickingLoading = false;
            this.showAssociatedPicking('Manufacturing',this.acp1Identifier,this.selectedACPid,this.manufacturingAcpStatus,true);
            document.getElementById('closeshowAddPickingQua').click();
          }
        });
      });
    }
  }
  /**END add associated picking */

  /**Start Name Sync Model*/
  openSyncMainEntranceName(name){
    this.mainEntranceNameToSync = name;
    this.disableNameSync = false;
  }

  syncMainEntranceName(){
    const datas = {label : this.mainEntranceNameToSync};
    for(let i=0;i<this.rowIdQua.length;i++){
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowIdQua[i]}`, datas).subscribe(() => {
        this.disableNameSync = true;
        if(i==this.rowIdQua.length-1){
          window.document.getElementById("closeshowNameSync").click();
          this.dispQualifiers('reload');
        }
      },error => {
        console.info('error in Updating, try again',error)
        this.disableNameSync = false;
      });
    }
  }
  /**End Name Sync Model*/

  /**start factories code display modal  */
  FactoriesCodedisp(acp1Identifier,acp2Identifier,RowID,Acp2rowId,page=1,Factoriescode = []){
    this.AcpID1 =acp1Identifier;
    this.AcpID2 =acp2Identifier;
    this.forAcpRowId =RowID;
    this.Acp2rowId = Acp2rowId;
    this.FactoriescodeLoading=true;
    this.uniquefactcode=[];
    this.uniquefactNameAndCode=[];
    this.sitesService.getAccessPointAttachmentAttributes(`${this.Config.ApiSitesUrl}access-point-attachment-attributes?type=FACTORY_CODE&_page=${page}`).subscribe((data: any) => {
      if (data['access-point-attachment-attributes'].length > 0) {
        data['access-point-attachment-attributes'].forEach(element1 => {
          Factoriescode.push(element1.value.slice(2));
        });
      }
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.FactoriesCodedisp(acp1Identifier,acp2Identifier,RowID,Acp2rowId,page + 1,Factoriescode);
      } else if(data['maxPage'] === page){
          Factoriescode.forEach(element => {
            if (!this.uniquefactcode.includes(element)) {
              this.uniquefactcode.push(element);
            }
          });
          this.FactoriescodeLoading=false;
          this.FactoriesNamedisp();
        }
    }, _error => {
      this.FactoriescodeLoading = false;
    });
  }
  /**End factories code display modal */

  /**start factoriesname display */
  FactoriesNamedisp(){
    this.FactoriescodeLoading=false;
    this.uniquefactNameAndCode=[];
    this.uniquefactcode.forEach(element1 => {
      this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?identifierType=RAFT_ACCOUNT&businessIdentifierValue=${element1}` ).subscribe((data: any) => {
        if (data['real-estate-asset-identifiers'].length > 0) {
            this.uniquefactNameAndCode.push({'value':element1,'label':data['real-estate-asset-identifiers'][0].businessIdentifierName});
        }
        if(this.allAttachmentData){
          this.allAttachmentData.forEach(element => {
            this.uniquefactNameAndCode.forEach(ele =>{
              if(element.businessvalue ==ele.value){
                ele.disableuniquefactNameCode =true;
              }
            });
          });
      }
      });
    });
  }
  /**End factoriesname display */

  /**START select factory */
  selectAddFactoryCodeName(value){
    this.uniquefactNameAndCode.forEach(e => {
      if(e.value === value){
        if(e['isChecked']){
          e['isChecked'] = !e['isChecked'];
        }else{
          e['isChecked'] = true;
        }
      }
    });
  }
  /**END select factory */

  /**Start add factory code and names */
  AddFactoryCodeName(){
    const temp = this.uniquefactNameAndCode.filter(val => val.isChecked === true);
    if(temp.length > 0){
      temp.forEach((e,i) => {
        const CodeName = {
          "effectiveDate"          : "2222-01-01",
          'businessIdentifierName' : e.label,
          'businessIdentifierValue': e.value,
          'realEstateAssetId'      : this.siteId,
          'businessIdentifierId'   : this.siteIdentTypesData['RAFT_ACCOUNT'],
          'sourceSystemId'         : "2",
        }
        if(this.alcornameandvalue[this.AcpID2]){
          const acpVals = {
            "type": "RAFT_EXCEPTION",
            "acp1Id": this.selectedACPid,
            "acp2Id": this.Acp2rowId,
            "effectiveDate": "2222-01-01"
          };
          this.sitesService.createAccessPointAttachment(`${this.Config.ApiSitesUrl}access-point-attachments`,acpVals).subscribe(data=>{
            const CodeN = {
              "attId": data['rowId'],
              "acp1Id": this.AcpID1,
              "acp2Id": this.AcpID2,
              "type": "FACTORY_CODE",
              "value": `00${e.value}`,
            }
            this.sitesService.createAccessPointAttachmentAttributes(`${this.Config.ApiSitesUrl}access-point-attachment-attributes`,CodeN).subscribe(() => {

                if(i+1 === temp.length){
                    this.showAssociatedPicking('Manufacturing',this.AcpID1,this.selectedACPid,this.manufacturingAcpStatus,true);
                    window.document.getElementById("closeFactoriesModal").click();
                }

            });
          });
        }else{
          const acpVals = {
            "effectiveDate": "2222-01-01"
          };
          this.sitesService.updateAccessPointAttachment(`${this.Config.ApiSitesUrl}access-point-attachments/${this.forAcpRowId}`,acpVals).subscribe(() =>{
            const CodeN = {
              "attId": this.forAcpRowId,
              "acp1Id": this.AcpID1,
              "acp2Id": this.AcpID2,
              "type": "FACTORY_CODE",
              "value": `00${e.value}`,
            }
            this.sitesService.createAccessPointAttachmentAttributes(`${this.Config.ApiSitesUrl}access-point-attachment-attributes`,CodeN).subscribe(() => {
                if(i+1 === temp.length){
                  this.showAssociatedPicking('Manufacturing',this.AcpID1,this.selectedACPid,this.manufacturingAcpStatus,true);
                  window.document.getElementById("closeFactoriesModal").click();
                }
            });
          });
        }
      });
    }
  }
  /**End add factory code and names */
  /** start filter  factory code and names */
  FilterFunction(){
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[2];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }
  clearfields(val){
    if (val === 'clear'){
      this.filtername = '';
      this.FactoriesNamedisp();
    }
  }
  /** End filter  factory code and names */

  editSaerAliasSet(values,rowIdRaft,accessRowId,name,endDate){
    if(endDate!='' && endDate!=undefined){
       this.showArchivedId = false;
    }
    else{
      this.showArchivedId = true;
    }
    this.saerRowIdVar = rowIdRaft;
    this.saerAccessRowIdVar = accessRowId;
    this.saveDatas = 'Save';
    this.saerNameHolder = name;
    this.disableEditsaerCodeBtn = false;
    this.disableEditsaerNameBtn = false;
    if(values != undefined && values != ''){
      if(values.length > 1){
        this.hasMultiplesaerAlias = true;
      }
      else{
        this.saveAsNewsaerCode = false;       
        this.hasMultiplesaerAlias = false;    
        this.editsaerAliasModel = values;
      }
    }
    else{
      this.editsaerAliasModel = '';
      this.hasMultiplesaerAlias = false;
      this.saveAsNewsaerCode = true;
    }
    if(name != undefined && name != ''){
      this.saveAsNewsaerName = false;
    }else{
      this.saveAsNewsaerName = true;
    }
    this.editsaerAliasError = false;
  }

  checksaerAliasVal(){
    if(this.editsaerAliasModel != ''){
      this.editsaerAliasError = false;
    }
    else{
      this.editsaerAliasError = true;
    }
  }

  resetsaerAliasVal(){
    this.editsaerAliasModel = '';
    this.editsaerAliasError = true;
  }

  checksaerName(){
    if(this.saerNameHolder != ''){
      this.editsaerNameError = false;

    }
    else{
      this.editsaerNameError = true;
    }
  }
  resetsaerName(){
    this.saerNameHolder = '';
    this.editsaerNameError = true;
  }

  savesaerAliasVal(){
    this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&identifierValue=${this.editsaerAliasModel}` ).subscribe( data => {
      if(data['access-point-identifiers'].length>0){
        this.saerUnique=true;
        this.saerLessthanEight=false;
      }else{
        this.saerUnique=false;
        this.saerLessthanEight=false;
        console.info("edit",this.editsaerAliasModel)
        if(this.editsaerAliasModel != undefined && this.editsaerAliasModel != ''&&this.editsaerAliasModel.length==SiteDetailsComponent.EIGHT){
          this.disableEditsaerCodeBtn = true;
          let const2 = {
            "identifierValue" : this.editsaerAliasModel
          }
          if(this.saveAsNewsaerCode === false){
            this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.saerRowIdVar}`, const2 ).subscribe(() => {
              this.changeStatusToPending();
            },_error => {
              this.disableEditsaerCodeBtn = false;
            });
          }
          else{
            let const5 ={
                "identifierId":this.siteIdentTypesData['SAER_CODE'],
                "sourceSystemId":"2",
                "accessPointRowId" : this.saerAccessRowIdVar,
                "identifierValue" : this.editsaerAliasModel,
                "effectiveDate" : this.apiService.getTodayDate()
            }
            this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
              this.changeStatusToPending();
            })
          }
        }else{
          this.saerLessthanEight =true;
        }
      }
    });

  }

  deleteSaerCode(){
    this.disabledeleteSaerCode==true;
    if(this.editsaerAliasModel != undefined && this.editsaerAliasModel != ''){
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&rowId=${this.saerRowIdVar}` ).subscribe( data => {
        data['access-point-identifiers'].forEach(element => {
          console.info("accessPointRowId",element.accessPointRowId);
          this.sitesService.deleteAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.accessPointRowId}` ).subscribe(() => {
            document.getElementById('closeeditsaerAlias').click();
            this.dispQualifiers('reload');
          });
        });
      })

    }
  }

  savesaerAliasName(){
    if(this.saerNameHolder != undefined && this.saerNameHolder != ''){
      this.disableEditsaerNameBtn = true;
      const name = {
        "identifierValue" : this.saerNameHolder
      };
        if(this.saveAsNewsaerName === false){
          this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.saerRowIdVar}`,name ).subscribe(() => {
            document.getElementById('closeEditsaerName').click();
            this.dispQualifiers('reload');
          });
        }
        else{
          let const5 ={
              "identifierId":this.siteIdentTypesData['SOCIAL_RAISON'],
              "sourceSystemId":"2",
              "accessPointRowId" : this.saerAccessRowIdVar,
              "identifierValue" : this.saerNameHolder,
              "effectiveDate" : this.apiService.getTodayDate()
          }
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
            document.getElementById('closeEditsaerName').click();
            this.dispQualifiers('reload')
          })
      }
    }
  }

  toggleForNewAddress(){
    const tempNewAddBtn = document.getElementById('AddNewAddressRadio') as HTMLInputElement;
    if(this.AddNewAddress){
      this.AddNewAddress = !this.AddNewAddress;
      tempNewAddBtn.checked = false;
      console.info("close")
    }else{
      if((tempNewAddBtn.checked) && (this.addressRadioval!='' || this.addressRadioval!=undefined)){
          for(let index=0;index<this.newData.length;index++){
            let tempOldBtns = document.getElementById(`addressRadiovalBtn[${index}]`) as HTMLInputElement;
            tempOldBtns.checked = false;
          }
        this.AddNewAddress = true;
        this.latDegVal='';
        this.latMinVal='';
        this.latSecVal='';
        this.longDegVal='';
        this.longMinVal='';
        this.longSecVal='';
        console.info("open")
      }
    }
  }
  getGroupAssignments(contine = "Yes", page = 1, subscribeData = []) {
    this.GroupAssign = [];
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${this.companyId}&_page=${page}`).subscribe((data: any) => {
      var s = 1;
      data['group-assignments'].forEach(element => {
        subscribeData.push(element);
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getGroupAssignments(contine, page + 1, subscribeData);
      } else if (data['maxPage'] === page) {
        data['group-assignments'].forEach(element => {
          if (element.apoStatus.toLowerCase() === "active") {
            this.GroupAssign = element;
            this.allianceIdentifier =element.companyAllianceIdentifier
            this.GroupAssign['apoStatus2'] = element.groupStatus.toLowerCase();
            this.statusDisplay = element.groupStatus
            if (element.groupId != "" && data['group-assignments'].length === s) {
              this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${element.groupId}`).subscribe((data2: any) => {
                this.GroupAssign['GroupCategory'] = data2.groupTypeCode;
                this.grpDate = data2['modificationStatus'].toLowerCase() === 'archived' ? data2['endDate'] : data2['startDate']
              });
            }
          } else {
          }
          s++;
        });
        console.info("this.GroupAssign====>", this.GroupAssign.groupId);
        this.getGroupAliasByRowid();
        this.getbvd()
      }
    }, _error => {

      this.TaxIdentifiLoading = false;
      this.CompanyIdentiLoading = false;
    });
  }
  loadWorkflowValidation(type,folio,reqId){
    if(type=='valid'){
      this.wkfValNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
    }else if(type=='reject'){
      this.wkfRejNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
      this.rejectWorkflowNotesError = false;
    }else if(type=='info'){
      this.wkfInfoNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
    }
  }

  resetWkfValNotesModel(){
    this.wkfValNotesModel='';
  }

  validateWkfNoteRoute(){
    this.validatingWorkflow=true;
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if(data1.length>0){
        data1.forEach(ele1 => {
          if(this.workflowFolioFromK2Isa){
            if(ele1['folio'].includes(this.workflowFolioFromK2Isa)){
              const serialNumber = ele1['serialNumber'];
              const workflowOwner = ele1['locatedUser'].split(":");
              const temp = workflowOwner[1].split("\\");
              if(temp[1].toLowerCase()==this.Uid){
                const domain = temp[0];
                const note =this.wkfValNotesModel;
                const encoded = encodeURIComponent(note);
                this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Submit&domain=${domain}`,{}).subscribe(() => {
                  this.workflowValidationLoading = true;
                  setTimeout(() => {
                    this.sendMailToRequestor(this.workflowFolioFromK2Isa,note)


                    setTimeout(() => {


                      this.validatingWorkflow=false;
                      document.getElementById('closeWorkflowValidation').click();
                      this.workflowValidationLoading = false;

                    }, SiteDetailsComponent.EIGHT_THOUSAND_MS);
                  }, SiteDetailsComponent.LONG_OPERATION_DELAY_MS);
                });
              }
            }
          }
        });
        if(this.companyStatusCode=='Pending' && this.showForSupplier==false){
          this.sendToBuyer();
        }

      }
    },error => {
      console.info('error',error);
    });
  }
  /**end validate workflow */


  /**START send to buyer */
  sendToBuyer(){


    const sendReq={
      "companyStatusCode" : "Waiting for Approval",
      "companyStatusId": "6"
    };
    const siteStatusChange={
      "activeStatus": "CREATED"
    };
    this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyId}`, sendReq).subscribe(() => {});
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=${this.companyId}`).subscribe((data1: any) => {
      console.info("data1",data1)
      if (data1['site-assignments'].length > 0) {
        data1['site-assignments'].forEach(element => {
          if (element.site.href) {
            var site_row_ID = element.site.href.split("/");

            const SiteRowIDExis = this.SiteRowID.indexOf(site_row_ID[1]);
            if (SiteRowIDExis === -1) {
              this.SiteRowID.push(site_row_ID[1]);
            }
          }
        })
      }
      this.SiteRowID.forEach(element => {
        this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${element})`).subscribe((data3: any) => {
          data3['sites'].forEach(element5 => {
             console.info("stati",element5.activeStatus)
             if (element5.activeStatus === 'PENDING') {
              this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${element}`, siteStatusChange).subscribe(() => {

              })
             }
          });
        });
      });
    });
  }
  /**START send to buyer */

  sendMailToRequestor(folio,notes){
    const baseUrl1 = baseUrl
    const style = "font-weight-bold text-warning"
    let mailSubject = 'Approval request for ';
    const onlineHelp = online
    this.Uid = this.apiService.fromApp_UserIPN.toLowerCase();
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    const specificLink = `${baseUrl1}/workflow`;
    const changed = folio.match(/^(.*_)(\d.*)$/);
    this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa`).subscribe(data => {
      const list =data['listRequestDetails']
      const current_WrkFlow= list.filter(x=> x.folio.includes(changed[1]))[0]
const requestedUser=current_WrkFlow.requestor;

if(current_WrkFlow.status.toLowerCase()==='approved' || current_WrkFlow.status.toLowerCase()==='refused' ){

  this.arcaService.getPerson(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${current_WrkFlow.allianceId}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
    this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${requestedUser.user}')`).subscribe((reqUser : any) => {
      if(current_WrkFlow.status.toLowerCase()==='approved'){
        mailSubject = `Request approved for ${companyData['companies'][0].legalName}`;

      this.mailBodyContent =
      `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was approved by the all validators! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from last approver : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Alliance supplier repository team</p></body>`;
      }
      if(current_WrkFlow.status.toLowerCase()==='refused'){
        mailSubject = `Request refused for ${companyData['companies'].at(0).legalName}`;

        this.mailBodyContent = `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} (${current_WrkFlow.strRequestType}) was refused! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from the rejector : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Alliance supplier repository team</p></body>`;
        }
      this.sendMailFn(reqUser.Mail, mailSubject, this.mailBodyContent);
    })
  })

    }
     } )


  }
  sendToNewApprover(data,newowner){
      const destination = newowner.split('  -  ');
      const letters = ['f','F']
      const originalDomain = letters.some(letter => data['workflowOwner'][0].includes(letter)) ? "EXTALLIANCEIT" :  "CORP";
      const destinationDomain = letters.some(letter => destination[0].includes(letter)) ? "EXTALLIANCEIT" :  "CORP";
      const newData = ''
      console.info('data', newData);
  
      this.k2Service.createK2Isa(`${this.Config.ApiK2Url}redirect-tasks?taskID=${data['taskID']}&destinationDN=${destination[0]}%20on-behalf-of%20${data['workflowOwner'][0]}&originalIpn=${data['workflowOwner'][0]}&destinationIpn=${destination[0]}&originalDomain=${originalDomain}&destinationDomain=${destinationDomain}`, newData).subscribe(() => {
        console.info("send Mail");
          
          
          const sendMailTo = this.sendMailToApprover
          var desc = this.senReqNotesMOdel;
          const baseUrl1 = baseUrl
          const specificLink = `${baseUrl1}/company-details/${this.companyId}#workflows`;
          const mailSubject = `Approval request for ${data.supplierName}`;
          const onlineHelp = online
          this.mailBodyContent =
            `<p>Dear ${destination[1]} ${destination[2]},</p><p> You have been designed as new approver of the request ${data['folio']}</p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p><p>Notes from the Admin Team:</p> <p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
          this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
      })
    }
    focusFunction(field) {
    if (field === 'sam' && this.senReqSamMOdel === '') {
      this.lookupArca('sam');
      document.getElementById('btnForArcaPopup').click();
    } 
  }
    PasteSam(ipn, firstName, lastName,mail) {
    this.sendMailToApprover = mail;
    if (this.arcasearchModel === 'sam') {
      this.senReqSamMOdel = `${ipn}  -  ${firstName}  -  ${lastName}`;
      this.senReqSamMOdelError = false;
    }
    if (this.arcasearchModel === 'buyeraasis') {
      this.senReqBuyerAssiMOdel = `${ipn}  -  ${firstName}  -  ${lastName}`;
      this.buyerNameSelected = `${firstName} ${lastName}`;
    }
    window.document.getElementById("closeGCBtn").click();
  }
  ArcNameModelChange() {
    this.data = [];
    this.resetArca = false;
    this.arcaSrchWait = false;
    this.arcaSrchnoresults = false;
  }
  resetArcaSearch(val) {
    if (val === "ArcIpn") {
      this.ArcIpn = '';
    } else if (val === "ArcFirstName") {
      this.ArcFirstName = '';
    } else if (val === "ArcLastName") {
      this.ArcLastName = '';
    }
  }
  ArcSearch() {
    var FilterParam = "";
    let firstAndLast = false;
    if (this.ArcFirstName != "" && this.ArcLastName === "") {
      FilterParam += `contains(FirstName,'${this.ArcFirstName}') `;
    } else if (this.ArcFirstName === "" && this.ArcLastName != "") {
      FilterParam += `contains(LastName,'${this.ArcLastName}') `;
    }
    if (this.ArcLastName != "") {
      if (this.ArcFirstName != "") {
        firstAndLast = true;
        FilterParam += `contains(FirstName,'${this.ArcFirstName}') `;
      }
    }
    if (this.ArcIpn != "") {
      if (this.ArcFirstName != "" || this.ArcLastName != "") {
      }
    }
    let sam_arr: any = []

    if (FilterParam != "" && firstAndLast === false) {

      this.arcaSrchnoresults = false;
      this.arcaSrchWait = true;
      this.isaRoleFor_Uid = [];
      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person?$filter=${FilterParam}&$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode&$top=10`).subscribe(data => {
        if (data ? data['value'].length > 0 : false) {
          if (data['value'].length > 0) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            data['value'].forEach(e => {
              if (e.PersonSuperDomainCode === 'renault' || e.PersonSuperDomainCode === 'nna' || e.PersonSuperDomainCode === 'ne' || e.PersonSuperDomainCode === 'nml') {
                sam_arr.push(e);
                if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                  this.getArcaUserIsaRole(e.Uid);
                } else if (this.isEnvQua === true || this.isEnvInt === true) {
                  this.isaRoleFor_Uid[e.Uid] = 'manager';
                }
              }
            })
            if (sam_arr.length > 0) {
              this.data = sam_arr;

            }
          }
          else {
            this.data = data['value'];
          }
          this.resetArca = true;
        } else {
          this.resetArca = false;
        }
      }else{
        this.resetArca = false;
      }
        this.arcaSrchWait = false;
        this.arcaSrchnoresults = false;
      },
        _err => {
          this.data = [];
          this.resetArca = false;
          this.arcaSrchWait = false;
          this.arcaSrchnoresults = true;
        });
    } else if (FilterParam != '' && firstAndLast === true) {
      this.arcaSrchnoresults = false;
      this.arcaSrchWait = true;
      this.isaRoleFor_Uid = [];

      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person?$filter=${FilterParam}&$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode`).subscribe(data => {
        console.info(data);
        if (data['value'].length > 0) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            data['value'].forEach(e => {
              if (e.PersonSuperDomainCode === 'renault' || e.PersonSuperDomainCode === 'nna' || e.PersonSuperDomainCode === 'ne' || e.PersonSuperDomainCode === 'nml') {
                if (e.LastName != undefined) {
                  if (e.LastName.toLowerCase().includes(this.ArcLastName.toLowerCase())) {
                    sam_arr.push(e);
                  }
                  if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                    this.getArcaUserIsaRole(e.Uid);
                  } else if (this.isEnvQua === true || this.isEnvInt === true) {
                    this.isaRoleFor_Uid[e.Uid] = 'manager';
                  }
                }
              }
            });
            console.info("sam_arr", sam_arr);
            if (sam_arr.length > 0) {
              this.data = sam_arr;
              this.resetArca = true;
              this.arcaSrchWait = false;
              this.arcaSrchnoresults = false;
            } else {
              console.info("data null, search lastname", this.data);
              this.seacrhLastname();
            }
          }
          else {
            this.data = data['value'];
          }
        } else {
          this.resetArca = false;
        }
      },
        _err => {
          this.data = [];
          this.resetArca = false;
          this.arcaSrchWait = false;
          this.arcaSrchnoresults = true;
        });
    } else if (this.ArcIpn != "") {
      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.ArcIpn}')`).subscribe((data: any) => {
        if (data != null) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            if (data.PersonSuperDomainCode === 'renault' || data.PersonSuperDomainCode === 'nna' || data.PersonSuperDomainCode === 'ne' || data.PersonSuperDomainCode === 'nml') {
              if (data.Uid != undefined) {
                if (data.Uid.toLowerCase().includes(this.ArcIpn.toLowerCase())) {
                  sam_arr.push(data);
                }
                if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                  this.getArcaUserIsaRole(data.Uid);
                } else if (this.isEnvQua === true || this.isEnvInt === true) {
                  this.isaRoleFor_Uid[data.Uid] = 'manager';
                }
              }
            }

            if (sam_arr.length > 0) {
              this.data = sam_arr;
              this.resetArca = true;
              this.arcaSrchWait = false;
              this.arcaSrchnoresults = false;
            } else {
              this.data.push(data);
            }
          }
          else {
            this.data.push(data);
          }
        } else {
          this.resetArca = false;
        }

      });

    }
    else {
      console.info("Please fill anyone to search");

    }
  }
  seacrhLastname() {
    let sam_arr: any = [];
    this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person?$filter=contains(LastName,'${this.ArcLastName}') &$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode`).subscribe(data => {
      console.info(data);
      if (data['value'] != null && data['value'] != undefined) {
        if (data['value'].length > 0) {
          if (this.arcasearchModel === 'sam' || this.arcasearchModel === 'buyeraasis') {
            data['value'].forEach(e => {
              if (e.PersonSuperDomainCode === 'renault' || e.PersonSuperDomainCode === 'nna' || e.PersonSuperDomainCode === 'ne' || e.PersonSuperDomainCode === 'nml') {
                if (e.FirstName != undefined) {
                  if (e.FirstName.toLowerCase().includes(this.ArcFirstName.toLowerCase())) {
                    sam_arr.push(e);
                  }
                  if (this.showUidDisable === false && this.isEnvQua === false && this.isEnvInt === false) {
                    this.getArcaUserIsaRole(e.Uid);
                  } else if (this.isEnvQua === true || this.isEnvInt === true) {
                    this.isaRoleFor_Uid[e.Uid] = 'manager';
                  }
                }
              }
            });
            console.info("sam_arr", sam_arr);
            if (sam_arr.length > 0) {
              this.data = sam_arr;
              this.resetArca = true;
              this.arcaSrchWait = false;
              this.arcaSrchnoresults = false;
            } else {
              this.arcaSrchnoresults = true;
              this.arcaSrchWait = false;
            }
          }
          else {
            this.data = data['value'];
          }
        } else {
          this.resetArca = false;
        }
      } else {
        this.resetArca = false;
      }
    },
      _err => {
        this.data = [];
        this.resetArca = false;
        this.arcaSrchWait = false;
        this.arcaSrchnoresults = true;
      });
  }
  getArcaUserIsaRole(ipn) {
    if (ipn != '') {
      this.arcaService.getrole(`${this.Config.ApiArcaURL}Role?$filter=(ApplicationDomain eq 'FRA') and (ApplicationId eq 'ISA') and (Uid eq '${ipn}')`).subscribe(data => {
        if (data != null) {
          if (data['value']) {
            data['value'].forEach(e => {

              this.isaRoleFor_Uid[ipn] = e.CommonName.toLowerCase();

            });
          }
        }
        console.info('roles in isa', this.isaRoleFor_Uid);
      }, error => {
        if (error.status === SiteDetailsComponent.HTTP_STATUS_NOT_FOUND) {
          this.isaRoleFor_Uid[ipn] = 'norole';
        }
      });
    }
  }
  resetSendReqToSupp(fieEld) {  
    if (fieEld === "senReqSamMOdel") {
      this.senReqSamMOdel = "";
      this.senReqSamMOdelError = true;
    }else if (fieEld === "senReqNotesMOdel") {
      this.senReqNotesMOdel = "";
    }
  }
  lookupArca(model) {
    this.arcasearchModel = model;
    this.resetArca = false;
    this.ArcIpn = "";
    this.ArcFirstName = "";
    this.ArcLastName = "";
    this.arcaSrchWait = false;
    if (model === 'sam') {
      this.showUidDisable = false;
    } else {
      this.showUidDisable = true;
    }
  }

  sendMailFn(mailTo,mailSubject,mailBody,onSuccess?: () => void, onError?: () => void){
    const mailcontent:any={};
    mailcontent.toAddress = mailTo,
    mailcontent.mailSubject = mailSubject,
    mailcontent.body = mailBody
    const baseUrl1 = baseUrl === localUrl ? intUrl : baseUrl
    this.documentService.postServiceCall(`${baseUrl1}/api/sendMail`, mailcontent).subscribe(() => {
      if (onSuccess) {
        onSuccess();
      }
    }, error => {
      console.info('Error while sending email:', error);
      if (onError) {
        onError();
      }
    });
  }

  resetWkfRejNotesModel(){
    this.wkfRejNotesModel='';
  }

  rejectWkfNoteRoute(){
    this.validatingWorkflow=true;
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    if(this.wkfRejNotesModel!=''){
      this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
        if(data1.length>0){
          data1.forEach(ele1 => {
            if(this.workflowFolioFromK2Isa){
              if(ele1['folio'].includes(this.workflowFolioFromK2Isa)){
                const serialNumber = ele1['serialNumber'];
                const workflowOwner = ele1['locatedUser'].split(":");
                const temp = workflowOwner[1].split("\\");
                if(temp[1].toLowerCase()==this.Uid){
                  const domain = temp[0];
                  const note =this.wkfRejNotesModel;
                  const encoded = encodeURIComponent(note);
                  this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Refuse&domain=${domain}`,{}).subscribe(() => {
                    this.workflowValidationLoading = true;
                    setTimeout(() => {
                      this.sendMailToRequestor(this.workflowFolioFromK2Isa,note)
                      setTimeout(() => {
                        setTimeout(() => {
                          this.validatingWorkflow=false;
                          document.getElementById('closeWorkflowRejection').click();

                       }, SiteDetailsComponent.LONG_OPERATION_DELAY_MS);
                      }, SiteDetailsComponent.EIGHT_THOUSAND_MS);
                    }, SiteDetailsComponent.LONG_OPERATION_DELAY_MS);
                  });
                }
              }
            }
          });
        }
      },error => {
        console.info('error',error);
      });
    }else{
      this.rejectWorkflowNotesError = true;
    }
  }

  checkCommentsField(){
    if(this.wkfRejNotesModel === '') {
      this.rejectWorkflowNotesError=true;
    }else {
      this.rejectWorkflowNotesError=false;
    }
  }
  resetWkfInfoNotesModel(){
    this.wkfInfoNotesModel='';
  }

  infoWkfNoteRoute(){
    this.validatingWorkflow=true;
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if(data1.length>0){
        data1.forEach(ele1 => {
          if(this.workflowFolioFromK2Isa){
            if(ele1['folio'].includes(this.workflowFolioFromK2Isa)){
              const serialNumber = ele1['serialNumber'];
              const workflowOwner = ele1['locatedUser'].split(":");
              const temp = workflowOwner[1].split("\\");
              if(temp[1].toLowerCase()==this.Uid){
                const domain = temp[0];
                const encoded = encodeURIComponent(this.wkfInfoNotesModel);
                this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=More info needed&domain=${domain}`,{}).subscribe(() => {
                  this.workflowValidationLoading = true;
                  setTimeout(() => {
                    setTimeout(() => {
                      document.getElementById('closeWorkflowInfoRequest').click();
                      this.validatingWorkflow=false

                    }, SiteDetailsComponent.EIGHT_THOUSAND_MS);
                  }, SiteDetailsComponent.LONG_OPERATION_DELAY_MS);
                });
              }
            }
          }
        });
      }
    },error => {
      console.info('error',error);
    });
  }

  acc(check){
    if(check =='group'){
      var x = document.getElementById("openAllBoxgroup");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDownGroup =false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDownGroup =true;
      }
    }else if(check =='company'){
      var x = document.getElementById("openAllBoxcompany");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDowncompany =false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDowncompany =true;
      }
    }else if(check =='site'){
          var x = document.getElementById("openAllBoxcsite");
          if (x.style.display === "none") {
            x.style.display = "block";
            this.showBoxDownSite =false;
            this.showBoxDownForAllSec = true;
          } else {
            x.style.display = "none";
            this.showBoxDownSite =true;
          }
    }else if(check =='workflow'){
      var x = document.getElementById("openworkflow");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDownworkflow =false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDownworkflow =true;
      }
    }
    if(this.showBoxDownworkflow && this.showBoxDownSite && this.showBoxDowncompany && this.showBoxDownGroup){
      this.showBoxDownForAllSec = false;
    }
  }

  getColor2(status) {
    let flag = 1;
    for(let i=0; i<this.colors2.length; i++)  {
      if(this.colors2[i].status === status) {
        flag = SiteDetailsComponent.TWO
      return this.colors2.filter(item => item.status === status)[0].color;
      }
    }
    if(flag === 1) {
      return "#FFBD69";
    }
  }

  showDropdownStatusWorkFlow(dos='main'){
    if(dos === 'close'){
      this.FiltercheckStatusWorkFlow.forEach(ele => {
        this[ele] = false;
      });
    }else{
      this.showFilterStatusWorkFlow = !this.showFilterStatusWorkFlow;
    }
    setTimeout(function(){
      this.FiltercheckStatusWorkFlow.forEach(ele => {
        const type = ele.split('_');
        if(this[ele] === true){
          if(document.getElementById(type[0])){
           document.getElementById(type[0]).setAttribute('checked','');
          }
        }else{
          if(document.getElementById(type[0])){
           document.getElementById(type[0]).removeAttribute('checked');
          }
        }
      });
      if(dos === 'close'){
        this.filterStatusWorkFlow();
      }
    }.bind(this),SiteDetailsComponent.TEN)
  }

  setCheckboxValWorkFlow(status){
    this[`${status}_status`] = !this[`${status}_status`];
  }

  filterStatusWorkFlow(){
    this.workFlowVisibility =true;
    const statusToFilter = [];
    const validsiteIds = [];
    this.filteredWorkFlow = [];
    this.workFlowDetails=[];
    this.statusFilteredWorkFlow =false;
    this.FiltercheckStatusWorkFlow.forEach(ele => {
      if(this[ele] === true){
        const type = ele.split('_');
        this.statusFilteredWorkFlow =true;
        if(type[0] =='Inprogress'){
          statusToFilter.push('In progress')
        }else if(type[0] =='Needmoreinfo'){
          statusToFilter.push('Need more info')
        }
        else{
          statusToFilter.push(type[0]);
        }
      }
    });
    console.info("status",statusToFilter)
    this.workFlowDetails = this.tempWorkflow;
    if(statusToFilter.length > 0){
      this.siteRowIdFilterWorkFlow.forEach(element => {
        for(let i=0; i< statusToFilter.length; i++){
        for(let j=0; j< this.workflowStatus[element].length; j++){
          if(this.workflowStatus[element]){
            if(statusToFilter[i] === this.workflowStatus[element][j] ){
              if(validsiteIds.indexOf(element) === -1){
                validsiteIds.push(element);
              }
            }
          }
        }
        }
      });
      this.workFlowDetails.forEach(elements => {
        if(validsiteIds.indexOf(elements.requestId) != -1){
          elements['filterTrue'] = true;
          this.filteredWorkFlow.push(elements);
        }else{
          elements['filterTrue'] = false;
        }
      });
      this.workFlowDetails = this.filteredWorkFlow;
      const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
      let len = this.filteredWorkFlow.length;
    }else{
      this.workFlowDetails.forEach(e => {
          e['filterTrue'] = true;
      });
      let len = this.workFlowDetails.length;
      const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
    }
    this.showFilterStatusWorkFlow = false;
  }

  notesHistoryOpen(request,type='',page=1){
    this.approverEdit = type === 'edit' ? true : false;
    this.senReqNotesMOdel = ''
    this.senReqSamMOdel=''
    this.history;
    this.requestForNotesHistory = [];
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${request['requestId']}`).subscribe(data => {
      let roleTemp;
      if(data['validatorRole']!=null || data['validatorRole']!=''){
        roleTemp = data['validatorRole'];
      }else{
        roleTemp = '';
      }
      if(request['workflowOwnerWithRole'].length>0){
        request['approver'] = `${request['workflowOwnerWithRole'][0]} (${roleTemp})`;
      }else{
        request['approver'] = '';
      }
    });
    let notsubmitted =false;
    const temp =[];
    request['historys'].forEach(element => {
      if (element.route =="Submitted" && notsubmitted ==false){
        temp.push(element);
        notsubmitted =true;
      }else if(element.route !="Submitted"){
        temp.push(element);
      }
    });
    request['historys'] =temp;
    this.requestForNotesHistory=request;
    this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, 10);
    this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + 1);
    this.history=this.requestForNotesHistory['historys'].length>SiteDetailsComponent.TEN ? false : true
  }

  approverColor(a) {
    if (a[0].length==SiteDetailsComponent.SEVEN) {
      let mystyle = {
        'color': '#cb4b32'
      }
      return mystyle
    }
  }
  
  historyTable(page){
    this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, 10);
    this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + 1);
  }

  closeAllSections(){
    const a = document.getElementById('openAllSection');
    if(a && a.classList.contains('opened_all')){
      this.showBoxDownForAllSec = false;
    }
    let x = document.getElementById("openAllBoxgroup");
    if (x && x.style.display !== "none") {
      x.style.display = "none";
      this.showBoxDownGroup =true;
    }
    x = document.getElementById("openAllBoxcompany");
    if (x && x.style.display !== "none") {
      x.style.display = "none";
      this.showBoxDowncompany =true;
    }
    x = document.getElementById("openAllBoxcsite");
    if (x && x.style.display !== "none") {
      x.style.display = "none";
      this.showBoxDownSite =true;
    }
    x = document.getElementById("openworkflow");
    if (x && x.style.display !== "none") {
      x.style.display = "none";
      this.showBoxDownworkflow =true;
    }
  }

  openSiteWorkflowStatusModal() {
    this.siteWorkflowStatusModel = this.siteWorkflowStatus || '';
    this.disableSiteWorkflowStatusBtn = false;
  }

  updateSiteWorkflowStatus() {
    if (this.siteWorkflowStatusModel !== '') {
      this.disableSiteWorkflowStatusBtn = true;
      const payload = { workflowStatus: this.siteWorkflowStatusModel };
      this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
        this.siteWorkflowStatus = this.siteWorkflowStatusModel;
        this.disableSiteWorkflowStatusBtn = false;
        document.getElementById('closeSiteWorkflowStatusModal').click();
      }, () => {
        this.disableSiteWorkflowStatusBtn = false;
      });
    }
  }
  dmsversdd(){
    var lat, lng, nordsud, estouest, latitude_degres, latitude_minutes, latitude_secondes, longitude_degres, longitude_minutes, longitude_secondes;
    if (this.northSouthModel=='South')
        nordsud = -1;
    else
        nordsud = 1;
    if (this.eastWestModel=='West')
        estouest = -1;
    else
        estouest = 1;
    latitude_degres = parseFloat(this.latDegVal) || 0;
    latitude_minutes = parseFloat(this.latMinVal) || 0;
    latitude_secondes = parseFloat(this.latSecVal) || 0;
    longitude_degres = parseFloat(this.longDegVal) || 0;
    longitude_minutes = parseFloat(this.longMinVal) || 0;
    longitude_secondes = parseFloat(this.longSecVal) || 0;
    lat = nordsud * (latitude_degres + latitude_minutes / SiteDetailsComponent.MINUTES_PER_DEGREE + latitude_secondes / SiteDetailsComponent.SECONDS_PER_DEGREE);
    lng = estouest * (longitude_degres + longitude_minutes / SiteDetailsComponent.MINUTES_PER_DEGREE + longitude_secondes / SiteDetailsComponent.SECONDS_PER_DEGREE);
    const tem1 = Math.round(lat * SiteDetailsComponent.COORD_PRECISION_SCALE) / SiteDetailsComponent.COORD_PRECISION_SCALE;
    this.latitudeVal = tem1.toString();
    this.longitudeVal = lng;
  }

  ddversdms() {
    var lat, lng, latdeg, latmin, latsec, lngdeg, lngmin, lngsec;
    lat = parseFloat(this.latitudeVal) || 0;
    lng = parseFloat(this.longitudeVal) || 0;
    console.info("lat",lat)
    console.info("lat",lng)
    if (lat >= 0)
        this.northSouthModel='North';
    if (lat < 0)
        this.northSouthModel='South';
    if (lng >= 0)
        this.eastWestModel='East';
    if (lng < 0)
        this.eastWestModel='West';
    lat = Math.abs(lat);
    lng = Math.abs(lng);
    latdeg = Math.floor(lat);
    latmin = Math.floor((lat - latdeg) * SiteDetailsComponent.MINUTES_PER_DEGREE);
    latsec = Math.round((((lat - latdeg - latmin / SiteDetailsComponent.MINUTES_PER_DEGREE) * SiteDetailsComponent.ROUND_TRIM_SCALE * SiteDetailsComponent.SECONDS_PER_DEGREE) / SiteDetailsComponent.ROUND_TRIM_SCALE) * SiteDetailsComponent.DECIMAL_TENTH) / SiteDetailsComponent.DECIMAL_TENTH;
    lngdeg = Math.floor(lng);
    lngmin = Math.floor((lng - lngdeg) * SiteDetailsComponent.MINUTES_PER_DEGREE);
    lngsec = Math.floor((((lng - lngdeg - lngmin / SiteDetailsComponent.MINUTES_PER_DEGREE) * SiteDetailsComponent.ROUND_TRIM_SCALE * SiteDetailsComponent.SECONDS_PER_DEGREE) / SiteDetailsComponent.ROUND_TRIM_SCALE) * SiteDetailsComponent.DECIMAL_TENTH) / SiteDetailsComponent.DECIMAL_TENTH;
    this.latDegVal = latdeg;
    this.latMinVal = latmin;
    this.latSecVal = latsec;
    this.longDegVal = lngdeg;
    this.longMinVal = lngmin;
    this.longSecVal = lngsec;
  }
  copyGpsdata(check){
    this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryName=${this.siteCountry}&name=${this.siteCity}`).subscribe((data1: any) => {
      data1['cities'].forEach(element => {
        if(element.latitude !='' && element.longitude !=''){
          if(check =='latval'){
            this.latitudeVal =element.latitude.replace(",", ".");
            this.longitudeVal=element.longitude.replace(",", ".");
            this.ddversdms();
            this.dmsversdd();
          }else if(check =='gpslat'){
            this.gpsValueModelLat=element.latitude.replace(",", ".");
            this.gpsValueModelLon=element.longitude.replace(",", ".");
            this.ddversdmsanotheraddress()
            this.dmsversddanotheraddress()
          }
        }else{
          document.getElementById('btnForNoGpsData').click();
        }
      });
    });
  }

  showAddressList(addressEdit,accessPointRowId,addressEditForGPS){
    console.info("..........addressEdit",addressEdit)
    console.info("..........accessPointRowId",accessPointRowId)
    console.info("..........addressEditForGPS",addressEditForGPS)
    this.addressEditRowIdForSelAnAdd = addressEdit;
    this.accessPointRowIdForSelAnAdd = accessPointRowId;
    this.qualiferSiteStreetModelUp = '';
    this.qualiferSiteAdditionalAddressInfoModelUp = '';
    this.AddNewAddress = false;
    const tempNewAddBtn = document.getElementById('AddNewAddressRadio2') as HTMLInputElement;
    tempNewAddBtn.checked = false;
    this.tempNewData=[];
    console.info("....newData",this.newData)
    this.newData.forEach(element => {
      if(element['addressEditRowId']!=addressEdit || element['addressEditRowIdForGPS']!=addressEditForGPS){
        this.tempNewData.push(element);
      }
    });
    console.info("temp data",this.tempNewData)
    setTimeout(() => {
      if(this.tempNewData.length==1){
        if(this.tempNewData[0].addressEditRowIdForGPS!=undefined && this.tempNewData[0].addressEditRowIdForGPS!=''){
        let tempOldBtns = document.getElementById('addressRadiovalButton[0]') as HTMLInputElement;
        tempOldBtns.checked = true;
        this.addressRadioval2 = this.tempNewData[0].addressEditRowIdForGPS;
        }else if(this.tempNewData[0].addressEditRowId!=undefined && this.tempNewData[0].addressEditRowId!=''){
          let tempOldBtns = document.getElementById('addressRadiovalButton[0]') as HTMLInputElement;
          tempOldBtns.checked = true;
          this.addressRadioval2 = this.tempNewData[0].addressEditRowId;
        }
      }else{
        for(let index=0;index<this.tempNewData.length;index++){
          let tempOldBtns = document.getElementById(`addressRadiovalButton[${index}]`) as HTMLInputElement;
          tempOldBtns.checked = false;
        }
        this.addressRadioval2 = '';
      }
    }, SiteDetailsComponent.POLLING_DELAY_MS);
    this.qualiferSiteAdditionalAddress = '';
    this.qualiferSiteAdditionalAddressInfo = '';
    this.postalCodeModel = '';
    this.gpsValueModelLat = '';
    this.gpsValueModelLon = '';
    this.territorialDivModelQualifierEdit = '';
    this.wayNumberModelQualifierEdit = '';
    this.wayNumberModelQualifierEditRegExError = false;
    this.qualiferSiteStreetModelUpRegExError = false;
    this.qualiferSiteAdditionalAddressRegExError = false;
    this.qualiferSiteAdditionalAddressInfoRegExError = false;
    this.postalCodeModelRegExError = false;
    this.territorialDivModelQualifierEditRegExError = false;
    this.disableSelAnotherAddress = false;
    this.qualiferSiteStreetModelErrorUp = false;
    this.saveDatas = 'Save';
    this.radioNotChecked = false;
  }

  toggleForNewAddress2(){
    const tempNewAddBtn = document.getElementById('AddNewAddressRadio2') as HTMLInputElement;
    if(this.AddNewAddress){
      this.AddNewAddress = !this.AddNewAddress;
      tempNewAddBtn.checked = false;
      console.info("close")
    }else{
      if((tempNewAddBtn.checked) && (this.addressRadioval2!='' || this.addressRadioval2!=undefined)){
          for(let index=0;index<this.tempNewData.length;index++){
            let tempOldBtns = document.getElementById(`addressRadiovalButton[${index}]`) as HTMLInputElement;
            tempOldBtns.checked = false;
          }
        this.AddNewAddress = true;
        this.latDegVal='';
        this.latMinVal='';
        this.latSecVal='';
        this.longDegVal='';
        this.longMinVal='';
        this.longSecVal='';
        console.info("open")
      }
    }
  }

  selectAnotherAddress(){
    let temporaryAddress=[];
    if(this.AddNewAddress==false && this.addressRadioval2!='' && this.addressRadioval2!=undefined){
      console.info("radio checked",this.addressRadioval2)
      this.radioNotChecked = false;
      this.tempNewData.forEach(element => {
        if(element.addressEditRowIdForGPS==this.addressRadioval2 || element.addressEditRowId==this.addressRadioval2){
          temporaryAddress=element;
        }
      });
      this.qualiferSiteStreetModelUp = temporaryAddress['streetName'];
      if(temporaryAddress['additionalInformation1']){
        this.qualiferSiteAdditionalAddress = temporaryAddress['additionalInformation1'];
      }else{
        this.qualiferSiteAdditionalAddress = '';
      }
      if(temporaryAddress['additionalInformation2']){
        this.qualiferSiteAdditionalAddressInfo = temporaryAddress['additionalInformation2'];
      }else{
        this.qualiferSiteAdditionalAddressInfo = '';
      }
      this.postalCodeModel = temporaryAddress['postalCode'];
      this.gpsValueModelLat = temporaryAddress['gpsDataLat'];
      this.gpsValueModelLon = temporaryAddress['gpsDataLon'];
      this.territorialDivModelQualifierEdit = temporaryAddress['territorialDivision'];
      this.wayNumberModelQualifierEdit = temporaryAddress['wayNumber'];
      this.currentAddressId = temporaryAddress['addressEditRowId'];
      this.currentGpsAddressId = temporaryAddress['addressEditRowIdForGPS'];
      this.wayNumberModelQualifierEditRegExError = false;
      this.qualiferSiteStreetModelUpRegExError = false;
      this.qualiferSiteAdditionalAddressRegExError = false;
      this.qualiferSiteAdditionalAddressInfoRegExError = false;
      this.postalCodeModelRegExError = false;
      this.territorialDivModelQualifierEditRegExError = false;
    }else{
      this.currentAddressId='';
      this.currentGpsAddressId='';
    }
    const temp = this.qualiferSiteAdditionalAddress;
    if(temp.length <= SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH){   
      for (let i =temp.length; i < SiteDetailsComponent.ADDRESS_INFO_CHUNK_LENGTH; i++){
        this.qualiferSiteAdditionalAddress =  `${this.qualiferSiteAdditionalAddress} `;
      }
    }
    let str1 =  this.qualiferSiteAdditionalAddress;
    let str2 = this.qualiferSiteAdditionalAddressInfo;
    this.qualiferSiteAdditionalAddressInfoModelUp= `${str1}${str2}`;
    if(this.qualiferSiteStreetModelUp != '' &&
    this.qualiferSiteStreetModelUp != undefined &&
    this.wayNumberModelQualifierEditRegExError==false &&
    this.qualiferSiteStreetModelUpRegExError === false &&
    this.qualiferSiteAdditionalAddressRegExError === false &&
    this.qualiferSiteAdditionalAddressInfoRegExError === false &&
    this.postalCodeModelRegExError === false &&
    this.territorialDivModelQualifierEditRegExError === false){
      this.qualiferSiteStreetModelErrorUp = false;
      this.radioNotChecked = false;
      this.disableSelAnotherAddress = true;
      const geoADatas =
      {
        additionalInformation:this.qualiferSiteAdditionalAddressInfoModelUp,
        streetName:this.qualiferSiteStreetModelUp,
        cityName:this.siteCity,
        cityId : this.allSiteData['cityId'],
        countryName:this.siteCountry,
        postalCode:this.postalCodeModel,
        wayNumber:this.wayNumberModelQualifierEdit,
        territorialDivision:this.territorialDivModelQualifierEdit
      };
      this.sitesService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=${this.accessPointRowIdForSelAnAdd}`).subscribe(data =>{
        if(data['access-points-addresses'].length>0){
          data['access-points-addresses'].forEach(element => {
            this.sitesService.deleteAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses/${element['rowId']}`).subscribe(() => {
            });
          });
        }
      });
      setTimeout(() => {
        if(this.currentAddressId != ''){
          const accessPointDatas = {accessPointId:this.accessPointRowIdForSelAnAdd, addressId: this.currentAddressId};
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
          });
        }else{
          this.AddressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA:any) => {
            var geo_adress_row_id = dataGeoA['rowId'];
            this.acpAddressCreation = this.successSteps;
            const accessPointDatas = {accessPointId:this.accessPointRowIdForSelAnAdd, addressId: geo_adress_row_id};
            this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {

            });
          });
        }
        if(this.gpsValueModelLat != '' && this.gpsValueModelLat != undefined && this.gpsValueModelLon != '' && this.gpsValueModelLon != undefined){
          if(this.currentGpsAddressId != ''){
            const accessPointDatas = {accessPointId:this.accessPointRowIdForSelAnAdd, addressId:this.currentGpsAddressId};
            this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
              this.saveDatas = "Save";
              this.getRowIdForQua('reload');
              window.document.getElementById("closeSelectAnotherAddress").click();
            });
          }else{
            const gpsDatas = { 'accessPointId' : this.accessPointRowIdForSelAnAdd, 'latitude' : this.gpsValueModelLat,'longitude' : this.gpsValueModelLon.toString()}
            this.AddressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA:any) => {
              var geo_adress_row_id2 = dataGeoA['rowId'];
              const accessPointDatas = {accessPointId:this.accessPointRowIdForSelAnAdd, addressId:geo_adress_row_id2};
              this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe(() => {
                this.saveDatas = "Save";
                this.getRowIdForQua('reload');
                window.document.getElementById("closeSelectAnotherAddress").click();
              });
            });
          }
        }else{
          this.saveDatas = "Save";
          this.getRowIdForQua('reload');
          window.document.getElementById("closeSelectAnotherAddress").click();
        }
      }, 2500);
    }else{
      if(this.AddNewAddress==false && (this.addressRadioval2=='' || this.addressRadioval2==undefined)){
        this.radioNotChecked = true;
      }else {
        this.radioNotChecked = false;
      }
      if(this.qualiferSiteStreetModelUp === '' && this.AddNewAddress==true) {
        this.qualiferSiteStreetModelErrorUp = true;
      }else {
        this.qualiferSiteStreetModelErrorUp = false;
      }
    }
  }
  dmsversddanotheraddress(){
    var lat, lng, nordsud, estouest, latitude_degres, latitude_minutes, latitude_secondes, longitude_degres, longitude_minutes, longitude_secondes;
    if (this.northSouthModel=='South')
        nordsud = -1;
    else
        nordsud = 1;
    if (this.eastWestModel=='West')
        estouest = -1;
    else
        estouest = 1;
    latitude_degres = parseFloat(this.latDegVal) || 0;
    latitude_minutes = parseFloat(this.latMinVal) || 0;
    latitude_secondes = parseFloat(this.latSecVal) || 0;
    longitude_degres = parseFloat(this.longDegVal) || 0;
    longitude_minutes = parseFloat(this.longMinVal) || 0;
    longitude_secondes = parseFloat(this.longSecVal) || 0;
    lat = nordsud * (latitude_degres + latitude_minutes / SiteDetailsComponent.MINUTES_PER_DEGREE + latitude_secondes / SiteDetailsComponent.SECONDS_PER_DEGREE);
    lng = estouest * (longitude_degres + longitude_minutes / SiteDetailsComponent.MINUTES_PER_DEGREE + longitude_secondes / SiteDetailsComponent.SECONDS_PER_DEGREE);
    const tem1 = Math.round(lat * SiteDetailsComponent.COORD_PRECISION_SCALE) / SiteDetailsComponent.COORD_PRECISION_SCALE;
    this.gpsValueModelLat = tem1.toString();
    this.gpsValueModelLon = lng;
  }

  ddversdmsanotheraddress() {
    var lat, lng, latdeg, latmin, latsec, lngdeg, lngmin, lngsec;
    lat = parseFloat(this.gpsValueModelLat) || 0;
    lng = parseFloat(this.gpsValueModelLon) || 0;
    console.info("lat",lat)
    console.info("lat",lng)
    if (lat >= 0)
        this.northSouthModel='North';
    if (lat < 0)
        this.northSouthModel='South';
    if (lng >= 0)
        this.eastWestModel='East';
    if (lng < 0)
        this.eastWestModel='West';
    lat = Math.abs(lat);
    lng = Math.abs(lng);
    latdeg = Math.floor(lat);
    latmin = Math.floor((lat - latdeg) * SiteDetailsComponent.MINUTES_PER_DEGREE);
    latsec = Math.round((((lat - latdeg - latmin / SiteDetailsComponent.MINUTES_PER_DEGREE) * SiteDetailsComponent.ROUND_TRIM_SCALE * SiteDetailsComponent.SECONDS_PER_DEGREE) / SiteDetailsComponent.ROUND_TRIM_SCALE) * SiteDetailsComponent.DECIMAL_TENTH) / SiteDetailsComponent.DECIMAL_TENTH;
    lngdeg = Math.floor(lng);
    lngmin = Math.floor((lng - lngdeg) * SiteDetailsComponent.MINUTES_PER_DEGREE);
    lngsec = Math.floor((((lng - lngdeg - lngmin / SiteDetailsComponent.MINUTES_PER_DEGREE) * SiteDetailsComponent.ROUND_TRIM_SCALE * SiteDetailsComponent.SECONDS_PER_DEGREE) / SiteDetailsComponent.ROUND_TRIM_SCALE) * SiteDetailsComponent.DECIMAL_TENTH) / SiteDetailsComponent.DECIMAL_TENTH;
    this.latDegVal = latdeg;
    this.latMinVal = latmin;
    this.latSecVal = latsec;
    this.longDegVal = lngdeg;
    this.longMinVal = lngmin;
    this.longSecVal = lngsec;
  }
  LoadTaxType() {
    this.TaxTypeIdnetifierModel = "";
    this.saveDatas = 'Save';
    this.NewIdnetifierValue = "";
    this.IdnetifierTypeError = false;
    this.IdnetifierValueError = false;
    this.saveIdenClicked = false;
    console.info("this.TaxTypeIdnetifierModel",this.TaxTypeIdnetifierModel)
  }

  resetTaxidentif() {
    this.NewIdnetifierValue = ""
    this.IdnetifierValueError = true;
    this.disableSaveBtnAlias = true;
  }

  changeTaxType(event: any) {
    this.TaxTypeIdnetifierModel = event;
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined) {
      this.IdnetifierTypeError = false;
    }
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined && this.NewIdnetifierValue.trim() != '' && this.NewIdnetifierValue != undefined) {
      this.disableSaveBtnAlias = false;
    }
    if (this.taxIdentifierRowName['european vat number'] === this.TaxTypeIdnetifierModel) {
      if(document.getElementById('addTaxIdenInput')){
        document.getElementById('addTaxIdenInput').setAttribute('maxLength', '20');
      }
    } else {
      if(document.getElementById('addTaxIdenInput')){
        document.getElementById('addTaxIdenInput').removeAttribute('maxLength');
      }
    }
  }

  emptyCheck() {
    if ((this.NewIdnetifierValue).trim() === '') {
      this.IdnetifierValueError = true;
      this.disableSaveBtnAlias = true;
    } else {
      this.IdnetifierValueError = false;
    }
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined && this.NewIdnetifierValue.trim() != '' && this.NewIdnetifierValue != undefined) {
      this.disableSaveBtnAlias = false;
    }
  }

  AddTaxIdentifiersType(page=1) {
    const setDate = {"endDate" : '',"startDate": this.apiService.getTodayDate() ,"value":this.NewIdnetifierValue }

    const const2 = {
      "businessEntityIdentifierTypeId"    : this.taxIdentifierRowName[this.TaxTypeIdnetifierModel],
      "businessEntityIdentifierTypeName"  : this.TaxTypeIdnetifierModel,
      "startDate"                         : this.apiService.getTodayDate(),
      "businessEntityId"                  : this.businessEntityIdSite,
      "value"                             : this.NewIdnetifierValue
    }
   let isSimilarValue= this.companyAliasAll1[this.TaxTypeIdnetifierModel]? this.companyAliasAll1[this.TaxTypeIdnetifierModel][0].val.replace(/[\. ,:-]+/g, "") ==this.NewIdnetifierValue.replace(/[\. ,:-]+/g, "") :false;
   let IdentifiersArray=[]
  this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${this.businessEntityIdSite})&_page=${page}`).subscribe(data => {
    if(data['business-entity-identifiers'].length > 0){
      data['business-entity-identifiers'].forEach(e => {
        if(e.businessEntityIdentifierTypeName != 'BVD ID'){
          IdentifiersArray.push(e);
        }
      });
    }
    if(data['maxPage'] > 1 && data['maxPage'] != page){
      this.AddTaxIdentifiersType(page+1)
    }else if(data['maxPage'] === page){

      const isExists=  IdentifiersArray.filter(x=>x.businessEntityIdentifierTypeId== const2.businessEntityIdentifierTypeId && x.value.replace(/[\. ,:-]+/g, "")==const2.value.replace(/[\. ,:-]+/g, "") )

   if(isExists.length==0 ){

    this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(() => {
        this.companyAliasAll=[];
        this.dispBvdId(this.businessEntityIdSite)
        window.document.getElementById("closeAddTax").click();

      });
    }
  else{
    this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${isExists[0].row_id}?startDate=${this.apiService.getTodayDate()}&value=${this.NewIdnetifierValue}&endDate=""`,setDate).subscribe(() => {
      this.companyAliasAll=[];
      this.dispBvdId(this.businessEntityIdSite)
      window.document.getElementById("closeAddTax").click();
    })

  }
}
})
}

  getCertificates(){
    this.certiFicate=[];

    this.sitesService.getSiteCertifications(`${this.Config.ApiSitesUrl}sites-certifications?siteIdentifier=${this.siteIdentifier}` ).subscribe(data =>{
    console.info("sites-certifications",data['sites-certifications'])
    data['sites-certifications'].forEach(element => {
      this.certiFicate.push(element);
    });
  })
  console.info("this.certiFicate",this.certiFicate)
  }

  getGroupAliasByRowid(page=1,subscribeData=[]) {
    this.groupAlias = [];
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${this.GroupAssign['groupId']}&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data:any) => {
      if(data['group-identifiers'] && data['group-identifiers'] != null){
        data['group-identifiers'].forEach(ele => {
            if(ele.groupIdentifierKeyName != 'BVD'){
              subscribeData.push(ele);
            }
        });
        this.groupAlias=subscribeData;
          console.info("this.groupAlias[i]===>", this.groupAlias);
      }
    });
  }
  bolding(data: unknown): string {
    if (typeof data !== 'string' || data === '') {
      return '';
    }

    const parts = data.split(/(\d+)/).filter(Boolean);
    const prefix = parts[0] !== 'Updating...' ? `<strong>${parts[0]}</strong>` : parts[0];
    const identifier = parts[1] ?? '';
    return `${prefix}${identifier}`;
  }
  updatemailModelName(comment,_folio,reqId,days){
    this.workflowReqIdFromK2Isa= reqId;
    this.differenceinDays=days
    console.info("req",reqId)
    console.info("req",comment)
  }
  resetCompanyNameFields(){
    this.MailNameModel='';
  }

  AddEditSiteContact(type, rowIdd = null){
    this.Editcontact_rowId = "";
    this.saveDatas = 'Save';
    this.personRowId = "";
    this.updPersonId = "";
    this.isReadOnly = false;
    this["SiteConIpn"] = "";
    this["SiteConCellphone"] = "";
    this["SiteConPhone"] = "";
    this.SiteConRoleSelected = "";
    this.Editrow_id_siteContactcs = "";
    this.disableEmail = false;

    if (type === "load") {
      this.site_ShowNext = true;
      this.site_ShowSave = false;
      this.siteConEmailexistsError = false;
      this.site_modelEmail = true;
      this.site_modelLabelName = false;
      this.site_modelIpn = false;
      this.site_modelFname = false;
      this.site_modelLname = false;
      this.site_modelCellphone = false;
      this.site_modelPhone = false;
      this.site_modelRole = false;
      this.SiteConField.forEach(element2 => {
        this[element2] = "";
        this[`${element2}Error`] = false;
        if (element2 === "SiteConCellphone" || element2 === "SiteConPhone") {
          this[`${element2}Error2`] = false;
        }
      });
      this.getPersonRoleType();
    }
    if (type === "add") {
      this.SiteConField.forEach(element2 => {
        this[element2] = "";
        this[`${element2}Error`] = false;
        if (element2 === "SiteConCellphone" || element2 === "SiteConPhone") {
          this[`${element2}Error2`] = false;
        }
      });
      this.getPersonRoleType();
    }
    else if (type === "edit") {
      console.info("Person Details", this.PersonDetails)
      this.disableContactRoleEdit = false;
      this.Editcontact_rowId = rowIdd;
      this.fixedPhoneEdit = false;
      this.cellPhoneEdit = false;
      this.changedRoleId = rowIdd;
      console.info("site",this.SiteContacts)
      this.SiteContacts.forEach(element => {
        if (element.rowId === rowIdd) {
          console.info('contact', element);
          if (['KAM', 'SAL', 'ADF'].indexOf(element.personTypeCode) === -1) {
            this.disableContactRoleEdit = false;
          } else {
            this.disableContactRoleEdit = true;
          }
          this.personRowId = element.personRowId;
          this.upd_usersRow_id = "";
          this.Editrow_id_siteContactcs = element.rowId;
          this["SiteConFname"] = element.personFirstName;
          this["SiteConLname"] = element.personLastName;
          this["SiteConRole"] = element.roleTypeId;
          this.SiteConRoleSelected = element.personTypeCode;
          this["SiteConIpn"] = "";
          this["SiteConEmail"] = this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '';
          this["SiteConPhone"] = this.PersonDetails[`${element.personRowId}_f`] ? this.PersonDetails[`${element.personRowId}_f`].trim() : '';
          this["SiteConCellphone"] = this.PersonDetails[`${element.personRowId}_p`] ? this.PersonDetails[`${element.personRowId}_p`].trim() : '';
          this.personUsersSitecontact(this.personRowId, "No");

        }
      });
    }
  }

  personUsersSitecontact(RowID, next = "Yes") {
    if (this.personRowId != '') {
      this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${this.personRowId}`).subscribe((data: any) => {
        if (data['personAddresses'].length > 0) {
          this.contactsService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${data['personAddresses'][0].personRowId}`).subscribe((usrdata: any) => {
            if (usrdata.users.length > 0 && usrdata['users'][0]['loginType'].toLowerCase() === "renault_ipn") {
              console.info('IPn', usrdata)
               if( usrdata['users'][0]['loginId'] && usrdata['users'][0].endDate ==''){
                this.endDateisPresent =true; 
              }else{
                this.endDateisPresent =false;
              }
              this.siteModelIpn = usrdata["users"][0].loginId
              this["SiteConIpnError"] = false;
              this["SiteConIpn"] = usrdata["users"][0].loginId
              this.personRowId = usrdata["users"][0]['personRowId'];
              this.upd_usersRow_id = usrdata['users'][0]['rowId']; 
              this.getPersonRoleType();
            }
            if (next === "Yes") {
              this.personAddresses(RowID);
            } else {
              if (usrdata['users'].length > 0 && usrdata['users'][0]['loginType'].toLowerCase() === "renault_ipn") {
                this.personRowId = usrdata['users'][0]['personRowId'];
              } else {
                this["SiteConIpn"] = "";
                this.getPersonRoleType();
              }
            }
          }, _err => {
            this["SiteConIpn"] = "";
          });
        }
      });
    }
  }
  personAddresses(RowID) {
    this.contactsService.getPersons(`${this.Config.ApinewContactsUrl}persons/${RowID}/personAddresses`).subscribe((data: any) => {
      if (data['personAddresses'].length > 0) {
        data['personAddresses'].forEach(element => {
          if (element.addressType.toLowerCase() === "email") {
            this["SiteConEmailError"] = false;
            this["SiteConEmail"] = element.summary;
            this.SiteConEmailExists = element.summary;
            if (element.summary != '') this.isReadOnly = true;
            else this.isReadOnly = false;
          }
          if (element.addressType.toLowerCase() === "telephone") {
            var cpSplit = element.summary.split('*');
            if (cpSplit.length > 1) {
              if (cpSplit[1].toLowerCase().trim() === "f") {
                this["SiteConPhoneError"] = false;
                this["SiteConPhone"] = cpSplit[0].trim();
              }
              if (cpSplit[1].toLowerCase().trim() === "p") {
                this["SiteConCellphoneError"] = false;
                this["SiteConCellphone"] = cpSplit[0].trim();
              }
            }
          }
        });
      }
    });
  }

  switchVisible(btnId) {
    this.openData = true;
    this.openRole = false;
    if (btnId === 'btn1') {
      this.openData = true;
      this.openRole = false;
    } else {
      this.openRole = true;
      this.openData = false;
    }
  }
toggleSiteContacts() {
  this.showSiteContactsBlock = !this.showSiteContactsBlock;
}
toggleTaxIdentifiers(){
  this.showTaxIdentifiers = !this.showTaxIdentifiers;
  if (!this.showTaxIdentifiers) {
    this.taxIdentifiersDebugLogged = false;
  }
}
getTaxIdentifierCount(): number {
  if (!this.companyAliasAll) return 0;
  
  let count = 0;
  for (const key in this.companyAliasAll) {
    if (this.TaxIdentifierKeys && this.TaxIdentifierKeys.includes(key)) {
      count += this.companyAliasAll[key]?.length || 0;
    }
  }
  return count;
}

getAllTaxIdentifierKeys(): string[] {
  if (!this.companyAliasAll) return [];
  
  const allKeys = Object.keys(this.companyAliasAll);
  const filteredKeys = allKeys.filter(key => 
    this.TaxIdentifierKeys && this.TaxIdentifierKeys.includes(key)
  );

  if (this.showTaxIdentifiers && !this.taxIdentifiersDebugLogged) {
    console.info('All companyAliasAll keys:', allKeys);
    console.info('companyAliasAll data:', this.companyAliasAll);
    this.taxIdentifiersDebugLogged = true;
  }
  
  return filteredKeys;
}
  getPersonRoleType(kamFilter = "",page=1) {
    this.PersonRoleSelectOp = [];
    this.contactsService.getPersonRoleTypes(`${this.Config.ApinewContactsUrl}personRoleTypes?categoryCode=Site%20Contact&_page=${page}`).subscribe((data: any) => {
      if (data['personRoleTypes'].length > 0) {
        data['personRoleTypes'].forEach(element => {
          if (element.categoryCode.toLowerCase() === "site contact") {
            if (this.showForSupplier === false) {
              if (element.roleTypeCode.toLowerCase() != "kam" && element.roleTypeCode.toLowerCase() != "sal" && element.roleTypeCode.toLowerCase() != "adf") {
                this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
              }
            } else {
              if (kamFilter === "KamSales") {
                if (element.roleTypeCode.toLowerCase() === "kam" || element.roleTypeCode.toLowerCase() === "sales contact") {
                  if ((element.roleTypeCode.toLowerCase() === this.SiteConRole)) {
                    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                  }
                  else {
                    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                  }
                }
              }
              else if (kamFilter === "notkamsales") {
                if (element.roleTypeCode.toLowerCase() != "kam" && element.roleTypeCode.toLowerCase() != "sal" && element.roleTypeCode.toLowerCase() != "adf") {
                  this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                }
              }
              else if ((this["SiteConIpn"] != "")) {
                if(this.SiteConRoleSelected){
                if (this.SiteConRoleSelected.toLowerCase() === "kam") {
                  if (element.roleTypeLabel.toLowerCase() != "sal" && element.roleTypeCode.toLowerCase() != "adf") {
                    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                  }
                }
                else if (this.SiteConRoleSelected.toLowerCase() === "adf") {
                  if (element.roleTypeCode.toLowerCase() != "kam" && element.roleTypeCode.toLowerCase() != "sal") {
                    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                  }
                }
                else if (this.SiteConRoleSelected.toLowerCase() === "sal") {
                  if (element.roleTypeCode.toLowerCase() != "kam" && element.roleTypeCode.toLowerCase() != "adf") {
                    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                  }
                }
              }
                else {
                  if (element.roleTypeCode.toLowerCase() != "kam" && element.roleTypeCode.toLowerCase() != "sal" && element.roleTypeCode.toLowerCase() != "adf") {
                    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
                  }
                }
              }
              else {
                this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
              }
            }
          }
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getPersonRoleType(kamFilter,page+1);
        };
      }
    });
    console.info(this.SiteConRole,"this.PersonRoleSelectOp",this.PersonRoleSelectOp)
  }
  checkEmailChanged(){
    if (this.SiteConEmailExists != '' && this["SiteConEmail"] === this.SiteConEmailExists) {
      this.isReadOnly = true;
      this.SiteConEmailFormatError = false
    } else {
      if (this.SiteConEmailExists != '') {
        this["SiteConIpn"] = "";
        this["SiteConPhone"] = "";
        this["SiteConCellphone"] = "";
      }
      this.isReadOnly = false;
    }
  }
  focusOutFunctionEmail(){
    this.siteConEmailexistsError = false;
    this.SiteContacts.forEach(element => {
      if ((this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '') === this.SiteConEmail) {
      }
    });
  }

  resetSiteContact(fieEld) {
    if (fieEld != 'Email') {
      this[`SiteCon${fieEld}`] = "";
      if (fieEld != "Ipn" && fieEld != "Cellphone" && fieEld != "Phone") {
        this[`SiteCon${fieEld}`] = "";
        this[`SiteCon${fieEld}Error2`] = false;
        this[`SiteCon${fieEld}Error`] = true;
        if (fieEld === "Fname" || fieEld === "Lname") {
          this["SiteConIpn"] = "";
          this["SiteConPhone"] = "";
          this["SiteConCellphone"] = "";
        }
      }
      if (fieEld === "Cellphone" || fieEld === "Phone") {
        this[`SiteCon${fieEld}`] = "";
        this[`SiteCon${fieEld}Error2`] = false;
        this[`SiteCon${fieEld}Error`] = true;
      } else {
        this[`SiteCon${fieEld}Error`] = false;
      }
    }
    else {
      if (!this.disableEmail) {
        this[`SiteCon${fieEld}`] = "";
      }
    }
  }

  AddEditSaveSiteCnt(SaveType) {
    var validationSiteCnt = true;
    this.SiteConField.forEach(element2 => {
      if (SaveType === 'next') {
        if (this['SiteConEmail'] === undefined || this['SiteConEmail'].trim() === "") {
          this[`SiteConEmailError`] = true;
          validationSiteCnt = false;
          return false;
        } else {
          this[`${element2}Error`] = false;
        }
      }
      if (SaveType === 'add') {
        if (element2 != 'SiteConEmail') {
          if (this[element2] === undefined || this[element2].trim() === "") {
            this[`${element2}Error`] = true;
            validationSiteCnt = false;
            return false;
          } else {
            this[`${element2}Error`] = false;
          }
        }
      }
    });
    if (validationSiteCnt === true) {
      if (SaveType === "add" && this.siteConRoleexists === false) {
        if (this.personRowId != "") {
          if (this.SiteConEmailExists != '' && this.SiteConEmailExists != this['SiteConEmail'] && this.personRowId === '') {
            const datas10 = {
              personFirstName: this["SiteConFname"],
              personLastName: this["SiteConLname"]
            };
            this.contactsService.createPersons(`${this.Config.ApinewContactsUrl}persons`, datas10).subscribe((data: any) => {
              this.personRowId = data.rowId; 
              if (data.rowId != "") {
                this.newPersonId(data.rowId);
              }
            });
          } else {

            const datas = {
              roleTypeId: this["SiteConRole"],
              personRowId: this.personRowId,
              site: `CtcSiteService:${this.siteId}`,
              personSupplierCompany: `CtcSupplierCompanyService:${this.companyId}`,
              personRoleStatus: "VALIDATED",
              startDate: this.apiService.getTodayDate()
            };

            this.contactsService.createSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles`, datas).subscribe(() => {
              this.siteRoles();
              window.document.getElementById("closeSiteContacts").click();
            });
          }
        } else {
          const datas10 = {
            personFirstName: this["SiteConFname"],
            personLastName: this["SiteConLname"]
          };
          this.contactsService.createPersons(`${this.Config.ApinewContactsUrl}persons`, datas10).subscribe((data: any) => {
            this.personRowId = data.rowId; 
            if (data.rowId != "") {
              this.newPersonId(data.rowId);
            }
          });
        }
       }
      else if (SaveType === "edit") {
        let proceedToCreate = true;
        console.info('CompanyContacts', this.CompanyContacts);
        console.info('personRowId', this.personRowId);
        this.SiteContacts.forEach(ele => {
          if (ele.typeRowId === this["SiteConRole"] && ele.personRowId === this.personRowId) {
            proceedToCreate = false;
            console.info('role exists');
            document.getElementById('btnForOpenRoleExistsWarning').click();
          }
          window.document.getElementById("closeContactAndRole").click();
        });
        if (proceedToCreate === true) {
          if (this.personRowId != "") {
            if (this.siteRolechanged === true && this.changedRoleId != '') {
              let typeCode = '';
              this.PersonRoleSelectOp.forEach(ele => {
                if (ele.row_id === this["SiteConRole"]) {
                  typeCode = ele.roleTypeCode;
                }
              });
              const datas2 = {
                roleTypeId: this["SiteConRole"],
                roleTypeCode: typeCode
              }
              this.contactsService.updateSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles/${this.changedRoleId}`, datas2).subscribe(() => {
                this.siteRoles();
                window.document.getElementById("closeContactAndRole").click();
              });
            } else {
              const datas = {
                roleTypeId: this["SiteConRole"],
                personRowId: this.personRowId,
                site: `CtcSiteService:${this.siteId}`,
                personSupplierCompany: `CtcSupplierCompanyService:${this.companyId}`,
                personRoleStatus: "VALIDATED",
              };

              this.contactsService.createSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles`, datas).subscribe(() => {
                this.siteRoles();

              },
                err => {
                  console.info(err)
                });
            }
            const datas20 = {
              loginId: this["SiteConIpn"]
            };
            this.contactsService.updateUsers(`${this.Config.ApinewContactsUrl}users/${this.upd_usersRow_id}`, datas20).subscribe(() => {
              this.updateEmail();
            });
          } else {
            this.newPersonId(this.personRowId, "updNewIPN");
          }
        }
      }
      if (SaveType === "next") {
        this.addsitecontact_emailnext();
      }
    }
  }
  setEditConDetails(type) {
    this.editSiteConFname = this["SiteConFname"];
    this.editSiteConLname = this["SiteConLname"];
    this.editSiteConCellphone = this["SiteConCellphone"];
    this.editSiteConPhone = this["SiteConPhone"];
    this['SiteConFnameError'] = false;
    this['SiteConLnameError'] = false;
    this['SiteConCellphoneError'] = false;
    this['SiteConCellphoneError2'] = false;
    this['SiteConPhoneError'] = false;
    this['SiteConPhoneError2'] = false;
    if (type === 'cellPhone') {
      this.cellPhoneEdit = true;
    } else {
      this.cellPhoneEdit = false;
    } if (type === 'fixedPhone') {
      this.fixedPhoneEdit = true;
    } else {
      this.fixedPhoneEdit = false;
    }
  }

  editSiteConDetails(type) {
    if (type === 'name') {
      const datas = {
        personFirstName: this.editSiteConFname,
        personLastName: this.editSiteConLname
      };
      this.contactsService.updatePersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}`, datas).subscribe((data: any) => {
        document.getElementById('closeEditSiteConNameDetails').click();
        this.siteRoles();
        this["SiteConFname"] = data.personFirstName;
        this["SiteConLname"] = data.personLastName;
      });
    } else if (type === 'phone' && this.SiteConPhoneError2 === false && this.SiteConPhoneError === false && this.SiteConCellphoneError === false && this.SiteConCellphoneError2 === false) {
      this.updateFphone();
      this.fixedPhoneEdit = false;
      this.cellPhoneEdit = false;
    }

  }

  resetSiteEditContact(field) {
    if (field === 'Fname' || field === 'Lname') {
      this[`editSiteCon${field}`] = '';
      this[`SiteCon${field}Error`] = true;
    } else {
      this[`SiteCon${field}Error`] = false;
    }
  }

  SiteEditCntemptyCheck(fieEld) {
    if (fieEld === 'Fname' || fieEld === 'Lname') {
      if ((this[`editSiteCon${fieEld}`]).trim() === '') {
        this[`SiteCon${fieEld}Error`] = true;
      } else {
        this[`SiteCon${fieEld}Error`] = false;
      }
    }
  }

  toggleSiteConEdit() {
    this["SiteConCellphone"] = this.editSiteConCellphone;
    this["SiteConPhone"] = this.editSiteConPhone;
    this.fixedPhoneEdit = false;
    this.cellPhoneEdit = false;
  }
  /** Edit Contact Details ends here */

  addsitecontact_emailnext() {
    var ipnExists = false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let valid = emailRegex.test(this.SiteConEmail)
    if(valid){
      this.SiteConEmailFormatError=false
    if (this.siteConEmailexistsError === false) {
      this.disableEmail = true;
      this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${this.SiteConEmail}`).subscribe((data: any) => {
        if (data['personAddresses'].length > 0) {
          this.siteModelName = `${data['personAddresses'][0]["personFirstName"]} ${data['personAddresses'][0]["personLastName"]}`;
          this.SiteConFname = data['personAddresses'][0]["personFirstName"];
          this.SiteConLname = data['personAddresses'][0]["personLastName"];
          this.personRowId = data['personAddresses'][0]["personRowId"];
          this.contactsService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${data['personAddresses'][0].personRowId}`).subscribe((usrdata: any) => {
            if (usrdata.users.length > 0) {
              console.info('IPn', usrdata)
              this.siteModelIpn = usrdata["users"][0].loginId;

              ipnExists = true;
            }
            if (ipnExists) {
              this.site_modelLabelName = true;
              this.site_modelIpn = true;
              this.site_modelRole = true;
              this.site_modelFname = false;
              this.site_modelLname = false;
              this.site_modelCellphone = false;
              this.site_modelPhone = false;
              this.site_ShowNext = false;
              this.site_ShowSave = true;
              this.getPersonRoleType("notkamsales");
            }
            else {
              this.site_modelLabelName = true;
              this.site_modelIpn = false;
              this.site_modelRole = true;
              this.site_modelFname = false;
              this.site_modelLname = false;
              this.site_modelCellphone = false;
              this.site_modelPhone = false;
              this.site_ShowNext = false;
              this.site_ShowSave = true;
              this.getPersonRoleType();
            }
          }, _err => {
            this.site_modelLabelName = true;
            this.site_modelIpn = false;
            this.site_modelRole = true;
            this.site_modelFname = false;
            this.site_modelLname = false;
            this.site_modelCellphone = false;
            this.site_modelPhone = false;
            this.site_ShowNext = false;
            this.site_ShowSave = true;
            this.getPersonRoleType()
          })



        } else {
          this.site_modelLabelName = false;
          this.site_modelIpn = false;
          this.site_modelRole = true;
          this.site_modelFname = true;
          this.site_modelLname = true;
          this.site_modelCellphone = true;
          this.site_modelPhone = true;
          this.site_ShowNext = false;
          this.site_ShowSave = true;
          this.getPersonRoleType();
        }
      });
    }
  }else{
      this.SiteConEmailFormatError=true
    }
  }
  SiteCntemptyCheck(fieEld){
    if (fieEld != "Ipn" && fieEld != "Cellphone" && fieEld != "Phone") {
      if ((this[`SiteCon${fieEld}`]).trim() === '') {
        this[`SiteCon${fieEld}Error`] = true;

      } else {
        this[`SiteCon${fieEld}Error`] = false;
        if (fieEld === "Cellphone" || fieEld === "Phone") {
          if (!this[`SiteCon${fieEld}`].match(/^[ 0-9\+]*$/gm)) {
            this[`SiteCon${fieEld}Error`] = false;
            this[`SiteCon${fieEld}Error2`] = true;
          } else {
            this[`SiteCon${fieEld}Error2`] = false;
          }
        }
        if (fieEld === "Email") {

        }
      }
    }
    if (fieEld === "Cellphone" || fieEld === "Phone") {
      if ((this[`SiteCon${fieEld}`]).trim() === '') {
        this[`SiteCon${fieEld}Error`] = true;
      } else {
        this[`SiteCon${fieEld}Error`] = false;
        if (!this[`SiteCon${fieEld}`].match(/^[ 0-9\+]*$/gm)) {
          this[`SiteCon${fieEld}Error`] = false;
          this[`SiteCon${fieEld}Error2`] = true;
        } else {
          this[`SiteCon${fieEld}Error2`] = false;
        }
      }
    }
  }

  updateEmail() {
    var add_ID = this.PersonDetails[`${this.personRowId}_addIDEmail`];
    if (add_ID === undefined) {
      console.info("Email Undefined");
      this.updateFphone();
    } else {
      const datas21 = {
        email: this["SiteConEmail"]
      };
      this.contactsService.updateEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${add_ID}`, datas21).subscribe(() => {
        this.updateFphone();
      });
    }
  }

  updateFphone() {
    if (this["SiteConPhone"] != undefined && this["SiteConPhone"].trim() != "") {
      var add_IDf = this.PersonDetails[`${this.personRowId}_addIDf`];
      if (add_IDf === undefined) {
        this.newFixedphoneCreate("UpdateFphone");
      } else {
        const datas22 = {
          phoneNumber: this["SiteConPhone"]
        };
        this.contactsService.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${add_IDf}`, datas22).subscribe(() => {
          this.updateCphone();
        });
      }
    } else {
      this.updateCphone();
    }
  }

  updateCphone() {
    if (this["SiteConCellphone"] != undefined && this["SiteConCellphone"].trim() != "") {
      var add_IDc = this.PersonDetails[`${this.personRowId}_addIDp`];
      if (add_IDc === undefined) {
        this.newCellphoneCreate("UpdateCphone");
        window.document.getElementById("closeEditSiteConRole").click();
      } else {
        const datas23 = {
          phoneNumber: this["SiteConCellphone"]
        };
        this.contactsService.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${add_IDc}`, datas23).subscribe(() => {
          this.PersonAddresses();
          window.document.getElementById("closeEditSiteConRole").click();
        });
      }
    } else {
      this.PersonAddresses();
      window.document.getElementById("closeEditSiteConRole").click();
    }
  }
  newPersonId(_personRowID, Next = "Yes") {
    if (this["SiteConIpn"] != undefined && this["SiteConIpn"].trim() != "") {
      const datas11 = {
        loginId: this["SiteConIpn"],
        loginType: "RENAULT_IPN",
        personId: this.personRowId
      };
      this.contactsService.createUsers(`${this.Config.ApinewContactsUrl}users`, datas11).subscribe(() => {
        if (Next === "Yes") {
          this.newFixedphoneCreate();
        } else if (Next === "updNewIPN") {
          this.updateEmail();
        }
      });
    } else {
      this.newEmailCreate();
    }
  }

  newEmailCreate(Next = "Yes") {
    const datas12 = {
      email: this["SiteConEmail"]
    };
    this.contactsService.createEmailAddress(`${this.Config.ApinewContactsUrl}emailAddresses`, datas12).subscribe((data: any) => {
      if (Next === "Yes") {
        this.linkEmailtoAddresses(data.rowId); 
      }
    });
  }

  linkEmailtoAddresses(email_rowID) {
    const datas13 = {
      personRowId: this.personRowId,
      addressId: email_rowID
    };
    this.contactsService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas13).subscribe(() => {
      this.newFixedphoneCreate();
    });
  }
  newFixedphoneCreate(Next = "Yes") {
    if (this["SiteConPhone"] != undefined && this["SiteConPhone"].trim() != "") {
      const datas14 = {
        phoneType: "F",
        phoneNumber: this["SiteConPhone"]
      };
      this.contactsService.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, datas14).subscribe((data: any) => {
        if (Next === "Yes") {
          this.linkFixedphonetoAddresses(data.rowId);
        } else if (Next === "UpdateFphone") {
          this.linkFixedphonetoAddresses(data.rowId, "GotoUpdatephone");
        }
      });
    } else {
      this.newCellphoneCreate();
    }
  }

  linkFixedphonetoAddresses(Fphone_rowID, Next = "Yes") {
    const datas15 = {
      personRowId: this.personRowId,
      addressId: Fphone_rowID
    };
    this.contactsService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas15).subscribe((data: any) => {
      if (Next === "Yes") {
        this.newCellphoneCreate();
      } else if (Next === "GotoUpdatephone") {
        this.PersonDetails[`${this.personRowId}_addIDf`] = data.addressId;
        this.PersonDetails[`${this.personRowId}_f`] = this["SiteConPhone"];
        this.updateFphone();
      }
    });
  }

  newCellphoneCreate(Next = "Yes") {
    if (this["SiteConCellphone"] != undefined && this["SiteConCellphone"].trim() != "") {
      const datas16 = {
        phoneType: "P",
        phoneNumber: this["SiteConCellphone"]
      };
      this.contactsService.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, datas16).subscribe((data: any) => {
        if (Next === "Yes") {
          this.linkcellphonetoAddresses(data.rowId);
        } else if (Next === "UpdateCphone") {
          this.linkcellphonetoAddresses(data.rowId, "GotoUpdatephone");
        }
      });
    } else {
      this.personToAllLinkAddresses();
    }
  }

  linkcellphonetoAddresses(Cellphone_rowID, Next = "Yes") {
    const datas17 = {
      personRowId: this.personRowId,
      addressId: Cellphone_rowID
    };
    this.contactsService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas17).subscribe((data: any) => {
      if (Next === "Yes") {
        this.personToAllLinkAddresses();
      } else if (Next === "GotoUpdatephone") {
        this.PersonDetails[`${this.personRowId}_addIDp`] = data.addressId;
        this.PersonDetails[`${this.personRowId}_p`] = this["SiteConCellphone"];
        this.updateCphone();
      }

    });
  }

  personToAllLinkAddresses() {
    if (this.personRowId != "") {
      const datas18 = {
        roleTypeId: this["SiteConRole"],
        personRowId: this.personRowId,
        site: `CtcSiteService:${this.siteId}`,
        personSupplierCompany: `CtcSupplierCompanyService:${this.companyId}`,
        personRoleStatus: "VALIDATED",
        startDate: this.apiService.getTodayDate()
      };
      this.contactsService.createSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles`, datas18).subscribe(() => {
        this.siteRoles();
        window.document.getElementById("closeSiteContacts").click();
      });
    }
  }
  SiteCntRoleSelected(event:any){
    this.SiteConRole = event.value;
    this.siteConRoleexists = false;
    this.siteRolechanged = false;

    if (this.SiteConRole != undefined && this.SiteConRole != "") {
      this.SiteContacts.forEach(element => {
        if ((this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '') === this.SiteConEmail && element.typeRowId === this.SiteConRole) {
          this.siteRolechanged = true;

          this.siteConRoleexists = true;
          this["SiteConRoleError"] = false;
        }
        else {
          this.siteRolechanged = true;

          this["SiteConRoleError"] = false;
        }
      });
    }
    else {
      this["SiteConRoleError"] = true;

    }
  }

  getbvd(){
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${this.companyId}`).subscribe(data1 => {
      if(data1['group-assignments'].length > 0){
        this.groupAssignToCpy = data1['group-assignments'][0]['groupName'];
        this.grpAllianceIdForGR =data1['group-assignments'][0]['groupAllianceIdentifier']
      } else {
        this.bvdloading = false
      }
      this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=${this.grpAllianceIdForGR}&_page=1&_pagesize=10`).subscribe((data2: any) => {

        data2['groups'].forEach(element => {
          if(element.representingCompanyAllianceIdentifier!=''){
          this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${element.representingCompanyId}&isHQ=Y` ).subscribe(data0 => {

          console.info("data",data0['business-entities'][0]['row_id'])
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${data0['business-entities'][0]['row_id']})&_page=1` ).subscribe(
            (data: any) => {
              if(data['business-entity-identifiers'].length!=0){
                this.groupbvdIDcpy =data['business-entity-identifiers'][0]['value'];
                this.bvdloading = false
                this.getInPortfolioDetailsGrp()
              }else{
                this.bvdloading = false
                this.inPortfolioLoadingGrp = false
              }
              })
            })
          }
          this.bvdloading = false
          this.inPortfolioLoadingGrp = false
          })
        })
      })
  }
  getInPortfolioDetailsGrp(){
    if(this.groupbvdIDcpy != ''){
      this.inPortfolioLoadingGrp = true;
      const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.apiService.PortfolioRecordSet}`;
      this.apiService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
        this.inPortfolioLoadingGrp = false;
        this.countValueGrp = bvdData['Summary'] ? bvdData['Summary']['Count'] : 0;
        const switches = document.getElementById('sliderCheckBoxGrp');
        let bvdIndex = -1;
        if(bvdData['BvDIDs'].length>0){
          bvdIndex = bvdData['BvDIDs'].indexOf(this.groupbvdIDcpy);
        }
        if(bvdIndex != -1){
          if(switches){
            switches.setAttribute('checked','yes');
            this.bvdInPortfolioSetGrp = 'on';
          }
        }else{
          if(switches){
           switches.removeAttribute('checked');
           this.bvdInPortfolioSetGrp = 'off';
          }
        }
      },_error => {
        this.inPortfolioLoadingGrp = false;
      });
    }else{
      this.inPortfolioLoadingGrp = false;
    }
  }

  toggleInPortfolioSwitchGrp(event) {
    const data = { "bvd-id": this.groupbvdIDcpy }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, data).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      console.info("bVdDatas", bVdDatas);
      if (bVdDatas['Data'].length > 0) {
        const temp = bVdDatas['Data'][0];
        console.info("temp", bVdDatas['Data'].length)
        this.bvdidNumber = temp.BVD_ID_NUMBER;
        if (this.bvdidNumber === this.groupbvdIDcpy) {
          const toggleEL = event.srcElement.checked;
          let urlOperation = 'add'
          if (this.bvdInPortfolioSet === 'on') {
            urlOperation = 'remove';
          }
          this.inPortfolioLoading = true;
          const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.apiService.PortfolioRecordSet}`;
          const datas =
          {
            'WHERE':
              [
                {
                  "BvDID": [this.groupbvdIDcpy]
                }
              ]
          }
          this.apiService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(() => {
            this.getInPortfolioDetailsGrp();
          }, _error => {
            this.getInPortfolioDetailsGrp();
            this.inPortfolioLoading = false;
          });
        } else {
          document.getElementById('btnForWarningBvdportfolio').click();
        }
      } else {
        document.getElementById("btnForbvdnotpresentinOrbis").click();
      }
    });
  }
  getCmpBvd(subscribeDataIsHQ = []){
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyId}`).subscribe(data => {
      console.info('dd',data)
      if (data['business-entities'].length > 0) {
        data['business-entities'].forEach(e => {
          if (e.isHQ === 'Y') {
            subscribeDataIsHQ.push(e);
          }
       })
       this.bvd(subscribeDataIsHQ)
     }
   })
  }

  bvd(value){
    if(value? value.length>0 :false){
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${value[0]['row_id']}&_page=1`).subscribe(data1 => {
      if (data1['business-entity-identifiers'].length > 0) {
        data1['business-entity-identifiers'].forEach(ele => {
          if (ele.businessEntityIdentifierTypeName === 'BVD ID') {
            this.companybvdIDcpy = ele.value;
          }
          if (ele.businessEntityIdentifierTypeName === 'DUNS' && ele.endDate === '') {
            this.DUNSValue = ele.value;
          }
          if (ele.businessEntityIdentifierTypeName === 'BPN-L' && ele.endDate === '') {
            this.bpnCount+=1;
            this.BPNLValue = ele.value;
          }
          if (ele.businessEntityIdentifierTypeName === 'ORBIS-STATUS' && ele.endDate === '') {
            if (!this.latestCmpOrbisStatus || new Date(ele.startDate) > new Date(this.latestCmpOrbisStatus.startDate)) {
                    const statusValue = ele.value;
                    let pillColor = '#B7783C'; 
 
                    if (statusValue === 'Active') {
                      pillColor = '#5CBA63'; 
                    } else if (statusValue.startsWith('Active')) {
                      pillColor = '#FFBD69'; 
                    } else if (
                      statusValue.startsWith('Inactive') ||
                      statusValue.startsWith('Administratively suspended')
                    ) {
                      pillColor = '#FFBD69'; 
                    } else if (statusValue.startsWith('Status unknown')){
                     pillColor = '#FFBD69'; 
                    }else if (
                      statusValue.startsWith('In liquidation') ||
                      statusValue.startsWith('Dissolved') ||
                      statusValue.startsWith('Bankruptcy')
                    ) {
                      pillColor = '#CB4B32'; 
                    }
 
                    this.latestCmpOrbisStatus = {
                      value: statusValue,
                      startDate: ele.startDate,
                      color: pillColor
                    };
          }
        }
        })
        this.getInPortfolioDetailsCmp()
      }
     })
    }
  }
  getInPortfolioDetailsCmp() {
    if (this.companybvdIDcpy != '') {
      this.inPortfolioLoadingCmp = true;
      const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.apiService.PortfolioRecordSet}`;
      this.apiService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
        this.inPortfolioLoadingCmp = false;
        this.countValueCmp = bvdData['Summary'] ? bvdData['Summary']['Count'] : 0;
        const switches = document.getElementById('sliderCheckBoxCmp');
        let bvdIndex = -1;
        if (bvdData['BvDIDs'].length > 0) {
          bvdIndex = bvdData['BvDIDs'].indexOf(this.companybvdIDcpy);
        }
        if (bvdIndex != -1) {
        if(switches){
          switches.setAttribute('checked', 'yes');
          this.bvdInPortfolioSetCmp = 'on';
        }
        } else {
          if(switches){
          switches.removeAttribute('checked');
          this.bvdInPortfolioSetCmp = 'off';
          }
        }
      }, _error => {
        this.inPortfolioLoadingCmp = false;
      });
    } else {
      this.inPortfolioLoadingCmp = false;
    }
  }

  toggleInPortfolioSwitchCmp(event) {
    const data = { "bvd-id": this.companybvdIDcpy }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, data).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      console.info("bVdDatas", bVdDatas);
      if (bVdDatas['Data'].length > 0) {
        const temp = bVdDatas['Data'][0];
        console.info("temp", bVdDatas['Data'].length)
        this.bvdidNumber = temp.BVD_ID_NUMBER;
        if (this.bvdidNumber === this.companybvdIDcpy) {
          const toggleEL = event.srcElement.checked;
          let urlOperation = 'add'
          if (this.bvdInPortfolioSet === 'on') {
            urlOperation = 'remove';
          }
          this.inPortfolioLoading = true;
          const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.apiService.PortfolioRecordSet}`;
          const datas =
          {
            'WHERE':
              [
                {
                  "BvDID": [this.companybvdIDcpy]
                }
              ]
          }
          this.apiService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(() => {
            this.getInPortfolioDetailsCmp();
          }, _error => {
            this.getInPortfolioDetailsCmp();
            this.inPortfolioLoading = false;
          });
        } else {
          document.getElementById('btnForWarningBvdportfolio').click();
        }
      } else {
        document.getElementById("btnForbvdnotpresentinOrbis").click();
      }
    });
  }

  conInfoDEl(){
    this.contactsService.deletePersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}`).subscribe((_data: any) => {
        this.contactsService.deleteEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${this.PersonDetails[this.personRowId + '_addIDEmail']}`).subscribe(() => { });
        if (this.PersonDetails[`${this.personRowId}_addIDf`] != undefined && this.PersonDetails[`${this.personRowId}_addIDf`] != '') {
          this.contactsService.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.PersonDetails[this.personRowId + '_addIDf']}`).subscribe(() => { });
        }
        if (this.PersonDetails[`${this.personRowId}_addIDp`] != undefined && this.PersonDetails[`${this.personRowId}_addIDp`] != '') {
          this.contactsService.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.PersonDetails[this.personRowId + '_addIDp']}`).subscribe(() => { });
        }
        this.siteRoles();
        window.document.getElementById("DeleteContact").click();
        window.document.getElementById("closeEditSiteConNameDetails").click();
        window.document.getElementById("closeContactAndRole").click();
      });
  }

  delContact() {
    if (this.personRowId != "") {
      this.contactsService.deleteSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles/${this.Editcontact_rowId}`).subscribe(_data => {
      if (this.upd_usersRow_id != undefined && this.upd_usersRow_id != '') {
        this.contactsService.deleteusers(`${this.Config.ApinewContactsUrl}users/${this.upd_usersRow_id}`).subscribe(() => {
          this.conInfoDEl();
        });
      }else{
        this.conInfoDEl();
      }
      
      });
    }
  }

  delRole() {
    if (this.personRowId != "") {
      this.contactsService.deleteSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles/${this.Editcontact_rowId}`).subscribe(() => { });
      setTimeout(()=>{
        this.siteRoles()
      },SiteDetailsComponent.CLOSE_MODAL_DELAY_MS)
      window.document.getElementById("ccompanyContactRemoveModalPopup").click();
      window.document.getElementById("openWarningForRoleUpdate").click();
      window.document.getElementById("closeCCBtn").click();
      window.document.getElementById("closeContactAndRole").click();
  }
}
copyToClipboard(text: string) {
  this.apiService.copyToClipboard(text)
}

sort(key){
  this.key = key;
  this.reverse = !this.reverse;
}

editLatamAliasSet(values,rowIdRaft,accessRowId,name,endDate){
  if(endDate!='' && endDate!=undefined){
    this.showArchivedLatamId = false;
 }
 else{
   this.showArchivedLatamId = true;
 }

    console.info("name",name)
    console.info("values",values)
    this.latamRowIdVar = rowIdRaft;
    this.latamAccessRowIdVar = accessRowId;
    this.saveDatas = 'Save';
    this.latamNameHolder = name;
    this.disableEditLatamCodeBtn = false;
    this.disableEditLatamNameBtn = false;
    if(values != undefined && values != ''){
      if(values.length > 1){
        this.hasMultipleLatamAlias = true;
      }
      else{
        this.saveAsNewLatamCode = false;       
        this.hasMultipleLatamAlias = false;    
        this.editLatamAliasModel = values;
      }
    }
    else{
      this.editLatamAliasModel = '';
      this.hasMultipleLatamAlias = false;
      this.saveAsNewLatamCode = true;
    }
    if(name != undefined && name != ''){
      this.saveAsNewLatamName = false;
    }else{
      this.saveAsNewLatamName = true;
    }
    this.editLatamAliasError = false;
  }

  saveLatamAliasVal(){
    this.changeStatusforLatamAlias =true;
    if(this.editLatamAliasModel != undefined && this.editLatamAliasModel != ''){
      this.disableEditLatamCodeBtn = true;
      let const2 = {
        "identifierValue" : this.editLatamAliasModel
      }
      if(this.saveAsNewLatamCode === false){
        console.info("latam",this.latamRowIdVar);
        console.info("code",const2)
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.latamRowIdVar}`, const2 ).subscribe(() => {
          this.changeStatusToPending();
        },_error => {
          this.disableEditLatamCodeBtn = false;
        });
      }
      else{
        let const5 ={
            "identifierId":this.siteIdentTypesData['AP_LATAM_CODE'],
            "sourceSystemId":"2",
            "accessPointRowId" : this.latamAccessRowIdVar,
            "identifierValue" : this.editLatamAliasModel,
            "effectiveDate" : this.apiService.getTodayDate()
        }
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
          this.changeStatusToPending()
        })
      }
    }
  }

  checkLatamAliasVal(){
    if (this.editLatamAliasModel) {
      this.editLatamAliasModel = this.editLatamAliasModel.toUpperCase();
    }
    const latamCodePattern = /^[A-Z0-9]{2,10}$/;
  
    if (!this.editLatamAliasModel || !latamCodePattern.test(this.editLatamAliasModel)) {
      this.editLatamAliasError = true;
      this.disableEditLatamCodeBtn = true;
    } else {
      this.editLatamAliasError = false;
      this.disableEditLatamCodeBtn = this.editLatamAliasModel.length < 2; 
    }
  }

  resetLatamAliasVal(){
    this.editLatamAliasModel = '';
    this.editLatamAliasError = true;
  }

  editRnaiplAliasSet(values,rowIdRnaipl,accessRowId){
    this.rnaiplRowIdVar = rowIdRnaipl;
    this.rnaiplAccessRowIdVar = accessRowId;
    this.saveDatas = 'Save';
    this.disableEditRnaiplCodeBtn = false;
    if(values != undefined && values != ''){
      if(values.length > 1){
        this.hasMultipleRnaiplAlias = true;
      }
      else{
        this.saveAsNewRnaiplCode = false;
        this.hasMultipleRnaiplAlias = false;
        this.editRnaiplAliasModel = values[0] != undefined ? values[0] : values;
      }
    }
    else{
      this.editRnaiplAliasModel = '';
      this.hasMultipleRnaiplAlias = false;
      this.saveAsNewRnaiplCode = true;
    }
    this.editRnaiplAliasError = false;
  }

  checkRnaiplAliasVal(){
    if(this.editRnaiplAliasModel && this.editRnaiplAliasModel.toString().trim() != ''){
      this.editRnaiplAliasError = false;
    }
    else{
      this.editRnaiplAliasError = true;
    }
  }

  resetRnaiplAliasVal(){
    this.editRnaiplAliasModel = '';
    this.editRnaiplAliasError = true;
  }

  saveRnaiplAliasVal(){
    this.changeStatusforRnaiplAlias = true;
    if(this.editRnaiplAliasModel != undefined && this.editRnaiplAliasModel.toString().trim() != ''){
      this.disableEditRnaiplCodeBtn = true;
      let const2 = {
        "identifierValue" : this.editRnaiplAliasModel.toString().trim().toUpperCase()
      }
      if(this.saveAsNewRnaiplCode === false){
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.rnaiplRowIdVar}`, const2 ).subscribe(() => {
          this.changeStatusToPending();
        },_error => {
          this.disableEditRnaiplCodeBtn = false;
        });
      }
      else{
        let const5 ={
            "identifierId":this.siteIdentTypesData['AP_RNAIPL_CODE'],
            "sourceSystemId":"2",
            "accessPointRowId" : this.rnaiplAccessRowIdVar,
            "identifierValue" : this.editRnaiplAliasModel.toString().trim().toUpperCase(),
            "effectiveDate" : this.apiService.getTodayDate()
        }
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
          this.changeStatusToPending()
        })
      }
    } else {
      this.editRnaiplAliasError = true;
    }
  }

  editRnaiplNameSet(rowIdRnaiplName,accessRowId,name,aliasValue){
    this.rnaiplNameRowIdVar = rowIdRnaiplName;
    this.rnaiplAccessRowIdVar = accessRowId;
    this.saveDatas = 'Save';
    this.disableEditRnaiplNameBtn = false;
    this.rnaiplNameAliasHolder = (aliasValue != undefined && aliasValue != null && aliasValue !== '') ? (Array.isArray(aliasValue) ? aliasValue[0] : aliasValue) : '';
    this.rnaiplNameHolder = (name != undefined && name != null && name !== '') ? (Array.isArray(name) ? name[0] : name) : '';
    this.saveAsNewRnaiplName = !(this.rnaiplNameHolder != undefined && this.rnaiplNameHolder !== '');
    this.editRnaiplNameError = false;
  }

  checkRnaiplName(){
    if(this.rnaiplNameHolder != ''){
      this.editRnaiplNameError = false;
    }
    else{
      this.editRnaiplNameError = true;
    }
  }

  resetRnaiplName(){
    this.rnaiplNameHolder = '';
    this.editRnaiplNameError = true;
  }

  saveRnaiplAliasName(){
    if(this.rnaiplNameHolder != undefined && this.rnaiplNameHolder != ''){
      this.disableEditRnaiplNameBtn = true;
      const name = {
        "identifierValue" : this.rnaiplNameHolder
      };
      if(this.saveAsNewRnaiplName === false){
        this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.rnaiplNameRowIdVar}`,name ).subscribe(() => {
          document.getElementById('closeEditRnaiplName').click();
          this.dispQualifiers('reload');
        },_error => {
          this.disableEditRnaiplNameBtn = false;
        });
      }
      else{
        let const5 ={
            "identifierId":this.siteIdentTypesData['SOCIAL_RAISON'],
            "sourceSystemId":"2",
            "accessPointRowId" : this.rnaiplAccessRowIdVar,
            "identifierValue" : this.rnaiplNameHolder,
            "effectiveDate" : this.apiService.getTodayDate()
        }
        this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
          document.getElementById('closeEditRnaiplName').click();
          this.dispQualifiers('reload');
        },_error => {
          this.disableEditRnaiplNameBtn = false;
        });
      }
    }else{
      this.editRnaiplNameError = true;
    }
  }

  updateRnaiplName(_name,aliasValue){
    let tempAccessIdenVals = [];
    if(aliasValue != undefined && aliasValue != ''){
      this.disableEditRnaiplNameBtn = true;
      this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyId}`).subscribe( ( data1 : any) => {
        if(data1['company-names'].length > 0 && this.siteCity != ''){
          this.cpyShortName = data1['company-names'][0].value.slice(0, SiteDetailsComponent.SHORT_NAME_LENGTH);
          this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${aliasValue}&identifierTypeName=AP_RNAIPL_CODE`).subscribe(data => {
            data['access-point-identifiers'].forEach(element => {
              if(tempAccessIdenVals.indexOf(`'${element.accessPointIdentifier}'`) === -1){
                tempAccessIdenVals.push(`'${element.accessPointIdentifier}'`);
              }
            });
            if(tempAccessIdenVals.length > 0){
              this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointIdentifier=in(${tempAccessIdenVals})&identifierTypeName=SOCIAL_RAISON`).subscribe(data12 => {
                if(data12['access-point-identifiers'].length > 0){
                  const constShort = { identifierValue : this.cpyShortName.padEnd(SiteDetailsComponent.SHORT_NAME_LENGTH,' ') + this.siteCity.slice(0, SiteDetailsComponent.CITY_SHORT_LENGTH)}
                  data12['access-point-identifiers'].forEach((element1,index) => {
                    this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${element1.rowId}`,constShort).subscribe(() => {
                      if(index+1 === data12['access-point-identifiers'].length){
                        document.getElementById('closeEditRnaiplName').click();
                        this.dispQualifiers('reload');
                      }
                    });
                  })
                }else{
                  document.getElementById('closeEditRnaiplName').click();
                }
              });
            } else {
              document.getElementById('closeEditRnaiplName').click();
            }
          });
        }else{
          if(this.siteCity === ''){
            this.showNoSiteCity = true;
          }else{
            this.showNoSiteCity = false;
          }
          if(data1['company-names'].length === 0){
            this.showNoCompanyShortName = true;
          }else{
            this.showNoCompanyShortName = false;
          }
          document.getElementById('btnForNoShortNameOrCity').click();
        }
      });
    }
  }

  openCnfLatamArchiveModal(type){
    if(this.editLatamAliasModel != ''){
      if(type=='archive'){
        document.getElementById('btnForCnfLatamArchive').click();
      } else if(type=='unarchive'){
        document.getElementById('btnForCnfLatamUnArchive').click();
      }
    }
  }

  archiveLatam() {
    let archiveLatamId = this.editLatamAliasModel;
    if (archiveLatamId != '') {
      const setEndDate = {endDate : this.apiService.getTodayDate()}
      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.latamRowIdVar}`,setEndDate).subscribe(() => {
        this.showArchivedLATAM=true;
        this.dispQualifiers('reload');
        document.getElementById('closeCnfArchiveLATAM').click();
        document.getElementById('closeeditLatamAlias').click();
      });
    }else {

    }
  } 

  unarchiveLatam() {
    let UnarchiveLatamId = this.editLatamAliasModel;
    if (UnarchiveLatamId != '') {
      const setEndDate = { endDate: '' }
      this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.latamRowIdVar}`,setEndDate).subscribe(() => {
        this.showArchivedLATAM=false;
        this.dispQualifiers('reload');
        document.getElementById('closeCnfUnArchiveLATAM').click();
        document.getElementById('closeeditLatamAlias').click();
      });
    }else {

    }
  } 

  checkLatamName(){
    if(this.latamNameHolder != ''){
      this.editLatamNameError = false;

    }
    else{
      this.editLatamNameError = true;
    }
  }
  resetLatamName(){
    this.latamNameHolder = '';
    this.editLatamNameError = true;
  }

  saveLatamAliasName(){
    if(this.latamNameHolder != undefined && this.latamNameHolder != ''){
      this.disableEditLatamNameBtn = true;
      const name = {
        "identifierValue" : this.latamNameHolder
      };
        if(this.saveAsNewLatamName === false){
          this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${this.latamRowIdVar}`,name ).subscribe(() => {
            document.getElementById('closeEditLatamName').click();
            this.dispQualifiers('reload');
          });
        }
        else{
          let const5 ={
              "identifierId":this.siteIdentTypesData['SOCIAL_RAISON'],
              "sourceSystemId":"2",
              "accessPointRowId" : this.latamAccessRowIdVar,
              "identifierValue" : this.latamNameHolder,
              "effectiveDate" : this.apiService.getTodayDate()
          }
          this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`,const5).subscribe(() =>{
            document.getElementById('closeEditLatamName').click();
            this.dispQualifiers('reload')
          })
      }
    }
}

toggleCodeDispForValidation(type:string){
  if (type ==='SAER'){
     this.showSaerValidate =!this.showSaerValidate;
    this.showRaftValidate =false;
    this.showLatamValidate =false;
    this.showRnaiplValidate = false;
    if(this.raftvalidtaeswitch==true){
      this.raftvalidtaeswitch=false
    }
    if(this.latamswitchvalidate==true){
      this.latamswitchvalidate=false
    }
    if(this.rnaiplswitchvalidate==true){
      this.rnaiplswitchvalidate=false
    }
    this.rnaiplCodeModelValidate = '';
    this.rnaiplNameModelValidate = '';
    this.rnaiplCodeModelValidateError = false;
  }
  if (type ==='RAFT'){
    this.showSaerValidate =false;
    this.showRaftValidate =!this.showRaftValidate;
    this.showLatamValidate =false;
    this.showRnaiplValidate = false;
    this.raftLoading = true
     if(this.showRaftValidate === true){
      this.validateSite(this.rowVar,this.raftAliasVars,this.quaType,this.editRowIdForAlias,this.siteRaftName);
     }
     if(this.saerswitchvalidate==true){
      this.saerswitchvalidate=false
    }
     if(this.latamswitchvalidate==true){
      this.latamswitchvalidate=false
    }
     if(this.rnaiplswitchvalidate==true){
      this.rnaiplswitchvalidate=false
    }
    this.rnaiplCodeModelValidate = '';
    this.rnaiplNameModelValidate = '';
    this.rnaiplCodeModelValidateError = false;
     
  }
  if (type ==='LATAM'){
    this.showSaerValidate =false;
    this.showRaftValidate =false;
    this.showLatamValidate =!this.showLatamValidate;
    this.showRnaiplValidate = false;
    if(this.raftvalidtaeswitch==true){
      this.raftvalidtaeswitch=false
    }
    if(this.saerswitchvalidate==true){
      this.saerswitchvalidate=false
    }
    if(this.rnaiplswitchvalidate==true){
      this.rnaiplswitchvalidate=false
    }
    this.rnaiplCodeModelValidate = '';
    this.rnaiplNameModelValidate = '';
    this.rnaiplCodeModelValidateError = false;
  }
  if (type ==='RNAIPL'){
    this.showSaerValidate = false;
    this.showRaftValidate = false;
    this.showLatamValidate = false;
    this.showRnaiplValidate = !this.showRnaiplValidate;
    if(this.raftvalidtaeswitch==true){
      this.raftvalidtaeswitch=false
    }
    if(this.saerswitchvalidate==true){
      this.saerswitchvalidate=false
    }
    if(this.latamswitchvalidate==true){
      this.latamswitchvalidate=false
    }
    this.rnaiplCodeModelValidate = '';
    this.rnaiplNameModelValidate = '';
    this.rnaiplCodeModelValidateError = false;
  }
}
validateSaer(rowid,type,editrowid,saerCode,siteraft_alias,siteRaftName,latam_code,rnaipl_code){
  this.raftvalidtaeswitch =false;
  this.latamswitchvalidate =false;
  this.rnaiplswitchvalidate = false;
  this.saerswitchvalidate = false;
  this.showSaerValidate =false;
  this.showRaftValidate =false;
  this.showLatamValidate =false;
  this.showRnaiplValidate = false;
  this.saerCodeModelValidate ='';
  this.saerNameModelValidate="";
  this.latamCodeModelValidate ='';
  this.latamNameModelValidate ='';
  this.rnaiplCodeModelValidate = '';
  this.rnaiplNameModelValidate = '';
  this.rnaiplCodeModelValidateError = false;
  this.raftLoading = false
  this.saveButtonClicked = false
    this.rowVar = rowid;
    this.raftAliasVars = siteraft_alias; 
    this.quaType = type;
    this.editRowIdForAlias = editrowid;
    this.siteRaftName = siteRaftName;
    if ((saerCode  && saerCode !== '') || (siteraft_alias  && siteraft_alias !== '') || (latam_code  && latam_code != '') || (rnaipl_code && rnaipl_code != '')) {
    this.displayValidate = true;
      this.loadingValidateAcpSaer = true;
      console.info("rowid",rowid)
      const datas={ "activeStatus":"ACTIVE","endDate":" "} 
      const closeBtn = document.getElementById('closeValidateAcpSaer');
      if (closeBtn) {
        closeBtn.click();
      }
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${rowid}`, datas).subscribe((_data:any) => {
        const closeBtnAfter = document.getElementById('closeValidateAcpSaer');
        if (this.siteWorkflowStatus === 'WaitingForRenault') {
          const payload = { workflowStatus: 'Completed' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
          this.siteWorkflowStatus = 'Completed';
        });
        }
        // Update Site status to Active if status is Inactive or Identified
        if (this.siteActiveStatus && (this.siteActiveStatus.toUpperCase() === 'PENDING' || this.siteActiveStatus.toUpperCase() === 'CREATED')) {
          const sitePayload = { activeStatus: 'ACTIVE' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
            this.siteActiveStatus = 'ACTIVE';
          });
        }
        if (closeBtnAfter) {
          closeBtnAfter.click();
        }        
        this.dispQualifiers('reload')
      })
      
  }
  
  else  {
    this.displayValidate = false;
    this.loadingValidateAcpSaer = false;  
}

}
saveLatamAndSaer(){
  this.saveButtonClicked = true
  const datas = { "activeStatus" : "ACTIVE"};
  if(this.showSaerValidate){
    const siteDatasSaerCode =
    {
      identifierId:this.siteIdentTypesData['SAER_CODE'],
      sourceSystemId:this.siteSourceSystems['SAER'],
      accessPointRowId: this.rowVar,
      identifierValue:this.saerCodeModelValidate,
      effectiveDate:this.apiService.getTodayDate(),
    };
    this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasSaerCode).subscribe(() => {
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowVar}`, datas).subscribe((_data:any) => {
        if (this.siteWorkflowStatus === 'WaitingForRenault') {
          const payload = { workflowStatus: 'Completed' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
          this.siteWorkflowStatus = 'Completed';
        });
        }
        // Update Site status to Active if status is Inactive or Identified
        if (this.siteActiveStatus && (this.siteActiveStatus.toUpperCase() === 'PENDING' || this.siteActiveStatus.toUpperCase() === 'CREATED')) {
          const sitePayload = { activeStatus: 'ACTIVE' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
            this.siteActiveStatus = 'ACTIVE';
          });
        }
      })
     });
  
  if(this.saerNameModelValidate != ''){
    const siteDatasSaerName =
    {
      identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
      sourceSystemId:this.siteSourceSystems['SAER'],
      accessPointRowId: this.rowVar,
      identifierValue:this.saerNameModelValidate,
      effectiveDate:this.apiService.getTodayDate(),
    };
    this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasSaerName).subscribe(() => {
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowVar}`, datas).subscribe((_data:any) => {
        if (this.siteWorkflowStatus === 'WaitingForRenault') {
          const payload = { workflowStatus: 'Completed' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, payload).subscribe(() => {
          this.siteWorkflowStatus = 'Completed';
        });
        }
        // Update Site status to Active if not already Active
        if (this.siteActiveStatus && this.siteActiveStatus.toUpperCase() !== 'ACTIVE') {
          const sitePayload = { activeStatus: 'ACTIVE' };
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
            this.siteActiveStatus = 'ACTIVE';
          });
        }
        this.dispQualifiers('reload')
        document.getElementById('closeValidateAcplabelModel').click();
      })
     });
  }
}
  if(this.showLatamValidate){
    const siteDataLatamCode =
    {
      identifierId:this.siteIdentTypesData['AP_LATAM_CODE'],
      sourceSystemId:this.siteSourceSystems['LATAM'],
      accessPointRowId: this.rowVar,
      identifierValue:this.latamCodeModelValidate,
      effectiveDate:this.apiService.getTodayDate(),
    };
    this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDataLatamCode).subscribe(() => { });
    if(this.latamNameModelValidate){
    if(this.latamNameModelValidate != ''){
    const siteDataslatamName =
    {
      identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
      sourceSystemId:this.siteSourceSystems['LATAM'],
      accessPointRowId: this.rowVar,
      identifierValue:this.latamNameModelValidate,
      effectiveDate:this.apiService.getTodayDate(),
    };
    this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDataslatamName).subscribe(() => {
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowVar}`, datas).subscribe(() => {
      // Update Site status to Active if status is Inactive or Identified
      if (this.siteActiveStatus && (this.siteActiveStatus.toUpperCase() === 'PENDING' || this.siteActiveStatus.toUpperCase() === 'CREATED')) {
        const sitePayload = { activeStatus: 'ACTIVE' };
        this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
          this.siteActiveStatus = 'ACTIVE';
        });
      }
      this.dispQualifiers('reload')
      document.getElementById('closeValidateAcplabelModel').click();
      })
     });
  }
}
  }
  if(this.showRnaiplValidate){
    const siteDataRnaiplCode =
    {
      identifierId:this.siteIdentTypesData['AP_RNAIPL_CODE'],
      sourceSystemId:this.siteSourceSystems['RNAIPL'],
      accessPointRowId: this.rowVar,
      identifierValue:this.rnaiplCodeModelValidate.toUpperCase(),
      effectiveDate:this.apiService.getTodayDate(),
    };
    this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDataRnaiplCode).subscribe(() => { });
    if(this.rnaiplNameModelValidate){
    if(this.rnaiplNameModelValidate != ''){
    const siteDatasRnaiplName =
    {
      identifierId:this.siteIdentTypesData['SOCIAL_RAISON'],
      sourceSystemId:this.siteSourceSystems['RNAIPL'],
      accessPointRowId: this.rowVar,
      identifierValue:this.rnaiplNameModelValidate,
      effectiveDate:this.apiService.getTodayDate(),
    };
    this.sitesService.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, siteDatasRnaiplName).subscribe(() => {
      this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.rowVar}`, datas).subscribe(() => {
      if (this.siteActiveStatus && (this.siteActiveStatus.toUpperCase() === 'PENDING' || this.siteActiveStatus.toUpperCase() === 'CREATED')) {
        const sitePayload = { activeStatus: 'ACTIVE' };
        this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`, sitePayload).subscribe((_siteData: any) => {
          this.siteActiveStatus = 'ACTIVE';
        });
      }
      this.dispQualifiers('reload')
      document.getElementById('closeValidateAcplabelModel').click();
      })
     });
  }
}
  }
}
EditTaxId(edittaxrowid,value,endDate){
  this.taxIdRowId = edittaxrowid;
  this.taxIdModel =value
   if(endDate === 'archived'){
    this.showArchivedTax = true;
  } else {
    this.showArchivedTax = false; 
  }
  console.info("taxIdRowId",this.taxIdRowId)
}
saveTaxId(_page=1){
  console.info("taxId",this.taxIdRowId)
  if(this.taxIdModel != undefined && this.taxIdModel != ''){
    let const5 = {
      value : this.taxIdModel
    }
    this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.taxIdRowId}` , const5).subscribe(data1 => {
      console.info("taxId",data1)
      document.getElementById('closetaxmodal').click();
      this.dispBvdId(this.businessEntityIdSite)
    })
  }
}
DeleteTaxID(){
  if(this.taxIdRowId != undefined && this.taxIdRowId != ''){
    this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.taxIdRowId}`).subscribe(data => {
      console.info("taxId",data)
      document.getElementById('closeCnfDeleteTaxId').click();
      document.getElementById('closetaxmodal').click();
      this.dispBvdId(this.businessEntityIdSite)
    })
  }
}
saveDisable(){
  if(this.saveButtonClicked){
    return true
  }else{
      if (this.saerswitchvalidate) {
        if (this.saerCodeModelValidate != '' && this.saerNameModelValidate != '') {
          return false
        } else {
          return true
        }
      } else if (this.latamswitchvalidate) {
        if (this.latamCodeModelValidate != '' && this.latamNameModelValidate != '') {
          return false
        } else {
          return true
        }
      } else if (this.rnaiplswitchvalidate) {
        const rnaiplCodePattern = /^[A-Z0-9]{2,6}$/;
        const rnaiplCode = this.rnaiplCodeModelValidate ? this.rnaiplCodeModelValidate.toUpperCase() : '';
        this.rnaiplCodeModelValidateError = rnaiplCode !== '' && !rnaiplCodePattern.test(rnaiplCode);
        if (rnaiplCodePattern.test(rnaiplCode) && this.rnaiplNameModelValidate != '') {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  }
  getShortNameDetails(page = 1, _subscribeData = []) {
  this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyId}&_page=${page}`).subscribe((data: any) => {
    if (data['company-names'].length > 0) {
      data['company-names'].forEach(element => {
        if (element.companyNameTypeName === "SHORT NAME") {
          this.companyShortName = element.value;
        }
      });
    }
  });
  }

  resetCreateSiteFields(selectedField: string) {
    if (selectedField === 'siteCountryModel') {
      this.delayResCountry.setValue('');
      this.siteCountryModel = '';
      this.selectedCountry = '';
      this.siteCountryModelError = true;
    }
    if (selectedField === 'siteCityModel') {
      this.delaySiteSearchResCountryCity.setValue('');
      this.editCountryCityModel = '';
    }
  }

  getCountriesListForEdit(event: any) {
    if(/^[A-Z]{1,3} - .+/i.test(event)){
      return;
    }
    this.CaptCountry = "";
    this.CaptCountry = [];
    this.countryLoad1 = true;
    const value = event.split(' - ');
    if (event.length >= SiteDetailsComponent.TWO) {
      const searchQuery = event.length===SiteDetailsComponent.TWO ? `countryCode=${value[0]}` : `countryName=*${value[0]}*`;
      this.getAllCountryPages(`${searchQuery}&countryStatus=1`).subscribe((countries: any[]) => {
        if (countries.length > 0) {
          this.CountryNameKeyId="";
          this.CountryNameKeyId = [];
         
          countries.forEach(element => {
            const displayValue = `${element.countryCode} - ${element.countryName}`;
            const captain_exist = this.CaptCountry.indexOf(displayValue);
            if (captain_exist === -1) {
              this.CaptCountry.push(displayValue);
              this.CountryRowId=element.rowId;
              this.CountryNameKeyId[element.countryName.toUpperCase()] = element;
            }
          });
          this.countryLoad1 = false;
        } else {
          this.CaptCountry = [];
          this.countryLoad1 = false;
        }
      });
    } else {
      this.countryLoad1 = false;
    }
  }
 
  onCountryeSelect(selected: any) {
    if (selected) {
      this.selectedCountry = selected;
      this.siteCountryModelError = false;
      this.siteCountryModel = selected;
      this.countryLoad1 = false;
      this.delayResCountry.setValue(selected, { emitEvent: false });
      this.showCityForCountryEdit = false;
      this.editCountryCityModel = '';
      this.editCountryCityDropDown = [];
      this.editCountryCityAllData = [];
      this.editCountryCityModelError = false;
      this.delaySiteSearchResCountryCity.setValue('', { emitEvent: false });
    } else {
      this.selectedCountry = "failed";
      this.siteCountryModelError = true;
      this.siteCountryModel = "";
      this.delayResCountry.setValue('', { emitEvent: false });
    }
  }
 
  saveNewCountry(){
    const countryValue = this.delayResCountry.value.split(' - ');
    if(!countryValue || countryValue == ''){
      this.siteCountryModelError = true;
      return;
    }
 
    if(this.showCityForCountryEdit){
      // USE CASE 2: UNKNOWN not found in new country, city was selected
      var city:any;
      this.countryId = countryValue[0];
      if (typeof this.editCountryCityModel === 'string') {
        city = this.editCountryCityModel.toUpperCase();
      } else {
        city = this.editCountryCityModel['name'];
      }
      if(!city || !this.editCountryCityAllData[city]){
        this.editCountryCityModelError = true;
        return;
      }
      let cityId = this.editCountryCityAllData[city].rowId;
      const const1 = {
        countryName : countryValue[1],
        countryCode : countryValue[0],
        countryId : this.CountryRowId,
        cityId: cityId,
        irnAuthor: "IRN-71016",
        siaAuthor: "IAF"
      }
      let const2 = {
        countryName : countryValue[1],
        countryCode : countryValue[0],
        countryId : this.CountryRowId,
        cityId: cityId,
        irnAuthor: "IRN-71016",
        siaAuthor: "IAF"
      }
      this.geoRowId.forEach(rowId=>{
        this.AddressService.updateGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses/${rowId}`,const2).subscribe(_data => {
          this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
            this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data2 => {
              this.siteCountry = data2['countryName'];
              this.siteCity = data2['cityName'];
              this.siteName = data2['name'];
              this.showCityForCountryEdit = false;
              document.getElementById('closeEditCountryModal').click();
            })
          })
        })
      })
      return;
    }
 
    // USE CASE 1: Check if UNKNOWN city exists in the new country
    this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${countryValue[0]}&name=UNKNOWN`).subscribe((data: any) => {
      if(data['cities'].length > 0){
        let cityId = data['cities'][0]['rowId'];
        this.siteCountryModelError = false;
        this.countryId = countryValue[0];
        const const1 = {
          countryName : countryValue[1],
          countryCode : countryValue[0],
          countryId : this.CountryRowId,
          cityId: cityId,
          irnAuthor: "IRN-71016",
          siaAuthor: "IAF"
        }
        let const2 = {
          countryName : countryValue[1],
          countryCode : countryValue[0],
          countryId : this.CountryRowId,
          cityId: cityId,
          irnAuthor: "IRN-71016",
          siaAuthor: "IAF"
        }
        this.geoRowId.forEach(rowId=>{
          this.AddressService.updateGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses/${rowId}`,const2).subscribe(_data => {
            this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.siteId}`,const1).subscribe(() => {
              this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites/${this.siteId}` ).subscribe( data2 => {
                this.siteCountry = data2['countryName'];
                document.getElementById('closeEditCountryModal').click();
              })
            })
          })
        })
      } else {
        // USE CASE 2: UNKNOWN not found, show city dropdown
        this.showCityForCountryEdit = true;
        this.editCountryCityModel = '';
        this.editCountryCityDropDown = [];
        this.editCountryCityAllData = [];
        this.editCountryCityModelError = false;
        this.delaySiteSearchResCountryCity.setValue('', { emitEvent: false });
      }
    })
  }
 
  resetEditCountry(){
    this.siteCountryModelError = false;
    this.editCreateCityCountryModelError = false;
    this.editCountryModel = '';
    this.siteCountryModel = '';
    this.selectedCountry = '';
    this.delayResCountry.setValue('');
    this.delaySiteSearchResCountry.setValue('');
    this.showCityForCountryEdit = false;
    this.editCountryCityModel = '';
    this.editCountryCityDropDown = [];
    this.editCountryCityAllData = [];
    this.editCountryCityModelError = false;
    this.delaySiteSearchResCountryCity.setValue('', { emitEvent: false });
  }
 
  changeCountryCityEditFn(){
    this.editCountryCityDropDown = [];
    this.editCountryCityAllData = [];
    if(this.editCountryCityModel && this.editCountryCityModel.length >= 2){
      this.cityLoad1 = true
      const countryValue = this.delayResCountry.value.split(' - ');
      const countryCode = countryValue[0];
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${countryCode}&name=${this.editCountryCityModel}`).subscribe((data1: any) => {
        if(data1['cities'].length > 0){
          data1['cities'].forEach(element => {
            const cityObject = {
              name: element.name || '',
              latitude: element.latitude || '',
              longitude: element.longitude || '',
              adminZoneCode: element.adminZoneCode || '',
              adminZoneName: element.adminZoneName || '',
              adminZoneCode2: element.adminZoneCode2 || '',
              adminZoneName2: element.adminZoneName2 || ''
            };
            this.editCountryCityDropDown.push(cityObject);
            this.editCountryCityAllData[element.name] = element;
          });
        }
        this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${countryCode}&name=*${this.editCountryCityModel}*`).subscribe((data: any) => {
          if(data['cities'].length > 0){
            data['cities'].forEach(element => {
              if(this.editCountryCityModel.trim().toLowerCase() != element.name.toLowerCase()){
                const cityObject = {
                  name: element.name || '',
                  latitude: element.latitude || '',
                  longitude: element.longitude || '',
                  adminZoneCode: element.adminZoneCode || '',
                  adminZoneName: element.adminZoneName || '',
                  adminZoneCode2: element.adminZoneCode2 || '',
                  adminZoneName2: element.adminZoneName2 || ''
                };
                const alreadyExists = this.editCountryCityDropDown.some(item => item.name.toLowerCase() === cityObject.name.toLowerCase());
                if (!alreadyExists) {
                  this.editCountryCityDropDown.push(cityObject);
                }
              }
              this.editCountryCityAllData[element.name] = element;
              this.cityLoad1 = false
            });
          }
        });
      });
    }
  }
 
  onCountryCitySelect(selected){
    if (selected != undefined && selected != null){
      this.editCountryCityModel = selected;
      this.editCountryCityModelError = false;
      this.delaySiteSearchResCountryCity.setValue(selected.name, { emitEvent: false });
    }
  }
 
  isCountryCitySelected(): boolean {
    if (!this.editCountryCityModel) return false;
    let cityName = typeof this.editCountryCityModel === 'string' ? this.editCountryCityModel.toUpperCase() : this.editCountryCityModel['name'];
    return cityName && this.editCountryCityAllData[cityName];
  }
 
  changeCountryEditFn(){
    this.tempcountry ='';
    this.editCountryAllData = "";
    this.editCountryAllData = [];
    this.cityCreateCountryDropDown=[];
    this.autoload4=true;
    if(this.editCountryModel.length != 0){
      this.editCreateCityCountryModelError = false;
    }
    if(this.editCountryModel.trim().length >= 2){
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryName=*${this.editCountryModel}*&_page=1&_pagesize=${SiteDetailsComponent.STANDARD_PAGE_SIZE}`).subscribe((data: any) => {
        this.tempcountry ='';
        if(data['countries'].length >0){
        data['countries'].forEach(element => {
        this.tempcountry = element.name;
        });
      }
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${this.siteCountryModel.split(' - ')[0]}&countryStatus=1&_page=1&_pagesize=${SiteDetailsComponent.STANDARD_PAGE_SIZE}`).subscribe((data: any) => {
        if(data['countries'].length >0){
          data['countries'].forEach(element => {
            const displayValue = `${element.countryCode} - ${element.countryName}`;
            if(this.editCountryModel.trim().toLowerCase() !=element.countryName.toLowerCase()){
              if (!this.cityCreateCountryDropDown.includes(displayValue)) {
                this.cityCreateCountryDropDown.push(displayValue);
            }
            this.editCountryAllData[displayValue] = element;
            this.autoload4=false
          }
          });
          console.info("this.cityCreateCountryDropDown",this.cityCreateCountryDropDown)
        }
      });
    });
    }else {
      this.cityCreateCountryDropDown = [];
    }
  }
toggleApproverEdit(): void {
    this.approverEdit = !this.approverEdit;
  }

  // Load GPS and address data from localStorage when component initializes
  private loadPersistentGpsData(): void {
    try {
      const savedData = localStorage.getItem(this.localStorageKey);
      if (savedData) {
        this.persistentGpsAddressData = JSON.parse(savedData);
        console.log('📂 Loaded persistent GPS and address data from localStorage:', Object.keys(this.persistentGpsAddressData));
      }
    } catch (error) {
      console.error('Error loading GPS/address data from localStorage:', error);
      this.persistentGpsAddressData = {};
    }
  }

  // Save GPS and address data to localStorage whenever it's updated
  private savePersistentGpsData(): void {
    try {
      localStorage.setItem(this.localStorageKey, JSON.stringify(this.persistentGpsAddressData));
      console.log('💾 Saved GPS/address data to localStorage. Keys:', Object.keys(this.persistentGpsAddressData));
    } catch (error) {
      console.error('Error saving GPS/address data to localStorage:', error);
    }
  }
}
 
